var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __typeError = (msg) => {
  throw TypeError(msg);
};
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i7 = decorators.length - 1, decorator; i7 >= 0; i7--)
    if (decorator = decorators[i7])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateSet = (obj, member, value, setter) => (__accessCheck(obj, member, "write to private field"), member.set(obj, value), value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);

// src/types/duoInterfaces.ts
var duoSpacingValues = [
  "none",
  "xxs",
  "xs",
  "s",
  "m",
  "l",
  "xl",
  "xxl"
];

// ../../node_modules/.pnpm/@lit-labs+ssr-dom-shim@1.5.1/node_modules/@lit-labs/ssr-dom-shim/lib/element-internals.js
var ElementInternalsShim = class ElementInternals {
  get shadowRoot() {
    return this.__host.__shadowRoot;
  }
  constructor(_host) {
    this.ariaActiveDescendantElement = null;
    this.ariaAtomic = "";
    this.ariaAutoComplete = "";
    this.ariaBrailleLabel = "";
    this.ariaBrailleRoleDescription = "";
    this.ariaBusy = "";
    this.ariaChecked = "";
    this.ariaColCount = "";
    this.ariaColIndex = "";
    this.ariaColIndexText = "";
    this.ariaColSpan = "";
    this.ariaControlsElements = null;
    this.ariaCurrent = "";
    this.ariaDescribedByElements = null;
    this.ariaDescription = "";
    this.ariaDetailsElements = null;
    this.ariaDisabled = "";
    this.ariaErrorMessageElements = null;
    this.ariaExpanded = "";
    this.ariaFlowToElements = null;
    this.ariaHasPopup = "";
    this.ariaHidden = "";
    this.ariaInvalid = "";
    this.ariaKeyShortcuts = "";
    this.ariaLabel = "";
    this.ariaLabelledByElements = null;
    this.ariaLevel = "";
    this.ariaLive = "";
    this.ariaModal = "";
    this.ariaMultiLine = "";
    this.ariaMultiSelectable = "";
    this.ariaOrientation = "";
    this.ariaOwnsElements = null;
    this.ariaPlaceholder = "";
    this.ariaPosInSet = "";
    this.ariaPressed = "";
    this.ariaReadOnly = "";
    this.ariaRelevant = "";
    this.ariaRequired = "";
    this.ariaRoleDescription = "";
    this.ariaRowCount = "";
    this.ariaRowIndex = "";
    this.ariaRowIndexText = "";
    this.ariaRowSpan = "";
    this.ariaSelected = "";
    this.ariaSetSize = "";
    this.ariaSort = "";
    this.ariaValueMax = "";
    this.ariaValueMin = "";
    this.ariaValueNow = "";
    this.ariaValueText = "";
    this.role = "";
    this.form = null;
    this.labels = [];
    this.states = /* @__PURE__ */ new Set();
    this.validationMessage = "";
    this.validity = {};
    this.willValidate = true;
    this.__host = _host;
  }
  checkValidity() {
    console.warn("`ElementInternals.checkValidity()` was called on the server.This method always returns true.");
    return true;
  }
  reportValidity() {
    return true;
  }
  setFormValue() {
  }
  setValidity() {
  }
};

// ../../node_modules/.pnpm/@lit-labs+ssr-dom-shim@1.5.1/node_modules/@lit-labs/ssr-dom-shim/lib/events.js
var __classPrivateFieldSet = function(receiver, state, value, kind, f3) {
  if (typeof state === "function" ? receiver !== state || true : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return state.set(receiver, value), value;
};
var __classPrivateFieldGet = function(receiver, state, kind, f3) {
  if (typeof state === "function" ? receiver !== state || !f3 : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f3 : kind === "a" ? f3.call(receiver) : f3 ? f3.value : state.get(receiver);
};
var _Event_cancelable;
var _Event_bubbles;
var _Event_composed;
var _Event_defaultPrevented;
var _Event_timestamp;
var _Event_propagationStopped;
var _Event_type;
var _Event_target;
var _Event_isBeingDispatched;
var _a;
var _CustomEvent_detail;
var _b;
var isCaptureEventListener = (options) => typeof options === "boolean" ? options : options?.capture ?? false;
var NONE = 0;
var CAPTURING_PHASE = 1;
var AT_TARGET = 2;
var BUBBLING_PHASE = 3;
var EventTarget = class {
  constructor() {
    this.__eventListeners = /* @__PURE__ */ new Map();
    this.__captureEventListeners = /* @__PURE__ */ new Map();
  }
  addEventListener(type, callback, options) {
    if (callback === void 0 || callback === null) {
      return;
    }
    const eventListenersMap = isCaptureEventListener(options) ? this.__captureEventListeners : this.__eventListeners;
    let eventListeners = eventListenersMap.get(type);
    if (eventListeners === void 0) {
      eventListeners = /* @__PURE__ */ new Map();
      eventListenersMap.set(type, eventListeners);
    } else if (eventListeners.has(callback)) {
      return;
    }
    const normalizedOptions = typeof options === "object" && options ? options : {};
    normalizedOptions.signal?.addEventListener("abort", () => this.removeEventListener(type, callback, options));
    eventListeners.set(callback, normalizedOptions ?? {});
  }
  removeEventListener(type, callback, options) {
    if (callback === void 0 || callback === null) {
      return;
    }
    const eventListenersMap = isCaptureEventListener(options) ? this.__captureEventListeners : this.__eventListeners;
    const eventListeners = eventListenersMap.get(type);
    if (eventListeners !== void 0) {
      eventListeners.delete(callback);
      if (!eventListeners.size) {
        eventListenersMap.delete(type);
      }
    }
  }
  dispatchEvent(event) {
    const composedPath = [this];
    let parent = this.__eventTargetParent;
    if (event.composed) {
      while (parent) {
        composedPath.push(parent);
        parent = parent.__eventTargetParent;
      }
    } else {
      while (parent && parent !== this.__host) {
        composedPath.push(parent);
        parent = parent.__eventTargetParent;
      }
    }
    let stopPropagation = false;
    let stopImmediatePropagation = false;
    let eventPhase = NONE;
    let target = null;
    let tmpTarget = null;
    let currentTarget = null;
    const originalStopPropagation = event.stopPropagation;
    const originalStopImmediatePropagation = event.stopImmediatePropagation;
    Object.defineProperties(event, {
      target: {
        get() {
          return target ?? tmpTarget;
        },
        ...enumerableProperty
      },
      srcElement: {
        get() {
          return event.target;
        },
        ...enumerableProperty
      },
      currentTarget: {
        get() {
          return currentTarget;
        },
        ...enumerableProperty
      },
      eventPhase: {
        get() {
          return eventPhase;
        },
        ...enumerableProperty
      },
      composedPath: {
        value: () => composedPath,
        ...enumerableProperty
      },
      stopPropagation: {
        value: () => {
          stopPropagation = true;
          originalStopPropagation.call(event);
        },
        ...enumerableProperty
      },
      stopImmediatePropagation: {
        value: () => {
          stopImmediatePropagation = true;
          originalStopImmediatePropagation.call(event);
        },
        ...enumerableProperty
      }
    });
    const invokeEventListener = (listener, options, eventListenerMap) => {
      if (typeof listener === "function") {
        listener(event);
      } else if (typeof listener?.handleEvent === "function") {
        listener.handleEvent(event);
      }
      if (options.once) {
        eventListenerMap.delete(listener);
      }
    };
    const finishDispatch = () => {
      currentTarget = null;
      eventPhase = NONE;
      return !event.defaultPrevented;
    };
    const captureEventPath = composedPath.slice().reverse();
    target = !this.__host || !event.composed ? this : null;
    const retarget = (eventTargets) => {
      tmpTarget = this;
      while (tmpTarget.__host && eventTargets.includes(tmpTarget.__host)) {
        tmpTarget = tmpTarget.__host;
      }
    };
    for (const eventTarget of captureEventPath) {
      if (!target && (!tmpTarget || tmpTarget === eventTarget.__host)) {
        retarget(captureEventPath.slice(captureEventPath.indexOf(eventTarget)));
      }
      currentTarget = eventTarget;
      eventPhase = eventTarget === event.target ? AT_TARGET : CAPTURING_PHASE;
      const captureEventListeners = eventTarget.__captureEventListeners.get(event.type);
      if (captureEventListeners) {
        for (const [listener, options] of captureEventListeners) {
          invokeEventListener(listener, options, captureEventListeners);
          if (stopImmediatePropagation) {
            return finishDispatch();
          }
        }
      }
      if (stopPropagation) {
        return finishDispatch();
      }
    }
    const bubbleEventPath = event.bubbles ? composedPath : [this];
    tmpTarget = null;
    for (const eventTarget of bubbleEventPath) {
      if (!target && (!tmpTarget || eventTarget === tmpTarget.__host)) {
        retarget(bubbleEventPath.slice(0, bubbleEventPath.indexOf(eventTarget) + 1));
      }
      currentTarget = eventTarget;
      eventPhase = eventTarget === event.target ? AT_TARGET : BUBBLING_PHASE;
      const captureEventListeners = eventTarget.__eventListeners.get(event.type);
      if (captureEventListeners) {
        for (const [listener, options] of captureEventListeners) {
          invokeEventListener(listener, options, captureEventListeners);
          if (stopImmediatePropagation) {
            return finishDispatch();
          }
        }
      }
      if (stopPropagation) {
        return finishDispatch();
      }
    }
    return finishDispatch();
  }
};
var EventTargetShimWithRealType = EventTarget;
var enumerableProperty = { __proto__: null };
enumerableProperty.enumerable = true;
Object.freeze(enumerableProperty);
var EventShim = (_a = class Event2 {
  constructor(type, options = {}) {
    _Event_cancelable.set(this, false);
    _Event_bubbles.set(this, false);
    _Event_composed.set(this, false);
    _Event_defaultPrevented.set(this, false);
    _Event_timestamp.set(this, Date.now());
    _Event_propagationStopped.set(this, false);
    _Event_type.set(this, void 0);
    _Event_target.set(this, void 0);
    _Event_isBeingDispatched.set(this, void 0);
    this.NONE = NONE;
    this.CAPTURING_PHASE = CAPTURING_PHASE;
    this.AT_TARGET = AT_TARGET;
    this.BUBBLING_PHASE = BUBBLING_PHASE;
    if (arguments.length === 0)
      throw new Error(`The type argument must be specified`);
    if (typeof options !== "object" || !options) {
      throw new Error(`The "options" argument must be an object`);
    }
    const { bubbles, cancelable, composed } = options;
    __classPrivateFieldSet(this, _Event_cancelable, !!cancelable);
    __classPrivateFieldSet(this, _Event_bubbles, !!bubbles);
    __classPrivateFieldSet(this, _Event_composed, !!composed);
    __classPrivateFieldSet(this, _Event_type, `${type}`);
    __classPrivateFieldSet(this, _Event_target, null);
    __classPrivateFieldSet(this, _Event_isBeingDispatched, false);
  }
  initEvent(_type, _bubbles, _cancelable) {
    throw new Error("Method not implemented.");
  }
  stopImmediatePropagation() {
    this.stopPropagation();
  }
  preventDefault() {
    __classPrivateFieldSet(this, _Event_defaultPrevented, true);
  }
  get target() {
    return __classPrivateFieldGet(this, _Event_target, "f");
  }
  get currentTarget() {
    return __classPrivateFieldGet(this, _Event_target, "f");
  }
  get srcElement() {
    return __classPrivateFieldGet(this, _Event_target, "f");
  }
  get type() {
    return __classPrivateFieldGet(this, _Event_type, "f");
  }
  get cancelable() {
    return __classPrivateFieldGet(this, _Event_cancelable, "f");
  }
  get defaultPrevented() {
    return __classPrivateFieldGet(this, _Event_cancelable, "f") && __classPrivateFieldGet(this, _Event_defaultPrevented, "f");
  }
  get timeStamp() {
    return __classPrivateFieldGet(this, _Event_timestamp, "f");
  }
  composedPath() {
    return __classPrivateFieldGet(this, _Event_isBeingDispatched, "f") ? [__classPrivateFieldGet(this, _Event_target, "f")] : [];
  }
  get returnValue() {
    return !__classPrivateFieldGet(this, _Event_cancelable, "f") || !__classPrivateFieldGet(this, _Event_defaultPrevented, "f");
  }
  get bubbles() {
    return __classPrivateFieldGet(this, _Event_bubbles, "f");
  }
  get composed() {
    return __classPrivateFieldGet(this, _Event_composed, "f");
  }
  get eventPhase() {
    return __classPrivateFieldGet(this, _Event_isBeingDispatched, "f") ? _a.AT_TARGET : _a.NONE;
  }
  get cancelBubble() {
    return __classPrivateFieldGet(this, _Event_propagationStopped, "f");
  }
  set cancelBubble(value) {
    if (value) {
      __classPrivateFieldSet(this, _Event_propagationStopped, true);
    }
  }
  stopPropagation() {
    __classPrivateFieldSet(this, _Event_propagationStopped, true);
  }
  get isTrusted() {
    return false;
  }
}, _Event_cancelable = /* @__PURE__ */ new WeakMap(), _Event_bubbles = /* @__PURE__ */ new WeakMap(), _Event_composed = /* @__PURE__ */ new WeakMap(), _Event_defaultPrevented = /* @__PURE__ */ new WeakMap(), _Event_timestamp = /* @__PURE__ */ new WeakMap(), _Event_propagationStopped = /* @__PURE__ */ new WeakMap(), _Event_type = /* @__PURE__ */ new WeakMap(), _Event_target = /* @__PURE__ */ new WeakMap(), _Event_isBeingDispatched = /* @__PURE__ */ new WeakMap(), _a.NONE = NONE, _a.CAPTURING_PHASE = CAPTURING_PHASE, _a.AT_TARGET = AT_TARGET, _a.BUBBLING_PHASE = BUBBLING_PHASE, _a);
Object.defineProperties(EventShim.prototype, {
  initEvent: enumerableProperty,
  stopImmediatePropagation: enumerableProperty,
  preventDefault: enumerableProperty,
  target: enumerableProperty,
  currentTarget: enumerableProperty,
  srcElement: enumerableProperty,
  type: enumerableProperty,
  cancelable: enumerableProperty,
  defaultPrevented: enumerableProperty,
  timeStamp: enumerableProperty,
  composedPath: enumerableProperty,
  returnValue: enumerableProperty,
  bubbles: enumerableProperty,
  composed: enumerableProperty,
  eventPhase: enumerableProperty,
  cancelBubble: enumerableProperty,
  stopPropagation: enumerableProperty,
  isTrusted: enumerableProperty
});
var CustomEventShim = (_b = class CustomEvent2 extends EventShim {
  constructor(type, options = {}) {
    super(type, options);
    _CustomEvent_detail.set(this, void 0);
    __classPrivateFieldSet(this, _CustomEvent_detail, options?.detail ?? null);
  }
  initCustomEvent(_type, _bubbles, _cancelable, _detail) {
    throw new Error("Method not implemented.");
  }
  get detail() {
    return __classPrivateFieldGet(this, _CustomEvent_detail, "f");
  }
}, _CustomEvent_detail = /* @__PURE__ */ new WeakMap(), _b);
Object.defineProperties(CustomEventShim.prototype, {
  detail: enumerableProperty
});
var EventShimWithRealType = EventShim;
var CustomEventShimWithRealType = CustomEventShim;

// ../../node_modules/.pnpm/@lit-labs+ssr-dom-shim@1.5.1/node_modules/@lit-labs/ssr-dom-shim/lib/css.js
var _a2;
(_a2 = class CSSRule {
  constructor() {
    this.STYLE_RULE = 1;
    this.CHARSET_RULE = 2;
    this.IMPORT_RULE = 3;
    this.MEDIA_RULE = 4;
    this.FONT_FACE_RULE = 5;
    this.PAGE_RULE = 6;
    this.NAMESPACE_RULE = 10;
    this.KEYFRAMES_RULE = 7;
    this.KEYFRAME_RULE = 8;
    this.SUPPORTS_RULE = 12;
    this.COUNTER_STYLE_RULE = 11;
    this.FONT_FEATURE_VALUES_RULE = 14;
    this.__parentStyleSheet = null;
    this.cssText = "";
  }
  get parentRule() {
    return null;
  }
  get parentStyleSheet() {
    return this.__parentStyleSheet;
  }
  get type() {
    return 0;
  }
}, _a2.STYLE_RULE = 1, _a2.CHARSET_RULE = 2, _a2.IMPORT_RULE = 3, _a2.MEDIA_RULE = 4, _a2.FONT_FACE_RULE = 5, _a2.PAGE_RULE = 6, _a2.NAMESPACE_RULE = 10, _a2.KEYFRAMES_RULE = 7, _a2.KEYFRAME_RULE = 8, _a2.SUPPORTS_RULE = 12, _a2.COUNTER_STYLE_RULE = 11, _a2.FONT_FEATURE_VALUES_RULE = 14, _a2);

// ../../node_modules/.pnpm/@lit-labs+ssr-dom-shim@1.5.1/node_modules/@lit-labs/ssr-dom-shim/index.js
globalThis.Event ??= EventShimWithRealType;
globalThis.CustomEvent ??= CustomEventShimWithRealType;
var attributes = /* @__PURE__ */ new WeakMap();
var attributesForElement = (element) => {
  let attrs = attributes.get(element);
  if (attrs === void 0) {
    attributes.set(element, attrs = /* @__PURE__ */ new Map());
  }
  return attrs;
};
var ElementShim = class Element2 extends EventTargetShimWithRealType {
  constructor() {
    super(...arguments);
    this.__shadowRootMode = null;
    this.__shadowRoot = null;
    this.__internals = null;
  }
  get attributes() {
    return Array.from(attributesForElement(this)).map(([name, value]) => ({
      name,
      value
    }));
  }
  get shadowRoot() {
    if (this.__shadowRootMode === "closed") {
      return null;
    }
    return this.__shadowRoot;
  }
  get localName() {
    return this.constructor.__localName;
  }
  get tagName() {
    return this.localName?.toUpperCase();
  }
  setAttribute(name, value) {
    attributesForElement(this).set(name, String(value));
  }
  removeAttribute(name) {
    attributesForElement(this).delete(name);
  }
  toggleAttribute(name, force) {
    if (this.hasAttribute(name)) {
      if (force === void 0 || !force) {
        this.removeAttribute(name);
        return false;
      }
    } else {
      if (force === void 0 || force) {
        this.setAttribute(name, "");
        return true;
      } else {
        return false;
      }
    }
    return true;
  }
  hasAttribute(name) {
    return attributesForElement(this).has(name);
  }
  attachShadow(init) {
    const shadowRoot = { host: this };
    this.__shadowRootMode = init.mode;
    if (init && init.mode === "open") {
      this.__shadowRoot = shadowRoot;
    }
    return shadowRoot;
  }
  attachInternals() {
    if (this.__internals !== null) {
      throw new Error(`Failed to execute 'attachInternals' on 'HTMLElement': ElementInternals for the specified element was already attached.`);
    }
    const internals = new ElementInternalsShim(this);
    this.__internals = internals;
    return internals;
  }
  getAttribute(name) {
    const value = attributesForElement(this).get(name);
    return value ?? null;
  }
};
var HTMLElementShim = class HTMLElement2 extends ElementShim {
};
var HTMLElementShimWithRealType = HTMLElementShim;
globalThis.litServerRoot ??= Object.defineProperty(new HTMLElementShimWithRealType(), "localName", {
  // Patch localName (and tagName) to return a unique name.
  get() {
    return "lit-server-root";
  }
});
function promiseWithResolvers() {
  let resolve;
  let reject;
  const promise = new Promise((res, rej) => {
    resolve = res;
    reject = rej;
  });
  return { promise, resolve, reject };
}
var CustomElementRegistry = class {
  constructor() {
    this.__definitions = /* @__PURE__ */ new Map();
    this.__reverseDefinitions = /* @__PURE__ */ new Map();
    this.__pendingWhenDefineds = /* @__PURE__ */ new Map();
  }
  define(name, ctor) {
    if (this.__definitions.has(name)) {
      if (process.env.NODE_ENV === "development") {
        console.warn(`'CustomElementRegistry' already has "${name}" defined. This may have been caused by live reload or hot module replacement in which case it can be safely ignored.
Make sure to test your application with a production build as repeat registrations will throw in production.`);
      } else {
        throw new Error(`Failed to execute 'define' on 'CustomElementRegistry': the name "${name}" has already been used with this registry`);
      }
    }
    if (this.__reverseDefinitions.has(ctor)) {
      throw new Error(`Failed to execute 'define' on 'CustomElementRegistry': the constructor has already been used with this registry for the tag name ${this.__reverseDefinitions.get(ctor)}`);
    }
    ctor.__localName = name;
    this.__definitions.set(name, {
      ctor,
      // Note it's important we read `observedAttributes` in case it is a getter
      // with side-effects, as is the case in Lit, where it triggers class
      // finalization.
      //
      // TODO(aomarks) To be spec compliant, we should also capture the
      // registration-time lifecycle methods like `connectedCallback`. For them
      // to be actually accessible to e.g. the Lit SSR element renderer, though,
      // we'd need to introduce a new API for accessing them (since `get` only
      // returns the constructor).
      observedAttributes: ctor.observedAttributes ?? []
    });
    this.__reverseDefinitions.set(ctor, name);
    this.__pendingWhenDefineds.get(name)?.resolve(ctor);
    this.__pendingWhenDefineds.delete(name);
  }
  get(name) {
    const definition = this.__definitions.get(name);
    return definition?.ctor;
  }
  getName(ctor) {
    return this.__reverseDefinitions.get(ctor) ?? null;
  }
  upgrade(_element) {
    throw new Error(`customElements.upgrade is not currently supported in SSR. Please file a bug if you need it.`);
  }
  async whenDefined(name) {
    const definition = this.__definitions.get(name);
    if (definition) {
      return definition.ctor;
    }
    let withResolvers = this.__pendingWhenDefineds.get(name);
    if (!withResolvers) {
      withResolvers = promiseWithResolvers();
      this.__pendingWhenDefineds.set(name, withResolvers);
    }
    return withResolvers.promise;
  }
};
var CustomElementRegistryShimWithRealType = CustomElementRegistry;
var customElements2 = new CustomElementRegistryShimWithRealType();

// ../../node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/node/css-tag.js
var t = globalThis;
var e = t.ShadowRoot && (void 0 === t.ShadyCSS || t.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype;
var s = /* @__PURE__ */ Symbol();
var o = /* @__PURE__ */ new WeakMap();
var n = class {
  constructor(t7, e8, o11) {
    if (this._$cssResult$ = true, o11 !== s) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
    this.cssText = t7, this.t = e8;
  }
  get styleSheet() {
    let t7 = this.o;
    const s5 = this.t;
    if (e && void 0 === t7) {
      const e8 = void 0 !== s5 && 1 === s5.length;
      e8 && (t7 = o.get(s5)), void 0 === t7 && ((this.o = t7 = new CSSStyleSheet()).replaceSync(this.cssText), e8 && o.set(s5, t7));
    }
    return t7;
  }
  toString() {
    return this.cssText;
  }
};
var r = (t7) => new n("string" == typeof t7 ? t7 : t7 + "", void 0, s);
var i = (t7, ...e8) => {
  const o11 = 1 === t7.length ? t7[0] : e8.reduce((e9, s5, o12) => e9 + ((t8) => {
    if (true === t8._$cssResult$) return t8.cssText;
    if ("number" == typeof t8) return t8;
    throw Error("Value passed to 'css' function must be a 'css' function result: " + t8 + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
  })(s5) + t7[o12 + 1], t7[0]);
  return new n(o11, t7, s);
};
var S = (s5, o11) => {
  if (e) s5.adoptedStyleSheets = o11.map((t7) => t7 instanceof CSSStyleSheet ? t7 : t7.styleSheet);
  else for (const e8 of o11) {
    const o12 = document.createElement("style"), n6 = t.litNonce;
    void 0 !== n6 && o12.setAttribute("nonce", n6), o12.textContent = e8.cssText, s5.appendChild(o12);
  }
};
var c = e || void 0 === t.CSSStyleSheet ? (t7) => t7 : (t7) => t7 instanceof CSSStyleSheet ? ((t8) => {
  let e8 = "";
  for (const s5 of t8.cssRules) e8 += s5.cssText;
  return r(e8);
})(t7) : t7;

// ../../node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/node/reactive-element.js
var { is: h, defineProperty: r2, getOwnPropertyDescriptor: o2, getOwnPropertyNames: n2, getOwnPropertySymbols: a, getPrototypeOf: c2 } = Object;
var l = globalThis;
l.customElements ??= customElements2;
var p = l.trustedTypes;
var d = p ? p.emptyScript : "";
var u = l.reactiveElementPolyfillSupport;
var f = (t7, s5) => t7;
var b = { toAttribute(t7, s5) {
  switch (s5) {
    case Boolean:
      t7 = t7 ? d : null;
      break;
    case Object:
    case Array:
      t7 = null == t7 ? t7 : JSON.stringify(t7);
  }
  return t7;
}, fromAttribute(t7, s5) {
  let i7 = t7;
  switch (s5) {
    case Boolean:
      i7 = null !== t7;
      break;
    case Number:
      i7 = null === t7 ? null : Number(t7);
      break;
    case Object:
    case Array:
      try {
        i7 = JSON.parse(t7);
      } catch (t8) {
        i7 = null;
      }
  }
  return i7;
} };
var m = (t7, s5) => !h(t7, s5);
var y = { attribute: true, type: String, converter: b, reflect: false, useDefault: false, hasChanged: m };
Symbol.metadata ??= /* @__PURE__ */ Symbol("metadata"), l.litPropertyMetadata ??= /* @__PURE__ */ new WeakMap();
var g = class extends (globalThis.HTMLElement ?? HTMLElementShimWithRealType) {
  static addInitializer(t7) {
    this._$Ei(), (this.l ??= []).push(t7);
  }
  static get observedAttributes() {
    return this.finalize(), this._$Eh && [...this._$Eh.keys()];
  }
  static createProperty(t7, s5 = y) {
    if (s5.state && (s5.attribute = false), this._$Ei(), this.prototype.hasOwnProperty(t7) && ((s5 = Object.create(s5)).wrapped = true), this.elementProperties.set(t7, s5), !s5.noAccessor) {
      const i7 = /* @__PURE__ */ Symbol(), e8 = this.getPropertyDescriptor(t7, i7, s5);
      void 0 !== e8 && r2(this.prototype, t7, e8);
    }
  }
  static getPropertyDescriptor(t7, s5, i7) {
    const { get: e8, set: h4 } = o2(this.prototype, t7) ?? { get() {
      return this[s5];
    }, set(t8) {
      this[s5] = t8;
    } };
    return { get: e8, set(s6) {
      const r6 = e8?.call(this);
      h4?.call(this, s6), this.requestUpdate(t7, r6, i7);
    }, configurable: true, enumerable: true };
  }
  static getPropertyOptions(t7) {
    return this.elementProperties.get(t7) ?? y;
  }
  static _$Ei() {
    if (this.hasOwnProperty(f("elementProperties"))) return;
    const t7 = c2(this);
    t7.finalize(), void 0 !== t7.l && (this.l = [...t7.l]), this.elementProperties = new Map(t7.elementProperties);
  }
  static finalize() {
    if (this.hasOwnProperty(f("finalized"))) return;
    if (this.finalized = true, this._$Ei(), this.hasOwnProperty(f("properties"))) {
      const t8 = this.properties, s5 = [...n2(t8), ...a(t8)];
      for (const i7 of s5) this.createProperty(i7, t8[i7]);
    }
    const t7 = this[Symbol.metadata];
    if (null !== t7) {
      const s5 = litPropertyMetadata.get(t7);
      if (void 0 !== s5) for (const [t8, i7] of s5) this.elementProperties.set(t8, i7);
    }
    this._$Eh = /* @__PURE__ */ new Map();
    for (const [t8, s5] of this.elementProperties) {
      const i7 = this._$Eu(t8, s5);
      void 0 !== i7 && this._$Eh.set(i7, t8);
    }
    this.elementStyles = this.finalizeStyles(this.styles);
  }
  static finalizeStyles(t7) {
    const s5 = [];
    if (Array.isArray(t7)) {
      const e8 = new Set(t7.flat(1 / 0).reverse());
      for (const t8 of e8) s5.unshift(c(t8));
    } else void 0 !== t7 && s5.push(c(t7));
    return s5;
  }
  static _$Eu(t7, s5) {
    const i7 = s5.attribute;
    return false === i7 ? void 0 : "string" == typeof i7 ? i7 : "string" == typeof t7 ? t7.toLowerCase() : void 0;
  }
  constructor() {
    super(), this._$Ep = void 0, this.isUpdatePending = false, this.hasUpdated = false, this._$Em = null, this._$Ev();
  }
  _$Ev() {
    this._$ES = new Promise((t7) => this.enableUpdating = t7), this._$AL = /* @__PURE__ */ new Map(), this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((t7) => t7(this));
  }
  addController(t7) {
    (this._$EO ??= /* @__PURE__ */ new Set()).add(t7), void 0 !== this.renderRoot && this.isConnected && t7.hostConnected?.();
  }
  removeController(t7) {
    this._$EO?.delete(t7);
  }
  _$E_() {
    const t7 = /* @__PURE__ */ new Map(), s5 = this.constructor.elementProperties;
    for (const i7 of s5.keys()) this.hasOwnProperty(i7) && (t7.set(i7, this[i7]), delete this[i7]);
    t7.size > 0 && (this._$Ep = t7);
  }
  createRenderRoot() {
    const t7 = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
    return S(t7, this.constructor.elementStyles), t7;
  }
  connectedCallback() {
    this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(true), this._$EO?.forEach((t7) => t7.hostConnected?.());
  }
  enableUpdating(t7) {
  }
  disconnectedCallback() {
    this._$EO?.forEach((t7) => t7.hostDisconnected?.());
  }
  attributeChangedCallback(t7, s5, i7) {
    this._$AK(t7, i7);
  }
  _$ET(t7, s5) {
    const i7 = this.constructor.elementProperties.get(t7), e8 = this.constructor._$Eu(t7, i7);
    if (void 0 !== e8 && true === i7.reflect) {
      const h4 = (void 0 !== i7.converter?.toAttribute ? i7.converter : b).toAttribute(s5, i7.type);
      this._$Em = t7, null == h4 ? this.removeAttribute(e8) : this.setAttribute(e8, h4), this._$Em = null;
    }
  }
  _$AK(t7, s5) {
    const i7 = this.constructor, e8 = i7._$Eh.get(t7);
    if (void 0 !== e8 && this._$Em !== e8) {
      const t8 = i7.getPropertyOptions(e8), h4 = "function" == typeof t8.converter ? { fromAttribute: t8.converter } : void 0 !== t8.converter?.fromAttribute ? t8.converter : b;
      this._$Em = e8;
      const r6 = h4.fromAttribute(s5, t8.type);
      this[e8] = r6 ?? this._$Ej?.get(e8) ?? r6, this._$Em = null;
    }
  }
  requestUpdate(t7, s5, i7, e8 = false, h4) {
    if (void 0 !== t7) {
      const r6 = this.constructor;
      if (false === e8 && (h4 = this[t7]), i7 ??= r6.getPropertyOptions(t7), !((i7.hasChanged ?? m)(h4, s5) || i7.useDefault && i7.reflect && h4 === this._$Ej?.get(t7) && !this.hasAttribute(r6._$Eu(t7, i7)))) return;
      this.C(t7, s5, i7);
    }
    false === this.isUpdatePending && (this._$ES = this._$EP());
  }
  C(t7, s5, { useDefault: i7, reflect: e8, wrapped: h4 }, r6) {
    i7 && !(this._$Ej ??= /* @__PURE__ */ new Map()).has(t7) && (this._$Ej.set(t7, r6 ?? s5 ?? this[t7]), true !== h4 || void 0 !== r6) || (this._$AL.has(t7) || (this.hasUpdated || i7 || (s5 = void 0), this._$AL.set(t7, s5)), true === e8 && this._$Em !== t7 && (this._$Eq ??= /* @__PURE__ */ new Set()).add(t7));
  }
  async _$EP() {
    this.isUpdatePending = true;
    try {
      await this._$ES;
    } catch (t8) {
      Promise.reject(t8);
    }
    const t7 = this.scheduleUpdate();
    return null != t7 && await t7, !this.isUpdatePending;
  }
  scheduleUpdate() {
    return this.performUpdate();
  }
  performUpdate() {
    if (!this.isUpdatePending) return;
    if (!this.hasUpdated) {
      if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
        for (const [t9, s6] of this._$Ep) this[t9] = s6;
        this._$Ep = void 0;
      }
      const t8 = this.constructor.elementProperties;
      if (t8.size > 0) for (const [s6, i7] of t8) {
        const { wrapped: t9 } = i7, e8 = this[s6];
        true !== t9 || this._$AL.has(s6) || void 0 === e8 || this.C(s6, void 0, i7, e8);
      }
    }
    let t7 = false;
    const s5 = this._$AL;
    try {
      t7 = this.shouldUpdate(s5), t7 ? (this.willUpdate(s5), this._$EO?.forEach((t8) => t8.hostUpdate?.()), this.update(s5)) : this._$EM();
    } catch (s6) {
      throw t7 = false, this._$EM(), s6;
    }
    t7 && this._$AE(s5);
  }
  willUpdate(t7) {
  }
  _$AE(t7) {
    this._$EO?.forEach((t8) => t8.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = true, this.firstUpdated(t7)), this.updated(t7);
  }
  _$EM() {
    this._$AL = /* @__PURE__ */ new Map(), this.isUpdatePending = false;
  }
  get updateComplete() {
    return this.getUpdateComplete();
  }
  getUpdateComplete() {
    return this._$ES;
  }
  shouldUpdate(t7) {
    return true;
  }
  update(t7) {
    this._$Eq &&= this._$Eq.forEach((t8) => this._$ET(t8, this[t8])), this._$EM();
  }
  updated(t7) {
  }
  firstUpdated(t7) {
  }
};
g.elementStyles = [], g.shadowRootOptions = { mode: "open" }, g[f("elementProperties")] = /* @__PURE__ */ new Map(), g[f("finalized")] = /* @__PURE__ */ new Map(), u?.({ ReactiveElement: g }), (l.reactiveElementVersions ??= []).push("2.1.2");

// ../../node_modules/.pnpm/lit-html@3.3.2/node_modules/lit-html/node/lit-html.js
var t2 = globalThis;
var i2 = (t7) => t7;
var s2 = t2.trustedTypes;
var e2 = s2 ? s2.createPolicy("lit-html", { createHTML: (t7) => t7 }) : void 0;
var h2 = "$lit$";
var o3 = `lit$${Math.random().toFixed(9).slice(2)}$`;
var n3 = "?" + o3;
var r3 = `<${n3}>`;
var l2 = void 0 === t2.document ? { createTreeWalker: () => ({}) } : document;
var c3 = () => l2.createComment("");
var a2 = (t7) => null === t7 || "object" != typeof t7 && "function" != typeof t7;
var u2 = Array.isArray;
var d2 = (t7) => u2(t7) || "function" == typeof t7?.[Symbol.iterator];
var f2 = "[ 	\n\f\r]";
var v = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g;
var _ = /-->/g;
var m2 = />/g;
var p2 = RegExp(`>|${f2}(?:([^\\s"'>=/]+)(${f2}*=${f2}*(?:[^ 	
\f\r"'\`<>=]|("|')|))|$)`, "g");
var g2 = /'/g;
var $ = /"/g;
var y2 = /^(?:script|style|textarea|title)$/i;
var x = (t7) => (i7, ...s5) => ({ _$litType$: t7, strings: i7, values: s5 });
var T = x(1);
var E = /* @__PURE__ */ Symbol.for("lit-noChange");
var A = /* @__PURE__ */ Symbol.for("lit-nothing");
var C = /* @__PURE__ */ new WeakMap();
var P = l2.createTreeWalker(l2, 129);
function V(t7, i7) {
  if (!u2(t7) || !t7.hasOwnProperty("raw")) throw Error("invalid template strings array");
  return void 0 !== e2 ? e2.createHTML(i7) : i7;
}
var N = (t7, i7) => {
  const s5 = t7.length - 1, e8 = [];
  let n6, l3 = 2 === i7 ? "<svg>" : 3 === i7 ? "<math>" : "", c5 = v;
  for (let i8 = 0; i8 < s5; i8++) {
    const s6 = t7[i8];
    let a3, u5, d3 = -1, f3 = 0;
    for (; f3 < s6.length && (c5.lastIndex = f3, u5 = c5.exec(s6), null !== u5); ) f3 = c5.lastIndex, c5 === v ? "!--" === u5[1] ? c5 = _ : void 0 !== u5[1] ? c5 = m2 : void 0 !== u5[2] ? (y2.test(u5[2]) && (n6 = RegExp("</" + u5[2], "g")), c5 = p2) : void 0 !== u5[3] && (c5 = p2) : c5 === p2 ? ">" === u5[0] ? (c5 = n6 ?? v, d3 = -1) : void 0 === u5[1] ? d3 = -2 : (d3 = c5.lastIndex - u5[2].length, a3 = u5[1], c5 = void 0 === u5[3] ? p2 : '"' === u5[3] ? $ : g2) : c5 === $ || c5 === g2 ? c5 = p2 : c5 === _ || c5 === m2 ? c5 = v : (c5 = p2, n6 = void 0);
    const x2 = c5 === p2 && t7[i8 + 1].startsWith("/>") ? " " : "";
    l3 += c5 === v ? s6 + r3 : d3 >= 0 ? (e8.push(a3), s6.slice(0, d3) + h2 + s6.slice(d3) + o3 + x2) : s6 + o3 + (-2 === d3 ? i8 : x2);
  }
  return [V(t7, l3 + (t7[s5] || "<?>") + (2 === i7 ? "</svg>" : 3 === i7 ? "</math>" : "")), e8];
};
var S2 = class _S {
  constructor({ strings: t7, _$litType$: i7 }, e8) {
    let r6;
    this.parts = [];
    let l3 = 0, a3 = 0;
    const u5 = t7.length - 1, d3 = this.parts, [f3, v3] = N(t7, i7);
    if (this.el = _S.createElement(f3, e8), P.currentNode = this.el.content, 2 === i7 || 3 === i7) {
      const t8 = this.el.content.firstChild;
      t8.replaceWith(...t8.childNodes);
    }
    for (; null !== (r6 = P.nextNode()) && d3.length < u5; ) {
      if (1 === r6.nodeType) {
        if (r6.hasAttributes()) for (const t8 of r6.getAttributeNames()) if (t8.endsWith(h2)) {
          const i8 = v3[a3++], s5 = r6.getAttribute(t8).split(o3), e9 = /([.?@])?(.*)/.exec(i8);
          d3.push({ type: 1, index: l3, name: e9[2], strings: s5, ctor: "." === e9[1] ? I : "?" === e9[1] ? L : "@" === e9[1] ? z : H }), r6.removeAttribute(t8);
        } else t8.startsWith(o3) && (d3.push({ type: 6, index: l3 }), r6.removeAttribute(t8));
        if (y2.test(r6.tagName)) {
          const t8 = r6.textContent.split(o3), i8 = t8.length - 1;
          if (i8 > 0) {
            r6.textContent = s2 ? s2.emptyScript : "";
            for (let s5 = 0; s5 < i8; s5++) r6.append(t8[s5], c3()), P.nextNode(), d3.push({ type: 2, index: ++l3 });
            r6.append(t8[i8], c3());
          }
        }
      } else if (8 === r6.nodeType) if (r6.data === n3) d3.push({ type: 2, index: l3 });
      else {
        let t8 = -1;
        for (; -1 !== (t8 = r6.data.indexOf(o3, t8 + 1)); ) d3.push({ type: 7, index: l3 }), t8 += o3.length - 1;
      }
      l3++;
    }
  }
  static createElement(t7, i7) {
    const s5 = l2.createElement("template");
    return s5.innerHTML = t7, s5;
  }
};
function M(t7, i7, s5 = t7, e8) {
  if (i7 === E) return i7;
  let h4 = void 0 !== e8 ? s5._$Co?.[e8] : s5._$Cl;
  const o11 = a2(i7) ? void 0 : i7._$litDirective$;
  return h4?.constructor !== o11 && (h4?._$AO?.(false), void 0 === o11 ? h4 = void 0 : (h4 = new o11(t7), h4._$AT(t7, s5, e8)), void 0 !== e8 ? (s5._$Co ??= [])[e8] = h4 : s5._$Cl = h4), void 0 !== h4 && (i7 = M(t7, h4._$AS(t7, i7.values), h4, e8)), i7;
}
var k = class {
  constructor(t7, i7) {
    this._$AV = [], this._$AN = void 0, this._$AD = t7, this._$AM = i7;
  }
  get parentNode() {
    return this._$AM.parentNode;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  u(t7) {
    const { el: { content: i7 }, parts: s5 } = this._$AD, e8 = (t7?.creationScope ?? l2).importNode(i7, true);
    P.currentNode = e8;
    let h4 = P.nextNode(), o11 = 0, n6 = 0, r6 = s5[0];
    for (; void 0 !== r6; ) {
      if (o11 === r6.index) {
        let i8;
        2 === r6.type ? i8 = new R(h4, h4.nextSibling, this, t7) : 1 === r6.type ? i8 = new r6.ctor(h4, r6.name, r6.strings, this, t7) : 6 === r6.type && (i8 = new W(h4, this, t7)), this._$AV.push(i8), r6 = s5[++n6];
      }
      o11 !== r6?.index && (h4 = P.nextNode(), o11++);
    }
    return P.currentNode = l2, e8;
  }
  p(t7) {
    let i7 = 0;
    for (const s5 of this._$AV) void 0 !== s5 && (void 0 !== s5.strings ? (s5._$AI(t7, s5, i7), i7 += s5.strings.length - 2) : s5._$AI(t7[i7])), i7++;
  }
};
var R = class _R {
  get _$AU() {
    return this._$AM?._$AU ?? this._$Cv;
  }
  constructor(t7, i7, s5, e8) {
    this.type = 2, this._$AH = A, this._$AN = void 0, this._$AA = t7, this._$AB = i7, this._$AM = s5, this.options = e8, this._$Cv = e8?.isConnected ?? true;
  }
  get parentNode() {
    let t7 = this._$AA.parentNode;
    const i7 = this._$AM;
    return void 0 !== i7 && 11 === t7?.nodeType && (t7 = i7.parentNode), t7;
  }
  get startNode() {
    return this._$AA;
  }
  get endNode() {
    return this._$AB;
  }
  _$AI(t7, i7 = this) {
    t7 = M(this, t7, i7), a2(t7) ? t7 === A || null == t7 || "" === t7 ? (this._$AH !== A && this._$AR(), this._$AH = A) : t7 !== this._$AH && t7 !== E && this._(t7) : void 0 !== t7._$litType$ ? this.$(t7) : void 0 !== t7.nodeType ? this.T(t7) : d2(t7) ? this.k(t7) : this._(t7);
  }
  O(t7) {
    return this._$AA.parentNode.insertBefore(t7, this._$AB);
  }
  T(t7) {
    this._$AH !== t7 && (this._$AR(), this._$AH = this.O(t7));
  }
  _(t7) {
    this._$AH !== A && a2(this._$AH) ? this._$AA.nextSibling.data = t7 : this.T(l2.createTextNode(t7)), this._$AH = t7;
  }
  $(t7) {
    const { values: i7, _$litType$: s5 } = t7, e8 = "number" == typeof s5 ? this._$AC(t7) : (void 0 === s5.el && (s5.el = S2.createElement(V(s5.h, s5.h[0]), this.options)), s5);
    if (this._$AH?._$AD === e8) this._$AH.p(i7);
    else {
      const t8 = new k(e8, this), s6 = t8.u(this.options);
      t8.p(i7), this.T(s6), this._$AH = t8;
    }
  }
  _$AC(t7) {
    let i7 = C.get(t7.strings);
    return void 0 === i7 && C.set(t7.strings, i7 = new S2(t7)), i7;
  }
  k(t7) {
    u2(this._$AH) || (this._$AH = [], this._$AR());
    const i7 = this._$AH;
    let s5, e8 = 0;
    for (const h4 of t7) e8 === i7.length ? i7.push(s5 = new _R(this.O(c3()), this.O(c3()), this, this.options)) : s5 = i7[e8], s5._$AI(h4), e8++;
    e8 < i7.length && (this._$AR(s5 && s5._$AB.nextSibling, e8), i7.length = e8);
  }
  _$AR(t7 = this._$AA.nextSibling, s5) {
    for (this._$AP?.(false, true, s5); t7 !== this._$AB; ) {
      const s6 = i2(t7).nextSibling;
      i2(t7).remove(), t7 = s6;
    }
  }
  setConnected(t7) {
    void 0 === this._$AM && (this._$Cv = t7, this._$AP?.(t7));
  }
};
var H = class {
  get tagName() {
    return this.element.tagName;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  constructor(t7, i7, s5, e8, h4) {
    this.type = 1, this._$AH = A, this._$AN = void 0, this.element = t7, this.name = i7, this._$AM = e8, this.options = h4, s5.length > 2 || "" !== s5[0] || "" !== s5[1] ? (this._$AH = Array(s5.length - 1).fill(new String()), this.strings = s5) : this._$AH = A;
  }
  _$AI(t7, i7 = this, s5, e8) {
    const h4 = this.strings;
    let o11 = false;
    if (void 0 === h4) t7 = M(this, t7, i7, 0), o11 = !a2(t7) || t7 !== this._$AH && t7 !== E, o11 && (this._$AH = t7);
    else {
      const e9 = t7;
      let n6, r6;
      for (t7 = h4[0], n6 = 0; n6 < h4.length - 1; n6++) r6 = M(this, e9[s5 + n6], i7, n6), r6 === E && (r6 = this._$AH[n6]), o11 ||= !a2(r6) || r6 !== this._$AH[n6], r6 === A ? t7 = A : t7 !== A && (t7 += (r6 ?? "") + h4[n6 + 1]), this._$AH[n6] = r6;
    }
    o11 && !e8 && this.j(t7);
  }
  j(t7) {
    t7 === A ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, t7 ?? "");
  }
};
var I = class extends H {
  constructor() {
    super(...arguments), this.type = 3;
  }
  j(t7) {
    this.element[this.name] = t7 === A ? void 0 : t7;
  }
};
var L = class extends H {
  constructor() {
    super(...arguments), this.type = 4;
  }
  j(t7) {
    this.element.toggleAttribute(this.name, !!t7 && t7 !== A);
  }
};
var z = class extends H {
  constructor(t7, i7, s5, e8, h4) {
    super(t7, i7, s5, e8, h4), this.type = 5;
  }
  _$AI(t7, i7 = this) {
    if ((t7 = M(this, t7, i7, 0) ?? A) === E) return;
    const s5 = this._$AH, e8 = t7 === A && s5 !== A || t7.capture !== s5.capture || t7.once !== s5.once || t7.passive !== s5.passive, h4 = t7 !== A && (s5 === A || e8);
    e8 && this.element.removeEventListener(this.name, this, s5), h4 && this.element.addEventListener(this.name, this, t7), this._$AH = t7;
  }
  handleEvent(t7) {
    "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, t7) : this._$AH.handleEvent(t7);
  }
};
var W = class {
  constructor(t7, i7, s5) {
    this.element = t7, this.type = 6, this._$AN = void 0, this._$AM = i7, this.options = s5;
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AI(t7) {
    M(this, t7);
  }
};
var Z = { I: R};
var j = t2.litHtmlPolyfillSupport;
j?.(S2, R), (t2.litHtmlVersions ??= []).push("3.3.2");
var B = (t7, i7, s5) => {
  const e8 = s5?.renderBefore ?? i7;
  let h4 = e8._$litPart$;
  if (void 0 === h4) {
    const t8 = s5?.renderBefore ?? null;
    e8._$litPart$ = h4 = new R(i7.insertBefore(c3(), t8), t8, void 0, s5 ?? {});
  }
  return h4._$AI(t7), h4;
};

// ../../node_modules/.pnpm/lit-element@4.2.2/node_modules/lit-element/lit-element.js
var s3 = globalThis;
var i3 = class extends g {
  constructor() {
    super(...arguments), this.renderOptions = { host: this }, this._$Do = void 0;
  }
  createRenderRoot() {
    const t7 = super.createRenderRoot();
    return this.renderOptions.renderBefore ??= t7.firstChild, t7;
  }
  update(t7) {
    const r6 = this.render();
    this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(t7), this._$Do = B(r6, this.renderRoot, this.renderOptions);
  }
  connectedCallback() {
    super.connectedCallback(), this._$Do?.setConnected(true);
  }
  disconnectedCallback() {
    super.disconnectedCallback(), this._$Do?.setConnected(false);
  }
  render() {
    return E;
  }
};
i3._$litElement$ = true, i3["finalized"] = true, s3.litElementHydrateSupport?.({ LitElement: i3 });
var o4 = s3.litElementPolyfillSupport;
o4?.({ LitElement: i3 });
(s3.litElementVersions ??= []).push("4.2.2");

// ../../node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/node/decorators/custom-element.js
var t3 = (t7) => (e8, o11) => {
  void 0 !== o11 ? o11.addInitializer(() => {
    customElements.define(t7, e8);
  }) : customElements.define(t7, e8);
};

// ../../node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/node/decorators/property.js
var o5 = { attribute: true, type: String, converter: b, reflect: false, hasChanged: m };
var r4 = (t7 = o5, e8, r6) => {
  const { kind: n6, metadata: i7 } = r6;
  let s5 = globalThis.litPropertyMetadata.get(i7);
  if (void 0 === s5 && globalThis.litPropertyMetadata.set(i7, s5 = /* @__PURE__ */ new Map()), "setter" === n6 && ((t7 = Object.create(t7)).wrapped = true), s5.set(r6.name, t7), "accessor" === n6) {
    const { name: o11 } = r6;
    return { set(r7) {
      const n7 = e8.get.call(this);
      e8.set.call(this, r7), this.requestUpdate(o11, n7, t7, true, r7);
    }, init(e9) {
      return void 0 !== e9 && this.C(o11, void 0, t7, e9), e9;
    } };
  }
  if ("setter" === n6) {
    const { name: o11 } = r6;
    return function(r7) {
      const n7 = this[o11];
      e8.call(this, r7), this.requestUpdate(o11, n7, t7, true, r7);
    };
  }
  throw Error("Unsupported decorator location: " + n6);
};
function n4(t7) {
  return (e8, o11) => "object" == typeof o11 ? r4(t7, e8, o11) : ((t8, e9, o12) => {
    const r6 = e9.hasOwnProperty(o12);
    return e9.constructor.createProperty(o12, t8), r6 ? Object.getOwnPropertyDescriptor(e9, o12) : void 0;
  })(t7, e8, o11);
}

// ../../node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/node/decorators/state.js
function r5(r6) {
  return n4({ ...r6, state: true, attribute: false });
}

// ../../node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/node/decorators/base.js
var e3 = (e8, t7, c5) => (c5.configurable = true, c5.enumerable = true, Reflect.decorate && "object" != typeof t7 && Object.defineProperty(e8, t7, c5), c5);

// ../../node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/node/decorators/query.js
function e4(e8, r6) {
  return (n6, s5, i7) => {
    const o11 = (t7) => t7.renderRoot?.querySelector(e8) ?? null;
    return e3(n6, s5, { get() {
      return o11(this);
    } });
  };
}

// ../../node_modules/.pnpm/@lit+reactive-element@2.1.2/node_modules/@lit/reactive-element/node/decorators/query-assigned-elements.js
function o6(o11) {
  return (e8, n6) => {
    const { slot: r6, selector: s5 } = o11 ?? {}, c5 = "slot" + (r6 ? `[name=${r6}]` : ":not([name])");
    return e3(e8, n6, { get() {
      const t7 = this.renderRoot?.querySelector(c5), e9 = t7?.assignedElements(o11) ?? [];
      return void 0 === s5 ? e9 : e9.filter((t8) => t8.matches(s5));
    } });
  };
}

// src/components/box/box.ts
var Box = class extends i3 {
  constructor() {
    super(...arguments);
    this.spacing = "m";
    this.paper = false;
    this.rounded = false;
    this.dropShadow = false;
    this.flex = false;
  }
  render() {
    return T`<div class="root"><slot></slot></div>`;
  }
};
Box.styles = i`
    :host {
      display: block;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .root {
      box-sizing: border-box;
      padding: var(--duo-space-m);
      border-radius: 0;
      background: transparent;
      color: inherit;
      align-items: inherit;
      justify-content: inherit;
      gap: inherit;
    }

    :host([paper]) .root {
      background: var(--duo-color-surface-raised);
      color: var(--duo-color-text);
    }

    :host([rounded]) .root {
      border-radius: var(--duo-border-radius-s);
    }

    :host([spacing="none"]) .root {
      padding: var(--duo-space-0);
    }

    :host([spacing="xs"]) .root {
      padding: var(--duo-space-xs);
    }

    :host([spacing="s"]) .root {
      padding: var(--duo-space-s);
    }

    :host([spacing="m"]) .root {
      padding: var(--duo-space-m);
    }

    :host([spacing="l"]) .root {
      padding: var(--duo-space-l);
    }

    :host([spacing="xl"]) .root {
      padding: var(--duo-space-xl);
    }

    :host([drop-shadow]) .root {
      box-shadow: 0 2px 2px 0 rgba(21, 21, 23, 0.04), 0 0 2px 0 rgba(21, 21, 23, 0.04);
    }

    :host([flex]) .root {
      display: flex;
    }

  `;
__decorateClass([
  n4({ type: String, reflect: true })
], Box.prototype, "spacing", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Box.prototype, "paper", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Box.prototype, "rounded", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true, attribute: "drop-shadow" })
], Box.prototype, "dropShadow", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Box.prototype, "flex", 2);
Box = __decorateClass([
  t3("duo-box")
], Box);

// ../../node_modules/.pnpm/lit-html@3.3.2/node_modules/lit-html/node/directive.js
var t4 = { ATTRIBUTE: 1, CHILD: 2};
var e5 = (t7) => (...e8) => ({ _$litDirective$: t7, values: e8 });
var i4 = class {
  constructor(t7) {
  }
  get _$AU() {
    return this._$AM._$AU;
  }
  _$AT(t7, e8, i7) {
    this._$Ct = t7, this._$AM = e8, this._$Ci = i7;
  }
  _$AS(t7, e8) {
    return this.update(t7, e8);
  }
  update(t7, e8) {
    return this.render(...e8);
  }
};

// ../../node_modules/.pnpm/lit-html@3.3.2/node_modules/lit-html/node/directives/style-map.js
var n5 = "important";
var i5 = " !" + n5;
var o7 = e5(class extends i4 {
  constructor(t7) {
    if (super(t7), t7.type !== t4.ATTRIBUTE || "style" !== t7.name || t7.strings?.length > 2) throw Error("The `styleMap` directive must be used in the `style` attribute and must be the only part in the attribute.");
  }
  render(t7) {
    return Object.keys(t7).reduce((e8, r6) => {
      const s5 = t7[r6];
      return null == s5 ? e8 : e8 + `${r6 = r6.includes("-") ? r6 : r6.replace(/(?:^(webkit|moz|ms|o)|)(?=[A-Z])/g, "-$&").toLowerCase()}:${s5};`;
    }, "");
  }
  update(e8, [r6]) {
    const { style: s5 } = e8.element;
    if (void 0 === this.ft) return this.ft = new Set(Object.keys(r6)), this.render(r6);
    for (const t7 of this.ft) null == r6[t7] && (this.ft.delete(t7), t7.includes("-") ? s5.removeProperty(t7) : s5[t7] = null);
    for (const t7 in r6) {
      const e9 = r6[t7];
      if (null != e9) {
        this.ft.add(t7);
        const r7 = "string" == typeof e9 && e9.endsWith(i5);
        t7.includes("-") || r7 ? s5.setProperty(t7, r7 ? e9.slice(0, -11) : e9, r7 ? n5 : "") : s5[t7] = e9;
      }
    }
    return E;
  }
});

// src/components/center/center.ts
var Center = class extends i3 {
  constructor() {
    super(...arguments);
    this.max = "var(--measure)";
    this.andText = false;
    this.gutters = "none";
    this.intrinsic = false;
  }
  render() {
    const rootStyles = {
      "--duo-center-max": this.max
    };
    return T`<div class="root" part="root" style=${o7(rootStyles)}><slot></slot></div>`;
  }
};
Center.styles = i`
    :host {
      display: block;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .root {
      box-sizing: content-box;
      margin-inline: auto;
      max-inline-size: var(--duo-center-max, var(--measure));
      padding-inline: var(--duo-space-0);
    }

    :host([gutters="none"]) .root {
      padding-inline: var(--duo-space-0);
    }

    :host([gutters="xxs"]) .root {
      padding-inline: var(--duo-space-xxs);
    }

    :host([gutters="xs"]) .root {
      padding-inline: var(--duo-space-xs);
    }

    :host([gutters="s"]) .root {
      padding-inline: var(--duo-space-s);
    }

    :host([gutters="m"]) .root {
      padding-inline: var(--duo-space-m);
    }

    :host([gutters="l"]) .root {
      padding-inline: var(--duo-space-l);
    }

    :host([gutters="xl"]) .root {
      padding-inline: var(--duo-space-xl);
    }

    :host([gutters="xxl"]) .root {
      padding-inline: var(--duo-space-xxl);
    }

    :host([and-text]) .root {
      text-align: center;
    }

    :host([intrinsic]) .root {
      display: flex;
      flex-direction: column;
      align-items: center;
    }

    .root > * {
      box-sizing: border-box;
      max-inline-size: 100%;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], Center.prototype, "max", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true, attribute: "and-text" })
], Center.prototype, "andText", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Center.prototype, "gutters", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Center.prototype, "intrinsic", 2);
Center = __decorateClass([
  t3("duo-center")
], Center);

// src/components/cover/cover.ts
var Cover = class extends i3 {
  constructor() {
    super(...arguments);
    this.gap = "s";
    this.spacing = "";
    this.minHeight = "100vh";
  }
  updated() {
    this.style.setProperty("--duo-cover-min-height", this.minHeight);
  }
  render() {
    return T`
      <slot name="top"></slot>
      <div class="main"><slot></slot></div>
      <slot name="bottom"></slot>
    `;
  }
};
Cover.styles = i`
    :host {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      width: 100%;
      --duo-cover-gap: var(--duo-space-s);
      --duo-cover-spacing: var(--duo-cover-gap);
      min-block-size: var(--duo-cover-min-height, 100vh);
      gap: var(--duo-cover-gap);
      padding: var(--duo-cover-spacing);
    }

    :host([hidden]) {
      display: none;
    }

    :host([spacing="none"]) {
      --duo-cover-spacing: var(--duo-space-0);
    }

    :host([spacing="xxs"]) {
      --duo-cover-spacing: var(--duo-space-xxs);
    }

    :host([spacing="xs"]) {
      --duo-cover-spacing: var(--duo-space-xs);
    }

    :host([spacing="s"]) {
      --duo-cover-spacing: var(--duo-space-s);
    }

    :host([spacing="m"]) {
      --duo-cover-spacing: var(--duo-space-m);
    }

    :host([spacing="l"]) {
      --duo-cover-spacing: var(--duo-space-l);
    }

    :host([spacing="xl"]) {
      --duo-cover-spacing: var(--duo-space-xl);
    }

    :host([spacing="xxl"]) {
      --duo-cover-spacing: var(--duo-space-xxl);
    }

    :host([gap="none"]) {
      --duo-cover-gap: var(--duo-space-0);
    }

    :host([gap="xxs"]) {
      --duo-cover-gap: var(--duo-space-xxs);
    }

    :host([gap="xs"]) {
      --duo-cover-gap: var(--duo-space-xs);
    }

    :host([gap="s"]) {
      --duo-cover-gap: var(--duo-space-s);
    }

    :host([gap="m"]) {
      --duo-cover-gap: var(--duo-space-m);
    }

    :host([gap="l"]) {
      --duo-cover-gap: var(--duo-space-l);
    }

    :host([gap="xl"]) {
      --duo-cover-gap: var(--duo-space-xl);
    }

    :host([gap="xxl"]) {
      --duo-cover-gap: var(--duo-space-xxl);
    }

    slot[name="top"],
    slot[name="bottom"] {
      display: contents;
    }

    ::slotted([slot="top"]),
    ::slotted([slot="bottom"]) {
      flex-shrink: 0;
      margin-inline: 0;
      box-sizing: border-box;
      max-inline-size: 100%;
    }

    .main {
      flex: 1 1 auto;
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-block-size: 0;
      margin-inline: 0;
      box-sizing: border-box;
      max-inline-size: 100%;
    }

    .main ::slotted(*) {
      margin-inline: 0;
      box-sizing: border-box;
      max-inline-size: 100%;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], Cover.prototype, "gap", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Cover.prototype, "spacing", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "min-height" })
], Cover.prototype, "minHeight", 2);
Cover = __decorateClass([
  t3("duo-cover")
], Cover);

// src/components/sidebar/sidebar.ts
var booleanAttribute = (defaultValue) => ({
  fromAttribute(value) {
    if (value === null) return defaultValue;
    if (value === "false" || value === "0") return false;
    return true;
  },
  toAttribute(value) {
    if (value === defaultValue) return null;
    return value ? "" : "false";
  }
});
var Sidebar = class extends i3 {
  constructor() {
    super(...arguments);
    this.side = "left";
    this.sideWidth = "";
    this.contentMin = "50%";
    this.spacing = "m";
    this.stretch = true;
  }
  render() {
    const isSideLeft = this.side === "left";
    const rawSideWidth = this.sideWidth.trim();
    const normalizedSideWidth = /^\d+(\.\d+)?$/.test(rawSideWidth) ? `${rawSideWidth}px` : rawSideWidth;
    const hasFixedSidebarWidth = Boolean(normalizedSideWidth);
    const rootStyles = {
      "--duo-sidebar-content-min": this.contentMin
    };
    if (hasFixedSidebarWidth) {
      rootStyles["--duo-sidebar-side-width"] = normalizedSideWidth;
    }
    const sidebar = T`
      <div
        class="sidebar"
        part="sidebar"
        ?data-fixed-width=${hasFixedSidebarWidth}
      >
        <slot name="sidebar"></slot>
      </div>
    `;
    const content = T`
      <div class="content" part="content">
        <slot></slot>
      </div>
    `;
    return T`
      <div
        class="root"
        part="root"
        ?data-stretch=${this.stretch}
        data-spacing=${this.spacing}
        style=${o7(rootStyles)}
      >
        ${isSideLeft ? T`${sidebar}${content}` : T`${content}${sidebar}`}
      </div>
    `;
  }
};
Sidebar.styles = i`
    :host {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }

    .root {
      display: flex;
      flex-wrap: wrap;
      box-sizing: border-box;
      align-items: flex-start;
      gap: var(--duo-space-m);
    }

    .root[data-stretch] {
      align-items: stretch;
    }

    .root[data-spacing="none"] {
      gap: var(--duo-space-0);
    }

    .root[data-spacing="xxs"] {
      gap: var(--duo-space-xxs);
    }

    .root[data-spacing="xs"] {
      gap: var(--duo-space-xs);
    }

    .root[data-spacing="s"] {
      gap: var(--duo-space-s);
    }

    .root[data-spacing="l"] {
      gap: var(--duo-space-l);
    }

    .root[data-spacing="xl"] {
      gap: var(--duo-space-xl);
    }

    .root[data-spacing="xxl"] {
      gap: var(--duo-space-xxl);
    }

    .sidebar {
      flex: 1 1 auto;
    }

    .root[data-stretch] .sidebar {
      display: flex;
      flex-direction: column;
    }

    .root[data-stretch] .sidebar ::slotted(*) {
      flex: 1 1 auto;
      min-height: 0;
    }

    .sidebar[data-fixed-width] {
      flex: 0 0 var(--duo-sidebar-side-width);
      width: var(--duo-sidebar-side-width);
      max-width: 100%;
    }

    .content {
      flex-basis: 0;
      flex-grow: 999;
      min-inline-size: min(100%, var(--duo-sidebar-content-min));
      min-width: 0;
    }

    ::slotted(*) {
      margin: 0;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], Sidebar.prototype, "side", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "side-width" })
], Sidebar.prototype, "sideWidth", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "content-min" })
], Sidebar.prototype, "contentMin", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Sidebar.prototype, "spacing", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true, converter: booleanAttribute(true) })
], Sidebar.prototype, "stretch", 2);
Sidebar = __decorateClass([
  t3("duo-sidebar")
], Sidebar);

// ../../node_modules/.pnpm/lit-html@3.3.2/node_modules/lit-html/node/directives/class-map.js
var e6 = e5(class extends i4 {
  constructor(t7) {
    if (super(t7), t7.type !== t4.ATTRIBUTE || "class" !== t7.name || t7.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
  }
  render(t7) {
    return " " + Object.keys(t7).filter((s5) => t7[s5]).join(" ") + " ";
  }
  update(s5, [i7]) {
    if (void 0 === this.st) {
      this.st = /* @__PURE__ */ new Set(), void 0 !== s5.strings && (this.nt = new Set(s5.strings.join(" ").split(/\s/).filter((t7) => "" !== t7)));
      for (const t7 in i7) i7[t7] && !this.nt?.has(t7) && this.st.add(t7);
      return this.render(i7);
    }
    const r6 = s5.element.classList;
    for (const t7 of this.st) t7 in i7 || (r6.remove(t7), this.st.delete(t7));
    for (const t7 in i7) {
      const s6 = !!i7[t7];
      s6 === this.st.has(t7) || this.nt?.has(t7) || (s6 ? (r6.add(t7), this.st.add(t7)) : (r6.remove(t7), this.st.delete(t7)));
    }
    return E;
  }
});

// ../../node_modules/.pnpm/lit-html@3.3.2/node_modules/lit-html/node/directives/if-defined.js
var o8 = (o11) => o11 ?? A;

// src/common/SlotController.ts
var SlotController = class {
  constructor(host, slotName = "") {
    this.host = host;
    this.slotName = slotName;
    this.observer = null;
    host.addController(this);
  }
  hostConnected() {
    this.observer = new MutationObserver(() => {
      this.host.requestUpdate();
    });
    this.observer.observe(this.host, {
      childList: true,
      characterData: true,
      subtree: true
    });
    this.host.requestUpdate();
  }
  hostDisconnected() {
    if (this.observer) {
      this.observer.disconnect();
      this.observer = null;
    }
  }
  get hasContent() {
    if (this.content != null) {
      return true;
    }
    if (this.slotName === "") {
      for (const node of this.host.childNodes) {
        if (node.nodeType === Node.TEXT_NODE && node.textContent?.trim()) {
          return true;
        }
      }
    }
    return false;
  }
  get isEmpty() {
    return !this.hasContent;
  }
  get content() {
    if (this.slotName) {
      for (const child of this.host.children) {
        if (this.#slotName(child) === this.slotName) {
          return child;
        }
      }
      return null;
    }
    for (const child of this.host.children) {
      if (this.#isDefaultSlotChild(child)) {
        return child;
      }
    }
    return null;
  }
  get assigned() {
    if (this.slotName) {
      return Array.from(this.host.children).filter(
        (child) => this.#slotName(child) === this.slotName
      );
    }
    return Array.from(this.host.children).filter((child) => this.#isDefaultSlotChild(child));
  }
  #slotName(element) {
    return (element.slot || element.getAttribute("slot") || "").trim();
  }
  #isDefaultSlotChild(element) {
    return !this.#slotName(element);
  }
};

// src/components/section/section.ts
var sectionTitleIdSeq = 0;
var _titleId, _Section_instances, hasHeader_fn, labelledBy_fn, renderTitleElement_fn, renderSubtitleElement_fn, renderHeader_fn;
var Section = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _Section_instances);
    this.variant = "default";
    this.titleSize = "large";
    this.title = "";
    this.subtitle = "";
    this.titleSlot = new SlotController(this, "title");
    this.subtitleSlot = new SlotController(this, "subtitle");
    this.actionsSlot = new SlotController(this, "actions");
    this.headerSlot = new SlotController(this, "header");
    __privateAdd(this, _titleId, `duo-section-title-${sectionTitleIdSeq++}`);
  }
  render() {
    const hasHeader = __privateMethod(this, _Section_instances, hasHeader_fn).call(this);
    const labelledBy = __privateMethod(this, _Section_instances, labelledBy_fn).call(this);
    return T`
      <section
        class="root"
        part="root"
        aria-labelledby=${o8(labelledBy)}
      >
        ${__privateMethod(this, _Section_instances, renderHeader_fn).call(this)}
        <div class=${e6({ body: true, "has-header": hasHeader })} part="body">
          <slot></slot>
        </div>
      </section>
    `;
  }
};
_titleId = new WeakMap();
_Section_instances = new WeakSet();
hasHeader_fn = function() {
  return this.headerSlot.hasContent || this.titleSlot.hasContent || this.subtitleSlot.hasContent || Boolean(this.title.trim()) || Boolean(this.subtitle.trim()) || this.actionsSlot.hasContent;
};
labelledBy_fn = function() {
  if (this.headerSlot.hasContent || this.titleSlot.hasContent) return void 0;
  if (this.title.trim()) return __privateGet(this, _titleId);
  return void 0;
};
renderTitleElement_fn = function() {
  if (this.titleSlot.hasContent) {
    return T`<div class="title" part="title">
        <slot name="title"></slot>
      </div>`;
  }
  if (!this.title.trim()) return A;
  return T`<h3 id=${__privateGet(this, _titleId)} class="title" part="title">${this.title}</h3>`;
};
renderSubtitleElement_fn = function() {
  if (this.subtitleSlot.hasContent) {
    return T`<div class="subtitle" part="subtitle">
        <slot name="subtitle"></slot>
      </div>`;
  }
  if (!this.subtitle.trim()) return A;
  return T`<p class="subtitle" part="subtitle">${this.subtitle}</p>`;
};
renderHeader_fn = function() {
  if (this.headerSlot.hasContent) {
    return T`<slot name="header"></slot>`;
  }
  const hasTitle = this.titleSlot.hasContent || Boolean(this.title.trim());
  const hasSubtitle = this.subtitleSlot.hasContent || Boolean(this.subtitle.trim());
  const hasActions = this.actionsSlot.hasContent;
  if (!hasTitle && !hasSubtitle && !hasActions) {
    return A;
  }
  const title = __privateMethod(this, _Section_instances, renderTitleElement_fn).call(this);
  const subtitle = __privateMethod(this, _Section_instances, renderSubtitleElement_fn).call(this);
  return T`
      <header class="header" part="header">
        <div class="header-text" part="header-text">
          ${title} ${subtitle}
        </div>
        ${this.actionsSlot.hasContent ? T`<div class="actions" part="actions">
              <slot name="actions"></slot>
            </div>` : A}
      </header>
    `;
};
Section.styles = i`
    :host {
      display: block;
      box-sizing: border-box;
      --duo-section-padding-inline: var(--duo-space-l);
      --duo-section-padding-block: var(--duo-space-l);
      --duo-section-padding-gap: var(--duo-space-s);
      --duo-section-title-font: var(--duo-font-xl);
    }

    :host([title-size="medium"]) {
      --duo-section-title-font: var(--duo-font-l);
    }

    :host([title-size="small"]) {
      --duo-section-title-font: var(--duo-font-m);
    }

    :host([hidden]) {
      display: none;
    }

    .root {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      overflow: visible;
      color: var(--duo-color-text);
    }

    :host([variant="raised"]) .root,
    :host([variant="outline"]) .root {
      border-radius: var(--duo-border-radius-m);
    }

    :host([variant="raised"]) .root {
      background-color: var(--duo-color-surface-raised);
    }

    :host([variant="outline"]) .root {
      border: 1px solid var(--duo-color-border);
    }

    .header {
      display: flex;
      align-items: flex-start;
      gap: var(--duo-space-xl);
      box-sizing: border-box;
    }

    :host([variant="raised"]) .header,
    :host([variant="outline"]) .header {
      padding-inline: var(--duo-section-padding-inline);
      padding-top: var(--duo-section-padding-block);
      padding-bottom: var(--duo-section-padding-gap);
    }

    .header-text {
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 0;
    }

    .title {
      margin: 0;
      font: var(--duo-section-title-font);
      color: var(--duo-color-text);
    }

    .title ::slotted(*) {
      margin: 0;
      max-width: 100%;
      /* Light-DOM heading rules beat ::slotted without !important (see duo-poster). */
      font: var(--duo-section-title-font) !important;
      color: var(--duo-color-text);
    }

    .subtitle {
      margin: 0;
      font: var(--duo-font-body);
      color: var(--duo-color-text-weak);
    }

    .subtitle ::slotted(*) {
      margin: 0;
      max-width: 100%;
    }

    .subtitle ::slotted(p) {
      font: var(--duo-font-body);
      color: var(--duo-color-text-weak);
    }

    .actions {
      display: flex;
      flex-shrink: 0;
      align-items: flex-start;
    }

    .body {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
    }

    :host([variant="raised"]) .body,
    :host([variant="outline"]) .body {
      padding: var(--duo-section-padding-block) var(--duo-section-padding-inline);
    }

    :host([variant="raised"]) .body.has-header,
    :host([variant="outline"]) .body.has-header {
      padding-top: 0;
    }

    .body ::slotted(*) {
      max-width: 100%;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], Section.prototype, "variant", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "title-size" })
], Section.prototype, "titleSize", 2);
__decorateClass([
  n4({ type: String })
], Section.prototype, "title", 2);
__decorateClass([
  n4({ type: String })
], Section.prototype, "subtitle", 2);
Section = __decorateClass([
  t3("duo-section")
], Section);

// src/components/stack/stack.ts
var Stack = class extends i3 {
  constructor() {
    super(...arguments);
    this.direction = "vertical";
    this.spacing = "m";
    this.align = "stretch";
    this.justify = "start";
  }
  render() {
    return T`<slot></slot>`;
  }
};
Stack.styles = i`
    :host {
      display: flex;
      width: 100%;
      box-sizing: border-box;
      gap: 0;
      flex-direction: column;
      align-items: stretch;
      justify-content: flex-start;
    }

    :host([hidden]) {
      display: none;
    }

    :host([direction="horizontal"]) {
      flex-direction: row;
    }

    :host([align="start"]) {
      align-items: flex-start;
    }

    :host([align="center"]) {
      align-items: center;
    }

    :host([align="end"]) {
      align-items: flex-end;
    }

    :host([align="stretch"]) {
      align-items: stretch;
    }

    :host([justify="start"]) {
      justify-content: flex-start;
    }

    :host([justify="center"]) {
      justify-content: center;
    }

    :host([justify="end"]) {
      justify-content: flex-end;
    }

    :host([justify="between"]) {
      justify-content: space-between;
    }

    :host([spacing="none"]) {
      gap: var(--duo-space-0);
    }

    :host([spacing="xxs"]) {
      gap: var(--duo-space-xxs);
    }

    :host([spacing="xs"]) {
      gap: var(--duo-space-xs);
    }

    :host([spacing="s"]) {
      gap: var(--duo-space-s);
    }

    :host([spacing="m"]) {
      gap: var(--duo-space-m);
    }

    :host([spacing="l"]) {
      gap: var(--duo-space-l);
    }

    :host([spacing="xl"]) {
      gap: var(--duo-space-xl);
    }

    :host([spacing="xxl"]) {
      gap: var(--duo-space-xxl);
    }

    ::slotted(*) {
      margin: 0;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], Stack.prototype, "direction", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Stack.prototype, "spacing", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Stack.prototype, "align", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Stack.prototype, "justify", 2);
Stack = __decorateClass([
  t3("duo-stack")
], Stack);

// src/components/field/field.ts
var RAW_CONTROL_SELECTOR = 'input:not([type="hidden"]):not([type="submit"]):not([type="button"]), textarea, select';
function isCheckboxOrRadio(el) {
  const t7 = el.type;
  return t7 === "checkbox" || t7 === "radio";
}
function addClasses(el, ...classes) {
  for (const c5 of classes) {
    if (c5) el.classList.add(c5);
  }
}
var Field = class extends i3 {
  constructor() {
    super(...arguments);
    this.invalid = false;
    this.disabled = false;
    this.required = false;
    this._enhanceScheduled = false;
    this._hostForcedDisabled = /* @__PURE__ */ new Set();
    this._disabledBaseline = /* @__PURE__ */ new WeakMap();
    this._customHostForcedDisabled = /* @__PURE__ */ new Set();
    this._customDisabledBaseline = /* @__PURE__ */ new WeakMap();
    this._primaryRequiredForced = null;
    this._requiredBaseline = /* @__PURE__ */ new WeakMap();
    this._onSlotChange = () => {
      this._enhance();
      this._syncStateFromHost();
    };
  }
  connectedCallback() {
    super.connectedCallback();
    this._observer = new MutationObserver(() => this._scheduleEnhance());
    this._observer.observe(this, { childList: true, subtree: false });
  }
  disconnectedCallback() {
    this._observer?.disconnect();
    super.disconnectedCallback();
  }
  firstUpdated() {
    this._enhance();
    this._syncStateFromHost();
  }
  updated(changed) {
    if (changed.has("invalid") || changed.has("disabled") || changed.has("required")) {
      this._syncStateFromHost();
    }
  }
  render() {
    return T`<slot @slotchange=${this._onSlotChange}></slot>`;
  }
  _scheduleEnhance() {
    if (this._enhanceScheduled) return;
    this._enhanceScheduled = true;
    queueMicrotask(() => {
      this._enhanceScheduled = false;
      this._enhance();
      this._syncStateFromHost();
    });
  }
  _enhance() {
    const slot = this.renderRoot.querySelector("slot");
    if (!slot || !(slot instanceof HTMLSlotElement)) return;
    const elements = slot.assignedElements({ flatten: false });
    let hasCheckboxOrRadio = false;
    for (const el of elements) {
      if (el.matches("input")) {
        const inp = el;
        if (isCheckboxOrRadio(inp)) {
          hasCheckboxOrRadio = true;
          break;
        }
      }
    }
    const firstControlIndex = this._findFirstControlIndex(elements);
    for (let i7 = 0; i7 < elements.length; i7++) {
      const el = elements[i7];
      if (el.matches("label")) {
        addClasses(el, "duo-field__label");
        if (hasCheckboxOrRadio) {
          addClasses(el, "duo-field__label--checkbox");
        }
        continue;
      }
      if (el.matches(RAW_CONTROL_SELECTOR)) {
        const input = el;
        if (el.matches("input") && isCheckboxOrRadio(input)) {
          addClasses(input, input.type === "checkbox" ? "duo-field__checkbox" : "duo-field__radio");
        } else {
          addClasses(el, "duo-field__control");
        }
        continue;
      }
      if (el.matches("p, small")) {
        this._classifyHelperText(el, i7, firstControlIndex);
      }
    }
    this.classList.toggle("duo-field--checkbox", hasCheckboxOrRadio);
    this._enhanceParentFieldset();
  }
  /** Borderless fieldset groups containing `duo-field` controls (see `forms.css`). */
  _enhanceParentFieldset() {
    const fieldset = this.closest("fieldset");
    if (!fieldset) return;
    fieldset.classList.add("duo-fieldset");
    const legend = fieldset.querySelector("legend");
    if (legend) {
      legend.classList.add("duo-fieldset__legend");
    }
  }
  _findFirstControlIndex(elements) {
    for (let i7 = 0; i7 < elements.length; i7++) {
      const el = elements[i7];
      if (el.matches("textarea, select")) return i7;
      if (el.matches("input")) {
        const inp = el;
        const t7 = inp.type;
        if (t7 === "hidden" || t7 === "submit" || t7 === "button") continue;
        return i7;
      }
    }
    return -1;
  }
  _classifyHelperText(el, index, controlIndex) {
    if (el.classList.contains("duo-field__hint") || el.classList.contains("duo-field__error") || el.classList.contains("duo-field__description")) {
      return;
    }
    const id = el.getAttribute("id") ?? "";
    const idLower = id.toLowerCase();
    if (el.getAttribute("role") === "alert" || idLower.includes("error")) {
      addClasses(el, "duo-field__error");
      return;
    }
    if (idLower.includes("hint")) {
      addClasses(el, "duo-field__hint");
      return;
    }
    if (idLower.includes("description") || idLower.includes("desc")) {
      addClasses(el, "duo-field__description");
      return;
    }
    if (controlIndex >= 0) {
      if (index < controlIndex) {
        addClasses(el, "duo-field__description");
      } else {
        addClasses(el, "duo-field__hint");
      }
    } else {
      addClasses(el, "duo-field__description");
    }
  }
  _syncStateFromHost() {
    const slot = this.renderRoot.querySelector("slot");
    if (!slot || !(slot instanceof HTMLSlotElement)) return;
    const elements = slot.assignedElements({ flatten: false });
    const controls = this._collectDirectControls(elements);
    const seen = /* @__PURE__ */ new Set();
    const unique = controls.filter((c5) => {
      if (seen.has(c5)) return false;
      seen.add(c5);
      return true;
    });
    if (this.disabled) {
      for (const c5 of unique) {
        if (!this._hostForcedDisabled.has(c5)) {
          this._disabledBaseline.set(c5, c5.disabled);
        }
        c5.disabled = true;
        this._hostForcedDisabled.add(c5);
      }
    } else {
      for (const c5 of this._hostForcedDisabled) {
        if (c5.isConnected) {
          c5.disabled = this._disabledBaseline.get(c5) ?? false;
        }
        this._disabledBaseline.delete(c5);
      }
      this._hostForcedDisabled.clear();
    }
    const primary = unique.find((c5) => {
      if (c5 instanceof HTMLInputElement && isCheckboxOrRadio(c5)) return false;
      return true;
    });
    if (this.required && primary) {
      if (this._primaryRequiredForced !== primary) {
        if (this._primaryRequiredForced?.isConnected) {
          const prev = this._primaryRequiredForced;
          prev.required = this._requiredBaseline.get(prev) ?? false;
          this._requiredBaseline.delete(prev);
        }
        this._requiredBaseline.set(primary, primary.required);
        this._primaryRequiredForced = primary;
      }
      primary.required = true;
    } else {
      if (this._primaryRequiredForced?.isConnected) {
        const prev = this._primaryRequiredForced;
        prev.required = this._requiredBaseline.get(prev) ?? false;
        this._requiredBaseline.delete(prev);
      }
      this._primaryRequiredForced = null;
    }
    this._syncDisabledToSlottedCustomControls(elements);
    this._syncInvalidToSlottedCustomControls(elements);
  }
  /** Native controls are handled above; this targets custom elements (e.g. `duo-file-input`) with a `disabled` property. */
  _syncDisabledToSlottedCustomControls(elements) {
    if (this.disabled) {
      for (const el of elements) {
        if (!(el instanceof HTMLElement)) continue;
        if (el.matches(RAW_CONTROL_SELECTOR)) continue;
        if (!("disabled" in el)) continue;
        const node = el;
        if (typeof node.disabled !== "boolean") continue;
        if (!this._customHostForcedDisabled.has(node)) {
          this._customDisabledBaseline.set(node, node.disabled);
        }
        node.disabled = true;
        this._customHostForcedDisabled.add(node);
      }
    } else {
      for (const node of this._customHostForcedDisabled) {
        const el = node;
        if (node.isConnected) {
          el.disabled = this._customDisabledBaseline.get(node) ?? false;
        }
        this._customDisabledBaseline.delete(node);
      }
      this._customHostForcedDisabled.clear();
    }
  }
  /** Native invalid chrome uses `::slotted(.duo-field__control)`; custom composites use their own `invalid` property. */
  _syncInvalidToSlottedCustomControls(elements) {
    for (const el of elements) {
      if (!(el instanceof HTMLElement)) continue;
      if (el.matches(RAW_CONTROL_SELECTOR)) continue;
      if (!("invalid" in el)) continue;
      const node = el;
      node.invalid = this.invalid;
    }
  }
  _collectDirectControls(elements) {
    const out = [];
    for (const el of elements) {
      if (!el.matches(RAW_CONTROL_SELECTOR)) continue;
      const node = el;
      if (node instanceof HTMLInputElement || node instanceof HTMLTextAreaElement || node instanceof HTMLSelectElement) {
        out.push(node);
      }
    }
    return out;
  }
};
Field.styles = i`
    :host {
      display: flex;
      flex-direction: column;
      gap: var(--duo-space-xs);
      margin-block-end: 0;
      max-width: none;
      box-sizing: border-box;
    }

    :host(.duo-field--checkbox) {
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
      gap: var(--duo-space-xs);
      max-width: none;
    }

    :host(.duo-field--checkbox) ::slotted(p),
    :host(.duo-field--checkbox) ::slotted(small) {
      flex-basis: 100%;
    }

    :host([hidden]) {
      display: none;
    }

    slot {
      display: contents;
    }

    ::slotted(label.duo-field__label) {
      color: var(--duo-color-text-weak);
      font-feature-settings: "liga" off, "clig" off;
      font: normal 600 0.75rem/1rem var(--duo-font-family-body);
      text-transform: uppercase;
    }

    ::slotted(.duo-field__required) {
      color: var(--duo-color-accent);
      font-weight: var(--duo-font-weight-bold);
    }

    ::slotted(.duo-field__description) {
      margin: 0;
      font: var(--duo-font-s);
      color: var(--duo-color-text-weakest);
    }

    ::slotted(.duo-field__hint) {
      margin: 0;
      color: var(--duo-color-text-weakest);
      font-feature-settings: "liga" off, "clig" off;
      font: var(--duo-font-xs);
    }

    ::slotted(.duo-field__error) {
      margin: 0;
      font: var(--duo-font-xs);
      color: var(--duo-color-text-feedback-negative);
    }

    ::slotted(.duo-field__error)[hidden] {
      display: none !important;
    }

    ::slotted(.duo-field__control) {
      width: 100%;
      min-height: 36px;
      margin: 0;
      font: var(--duo-font-body);
      color: var(--duo-color-text-weak);
      background-color: var(--duo-color-surface);
      border: 1px solid var(--duo-color-border);
      border-radius: var(--duo-border-radius-s);
      padding: var(--duo-space-s);
      transition:
        border-color 0.15s ease,
        box-shadow 0.15s ease;
    }

    ::slotted(.duo-field__control)::placeholder {
      color: var(--duo-color-text-disabled);
      opacity: 1;
    }

    ::slotted(.duo-field__control):hover {
      border-color: var(--duo-color-border-strong);
    }

    ::slotted(.duo-field__control):focus-visible {
      outline: none;
      border-color: var(--duo-color-border);
      box-shadow: var(--duo-box-shadow-input-focus);
    }

    ::slotted(.duo-field__control):disabled {
      opacity: 0.65;
      cursor: not-allowed;
      background-color: var(--duo-color-surface);
    }

    ::slotted(textarea.duo-field__control) {
      min-height: 6.5rem;
      resize: vertical;
    }

    ::slotted(select.duo-field__control) {
      cursor: pointer;
      appearance: none;
      -webkit-appearance: none;
      -moz-appearance: none;
      padding-inline-end: calc(var(--duo-space-s) + 14px + var(--duo-space-xs));
      background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2214%22%20height%3D%229%22%20viewBox%3D%220%200%2014%209%22%20fill%3D%22none%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M6.75%206.16659L11.6072%200.384197C12%20-0.0833933%2012.6823%20-0.130775%2013.1312%200.278366C13.5801%200.687508%2013.6255%201.39824%2013.2328%201.86583L7.56278%208.61582C7.1325%209.12806%206.3675%209.12806%205.93722%208.61582L0.267231%201.86583C-0.125544%201.39824%20-0.0800576%200.687508%200.368829%200.278366C0.817716%20-0.130775%201.50002%20-0.0833933%201.89279%200.384197L6.75%206.16659Z%22%20fill%3D%22%2326253E%22%2F%3E%3C%2Fsvg%3E");
      background-repeat: no-repeat;
      background-position: right var(--duo-space-s) center;
      background-size: 14px 9px;
    }

    ::slotted(select.duo-field__control)::-ms-expand {
      display: none;
    }

    :host([invalid]) ::slotted(.duo-field__control) {
      border-color: var(--duo-color-red-900);
    }

    :host([invalid]) ::slotted(.duo-field__control):focus-visible {
      box-shadow: 0 0 0 0.25rem color-mix(in srgb, var(--duo-color-red-700) 55%, transparent);
    }

    ::slotted(label.duo-field__label--checkbox) {
      display: block;
      box-sizing: border-box;
      flex: 1 1 0;
      min-width: 0;
      font-family: var(--duo-font-family-body), Helvetica, sans-serif;
      font-size: 1rem;
      font-weight: var(--duo-font-weight-regular);
      line-height: 1.5rem;
      font-feature-settings: "liga" off, "clig" off;
      color: var(--duo-color-text-weakest);
      cursor: pointer;
      text-transform: none;
    }

    ::slotted(.duo-field__checkbox) {
      appearance: none;
      -webkit-appearance: none;
      flex-shrink: 0;
      width: 1.25rem;
      height: 1.25rem;
      margin: 0;
      box-sizing: border-box;
      border: 1px solid var(--duo-color-border);
      border-radius: var(--duo-border-radius-xs);
      background-color: var(--duo-color-surface);
      cursor: pointer;
      vertical-align: top;
    }

    ::slotted(.duo-field__checkbox):checked {
      border-color: var(--duo-color-accent);
      background-color: var(--duo-color-accent);
      background-image: url("data:image/svg+xml,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2210%22%20height%3D%2210%22%20viewBox%3D%220%200%2010%2010%22%20fill%3D%22none%22%3E%3Cpath%20fill-rule%3D%22evenodd%22%20clip-rule%3D%22evenodd%22%20d%3D%22M4.98922%207.67719C4.64622%208.07732%204.05156%208.14257%203.62996%207.82635L0.916632%205.79121C0.594339%205.54985%200.529443%205.09266%200.770798%204.77037C1.01215%204.44954%201.46861%204.38245%201.79164%204.62454L4.16144%206.40225L8.09166%201.8165C8.35417%201.51171%208.815%201.47598%209.11979%201.73775C9.42605%201.99952%209.46177%202.46036%209.19927%202.76588L4.98922%207.67719Z%22%20fill%3D%22white%22%2F%3E%3C%2Fsvg%3E");
      background-repeat: no-repeat;
      background-position: center;
      background-size: 14px 14px;
    }

    ::slotted(.duo-field__checkbox):focus-visible {
      outline: none;
      box-shadow: var(--duo-box-shadow-input-focus);
    }

    ::slotted(.duo-field__checkbox):disabled {
      opacity: 0.65;
      cursor: not-allowed;
    }

    ::slotted(.duo-field__radio) {
      appearance: none;
      -webkit-appearance: none;
      flex-shrink: 0;
      width: 1.25rem;
      height: 1.25rem;
      margin: 0;
      box-sizing: border-box;
      border: 1px solid var(--duo-color-border);
      border-radius: 50%;
      background-color: var(--duo-color-surface);
      cursor: pointer;
      vertical-align: top;
    }

    ::slotted(.duo-field__radio):checked {
      border-color: var(--duo-color-accent);
      background-color: var(--duo-color-surface);
      box-shadow: inset 0 0 0 4px var(--duo-color-accent);
    }

    ::slotted(.duo-field__radio):focus-visible {
      outline: 2px solid var(--duo-color-accent);
    }

   

    ::slotted(.duo-field__radio):disabled {
      opacity: 0.65;
      cursor: not-allowed;
    }

    :host([disabled]) ::slotted(.duo-field__control),
    :host([disabled]) ::slotted(.duo-field__checkbox),
    :host([disabled]) ::slotted(.duo-field__radio) {
      opacity: 0.65;
      cursor: not-allowed;
      background-color: var(--duo-color-surface);
    }

    :host([disabled]) ::slotted(.duo-field__checkbox):checked,
    :host([disabled]) ::slotted(.duo-field__radio):checked {
      opacity: 0.65;
    }
  `;
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Field.prototype, "invalid", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Field.prototype, "disabled", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Field.prototype, "required", 2);
Field = __decorateClass([
  t3("duo-field")
], Field);

// src/components/file-input/file-input.ts
var _idSeq = 0;
function nextFallbackId() {
  _idSeq += 1;
  return `duo-file-input-${_idSeq}`;
}
function dispatchStateInput(target, state) {
  target.dispatchEvent(
    new CustomEvent("input", {
      bubbles: true,
      composed: true,
      detail: { name: state.name, file: state.file ?? null }
    })
  );
}
var FileInput = class extends i3 {
  constructor() {
    super();
    this.invalid = false;
    this.readOnly = false;
    this.disabled = false;
    this.labelFile = "File";
    this.labelBrowse = "Browse";
    this.labelClear = "Clear";
    this.accept = "";
    this.name = "";
    this.placeholder = "";
    this.ariaLabel = "";
    this.ariaLabelledby = "";
    this.ariaDescribedby = "";
    this.fileName = "";
    this._baseId = "";
    /** Selected file; not reflected as an attribute. */
    this._file = null;
    this._internals = typeof this.attachInternals === "function" ? this.attachInternals() : { setFormValue: () => {
    } };
  }
  connectedCallback() {
    super.connectedCallback();
    this._baseId = this.id && this.id.trim() || nextFallbackId();
    if (!this.id) {
      this.id = this._baseId;
    }
    this._syncFormValue();
  }
  formResetCallback() {
    this._applyState({ name: "", file: null }, false);
  }
  /** Display name and selected file (`DuoFileInputState`). */
  get value() {
    return { name: this.fileName, file: this._file };
  }
  set value(next) {
    if (!next) return;
    this._applyState(
      {
        name: next.name ?? "",
        file: next.file === void 0 || next.file === null ? null : next.file
      },
      false
    );
  }
  willUpdate(changed) {
    if (changed.has("id") && this.id && this.id.trim()) {
      this._baseId = this.id.trim();
    }
  }
  _idFile() {
    return `${this._baseId}--fileInput`;
  }
  _idText() {
    return `${this._baseId}--textField`;
  }
  _state() {
    return { name: this.fileName, file: this._file };
  }
  _syncFormValue() {
    this._internals.setFormValue(this._file);
  }
  _emitState(state) {
    dispatchStateInput(this, state);
  }
  _applyState(next, dispatch) {
    const name = next.name ?? "";
    const file = next.file === void 0 || next.file === null ? null : next.file;
    this.fileName = name;
    this._file = file;
    this._syncFormValue();
    if (dispatch) {
      this._emitState(this._state());
    }
  }
  _onNativeFileChange(e8) {
    const input = e8.target;
    const picked = input.files?.item(0) ?? null;
    if (picked) {
      this._applyState({ name: picked.name, file: picked }, true);
    }
    input.value = "";
  }
  _onFilenameInput(e8) {
    if (this.readOnly || this.disabled) return;
    const input = e8.target;
    this.fileName = input.value;
    this._emitState(this._state());
  }
  _onClear() {
    if (this.readOnly || this.disabled) return;
    const fileEl = this.shadowRoot?.getElementById(this._idFile());
    if (fileEl) fileEl.value = "";
    this._applyState({ name: "", file: null }, true);
  }
  render() {
    const showClear = !this.readOnly && !this.disabled && this._file !== null;
    const showBrowse = !this.readOnly && !this.disabled;
    return T`
      <input
        id=${this._idFile()}
        type="file"
        hidden
        ?disabled=${this.disabled}
        accept=${this.accept || A}
        @change=${this._onNativeFileChange}
      />
      <div
        class="row"
        role="group"
        aria-label=${o8(this.ariaLabel || void 0)}
        aria-labelledby=${o8(this.ariaLabelledby || void 0)}
        aria-describedby=${o8(this.ariaDescribedby || void 0)}
        aria-disabled=${this.disabled ? "true" : void 0}
        aria-invalid=${this.invalid ? "true" : void 0}
      >
        <div class="prefix">
          <label for=${this._idText()}>${this.labelFile}</label>
        </div>
        <input
          id=${this._idText()}
          class="filename"
          type="text"
          autocomplete="off"
          .value=${this.fileName}
          placeholder=${this.placeholder || ""}
          ?readonly=${this.readOnly}
          ?disabled=${this.disabled}
          aria-invalid=${this.invalid ? "true" : void 0}
          @input=${this._onFilenameInput}
        />
        ${showClear ? T`
              <button type="button" class="action" @click=${this._onClear}>${this.labelClear}</button>
            ` : A}
        ${showBrowse ? T`
              <label class="action" for=${this._idFile()}>${this.labelBrowse}</label>
            ` : A}
      </div>
    `;
  }
};
FileInput.formAssociated = true;
FileInput.styles = i`
    :host {
      display: block;
      box-sizing: border-box;
      max-inline-size: 100%;
    }

    :host([hidden]) {
      display: none;
    }

    .row {
      display: flex;
      flex-direction: row;
      align-items: stretch;
      box-sizing: border-box;
      flex: 1 1 auto;
      min-inline-size: 0;
      inline-size: 100%;
      min-block-size: calc(var(--duo-space-l) + var(--duo-space-m));
      border: 1px solid var(--duo-color-border);
      border-radius: var(--duo-border-radius-s);
      background-color: var(--duo-color-surface);
      overflow: visible;
    }

    .row > .prefix {
      border-start-start-radius: var(--duo-border-radius-s);
      border-end-start-radius: var(--duo-border-radius-s);
    }

    .row > :last-child {
      border-start-end-radius: var(--duo-border-radius-s);
      border-end-end-radius: var(--duo-border-radius-s);
    }

    :host([invalid]) .row {
      border-color: var(--duo-color-red-900);
    }

    .prefix {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-inline: var(--duo-space-s);
      background-color: var(--duo-color-surface);
      border-inline-end: 1px solid var(--duo-color-border);
      font: var(--duo-font-body);
      font-weight: var(--duo-font-weight-regular);
      color: var(--duo-color-text-weak);
      cursor: default;
      box-sizing: border-box;
      min-inline-size: var(--duo-space-xl);
    }

    .prefix label {
      cursor: inherit;
      margin: 0;
    }

    .filename {
      flex: 1 1 auto;
      min-inline-size: 0;
      border: none;
      margin: 0;
      padding-inline: var(--duo-space-s);
      font: var(--duo-font-body);
      color: var(--duo-color-text-strong);
      background-color: var(--duo-color-surface);
      outline: none;
      box-sizing: border-box;
      position: relative;
      z-index: 0;
    }

    .filename:read-only {
      cursor: default;
    }

    .filename::placeholder {
      color: var(--duo-color-text-disabled);
      opacity: 1;
    }

    .filename:is(:hover, :focus-visible):not(:disabled) {
      outline: none;
      
      box-shadow: 0 0 0 1px var(--duo-color-border-strong);
      z-index: 1;
    }

    :host([invalid]) .filename:is(:hover, :focus-visible):not(:disabled) {
      box-shadow: 0 0 0 0.25rem color-mix(in srgb, var(--duo-color-red-700) 55%, transparent);
    }

    .action {
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      padding-inline: var(--duo-space-s);
      border-inline-start: 1px solid var(--duo-color-border);
      font: var(--duo-font-body);
      color: var(--duo-color-text);
      background-color: var(--duo-color-background);
      box-sizing: border-box;
      cursor: pointer;
      user-select: none;
      position: relative;
      z-index: 0;
    }

    :host(:not([disabled])) .action:hover {
      filter: brightness(97%);
    }

    :host(:not([disabled])) .action:focus-visible {
      outline: none;
      box-shadow: 0 0 0 0.25rem var(--duo-color-purple-400);
      z-index: 1;
    }

    :host([invalid]:not([disabled])) .action:focus-visible {
      box-shadow: 0 0 0 0.25rem color-mix(in srgb, var(--duo-color-red-700) 55%, transparent);
    }

    .action:disabled,
    .action[aria-disabled="true"] {
      opacity: 0.65;
      cursor: not-allowed;
    }

    button.action {
      border: 0 solid transparent;
      border-inline-start: 1px solid var(--duo-color-border);
      font: inherit;
    }

    label.action {
      margin: 0;
    }
  `;
__decorateClass([
  n4({ type: Boolean, reflect: true })
], FileInput.prototype, "invalid", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], FileInput.prototype, "readOnly", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], FileInput.prototype, "disabled", 2);
__decorateClass([
  n4({ type: String, attribute: "label-file" })
], FileInput.prototype, "labelFile", 2);
__decorateClass([
  n4({ type: String, attribute: "label-browse" })
], FileInput.prototype, "labelBrowse", 2);
__decorateClass([
  n4({ type: String, attribute: "label-clear" })
], FileInput.prototype, "labelClear", 2);
__decorateClass([
  n4({ type: String })
], FileInput.prototype, "accept", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], FileInput.prototype, "name", 2);
__decorateClass([
  n4({ type: String })
], FileInput.prototype, "placeholder", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-label" })
], FileInput.prototype, "ariaLabel", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-labelledby" })
], FileInput.prototype, "ariaLabelledby", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-describedby" })
], FileInput.prototype, "ariaDescribedby", 2);
__decorateClass([
  n4({ type: String })
], FileInput.prototype, "fileName", 2);
FileInput = __decorateClass([
  t3("duo-file-input")
], FileInput);

// ../locales/src/da.json
var da_default = {
  otpInput: {
    digitCellAriaLabel: "{{index}} af {{count}}",
    digitCellAriaLabelWithGroupName: "{{groupName}}, digit {{index}} af {{count}}"
  },
  brandAttribution: {
    label: "Leveret af",
    accessibleLabel: "Leveret af Talentech",
    linkAccessibleLabel: "Leveret af Talentech. G\xE5 til vores website"
  }
};

// ../locales/src/de.json
var de_default = {
  otpInput: {
    digitCellAriaLabel: "Ziffer {{index}} von {{count}}",
    digitCellAriaLabelWithGroupName: "{{groupName}}, Ziffer {{index}} von {{count}}"
  },
  brandAttribution: {
    label: "Unterst\xFCtzt von",
    accessibleLabel: "Unterst\xFCtzt von Talentech",
    linkAccessibleLabel: "Unterst\xFCtzt von Talentech. Zur Website"
  }
};

// ../locales/src/en.json
var en_default = {
  otpInput: {
    digitCellAriaLabel: "Digit {{index}} of {{count}}",
    digitCellAriaLabelWithGroupName: "{{groupName}}, digit {{index}} of {{count}}"
  },
  brandAttribution: {
    label: "Powered by",
    accessibleLabel: "Powered by Talentech",
    linkAccessibleLabel: "Powered by Talentech. Go to our website"
  }
};

// ../locales/src/fi.json
var fi_default = {
  otpInput: {
    digitCellAriaLabel: "Merkki {{index}} / {{count}}",
    digitCellAriaLabelWithGroupName: "{{groupName}}, merkki {{index}} / {{count}}"
  },
  brandAttribution: {
    label: "Palvelun tarjoaa",
    accessibleLabel: "Palvelun tarjoaa Talentech",
    linkAccessibleLabel: "Palvelun tarjoaa Talentech. Siirry verkkosivuillemme"
  }
};

// ../locales/src/fr.json
var fr_default = {
  otpInput: {
    digitCellAriaLabel: "Num\xE9rotation {{index}} de {{count}}",
    digitCellAriaLabelWithGroupName: "{{groupName}}, digit {{index}} of {{count}}"
  },
  brandAttribution: {
    label: "Propuls\xE9 par",
    accessibleLabel: "Propuls\xE9 par Talentech",
    linkAccessibleLabel: "Propuls\xE9 par Talentech. Acc\xE9der \xE0 notre site"
  }
};

// ../locales/src/nb.json
var nb_default = {
  otpInput: {
    digitCellAriaLabel: "siffer {{index}} av {{count}}",
    digitCellAriaLabelWithGroupName: "{{groupName}}, sifret {{index}} av {{count}}"
  },
  brandAttribution: {
    label: "Drives av",
    accessibleLabel: "Drives av Talentech",
    linkAccessibleLabel: "Drives av Talentech. G\xE5 til nettstedet v\xE5rt"
  }
};

// ../locales/src/nl.json
var nl_default = {
  otpInput: {
    digitCellAriaLabel: "Digit {{index}} van {{count}}",
    digitCellAriaLabelWithGroupName: "{{groupName}}, cijfer {{index}} van {{count}}"
  },
  brandAttribution: {
    label: "Mogelijk gemaakt door",
    accessibleLabel: "Mogelijk gemaakt door Talentech",
    linkAccessibleLabel: "Mogelijk gemaakt door Talentech. Ga naar onze website"
  }
};

// ../locales/src/nn.json
var nn_default = {
  otpInput: {
    digitCellAriaLabel: "Digit {{index}} of {{count}}",
    digitCellAriaLabelWithGroupName: "{{groupName}}, digit {{index}} of {{count}}"
  },
  brandAttribution: {
    label: "Driven av",
    accessibleLabel: "Driven av Talentech",
    linkAccessibleLabel: "Driven av Talentech. G\xE5 til nettstaden v\xE5r"
  }
};

// ../locales/src/pl.json
var pl_default = {
  otpInput: {
    digitCellAriaLabel: "Cyfra {{index}} dla {{count}}",
    digitCellAriaLabelWithGroupName: "{{groupName}}, cyfra {{index}} z {{count}}"
  },
  brandAttribution: {
    label: "Wspierane przez",
    accessibleLabel: "Wspierane przez Talentech",
    linkAccessibleLabel: "Wspierane przez Talentech. Przejd\u017A do naszej witryny"
  }
};

// ../locales/src/sv.json
var sv_default = {
  otpInput: {
    digitCellAriaLabel: "Siffra {{index}} av {{count}}",
    digitCellAriaLabelWithGroupName: "{{groupName}}, siffra {{index}} i {{count}}"
  },
  brandAttribution: {
    label: "Drivs av",
    accessibleLabel: "Drivs av Talentech",
    linkAccessibleLabel: "Drivs av Talentech. G\xE5 till v\xE5r webbplats"
  }
};

// ../locales/src/index.mjs
var UI_LOCALES = ["da", "de", "en", "fi", "fr", "nb", "nl", "nn", "pl", "sv"];
var ALIASES = {
  no: "nb"
};
var localeMessages = { da: da_default, de: de_default, en: en_default, fi: fi_default, fr: fr_default, nb: nb_default, nl: nl_default, nn: nn_default, pl: pl_default, sv: sv_default };
var UI_LOCALE_SET = new Set(UI_LOCALES);
function resolveUiLocale(tag) {
  if (!tag || typeof tag !== "string") {
    return "en";
  }
  const primary = tag.trim().toLowerCase().replaceAll("_", "-").split("-")[0];
  if (!primary) {
    return "en";
  }
  const mapped = ALIASES[primary] ?? primary;
  return UI_LOCALE_SET.has(mapped) ? mapped : "en";
}
function lookup(messages, path) {
  const result = path.split(".").reduce((current, key) => {
    if (current && typeof current === "object" && key in current) {
      return current[key];
    }
    return void 0;
  }, messages);
  if (typeof result !== "string") {
    throw new Error(`Missing translation key: ${path}`);
  }
  return result;
}
function interpolate(template, vars) {
  if (!vars) {
    return template;
  }
  return template.replaceAll(/\{\{(\w+)\}\}/g, (match, name) => {
    if (!Object.hasOwn(vars, name)) {
      return match;
    }
    return String(vars[name]);
  });
}
function tUi(locale, path, vars) {
  const resolved = resolveUiLocale(locale);
  return interpolate(lookup(localeMessages[resolved], path), vars);
}

// src/common/LocaleController.ts
var hosts = /* @__PURE__ */ new Set();
var documentObserver = null;
function ensureDocumentObserver() {
  if (documentObserver || typeof document === "undefined") {
    return;
  }
  documentObserver = new MutationObserver(() => {
    for (const controller of hosts) {
      controller.sync();
    }
  });
  documentObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["lang"],
    subtree: true
  });
}
function releaseDocumentObserver() {
  if (hosts.size > 0 || !documentObserver) {
    return;
  }
  documentObserver.disconnect();
  documentObserver = null;
}
function effectiveLang(el) {
  const scoped = el.closest("[lang]");
  const fromScope = scoped?.getAttribute("lang")?.trim();
  if (fromScope) {
    return fromScope;
  }
  return document.documentElement.getAttribute("lang")?.trim() || "en";
}
var LocaleController = class {
  #host;
  #locale = "en";
  constructor(host) {
    this.#host = host;
    host.addController(this);
  }
  get locale() {
    return this.#locale;
  }
  t(path, vars) {
    return tUi(this.#locale, path, vars);
  }
  hostConnected() {
    hosts.add(this);
    ensureDocumentObserver();
    this.sync();
  }
  hostDisconnected() {
    hosts.delete(this);
    releaseDocumentObserver();
  }
  sync() {
    const next = resolveUiLocale(effectiveLang(this.#host));
    if (next === this.#locale) {
      return;
    }
    this.#locale = next;
    this.#host.requestUpdate();
  }
};

// src/components/otp-input/otp-input.ts
function digitsOnly(s5) {
  return s5.replace(/\D/g, "");
}
var _i18n;
var OtpInput = class extends i3 {
  constructor() {
    super();
    this.length = 6;
    this.value = "";
    this.invalid = false;
    this.disabled = false;
    this.ariaLabel = "";
    this.ariaLabelledby = "";
    this.ariaDescribedby = "";
    __privateAdd(this, _i18n, new LocaleController(this));
    /** Per-cell digits; kept in sync with `value`. */
    this._digits = [];
    /** Last value reported with `change` after an interactive edit. */
    this._lastChangeEmitted = "";
    /** True after an input/paste/key edit until the group loses focus. */
    this._pendingUserEdit = false;
    this._internals = typeof this.attachInternals === "function" ? this.attachInternals() : { setFormValue: () => {
    } };
  }
  connectedCallback() {
    super.connectedCallback();
    this._clampLength();
    this._syncDigitsFromValue();
    this._internals.setFormValue(this.value);
    this._lastChangeEmitted = this.value;
  }
  willUpdate(changed) {
    if (changed.has("length")) {
      this._clampLength();
    }
    if (changed.has("value")) {
      this._syncDigitsFromValue();
    }
  }
  updated(changed) {
    if (changed.has("value")) {
      this._internals.setFormValue(this.value);
      if (!this._pendingUserEdit) {
        this._lastChangeEmitted = this.value;
      }
    }
  }
  render() {
    return T`
      <div
        class="root"
        role="group"
        aria-label=${o8(this.ariaLabel || void 0)}
        aria-labelledby=${o8(this.ariaLabelledby || void 0)}
        aria-describedby=${o8(this.ariaDescribedby || void 0)}
        aria-disabled=${this.disabled ? "true" : void 0}
        aria-invalid=${this.invalid ? "true" : void 0}
        @focusout=${this._onGroupFocusOut}
      >
        ${Array.from(
      { length: this.length },
      (_2, i7) => T`
            <input
              class="duo-otp-input__cell"
              type="text"
              inputmode="numeric"
              autocomplete=${i7 === 0 ? "one-time-code" : "off"}
              maxlength="1"
              aria-label=${this._cellAriaLabel(i7)}
              .value=${this._digits[i7] ?? ""}
              ?disabled=${this.disabled}
              @input=${(e8) => this._onCellInput(e8, i7)}
              @keydown=${(e8) => this._onCellKeyDown(e8, i7)}
              @paste=${(e8) => this._onPaste(e8, i7)}
            />
          `
    )}
      </div>
    `;
  }
  _cellAriaLabel(index) {
    const vars = { index: index + 1, count: this.length };
    const groupName = this.ariaLabel?.trim();
    if (groupName) {
      return __privateGet(this, _i18n).t("otpInput.digitCellAriaLabelWithGroupName", {
        ...vars,
        groupName
      });
    }
    return __privateGet(this, _i18n).t("otpInput.digitCellAriaLabel", vars);
  }
  _clampLength() {
    const n6 = Number.isFinite(this.length) ? Math.floor(this.length) : 6;
    this.length = Math.min(12, Math.max(4, n6));
  }
  _syncDigitsFromValue() {
    const raw = digitsOnly(this.value).slice(0, this.length);
    this._digits = Array.from({ length: this.length }, (_2, i7) => raw[i7] ?? "");
    const joined = this._digits.join("");
    if (joined !== this.value) {
      this.value = joined;
    }
  }
  _commitValue(dispatchInput) {
    const joined = this._digits.join("");
    const previousValue = this.value;
    const wasComplete = previousValue.length === this.length;
    const nowComplete = joined.length === this.length;
    if (this.value !== joined) {
      this.value = joined;
    }
    this._internals.setFormValue(this.value);
    if (dispatchInput) {
      this._pendingUserEdit = true;
      this.dispatchEvent(new Event("input", { bubbles: true, composed: true }));
      if (nowComplete && !wasComplete) {
        this.dispatchEvent(
          new CustomEvent("complete", {
            detail: { value: joined },
            bubbles: true,
            composed: true
          })
        );
      }
    }
  }
  _focusCell(index) {
    const root = this.shadowRoot ?? void 0;
    const inputs = root?.querySelectorAll(".duo-otp-input__cell");
    const el = inputs?.[index];
    el?.focus();
    el?.select();
  }
  _onCellInput(e8, index) {
    const target = e8.target;
    const raw = digitsOnly(target.value).slice(-1) ?? "";
    this._digits[index] = raw;
    target.value = raw;
    this._commitValue(true);
    if (raw && index < this.length - 1) {
      queueMicrotask(() => this._focusCell(index + 1));
    }
  }
  _onCellKeyDown(e8, index) {
    if (this.disabled) return;
    if (e8.key === "ArrowLeft" && index > 0) {
      e8.preventDefault();
      this._focusCell(index - 1);
      return;
    }
    if (e8.key === "ArrowRight" && index < this.length - 1) {
      e8.preventDefault();
      this._focusCell(index + 1);
      return;
    }
    if (e8.key === "Backspace") {
      const input = e8.target;
      if (input.value) return;
      e8.preventDefault();
      if (index > 0) {
        this._digits[index - 1] = "";
        this._commitValue(true);
        queueMicrotask(() => this._focusCell(index - 1));
      }
      return;
    }
    if (e8.key.length === 1 && /\d/.test(e8.key)) {
      e8.preventDefault();
      this._digits[index] = e8.key;
      this._commitValue(true);
      queueMicrotask(() => {
        if (index < this.length - 1) {
          this._focusCell(index + 1);
        }
      });
    }
  }
  _onPaste(e8, startIndex) {
    if (this.disabled) return;
    e8.preventDefault();
    const text = e8.clipboardData?.getData("text") ?? "";
    const digits = digitsOnly(text);
    if (!digits) return;
    let di = 0;
    for (let i7 = startIndex; i7 < this.length && di < digits.length; i7++, di++) {
      this._digits[i7] = digits[di] ?? "";
    }
    this._commitValue(true);
    queueMicrotask(() => {
      const next = Math.min(startIndex + digits.length, this.length - 1);
      this._focusCell(next);
    });
  }
  _onGroupFocusOut(e8) {
    const next = e8.relatedTarget;
    if (next && this.shadowRoot?.contains(next)) return;
    if (!this._pendingUserEdit) return;
    if (this.value === this._lastChangeEmitted) {
      this._pendingUserEdit = false;
      return;
    }
    this._lastChangeEmitted = this.value;
    this._pendingUserEdit = false;
    this.dispatchEvent(new Event("change", { bubbles: true, composed: true }));
  }
};
_i18n = new WeakMap();
OtpInput.formAssociated = true;
OtpInput.styles = i`
    :host {
      display: block;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .root {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      gap: var(--duo-space-xs);
      box-sizing: border-box;
      max-inline-size: 100%;
      /* Let focus rings paint outside cells; no inner scroll (narrow viewports rely on parent layout). */
      overflow: visible;
    }

    .duo-otp-input__cell {
      box-sizing: border-box;
      flex: 0 0 auto;
      inline-size: calc(var(--duo-space-l) + var(--duo-space-m));
      max-inline-size: calc(var(--duo-space-l) + var(--duo-space-m));
      block-size: calc(var(--duo-space-l) + var(--duo-space-m));
      min-block-size: calc(var(--duo-space-l) + var(--duo-space-m));
      margin: 0;
      text-align: center;
      font: var(--duo-font-body);
      font-variant-numeric: tabular-nums;
      color: var(--duo-color-text-weak);
      background-color: var(--duo-color-surface);
      border: 1px solid var(--duo-color-border);
      border-radius: var(--duo-border-radius-s);
      padding: var(--duo-space-xxs);
      transition:
        border-color 0.15s ease,
        box-shadow 0.15s ease;
    }

    .duo-otp-input__cell::placeholder {
      color: var(--duo-color-text-disabled);
      opacity: 1;
    }
    .duo-otp-input__cell:hover {
      border-color: var(--duo-color-border-strong);
    }
    .duo-otp-input__cell:focus-visible {
      outline: 1px solid var(--duo-color-accent);
      border-color: var(--duo-color-accent);
    }

    .duo-otp-input__cell:disabled {
      opacity: 0.65;
      cursor: not-allowed;
      background-color: var(--duo-color-surface);
    }

    :host([invalid]) .duo-otp-input__cell {
      outline: 2px solid var(--duo-color-border-error);
      outline-offset: -1px;
    }

    :host([invalid]) .duo-otp-input__cell:focus-visible {
      outline: 2px solid var(--duo-color-border-error);
      outline-offset: -1px;
    }
  `;
__decorateClass([
  n4({ type: Number })
], OtpInput.prototype, "length", 2);
__decorateClass([
  n4({ type: String })
], OtpInput.prototype, "value", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], OtpInput.prototype, "invalid", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], OtpInput.prototype, "disabled", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-label" })
], OtpInput.prototype, "ariaLabel", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-labelledby" })
], OtpInput.prototype, "ariaLabelledby", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-describedby" })
], OtpInput.prototype, "ariaDescribedby", 2);
OtpInput = __decorateClass([
  t3("duo-otp-input")
], OtpInput);

// src/components/button/button.ts
var Button = class extends i3 {
  constructor() {
    super(...arguments);
    this.variant = "default";
    this.size = "m";
    this.disabled = false;
    this.loading = false;
    this.isLoading = false;
    this.outline = false;
    this.type = "button";
    this.square = false;
    this.block = false;
    this.href = "";
    this.target = "";
    this.rel = "";
    this.label = "";
    this.form = "";
    this.formTarget = "";
    this._onIconSlotChange = () => {
      this._syncSlottedIconSizes();
    };
    this._onInnerClick = (e8) => {
      if (this.disabled || this._isLoading) {
        e8.preventDefault();
        return;
      }
      if (this._isLink) {
        return;
      }
      if (this.type === "reset") {
        const formEl2 = this._resolveForm();
        if (!formEl2) return;
        e8.preventDefault();
        formEl2.reset();
        return;
      }
      if (this.type !== "submit") return;
      const formEl = this._resolveForm();
      if (!formEl) return;
      const inner = this.renderRoot.querySelector("button");
      if (!inner) return;
      e8.preventDefault();
      try {
        formEl.requestSubmit(inner);
      } catch {
        formEl.requestSubmit();
      }
    };
  }
  connectedCallback() {
    super.connectedCallback();
    if (this.hasAttribute("icon-only")) {
      this.square = true;
      this.removeAttribute("icon-only");
    }
  }
  get _isLink() {
    return Boolean(this.href?.trim());
  }
  _linkRel() {
    const user = this.rel?.trim();
    if (this.target === "_blank") {
      const parts = /* @__PURE__ */ new Set();
      if (user) {
        for (const p4 of user.split(/\s+/)) {
          if (p4) parts.add(p4);
        }
      }
      parts.add("noopener");
      parts.add("noreferrer");
      return Array.from(parts).join(" ");
    }
    return user || A;
  }
  _linkTabindex() {
    return this.disabled || this._isLoading ? -1 : A;
  }
  willUpdate(_changed) {
    if (this.variant === "secondary") {
      this.variant = "default";
    }
    super.willUpdate(_changed);
  }
  updated(_changed) {
    super.updated(_changed);
    this._syncSlottedIconSizes();
    this._syncAriaFromHost();
  }
  _syncSlottedIconSizes() {
    const slot = this.renderRoot?.querySelector(
      'slot[name="icon"]'
    );
    if (!slot) return;
    for (const node of slot.assignedNodes({ flatten: true })) {
      if (node.nodeType !== Node.ELEMENT_NODE) continue;
      const el = node;
      if (el.localName === "duo-icon" && !el.hasAttribute("size")) {
        el.setAttribute("size", "l");
      }
    }
  }
  get _isLoading() {
    return this.loading || this.isLoading;
  }
  _resolveForm() {
    const id = this.form?.trim() || this.formTarget?.trim();
    if (id) {
      const el = document.getElementById(id);
      return el instanceof HTMLFormElement ? el : null;
    }
    return this.closest("form");
  }
  _syncAriaFromHost() {
    const inner = this.renderRoot?.querySelector("button, a");
    if (!inner) return;
    const label = this.accessibleLabel ?? this.getAttribute("aria-label");
    if (label !== void 0 && label !== null && label !== "") {
      inner.setAttribute("aria-label", label);
    } else {
      inner.removeAttribute("aria-label");
    }
    const labelledBy = this.labelledBy ?? this.getAttribute("aria-labelledby");
    if (labelledBy !== void 0 && labelledBy !== null && labelledBy !== "") {
      inner.setAttribute("aria-labelledby", labelledBy);
    } else {
      inner.removeAttribute("aria-labelledby");
    }
    for (const attr of ["aria-expanded", "aria-haspopup", "aria-controls"]) {
      const v3 = this.getAttribute(attr);
      if (v3 !== null && v3 !== "") inner.setAttribute(attr, v3);
      else inner.removeAttribute(attr);
    }
  }
  render() {
    const inactive = this.disabled || this._isLoading;
    const formId = this.form?.trim() || this.formTarget?.trim() || A;
    const commonInner = T`
      <span class="inner">
        ${this._isLoading ? T`<span class="spinner" aria-hidden="true"></span>` : A}
        <span class="prefix"><slot name="icon" @slotchange=${this._onIconSlotChange}></slot></span>
        ${this.square ? A : T`<span class="label"><slot>${this.label}</slot></span>`}
        <span class="suffix"><slot name="badge"></slot></span>
      </span>
    `;
    if (this._isLink) {
      const relAttr = this._linkRel();
      return T`
        <a
          part="native-link"
          href=${this.href}
          target=${this.target?.trim() ? this.target : A}
          rel=${relAttr}
          aria-busy=${this._isLoading ? "true" : A}
          aria-disabled=${inactive ? "true" : A}
          tabindex=${this._linkTabindex()}
          @click=${this._onInnerClick}
        >
          ${commonInner}
        </a>
      `;
    }
    return T`
      <button
        part="native-button"
        type=${this.type}
        form=${formId}
        ?disabled=${inactive}
        aria-busy=${this._isLoading ? "true" : A}
        @click=${this._onInnerClick}
      >
        ${commonInner}
      </button>
    `;
  }
};
Button.styles = i`
    @keyframes duo-button-spin {
      to {
        transform: rotate(360deg);
      }
    }

    :host {
      display: inline-flex;
      vertical-align: middle;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    :host([block]) {
      display: flex;
      width: 100%;
    }

    button,
    a {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: var(--duo-space-xs);
      margin: 0;
      box-sizing: border-box;
      width: 100%;
      font: var(--duo-font-body);
      font-weight: var(--duo-font-weight-regular);
      line-height: 1.25rem;
      border-radius: var(--duo-border-radius-s);
      border: 1px solid var(--duo-color-border);
      cursor: pointer;
      font-family: inherit;
      text-decoration: none;
      transition:
        background-color 0.15s ease,
        color 0.15s ease,
        border-color 0.15s ease,
        box-shadow 0.15s ease;
    }

    :host([block]) button,
    :host([block]) a {
      width: 100%;
    }

    :host([square]) button,
    :host([square]) a {
      gap: 0;
    }

    :host([size="s"]) button,
    :host([size="s"]) a {
      height: 32px;
      padding: 0 var(--duo-space-s);
      font: var(--duo-font-small);
      line-height: 1.25rem;
    }

    :host([size="m"]) button,
    :host([size="m"]) a {
      height: 40px;
      padding: 0 10px;
      line-height: 20px;
    }

    :host([size="l"]) button,
    :host([size="l"]) a {
      height: 48px;
      padding: 0 var(--duo-space-m);
      font: var(--duo-font-body);
      line-height: 1.25rem;
    }

    :host([size="s"][square]) button,
    :host([size="s"][square]) a {
      height: 32px;
      width: 32px;
      padding: 0;
    }

    :host([size="m"][square]) button,
    :host([size="m"][square]) a {
      height: 40px;
      width: 40px;
      padding: 0;
    }

    :host([size="l"][square]) button,
    :host([size="l"][square]) a {
      height: 48px;
      width: 48px;
      padding: 0;
    }

    button:focus-visible,
    a:focus-visible {
      outline: 2px solid var(--duo-color-accent);
      outline-offset: 2px; 
    }

    button:disabled,
    a[aria-disabled="true"] {
      opacity: 0.55;
      cursor: not-allowed;
    }

    .inner {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      gap: var(--duo-space-xs);
      min-width: 0;
    }

    :host([square]) .inner {
      gap: 0;
    }

    .label {
      flex: 1;
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      text-align: center;
    }

    .prefix ::slotted(*) {
      flex-shrink: 0;
    }

    .suffix ::slotted(*) {
      flex-shrink: 0;
    }

    .spinner {
      flex-shrink: 0;
      width: 1rem;
      height: 1rem;
      box-sizing: border-box;
      border: 2px solid currentColor;
      border-right-color: transparent;
      border-radius: 50%;
      animation: duo-button-spin 0.65s linear infinite;
    }

    :host([variant="primary"]) button,
    :host([variant="primary"]) a {
      color: var(--duo-color-on-accent);
      background-color: var(--duo-color-accent);
      border-color: var(--duo-color-accent);
      font-weight: var(--duo-font-weight-medium, 500);
    }

    :host([variant="primary"]) button:hover:not(:disabled),
    :host([variant="primary"]) a:hover:not([aria-disabled="true"]) {
      filter: brightness(93%);
    }

    :host([variant="primary"]) button:active:not(:disabled),
    :host([variant="primary"]) a:active:not([aria-disabled="true"]) {
      transform: translateY(0.5px);
      opacity: 0.9;
    }

    :host([variant="default"]) button,
    :host([variant="default"]) a {
      color: var(--duo-color-text);
      background-color: var(--duo-color-background);
      border-color: var(--duo-color-border);
      box-shadow: 0 2px 1px 0 rgba(21, 21, 23, 0.04), 0 0 1px 0 rgba(21, 21, 23, 0.04);
    }

    :host([variant="default"]) button:hover:not(:disabled),
    :host([variant="default"]) a:hover:not([aria-disabled="true"]) {
      border-color: var(--duo-color-border-strong);
      filter: brightness(99%);
    }

    :host([variant="default"]) button:active:not(:disabled),
    :host([variant="default"]) a:active:not([aria-disabled="true"]) {
      transform: translateY(0.5px);
      opacity: 0.85;
      box-shadow: none;
    }

    :host([variant="ghost"]) button,
    :host([variant="ghost"]) a {
      color: var(--duo-color-text);
      background-color: transparent;
      border-color: transparent;
    }

    :host([variant="transparent"]) button,
    :host([variant="transparent"]) a {
      color: var(--duo-color-text);
      background-color: transparent;
      border-color: transparent;
    }

    :host([variant="ghost"]) button:hover:not(:disabled),
    :host([variant="ghost"]) a:hover:not([aria-disabled="true"]) {
      color: var(--duo-color-text);
      background-color: transparent;
      border-color: transparent;
      background-color: color-mix(in srgb, var(--duo-color-text) 7%, transparent);
    }

    :host([variant="transparent"]) button:hover:not(:disabled),
    :host([variant="transparent"]) a:hover:not([aria-disabled="true"]) {
      background-color: color-mix(in srgb, var(--duo-color-text) 7%, transparent);
    }

    :host([variant="ghost"]) button:active:not(:disabled),
    :host([variant="ghost"]) a:active:not([aria-disabled="true"]) {
      background-color: color-mix(in srgb, var(--duo-color-text) 7%, transparent);
      border-color: transparent;
      transform: translateY(0.5px);
      opacity: 0.85;
    }

    :host([variant="transparent"]) button:active:not(:disabled),
    :host([variant="transparent"]) a:active:not([aria-disabled="true"]) {
      transform: translateY(0.5px);
      opacity: 0.85;
    }

    :host([variant="success"]) button,
    :host([variant="success"]) a {
      color: var(--duo-color-text-feedback-positive);
      background-color: var(--duo-color-background-feedback-positive);
      border-color: var(--duo-color-green-400);
    }

    :host([variant="danger"]) button,
    :host([variant="danger"]) a {
      color: var(--duo-color-background);
      background-color: var(--duo-color-button-danger);
      border-color: transparent;
    }
    :host([variant="danger"]) button:focus-visible,
    :host([variant="danger"]) a:focus-visible {
      outline: 2px solid var(--duo-color-button-danger);
      outline-offset: 2px; 
    }

    :host([variant="warning"]) button,
    :host([variant="warning"]) a {
      color: var(--duo-color-text-feedback-warning);
      background-color: var(--duo-color-background-feedback-warning);
      border-color: transparent;
    }

    :host([variant="info"]) button,
    :host([variant="info"]) a {
      color: var(--duo-color-text-feedback-informative);
      background-color: var(--duo-color-background-feedback-informative);
      border-color: transparent;
    }

    :host([variant="light"]) button,
    :host([variant="light"]) a {
      color: var(--duo-color-accent);
      background-color: var(--duo-color-background-0);
      border-color: var(--duo-color-border);
    }

    :host([variant="dark"]) button,
    :host([variant="dark"]) a {
      color: var(--duo-color-on-accent);
      background-color: var(--duo-color-accent);
      border-color: var(--duo-color-accent);
      font-weight: var(--duo-font-weight-medium, 500);
    }

    :host([variant="success"]) button:hover:not(:disabled),
    :host([variant="success"]) a:hover:not([aria-disabled="true"]),
    :host([variant="danger"]) button:hover:not(:disabled),
    :host([variant="danger"]) a:hover:not([aria-disabled="true"]),
    :host([variant="warning"]) button:hover:not(:disabled),
    :host([variant="warning"]) a:hover:not([aria-disabled="true"]),
    :host([variant="info"]) button:hover:not(:disabled),
    :host([variant="info"]) a:hover:not([aria-disabled="true"]),
    :host([variant="light"]) button:hover:not(:disabled),
    :host([variant="light"]) a:hover:not([aria-disabled="true"]),
    :host([variant="dark"]) button:hover:not(:disabled),
    :host([variant="dark"]) a:hover:not([aria-disabled="true"]) {
      filter: brightness(0.97);
    }

    :host([variant="success"]) button:active:not(:disabled),
    :host([variant="success"]) a:active:not([aria-disabled="true"]),
    :host([variant="danger"]) button:active:not(:disabled),
    :host([variant="danger"]) a:active:not([aria-disabled="true"]),
    :host([variant="warning"]) button:active:not(:disabled),
    :host([variant="warning"]) a:active:not([aria-disabled="true"]),
    :host([variant="info"]) button:active:not(:disabled),
    :host([variant="info"]) a:active:not([aria-disabled="true"]),
    :host([variant="light"]) button:active:not(:disabled),
    :host([variant="light"]) a:active:not([aria-disabled="true"]),
    :host([variant="dark"]) button:active:not(:disabled),
    :host([variant="dark"]) a:active:not([aria-disabled="true"]) {
      transform: translateY(0.5px);
      opacity: 0.9;
    }

    :host([outline]) button,
    :host([outline]) a {
      background-color: transparent;
    }

    :host([outline][variant="primary"]) button,
    :host([outline][variant="primary"]) a {
      color: var(--duo-color-accent);
      border-color: var(--duo-color-accent);
    }

    :host([outline][variant="dark"]) button,
    :host([outline][variant="dark"]) a {
      color: var(--duo-color-gray-1300);
      border-color: var(--duo-color-gray-1300);
    }

    :host([outline][variant="success"]) button,
    :host([outline][variant="success"]) a {
      color: var(--duo-color-text-feedback-positive);
      border-color: var(--duo-color-text-feedback-positive);
    }

    :host([outline][variant="danger"]) button,
    :host([outline][variant="danger"]) a {
      color: var(--duo-color-text-feedback-negative);
      border-color: var(--duo-color-text-feedback-negative);
    }

    :host([outline][variant="warning"]) button,
    :host([outline][variant="warning"]) a {
      color: var(--duo-color-text-feedback-warning);
      border-color: var(--duo-color-text-feedback-warning);
    }

    :host([outline][variant="info"]) button,
    :host([outline][variant="info"]) a {
      color: var(--duo-color-text-feedback-informative);
      border-color: var(--duo-color-text-feedback-informative);
    }

    :host([outline][variant="light"]) button,
    :host([outline][variant="light"]) a {
      color: var(--duo-color-accent);
      border-color: var(--duo-color-gray-700);
    }

    :host([outline][variant="default"]) button,
    :host([outline][variant="default"]) a,
    :host([outline][variant="ghost"]) button,
    :host([outline][variant="ghost"]) a,
    :host([outline][variant="transparent"]) button,
    :host([outline][variant="transparent"]) a {
      color: var(--duo-color-text);
      border-color: var(--duo-color-border);
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], Button.prototype, "variant", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Button.prototype, "size", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Button.prototype, "disabled", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Button.prototype, "loading", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true, attribute: "is-loading" })
], Button.prototype, "isLoading", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Button.prototype, "outline", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Button.prototype, "type", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Button.prototype, "square", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Button.prototype, "block", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Button.prototype, "href", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Button.prototype, "target", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Button.prototype, "rel", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Button.prototype, "label", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-label" })
], Button.prototype, "accessibleLabel", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-labelledby" })
], Button.prototype, "labelledBy", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "form" })
], Button.prototype, "form", 2);
__decorateClass([
  n4({ type: String, attribute: "form-target" })
], Button.prototype, "formTarget", 2);
Button = __decorateClass([
  t3("duo-button")
], Button);

// src/components/confirm-button/confirm-button.ts
var _infoId, _listening, _ConfirmButton_instances, onButtonClick_fn, _onDocumentKeydown, _onDocumentPointerDown, _onFocusOut, setConfirming_fn, syncListeners_fn, setupListeners_fn, teardownListeners_fn, iconOnlyIdle_fn, accessibleName_fn, labelContent_fn;
var ConfirmButton = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ConfirmButton_instances);
    this.label = "";
    this.confirmLabel = "";
    this.confirmInfo = "";
    this.size = "m";
    this.square = false;
    this.disabled = false;
    this.confirming = false;
    this.defaultSlot = new SlotController(this);
    this.confirmLabelSlot = new SlotController(this, "confirm-label");
    __privateAdd(this, _infoId, `duo-confirm-info-${Math.random().toString(36).slice(2, 9)}`);
    __privateAdd(this, _listening, false);
    __privateAdd(this, _onDocumentKeydown, (event) => {
      if (event.key === "Escape" && this.confirming) {
        event.stopPropagation();
        __privateMethod(this, _ConfirmButton_instances, setConfirming_fn).call(this, false, "cancel");
      }
    });
    __privateAdd(this, _onDocumentPointerDown, (event) => {
      const target = event.target;
      if (!(target instanceof Node)) {
        return;
      }
      if (this.contains(target) || event.composedPath().includes(this)) {
        return;
      }
      __privateMethod(this, _ConfirmButton_instances, setConfirming_fn).call(this, false, "cancel");
    });
    __privateAdd(this, _onFocusOut, (event) => {
      const next = event.relatedTarget;
      if (next instanceof Node && this.contains(next)) {
        return;
      }
      __privateMethod(this, _ConfirmButton_instances, setConfirming_fn).call(this, false, "cancel");
    });
  }
  connectedCallback() {
    super.connectedCallback();
    __privateMethod(this, _ConfirmButton_instances, syncListeners_fn).call(this);
  }
  disconnectedCallback() {
    __privateMethod(this, _ConfirmButton_instances, teardownListeners_fn).call(this);
    super.disconnectedCallback();
  }
  updated(changed) {
    if (changed.has("disabled") && this.disabled && this.confirming) {
      __privateMethod(this, _ConfirmButton_instances, setConfirming_fn).call(this, false, "cancel");
      return;
    }
    __privateMethod(this, _ConfirmButton_instances, syncListeners_fn).call(this);
  }
  render() {
    const showInfo = this.confirming && Boolean(this.confirmInfo.trim());
    const accessibleName = __privateMethod(this, _ConfirmButton_instances, accessibleName_fn).call(this);
    return T`
      ${showInfo ? T`
            <p id=${__privateGet(this, _infoId)} class="info" role="status">
              ${this.confirmInfo}
            </p>
          ` : A}
      <duo-button
        variant=${this.confirming ? "danger" : "default"}
        size=${this.size}
        ?square=${__privateMethod(this, _ConfirmButton_instances, iconOnlyIdle_fn).call(this)}
        ?disabled=${this.disabled}
        type="button"
        aria-label=${accessibleName || A}
        aria-describedby=${showInfo ? __privateGet(this, _infoId) : A}
        @click=${__privateMethod(this, _ConfirmButton_instances, onButtonClick_fn)}
      >
        <slot name="icon" slot="icon"></slot>
        ${__privateMethod(this, _ConfirmButton_instances, labelContent_fn).call(this)}
      </duo-button>
    `;
  }
};
_infoId = new WeakMap();
_listening = new WeakMap();
_ConfirmButton_instances = new WeakSet();
onButtonClick_fn = function(event) {
  event.preventDefault();
  event.stopPropagation();
  if (this.disabled) {
    return;
  }
  if (!this.confirming) {
    __privateMethod(this, _ConfirmButton_instances, setConfirming_fn).call(this, true, "start");
    return;
  }
  __privateMethod(this, _ConfirmButton_instances, setConfirming_fn).call(this, false, "confirm");
};
_onDocumentKeydown = new WeakMap();
_onDocumentPointerDown = new WeakMap();
_onFocusOut = new WeakMap();
setConfirming_fn = function(next, reason) {
  if (this.confirming === next) {
    return;
  }
  this.confirming = next;
  __privateMethod(this, _ConfirmButton_instances, syncListeners_fn).call(this);
  const name = reason === "start" ? "confirmstart" : reason === "confirm" ? "confirm" : "confirmcancel";
  this.dispatchEvent(
    new CustomEvent(name, {
      bubbles: true,
      composed: true
    })
  );
};
syncListeners_fn = function() {
  if (this.confirming && !this.disabled && this.isConnected) {
    __privateMethod(this, _ConfirmButton_instances, setupListeners_fn).call(this);
    return;
  }
  __privateMethod(this, _ConfirmButton_instances, teardownListeners_fn).call(this);
};
setupListeners_fn = function() {
  if (__privateGet(this, _listening)) {
    return;
  }
  __privateSet(this, _listening, true);
  document.addEventListener("keydown", __privateGet(this, _onDocumentKeydown), true);
  document.addEventListener("pointerdown", __privateGet(this, _onDocumentPointerDown), true);
  this.addEventListener("focusout", __privateGet(this, _onFocusOut));
};
teardownListeners_fn = function() {
  if (!__privateGet(this, _listening)) {
    return;
  }
  __privateSet(this, _listening, false);
  document.removeEventListener("keydown", __privateGet(this, _onDocumentKeydown), true);
  document.removeEventListener("pointerdown", __privateGet(this, _onDocumentPointerDown), true);
  this.removeEventListener("focusout", __privateGet(this, _onFocusOut));
};
iconOnlyIdle_fn = function() {
  return this.square && !this.confirming;
};
accessibleName_fn = function() {
  if (this.confirming) {
    return "";
  }
  if (__privateMethod(this, _ConfirmButton_instances, iconOnlyIdle_fn).call(this)) {
    return this.accessibleLabel || this.label;
  }
  return this.accessibleLabel;
};
labelContent_fn = function() {
  if (__privateMethod(this, _ConfirmButton_instances, iconOnlyIdle_fn).call(this)) {
    return A;
  }
  if (this.confirming) {
    if (this.confirmLabelSlot.hasContent) {
      return T`<slot name="confirm-label"></slot>`;
    }
    return this.confirmLabel;
  }
  if (this.defaultSlot.hasContent) {
    return T`<slot></slot>`;
  }
  return this.label;
};
ConfirmButton.styles = i`
    :host {
      display: inline-flex;
      flex-direction: column;
      align-items: flex-start;
      vertical-align: middle;
      box-sizing: border-box;
      gap: var(--duo-space-xs);
    }

    :host([hidden]) {
      display: none;
    }

    .info {
      margin: 0;
      max-width: 16rem;
      font: var(--duo-font-small);
      color: var(--duo-color-text-weak);
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], ConfirmButton.prototype, "label", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "confirm-label" })
], ConfirmButton.prototype, "confirmLabel", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "confirm-info" })
], ConfirmButton.prototype, "confirmInfo", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], ConfirmButton.prototype, "size", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], ConfirmButton.prototype, "square", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-label" })
], ConfirmButton.prototype, "accessibleLabel", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], ConfirmButton.prototype, "disabled", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], ConfirmButton.prototype, "confirming", 2);
ConfirmButton = __decorateClass([
  t3("duo-confirm-button")
], ConfirmButton);

// ../../node_modules/.pnpm/lit-html@3.3.2/node_modules/lit-html/node/directives/unsafe-html.js
var e7 = class extends i4 {
  constructor(i7) {
    if (super(i7), this.it = A, i7.type !== t4.CHILD) throw Error(this.constructor.directiveName + "() can only be used in child bindings");
  }
  render(r6) {
    if (r6 === A || null == r6) return this._t = void 0, this.it = r6;
    if (r6 === E) return r6;
    if ("string" != typeof r6) throw Error(this.constructor.directiveName + "() called with a non-string value");
    if (r6 === this.it) return this._t;
    this.it = r6;
    const s5 = [r6];
    return s5.raw = s5, this._t = { _$litType$: this.constructor.resultType, strings: s5, values: [] };
  }
};
e7.directiveName = "unsafeHTML", e7.resultType = 1;
var o9 = e5(e7);

// ../icons/dist/index.js
var icons = {
  "address-book-tabs": `<svg viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm-16,72h16v48H192Zm16-16H192V48h16ZM48,48H176V208H48ZM208,208H192V168h16v40Zm-56.25-42a39.76,39.76,0,0,0-17.19-23.34,32,32,0,1,0-45.12,0A39.84,39.84,0,0,0,72.25,166a8,8,0,0,0,15.5,4c2.64-10.25,13.06-18,24.25-18s21.62,7.73,24.25,18a8,8,0,1,0,15.5-4ZM96,120a16,16,0,1,1,16,16A16,16,0,0,1,96,120Z"/></svg>`,
  "address-book": `<svg viewBox="0 0 256 256"><path d="M83.19,174.4a8,8,0,0,0,11.21-1.6,52,52,0,0,1,83.2,0,8,8,0,1,0,12.8-9.6A67.88,67.88,0,0,0,163,141.51a40,40,0,1,0-53.94,0A67.88,67.88,0,0,0,81.6,163.2,8,8,0,0,0,83.19,174.4ZM112,112a24,24,0,1,1,24,24A24,24,0,0,1,112,112Zm96-88H64A16,16,0,0,0,48,40V64H32a8,8,0,0,0,0,16H48v40H32a8,8,0,0,0,0,16H48v40H32a8,8,0,0,0,0,16H48v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V40A16,16,0,0,0,208,24Zm0,192H64V40H208Z"/></svg>`,
  "alarm": `<svg viewBox="0 0 256 256"><path d="M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM61.66,37.66l-32,32A8,8,0,0,1,18.34,58.34l32-32A8,8,0,0,1,61.66,37.66Zm176,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,237.66,69.66ZM184,128a8,8,0,0,1,0,16H128a8,8,0,0,1-8-8V80a8,8,0,0,1,16,0v48Z"/></svg>`,
  "app-window": `<svg viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM80,84A12,12,0,1,1,68,72,12,12,0,0,1,80,84Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,120,84Z"/></svg>`,
  "archive": `<svg viewBox="0 0 256 256"><path d="M224,48H32A16,16,0,0,0,16,64V88a16,16,0,0,0,16,16v88a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48ZM208,192H48V104H208ZM224,88H32V64H224V88ZM96,136a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,136Z"/></svg>`,
  "arrow-clockwise": `<svg viewBox="0 0 256 256"><path d="M240,56v48a8,8,0,0,1-8,8H184a8,8,0,0,1,0-16H211.4L184.81,71.64l-.25-.24a80,80,0,1,0-1.67,114.78,8,8,0,0,1,11,11.63A95.44,95.44,0,0,1,128,224h-1.32A96,96,0,1,1,195.75,60L224,85.8V56a8,8,0,1,1,16,0Z"/></svg>`,
  "arrow-counter-clockwise": `<svg viewBox="0 0 256 256"><path d="M224,128a96,96,0,0,1-94.71,96H128A95.38,95.38,0,0,1,62.1,197.8a8,8,0,0,1,11-11.63A80,80,0,1,0,71.43,71.39a3.07,3.07,0,0,1-.26.25L44.59,96H72a8,8,0,0,1,0,16H24a8,8,0,0,1-8-8V56a8,8,0,0,1,16,0V85.8L60.25,60A96,96,0,0,1,224,128Z"/></svg>`,
  "arrow-down": `<svg viewBox="0 0 256 256"><path d="M205.66,149.66l-72,72a8,8,0,0,1-11.32,0l-72-72a8,8,0,0,1,11.32-11.32L120,196.69V40a8,8,0,0,1,16,0V196.69l58.34-58.35a8,8,0,0,1,11.32,11.32Z"/></svg>`,
  "arrow-left": `<svg viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H59.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L59.31,120H216A8,8,0,0,1,224,128Z"/></svg>`,
  "arrow-line-down": `<svg viewBox="0 0 256 256"><path d="M50.34,117.66a8,8,0,0,1,11.32-11.32L120,164.69V32a8,8,0,0,1,16,0V164.69l58.34-58.35a8,8,0,0,1,11.32,11.32l-72,72a8,8,0,0,1-11.32,0ZM216,208H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"/></svg>`,
  "arrow-line-left": `<svg viewBox="0 0 256 256"><path d="M232,128a8,8,0,0,1-8,8H91.31l58.35,58.34a8,8,0,0,1-11.32,11.32l-72-72a8,8,0,0,1,0-11.32l72-72a8,8,0,0,1,11.32,11.32L91.31,120H224A8,8,0,0,1,232,128ZM40,32a8,8,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8,8,0,0,0,40,32Z"/></svg>`,
  "arrow-line-right": `<svg viewBox="0 0 256 256"><path d="M189.66,122.34a8,8,0,0,1,0,11.32l-72,72a8,8,0,0,1-11.32-11.32L164.69,136H32a8,8,0,0,1,0-16H164.69L106.34,61.66a8,8,0,0,1,11.32-11.32ZM216,32a8,8,0,0,0-8,8V216a8,8,0,0,0,16,0V40A8,8,0,0,0,216,32Z"/></svg>`,
  "arrow-line-up": `<svg viewBox="0 0 256 256"><path d="M205.66,138.34a8,8,0,0,1-11.32,11.32L136,91.31V224a8,8,0,0,1-16,0V91.31L61.66,149.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0ZM216,32H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"/></svg>`,
  "arrow-right": `<svg viewBox="0 0 256 256"><path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z"/></svg>`,
  "arrow-square-in": `<svg viewBox="0 0 256 256"><path d="M128,136v64a8,8,0,0,1-16,0V155.32L45.66,221.66a8,8,0,0,1-11.32-11.32L100.68,144H56a8,8,0,0,1,0-16h64A8,8,0,0,1,128,136ZM208,32H80A16,16,0,0,0,64,48V96a8,8,0,0,0,16,0V48H208V176H160a8,8,0,0,0,0,16h48a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Z"/></svg>`,
  "arrow-square-out": `<svg viewBox="0 0 256 256"><path d="M224,104a8,8,0,0,1-16,0V59.32l-66.33,66.34a8,8,0,0,1-11.32-11.32L196.68,48H152a8,8,0,0,1,0-16h64a8,8,0,0,1,8,8Zm-40,24a8,8,0,0,0-8,8v72H48V80h72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V136A8,8,0,0,0,184,128Z"/></svg>`,
  "arrow-up": `<svg viewBox="0 0 256 256"><path d="M205.66,117.66a8,8,0,0,1-11.32,0L136,59.31V216a8,8,0,0,1-16,0V59.31L61.66,117.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0l72,72A8,8,0,0,1,205.66,117.66Z"/></svg>`,
  "arrows-clockwise": `<svg viewBox="0 0 256 256"><path d="M224,48V96a8,8,0,0,1-8,8H168a8,8,0,0,1,0-16h28.69L182.06,73.37a79.56,79.56,0,0,0-56.13-23.43h-.45A79.52,79.52,0,0,0,69.59,72.71,8,8,0,0,1,58.41,61.27a96,96,0,0,1,135,.79L208,76.69V48a8,8,0,0,1,16,0ZM186.41,183.29a80,80,0,0,1-112.47-.66L59.31,168H88a8,8,0,0,0,0-16H40a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V179.31l14.63,14.63A95.43,95.43,0,0,0,130,222.06h.53a95.36,95.36,0,0,0,67.07-27.33,8,8,0,0,0-11.18-11.44Z"/></svg>`,
  "arrows-counter-clockwise": `<svg viewBox="0 0 256 256"><path d="M88,104H40a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0V76.69L62.63,62.06A95.43,95.43,0,0,1,130,33.94h.53a95.36,95.36,0,0,1,67.07,27.33,8,8,0,0,1-11.18,11.44,79.52,79.52,0,0,0-55.89-22.77h-.45A79.56,79.56,0,0,0,73.94,73.37L59.31,88H88a8,8,0,0,1,0,16Zm128,48H168a8,8,0,0,0,0,16h28.69l-14.63,14.63a79.56,79.56,0,0,1-56.13,23.43h-.45a79.52,79.52,0,0,1-55.89-22.77,8,8,0,1,0-11.18,11.44,95.36,95.36,0,0,0,67.07,27.33H126a95.43,95.43,0,0,0,67.36-28.12L208,179.31V208a8,8,0,0,0,16,0V160A8,8,0,0,0,216,152Z"/></svg>`,
  "arrows-down-up": `<svg viewBox="0 0 256 256"><path d="M117.66,170.34a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L72,188.69V48a8,8,0,0,1,16,0V188.69l18.34-18.35A8,8,0,0,1,117.66,170.34Zm96-96-32-32a8,8,0,0,0-11.32,0l-32,32a8,8,0,0,0,11.32,11.32L168,67.31V208a8,8,0,0,0,16,0V67.31l18.34,18.35a8,8,0,0,0,11.32-11.32Z"/></svg>`,
  "arrows-left-right": `<svg viewBox="0 0 256 256"><path d="M213.66,181.66l-32,32a8,8,0,0,1-11.32-11.32L188.69,184H48a8,8,0,0,1,0-16H188.69l-18.35-18.34a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,213.66,181.66Zm-139.32-64a8,8,0,0,0,11.32-11.32L67.31,88H208a8,8,0,0,0,0-16H67.31L85.66,53.66A8,8,0,0,0,74.34,42.34l-32,32a8,8,0,0,0,0,11.32Z"/></svg>`,
  "arrows-merge": `<svg viewBox="0 0 256 256"><path d="M192,40v64a8,8,0,0,1-2.34,5.66L136,163.31v49.38l18.34-18.35a8,8,0,0,1,11.32,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,212.69V163.31L66.34,109.66A8,8,0,0,1,64,104V40a8,8,0,0,1,16,0v60.69l48,48,48-48V40a8,8,0,0,1,16,0Z"/></svg>`,
  "arrows-out": `<svg viewBox="0 0 256 256"><path d="M216,48V88a8,8,0,0,1-16,0V67.31l-42.34,42.35a8,8,0,0,1-11.32-11.32L188.69,56H168a8,8,0,0,1,0-16h40A8,8,0,0,1,216,48ZM98.34,146.34,56,188.69V168a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H88a8,8,0,0,0,0-16H67.31l42.35-42.34a8,8,0,0,0-11.32-11.32ZM208,160a8,8,0,0,0-8,8v20.69l-42.34-42.35a8,8,0,0,0-11.32,11.32L188.69,200H168a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V168A8,8,0,0,0,208,160ZM67.31,56H88a8,8,0,0,0,0-16H48a8,8,0,0,0-8,8V88a8,8,0,0,0,16,0V67.31l42.34,42.35a8,8,0,0,0,11.32-11.32Z"/></svg>`,
  "arrows-split": `<svg viewBox="0 0 256 256"><path d="M229.66,189.66l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L184,196.69V139.31l-56-56-56,56v57.38l18.34-18.35a8,8,0,0,1,11.32,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L56,196.69V136a8,8,0,0,1,2.34-5.66L120,68.69V24a8,8,0,0,1,16,0V68.69l61.66,61.65A8,8,0,0,1,200,136v60.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z"/></svg>`,
  "article": `<svg viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,160H40V56H216V200ZM184,96a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,96Zm0,32a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,128Zm0,32a8,8,0,0,1-8,8H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,160Z"/></svg>`,
  "at": `<svg viewBox="0 0 256 256"><path d="M128,24a104,104,0,0,0,0,208c21.51,0,44.1-6.48,60.43-17.33a8,8,0,0,0-8.86-13.33C166,210.38,146.21,216,128,216a88,88,0,1,1,88-88c0,26.45-10.88,32-20,32s-20-5.55-20-32V88a8,8,0,0,0-16,0v4.26a48,48,0,1,0,5.93,65.1c6,12,16.35,18.64,30.07,18.64,22.54,0,36-17.94,36-48A104.11,104.11,0,0,0,128,24Zm0,136a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z"/></svg>`,
  "backspace": `<svg viewBox="0 0 256 256"><path d="M216,40H68.53a16.08,16.08,0,0,0-13.72,7.77L9.14,123.88a8,8,0,0,0,0,8.24l45.67,76.11A16.08,16.08,0,0,0,68.53,216H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM61.67,204.12,68.53,200h0ZM216,200H68.53l-43.2-72,43.2-72H216ZM106.34,146.34,124.69,128l-18.35-18.34a8,8,0,0,1,11.32-11.32L136,116.69l18.34-18.35a8,8,0,0,1,11.32,11.32L147.31,128l18.35,18.34a8,8,0,0,1-11.32,11.32L136,139.31l-18.34,18.35a8,8,0,0,1-11.32-11.32Z"/></svg>`,
  "bank": `<svg viewBox="0 0 256 256"><path d="M24,104H48v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16H208V104h24a8,8,0,0,0,4.19-14.81l-104-64a8,8,0,0,0-8.38,0l-104,64A8,8,0,0,0,24,104Zm40,0H96v64H64Zm80,0v64H112V104Zm48,64H160V104h32ZM128,41.39,203.74,88H52.26ZM248,208a8,8,0,0,1-8,8H16a8,8,0,0,1,0-16H240A8,8,0,0,1,248,208Z"/></svg>`,
  "bell-ringing": `<svg viewBox="0 0 256 256"><path d="M224,71.1a8,8,0,0,1-10.78-3.42,94.13,94.13,0,0,0-33.46-36.91,8,8,0,1,1,8.54-13.54,111.46,111.46,0,0,1,39.12,43.09A8,8,0,0,1,224,71.1ZM35.71,72a8,8,0,0,0,7.1-4.32A94.13,94.13,0,0,1,76.27,30.77a8,8,0,1,0-8.54-13.54A111.46,111.46,0,0,0,28.61,60.32,8,8,0,0,0,35.71,72Zm186.1,103.94A16,16,0,0,1,208,200H167.2a40,40,0,0,1-78.4,0H48a16,16,0,0,1-13.79-24.06C43.22,160.39,48,138.28,48,112a80,80,0,0,1,160,0C208,138.27,212.78,160.38,221.81,175.94ZM150.62,200H105.38a24,24,0,0,0,45.24,0ZM208,184c-10.64-18.27-16-42.49-16-72a64,64,0,0,0-128,0c0,29.52-5.38,53.74-16,72Z"/></svg>`,
  "bell-simple-ringing": `<svg viewBox="0 0 256 256"><path d="M168,224a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,224ZM227.39,60.32a111.36,111.36,0,0,0-39.12-43.08,8,8,0,1,0-8.54,13.53,94.13,94.13,0,0,1,33.46,36.91,8,8,0,0,0,14.2-7.36ZM35.71,72a8,8,0,0,0,7.1-4.32A94.13,94.13,0,0,1,76.27,30.77a8,8,0,1,0-8.54-13.53A111.36,111.36,0,0,0,28.61,60.32,8,8,0,0,0,35.71,72Zm186.1,103.94A16,16,0,0,1,208,200H48a16,16,0,0,1-13.79-24.06C43.22,160.39,48,138.28,48,112a80,80,0,0,1,160,0C208,138.27,212.78,160.38,221.81,175.94ZM208,184c-10.64-18.27-16-42.49-16-72a64,64,0,0,0-128,0c0,29.52-5.38,53.74-16,72Z"/></svg>`,
  "bell-simple-slash": `<svg viewBox="0 0 256 256"><path d="M53.92,34.62A8,8,0,1,0,42.08,45.38L58.82,63.8A79.59,79.59,0,0,0,48,104c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H182.64l19.44,21.38a8,8,0,1,0,11.84-10.76ZM48,184c7.7-13.24,16-43.92,16-80a63.65,63.65,0,0,1,6.26-27.62L168.09,184Zm120,40a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,224Zm46-44.75a8.13,8.13,0,0,1-2.93.55,8,8,0,0,1-7.44-5.08C196.35,156.19,192,129.75,192,104A64,64,0,0,0,96.43,48.31a8,8,0,0,1-7.9-13.91A80,80,0,0,1,208,104c0,35.35,8.05,58.59,10.52,64.88A8,8,0,0,1,214,179.25Z"/></svg>`,
  "bell-simple": `<svg viewBox="0 0 256 256"><path d="M168,224a8,8,0,0,1-8,8H96a8,8,0,1,1,0-16h64A8,8,0,0,1,168,224Zm53.85-32A15.8,15.8,0,0,1,208,200H48a16,16,0,0,1-13.8-24.06C39.75,166.38,48,139.34,48,104a80,80,0,1,1,160,0c0,35.33,8.26,62.38,13.81,71.94A15.89,15.89,0,0,1,221.84,192ZM208,184c-7.73-13.27-16-43.95-16-80a64,64,0,1,0-128,0c0,36.06-8.28,66.74-16,80Z"/></svg>`,
  "bell-slash": `<svg viewBox="0 0 256 256"><path d="M53.92,34.62A8,8,0,1,0,42.08,45.38L58.82,63.8A79.59,79.59,0,0,0,48,104c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H88.8a40,40,0,0,0,78.4,0h15.44l19.44,21.38a8,8,0,1,0,11.84-10.76ZM128,216a24,24,0,0,1-22.62-16h45.24A24,24,0,0,1,128,216ZM48,184c7.7-13.24,16-43.92,16-80a63.65,63.65,0,0,1,6.26-27.62L168.09,184Zm166-4.73a8.13,8.13,0,0,1-2.93.55,8,8,0,0,1-7.44-5.08C196.35,156.19,192,129.75,192,104A64,64,0,0,0,96.43,48.31a8,8,0,0,1-7.9-13.91A80,80,0,0,1,208,104c0,35.35,8.05,58.59,10.52,64.88A8,8,0,0,1,214,179.25Z"/></svg>`,
  "bell": `<svg viewBox="0 0 256 256"><path d="M221.8,175.94C216.25,166.38,208,139.33,208,104a80,80,0,1,0-160,0c0,35.34-8.26,62.38-13.81,71.94A16,16,0,0,0,48,200H88.81a40,40,0,0,0,78.38,0H208a16,16,0,0,0,13.8-24.06ZM128,216a24,24,0,0,1-22.62-16h45.24A24,24,0,0,1,128,216ZM48,184c7.7-13.24,16-43.92,16-80a64,64,0,1,1,128,0c0,36.05,8.28,66.73,16,80Z"/></svg>`,
  "book-open-text": `<svg viewBox="0 0 256 256"><path d="M232,48H160a40,40,0,0,0-32,16A40,40,0,0,0,96,48H24a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H96a24,24,0,0,1,24,24,8,8,0,0,0,16,0,24,24,0,0,1,24-24h72a8,8,0,0,0,8-8V56A8,8,0,0,0,232,48ZM96,192H32V64H96a24,24,0,0,1,24,24V200A39.81,39.81,0,0,0,96,192Zm128,0H160a39.81,39.81,0,0,0-24,8V88a24,24,0,0,1,24-24h64ZM160,88h40a8,8,0,0,1,0,16H160a8,8,0,0,1,0-16Zm48,40a8,8,0,0,1-8,8H160a8,8,0,0,1,0-16h40A8,8,0,0,1,208,128Zm0,32a8,8,0,0,1-8,8H160a8,8,0,0,1,0-16h40A8,8,0,0,1,208,160Z"/></svg>`,
  "book-open": `<svg viewBox="0 0 256 256"><path d="M232,48H160a40,40,0,0,0-32,16A40,40,0,0,0,96,48H24a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H96a24,24,0,0,1,24,24,8,8,0,0,0,16,0,24,24,0,0,1,24-24h72a8,8,0,0,0,8-8V56A8,8,0,0,0,232,48ZM96,192H32V64H96a24,24,0,0,1,24,24V200A39.81,39.81,0,0,0,96,192Zm128,0H160a39.81,39.81,0,0,0-24,8V88a24,24,0,0,1,24-24h64Z"/></svg>`,
  "book-user": `<svg viewBox="0 0 256 256"><path d="M232,72H160a40,40,0,0,0-32,16A40,40,0,0,0,96,72H24a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8H96a24,24,0,0,1,24,24,8,8,0,0,0,16,0,24,24,0,0,1,24-24h72a8,8,0,0,0,8-8V80A8,8,0,0,0,232,72ZM96,192H32V88H96a24,24,0,0,1,24,24v88A39.81,39.81,0,0,0,96,192Zm128,0H160a39.81,39.81,0,0,0-24,8V112a24,24,0,0,1,24-24h64ZM89.6,43.19a48,48,0,0,1,76.8,0,8,8,0,0,1-12.79,9.62,32,32,0,0,0-51.22,0A8,8,0,1,1,89.6,43.19Z"/></svg>`,
  "bookmark-simple": `<svg viewBox="0 0 256 256"><path d="M184,32H72A16,16,0,0,0,56,48V224a8,8,0,0,0,12.24,6.78L128,193.43l59.77,37.35A8,8,0,0,0,200,224V48A16,16,0,0,0,184,32Zm0,177.57-51.77-32.35a8,8,0,0,0-8.48,0L72,209.57V48H184Z"/></svg>`,
  "bookmark": `<svg viewBox="0 0 256 256"><path d="M184,32H72A16,16,0,0,0,56,48V224a8,8,0,0,0,12.24,6.78L128,193.43l59.77,37.35A8,8,0,0,0,200,224V48A16,16,0,0,0,184,32Zm0,16V161.57l-51.77-32.35a8,8,0,0,0-8.48,0L72,161.56V48ZM132.23,177.22a8,8,0,0,0-8.48,0L72,209.57V180.43l56-35,56,35v29.14Z"/></svg>`,
  "bookmarks-simple": `<svg viewBox="0 0 256 256"><path d="M160,56H64A16,16,0,0,0,48,72V224a8,8,0,0,0,12.65,6.51L112,193.83l51.36,36.68A8,8,0,0,0,176,224V72A16,16,0,0,0,160,56Zm0,152.46-43.36-31a8,8,0,0,0-9.3,0L64,208.45V72h96ZM208,40V192a8,8,0,0,1-16,0V40H88a8,8,0,0,1,0-16H192A16,16,0,0,1,208,40Z"/></svg>`,
  "bookmarks": `<svg viewBox="0 0 256 256"><path d="M192,24H96A16,16,0,0,0,80,40V56H64A16,16,0,0,0,48,72V224a8,8,0,0,0,12.65,6.51L112,193.83l51.36,36.68A8,8,0,0,0,176,224V184.69l19.35,13.82A8,8,0,0,0,208,192V40A16,16,0,0,0,192,24ZM160,208.46l-43.36-31a8,8,0,0,0-9.3,0L64,208.45V72h96Zm32-32L176,165V72a16,16,0,0,0-16-16H96V40h96Z"/></svg>`,
  "box-arrow-down": `<svg viewBox="0 0 256 256"><path d="M223.16,68.42l-16-32A8,8,0,0,0,200,32H56a8,8,0,0,0-7.16,4.42l-16,32A8.08,8.08,0,0,0,32,72V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V72A8.08,8.08,0,0,0,223.16,68.42ZM60.94,48H195.06l8,16H52.94ZM208,208H48V80H208V208Zm-42.34-61.66a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32L120,164.69V104a8,8,0,0,1,16,0v60.69l18.34-18.35A8,8,0,0,1,165.66,146.34Z"/></svg>`,
  "box-arrow-up": `<svg viewBox="0 0 256 256"><path d="M223.16,68.42l-16-32A8,8,0,0,0,200,32H56a8,8,0,0,0-7.16,4.42l-16,32A8.08,8.08,0,0,0,32,72V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V72A8.08,8.08,0,0,0,223.16,68.42ZM60.94,48H195.06l8,16H52.94ZM208,208H48V80H208V208Zm-42.34-77.66a8,8,0,0,1-11.32,11.32L136,123.31V184a8,8,0,0,1-16,0V123.31l-18.34,18.35a8,8,0,0,1-11.32-11.32l32-32a8,8,0,0,1,11.32,0Z"/></svg>`,
  "briefcase-metal": `<svg viewBox="0 0 256 256"><path d="M216,56H176V48a24,24,0,0,0-24-24H104A24,24,0,0,0,80,48v8H40A16,16,0,0,0,24,72V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V72A16,16,0,0,0,216,56ZM40,112H216v48H40ZM96,48a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96ZM216,72V96H40V72Zm0,128H40V176H216v24Z"/></svg>`,
  "briefcase": `<svg viewBox="0 0 256 256"><path d="M216,56H176V48a24,24,0,0,0-24-24H104A24,24,0,0,0,80,48v8H40A16,16,0,0,0,24,72V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V72A16,16,0,0,0,216,56ZM96,48a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96ZM216,72v41.61A184,184,0,0,1,128,136a184.07,184.07,0,0,1-88-22.38V72Zm0,128H40V131.64A200.19,200.19,0,0,0,128,152a200.25,200.25,0,0,0,88-20.37V200ZM104,112a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,112Z"/></svg>`,
  "broadcast": `<svg viewBox="0 0 256 256"><path d="M128,88a40,40,0,1,0,40,40A40,40,0,0,0,128,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,152Zm73.71,7.14a80,80,0,0,1-14.08,22.2,8,8,0,0,1-11.92-10.67,63.95,63.95,0,0,0,0-85.33,8,8,0,1,1,11.92-10.67,80.08,80.08,0,0,1,14.08,84.47ZM69,103.09a64,64,0,0,0,11.26,67.58,8,8,0,0,1-11.92,10.67,79.93,79.93,0,0,1,0-106.67A8,8,0,1,1,80.29,85.34,63.77,63.77,0,0,0,69,103.09ZM248,128a119.58,119.58,0,0,1-34.29,84,8,8,0,1,1-11.42-11.2,103.9,103.9,0,0,0,0-145.56A8,8,0,1,1,213.71,44,119.58,119.58,0,0,1,248,128ZM53.71,200.78A8,8,0,1,1,42.29,212a119.87,119.87,0,0,1,0-168,8,8,0,1,1,11.42,11.2,103.9,103.9,0,0,0,0,145.56Z"/></svg>`,
  "browser": `<svg viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V88H40V56Zm0,144H40V104H216v96Z"/></svg>`,
  "browsers": `<svg viewBox="0 0 256 256"><path d="M216,40H72A16,16,0,0,0,56,56V72H40A16,16,0,0,0,24,88V200a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V184h16a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM184,88v16H40V88Zm0,112H40V120H184v80Zm32-32H200V88a16,16,0,0,0-16-16H72V56H216Z"/></svg>`,
  "building-apartment": `<svg viewBox="0 0 256 256"><path d="M240,208h-8V72a8,8,0,0,0-8-8H184V40a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8V96H32a8,8,0,0,0-8,8V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM40,112H80a8,8,0,0,0,8-8V48h80V72a8,8,0,0,0,8,8h40V208H152V168a8,8,0,0,0-8-8H112a8,8,0,0,0-8,8v40H40Zm96,96H120V176h16ZM112,72a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H120A8,8,0,0,1,112,72Zm0,32a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H120A8,8,0,0,1,112,104Zm56,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H176A8,8,0,0,1,168,104ZM88,136a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H80A8,8,0,0,1,88,136Zm0,32a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H80A8,8,0,0,1,88,168Zm24-32a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H120A8,8,0,0,1,112,136Zm56,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H176A8,8,0,0,1,168,136Zm0,32a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H176A8,8,0,0,1,168,168Z"/></svg>`,
  "building-office": `<svg viewBox="0 0 256 256"><path d="M248,208H232V96a8,8,0,0,0,0-16H184V48a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16V208H24a8,8,0,0,0,0,16H248a8,8,0,0,0,0-16ZM216,96V208H184V96ZM56,48H168V208H144V160a8,8,0,0,0-8-8H88a8,8,0,0,0-8,8v48H56Zm72,160H96V168h32ZM72,80a8,8,0,0,1,8-8H96a8,8,0,0,1,0,16H80A8,8,0,0,1,72,80Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H128A8,8,0,0,1,120,80ZM72,120a8,8,0,0,1,8-8H96a8,8,0,0,1,0,16H80A8,8,0,0,1,72,120Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H128A8,8,0,0,1,120,120Z"/></svg>`,
  "building": `<svg viewBox="0 0 256 256"><path d="M232,224H208V32h8a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16h8V224H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM64,32H192V224H160V184a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v40H64Zm80,192H112V192h32ZM88,64a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,64Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,64ZM88,104a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,104Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,104ZM88,144a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H96A8,8,0,0,1,88,144Zm48,0a8,8,0,0,1,8-8h16a8,8,0,0,1,0,16H144A8,8,0,0,1,136,144Z"/></svg>`,
  "buildings": `<svg viewBox="0 0 256 256"><path d="M240,208H224V96a16,16,0,0,0-16-16H144V32a16,16,0,0,0-24.88-13.32L39.12,72A16,16,0,0,0,32,85.34V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM208,96V208H144V96ZM48,85.34,128,32V208H48ZM112,112v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm-32,0v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm0,56v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm32,0v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Z"/></svg>`,
  "calculator": `<svg viewBox="0 0 256 256"><path d="M80,120h96a8,8,0,0,0,8-8V64a8,8,0,0,0-8-8H80a8,8,0,0,0-8,8v48A8,8,0,0,0,80,120Zm8-48h80v32H88ZM200,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24Zm0,192H56V40H200ZM100,148a12,12,0,1,1-12-12A12,12,0,0,1,100,148Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,140,148Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,180,148Zm-80,40a12,12,0,1,1-12-12A12,12,0,0,1,100,188Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,140,188Zm40,0a12,12,0,1,1-12-12A12,12,0,0,1,180,188Z"/></svg>`,
  "calendar-blank": `<svg viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Z"/></svg>`,
  "calendar-check": `<svg viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-38.34-85.66a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L116,164.69l42.34-42.35A8,8,0,0,1,169.66,122.34Z"/></svg>`,
  "calendar-dot": `<svg viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-64-56a16,16,0,1,1-16-16A16,16,0,0,1,144,152Z"/></svg>`,
  "calendar-dots": `<svg viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-68-76a12,12,0,1,1-12-12A12,12,0,0,1,140,132Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,132ZM96,172a12,12,0,1,1-12-12A12,12,0,0,1,96,172Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,140,172Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,172Z"/></svg>`,
  "calendar-minus": `<svg viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-48-56a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16h48A8,8,0,0,1,160,152Z"/></svg>`,
  "calendar-plus": `<svg viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-48-56a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,152Z"/></svg>`,
  "calendar-slash": `<svg viewBox="0 0 256 256"><path d="M53.92,34.62A8,8,0,0,0,48,32,16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a8,8,0,0,0,5.92-13.38ZM73.55,80H48V51.88ZM48,208V96H88.1L189.92,208ZM224,48V177.23a8,8,0,1,1-16,0V96H134.88a8,8,0,0,1,0-16H208V48H184v8a8,8,0,0,1-16,0V48H91.25a8,8,0,0,1,0-16H168V24a8,8,0,0,1,16,0v8h24A16,16,0,0,1,224,48Z"/></svg>`,
  "calendar-star": `<svg viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H72v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V208Zm-31.38-94.36-29.84-2.31-11.43-26.5a8,8,0,0,0-14.7,0l-11.43,26.5-29.84,2.31a8,8,0,0,0-4.47,14.14l22.52,18.59-6.86,27.71a8,8,0,0,0,11.82,8.81L128,167.82l25.61,15.07a8,8,0,0,0,11.82-8.81l-6.86-27.71,22.52-18.59a8,8,0,0,0-4.47-14.14Zm-32.11,23.6a8,8,0,0,0-2.68,8.09l3.5,14.12-13.27-7.81a8,8,0,0,0-8.12,0l-13.27,7.81,3.5-14.12a8,8,0,0,0-2.68-8.09l-11.11-9.18,14.89-1.15a8,8,0,0,0,6.73-4.8l6-13.92,6,13.92a8,8,0,0,0,6.73,4.8l14.89,1.15Z"/></svg>`,
  "calendar-x": `<svg viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-50.34-74.34L139.31,152l18.35,18.34a8,8,0,0,1-11.32,11.32L128,163.31l-18.34,18.35a8,8,0,0,1-11.32-11.32L116.69,152,98.34,133.66a8,8,0,0,1,11.32-11.32L128,140.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z"/></svg>`,
  "calendar": `<svg viewBox="0 0 256 256"><path d="M208,32H184V24a8,8,0,0,0-16,0v8H88V24a8,8,0,0,0-16,0v8H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM72,48v8a8,8,0,0,0,16,0V48h80v8a8,8,0,0,0,16,0V48h24V80H48V48ZM208,208H48V96H208V208Zm-96-88v64a8,8,0,0,1-16,0V132.94l-4.42,2.22a8,8,0,0,1-7.16-14.32l16-8A8,8,0,0,1,112,120Zm59.16,30.45L152,176h16a8,8,0,0,1,0,16H136a8,8,0,0,1-6.4-12.8l28.78-38.37A8,8,0,1,0,145.07,132a8,8,0,1,1-13.85-8A24,24,0,0,1,176,136,23.76,23.76,0,0,1,171.16,150.45Z"/></svg>`,
  "cardholder": `<svg viewBox="0 0 256 256"><path d="M208,48H48A24,24,0,0,0,24,72V184a24,24,0,0,0,24,24H208a24,24,0,0,0,24-24V72A24,24,0,0,0,208,48ZM40,96H216v16H160a8,8,0,0,0-8,8,24,24,0,0,1-48,0,8,8,0,0,0-8-8H40Zm8-32H208a8,8,0,0,1,8,8v8H40V72A8,8,0,0,1,48,64ZM208,192H48a8,8,0,0,1-8-8V128H88.8a40,40,0,0,0,78.4,0H216v56A8,8,0,0,1,208,192Z"/></svg>`,
  "caret-circle-down": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm45.66-109.66a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32,0l-40-40a8,8,0,0,1,11.32-11.32L128,140.69l34.34-34.35A8,8,0,0,1,173.66,106.34Z"/></svg>`,
  "caret-circle-left": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216ZM149.66,93.66,115.31,128l34.35,34.34a8,8,0,0,1-11.32,11.32l-40-40a8,8,0,0,1,0-11.32l40-40a8,8,0,0,1,11.32,11.32Z"/></svg>`,
  "caret-circle-right": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm29.66-93.66a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32L140.69,128,106.34,93.66a8,8,0,0,1,11.32-11.32Z"/></svg>`,
  "caret-circle-up": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm45.66-77.66a8,8,0,0,1-11.32,11.32L128,115.31,93.66,149.66a8,8,0,0,1-11.32-11.32l40-40a8,8,0,0,1,11.32,0Z"/></svg>`,
  "caret-down": `<svg viewBox="0 0 256 256"><path d="M213.66,101.66l-80,80a8,8,0,0,1-11.32,0l-80-80A8,8,0,0,1,53.66,90.34L128,164.69l74.34-74.35a8,8,0,0,1,11.32,11.32Z"/></svg>`,
  "caret-left": `<svg viewBox="0 0 256 256"><path d="M165.66,202.34a8,8,0,0,1-11.32,11.32l-80-80a8,8,0,0,1,0-11.32l80-80a8,8,0,0,1,11.32,11.32L91.31,128Z"/></svg>`,
  "caret-right": `<svg viewBox="0 0 256 256"><path d="M181.66,133.66l-80,80a8,8,0,0,1-11.32-11.32L164.69,128,90.34,53.66a8,8,0,0,1,11.32-11.32l80,80A8,8,0,0,1,181.66,133.66Z"/></svg>`,
  "caret-up-down": `<svg viewBox="0 0 256 256"><path d="M181.66,170.34a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-48-48a8,8,0,0,1,11.32-11.32L128,212.69l42.34-42.35A8,8,0,0,1,181.66,170.34Zm-96-84.68L128,43.31l42.34,42.35a8,8,0,0,0,11.32-11.32l-48-48a8,8,0,0,0-11.32,0l-48,48A8,8,0,0,0,85.66,85.66Z"/></svg>`,
  "caret-up": `<svg viewBox="0 0 256 256"><path d="M213.66,165.66a8,8,0,0,1-11.32,0L128,91.31,53.66,165.66a8,8,0,0,1-11.32-11.32l80-80a8,8,0,0,1,11.32,0l80,80A8,8,0,0,1,213.66,165.66Z"/></svg>`,
  "certificate": `<svg viewBox="0 0 256 256"><path d="M128,136a8,8,0,0,1-8,8H72a8,8,0,0,1,0-16h48A8,8,0,0,1,128,136Zm-8-40H72a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Zm112,65.47V224A8,8,0,0,1,220,231l-24-13.74L172,231A8,8,0,0,1,160,224V200H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216a16,16,0,0,1,16,16V86.53a51.88,51.88,0,0,1,0,74.94ZM160,184V161.47A52,52,0,0,1,216,76V56H40V184Zm56-12a51.88,51.88,0,0,1-40,0v38.22l16-9.16a8,8,0,0,1,7.94,0l16,9.16Zm16-48a36,36,0,1,0-36,36A36,36,0,0,0,232,124Z"/></svg>`,
  "chart-bar-horizontal": `<svg viewBox="0 0 256 256"><path d="M224,96H184V56a8,8,0,0,0-8-8H56V40a8,8,0,0,0-16,0V216a8,8,0,0,0,16,0v-8h88a8,8,0,0,0,8-8V160h72a8,8,0,0,0,8-8V104A8,8,0,0,0,224,96ZM168,64V96H56V64ZM136,192H56V160h80Zm80-48H56V112H216Z"/></svg>`,
  "chart-bar": `<svg viewBox="0 0 256 256"><path d="M224,200h-8V40a8,8,0,0,0-8-8H152a8,8,0,0,0-8,8V80H96a8,8,0,0,0-8,8v40H48a8,8,0,0,0-8,8v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM160,48h40V200H160ZM104,96h40V200H104ZM56,144H88v56H56Z"/></svg>`,
  "chart-donut": `<svg viewBox="0 0 256 256"><path d="M128,24a8,8,0,0,0-8,8V88a8,8,0,0,0,8,8,32,32,0,1,1-27.72,16,8,8,0,0,0-2.93-10.93l-48.5-28A8,8,0,0,0,37.92,76,104,104,0,1,0,128,24ZM48.09,91.1,83,111.26A48.09,48.09,0,0,0,80,128c0,1.53.08,3,.22,4.52L41.28,143A88.16,88.16,0,0,1,48.09,91.1Zm-2.67,67.31,39-10.44A48.1,48.1,0,0,0,120,175.32v40.31A88.2,88.2,0,0,1,45.42,158.41ZM136,215.63V175.32a48,48,0,0,0,0-94.65V40.36a88,88,0,0,1,0,175.27Z"/></svg>`,
  "chart-line-down": `<svg viewBox="0 0 256 256"><path d="M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0V60.69l56,56,26.34-26.35a8,8,0,0,1,11.32,0L192,148.69V128a8,8,0,0,1,16,0v40a7,7,0,0,1,0,.8c0,.11,0,.21-.05.32s0,.3-.07.46a2.83,2.83,0,0,1-.09.37c0,.13-.06.26-.1.39s-.08.23-.12.35l-.14.39-.15.31c-.06.13-.12.27-.19.4s-.11.18-.16.28l-.24.39-.21.28-.26.35c-.11.14-.24.27-.36.4l-.16.18-.17.15a4.83,4.83,0,0,1-.42.37,3.92,3.92,0,0,1-.32.25l-.3.22-.38.23a2.91,2.91,0,0,1-.3.17l-.37.19-.34.15-.36.13a2.84,2.84,0,0,1-.38.13l-.36.1c-.14,0-.26.07-.4.09l-.42.07-.35.05a7,7,0,0,1-.79,0H160a8,8,0,0,1,0-16h20.69L128,107.31l-26.34,26.35a8,8,0,0,1-11.32,0L40,83.31V200H224A8,8,0,0,1,232,208Z"/></svg>`,
  "chart-line-up": `<svg viewBox="0 0 256 256"><path d="M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0V156.69l50.34-50.35a8,8,0,0,1,11.32,0L128,132.69,180.69,80H160a8,8,0,0,1,0-16h40a8,8,0,0,1,8,8v40a8,8,0,0,1-16,0V91.31l-58.34,58.35a8,8,0,0,1-11.32,0L96,123.31l-56,56V200H224A8,8,0,0,1,232,208Z"/></svg>`,
  "chart-line": `<svg viewBox="0 0 256 256"><path d="M232,208a8,8,0,0,1-8,8H32a8,8,0,0,1-8-8V48a8,8,0,0,1,16,0v94.37L90.73,98a8,8,0,0,1,10.07-.38l58.81,44.11L218.73,90a8,8,0,1,1,10.54,12l-64,56a8,8,0,0,1-10.07.38L96.39,114.29,40,163.63V200H224A8,8,0,0,1,232,208Z"/></svg>`,
  "chart-pie-slice": `<svg viewBox="0 0 256 256"><path d="M100,116.43a8,8,0,0,0,4-6.93v-72A8,8,0,0,0,93.34,30,104.06,104.06,0,0,0,25.73,147a8,8,0,0,0,4.52,5.81,7.86,7.86,0,0,0,3.35.74,8,8,0,0,0,4-1.07ZM88,49.62v55.26L40.12,132.51C40,131,40,129.48,40,128A88.12,88.12,0,0,1,88,49.62ZM128,24a8,8,0,0,0-8,8v91.82L41.19,169.73a8,8,0,0,0-2.87,11A104,104,0,1,0,128,24Zm0,192a88.47,88.47,0,0,1-71.49-36.68l75.52-44a8,8,0,0,0,4-6.92V40.36A88,88,0,0,1,128,216Z"/></svg>`,
  "chart-pie": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm71.87,53.27L136,114.14V40.37A88,88,0,0,1,199.87,77.27ZM120,40.37v83l-71.89,41.5A88,88,0,0,1,120,40.37ZM128,216a88,88,0,0,1-71.87-37.27L207.89,91.12A88,88,0,0,1,128,216Z"/></svg>`,
  "chat-centered-dots": `<svg viewBox="0 0 256 256"><path d="M116,120a12,12,0,1,1,12,12A12,12,0,0,1,116,120ZM84,132a12,12,0,1,0-12-12A12,12,0,0,0,84,132Zm88,0a12,12,0,1,0-12-12A12,12,0,0,0,172,132Zm60-76V184a16,16,0,0,1-16,16H155.57l-13.68,23.94a16,16,0,0,1-27.78,0L100.43,200H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Zm-16,0H40V184h65.07a8,8,0,0,1,7,4l16,28,16-28a8,8,0,0,1,7-4H216Z"/></svg>`,
  "chat-centered-slash": `<svg viewBox="0 0 256 256"><path d="M53.92,34.62A8,8,0,0,0,40,40h0A16,16,0,0,0,24,56V184a16,16,0,0,0,16,16h60.43l13.68,23.94a16,16,0,0,0,27.78,0L155.57,200h27.07l19.44,21.38a8,8,0,1,0,11.84-10.76Zm97,149.38a8,8,0,0,0-7,4l-16,28-16-28a8,8,0,0,0-7-4H40V56H51.73L168.1,184ZM232,56V186a8,8,0,0,1-16,0V56H98.52a8,8,0,1,1,0-16H216A16,16,0,0,1,232,56Z"/></svg>`,
  "chat-centered-text": `<svg viewBox="0 0 256 256"><path d="M88,104a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,104Zm8,40h64a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16ZM232,56V184a16,16,0,0,1-16,16H155.57l-13.68,23.94a16,16,0,0,1-27.78,0L100.43,200H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Zm-16,0H40V184h65.07a8,8,0,0,1,7,4l16,28,16-28a8,8,0,0,1,7-4H216Z"/></svg>`,
  "chat-centered": `<svg viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V184a16,16,0,0,0,16,16h60.43l13.68,23.94a16,16,0,0,0,27.78,0L155.57,200H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,144H150.93a8,8,0,0,0-7,4l-16,28-16-28a8,8,0,0,0-7-4H40V56H216Z"/></svg>`,
  "chat-circle-dots": `<svg viewBox="0 0 256 256"><path d="M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM84,116a12,12,0,1,0,12,12A12,12,0,0,0,84,116Zm88,0a12,12,0,1,0,12,12A12,12,0,0,0,172,116Zm60,12A104,104,0,0,1,79.12,219.82L45.07,231.17a16,16,0,0,1-20.24-20.24l11.35-34.05A104,104,0,1,1,232,128Zm-16,0A88,88,0,1,0,51.81,172.06a8,8,0,0,1,.66,6.54L40,216,77.4,203.53a7.85,7.85,0,0,1,2.53-.42,8,8,0,0,1,4,1.08A88,88,0,0,0,216,128Z"/></svg>`,
  "chat-circle-slash": `<svg viewBox="0 0 256 256"><path d="M53.92,34.62A8,8,0,1,0,42.08,45.38L52.33,56.66A104.06,104.06,0,0,0,36.18,176.88L24.83,210.93a16,16,0,0,0,20.24,20.24l34.05-11.35a104,104,0,0,0,112.7-9.73l10.26,11.29a8,8,0,1,0,11.84-10.76ZM128,216a87.87,87.87,0,0,1-44.06-11.81,8,8,0,0,0-6.54-.66L40,216,52.47,178.6a8,8,0,0,0-.66-6.54A88,88,0,0,1,63.14,68.54L181,198.23A87.77,87.77,0,0,1,128,216Zm104-88a104.15,104.15,0,0,1-12.38,49.25,8,8,0,0,1-14.09-7.58A88,88,0,0,0,93.88,46.86a8,8,0,0,1-6.21-14.75A104.06,104.06,0,0,1,232,128Z"/></svg>`,
  "chat-circle-text": `<svg viewBox="0 0 256 256"><path d="M168,112a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,112Zm-8,24H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm72-8A104,104,0,0,1,79.12,219.82L45.07,231.17a16,16,0,0,1-20.24-20.24l11.35-34.05A104,104,0,1,1,232,128Zm-16,0A88,88,0,1,0,51.81,172.06a8,8,0,0,1,.66,6.54L40,216,77.4,203.53a7.85,7.85,0,0,1,2.53-.42,8,8,0,0,1,4,1.08A88,88,0,0,0,216,128Z"/></svg>`,
  "chat-circle": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,0,0,36.18,176.88L24.83,210.93a16,16,0,0,0,20.24,20.24l34.05-11.35A104,104,0,1,0,128,24Zm0,192a87.87,87.87,0,0,1-44.06-11.81,8,8,0,0,0-6.54-.67L40,216,52.47,178.6a8,8,0,0,0-.66-6.54A88,88,0,1,1,128,216Z"/></svg>`,
  "chat-dots": `<svg viewBox="0 0 256 256"><path d="M116,128a12,12,0,1,1,12,12A12,12,0,0,1,116,128ZM84,140a12,12,0,1,0-12-12A12,12,0,0,0,84,140Zm88,0a12,12,0,1,0-12-12A12,12,0,0,0,172,140Zm60-76V192a16,16,0,0,1-16,16H83l-32.6,28.16-.09.07A15.89,15.89,0,0,1,40,240a16.13,16.13,0,0,1-6.8-1.52A15.85,15.85,0,0,1,24,224V64A16,16,0,0,1,40,48H216A16,16,0,0,1,232,64ZM40,224h0ZM216,64H40V224l34.77-30A8,8,0,0,1,80,192H216Z"/></svg>`,
  "chat-slash": `<svg viewBox="0 0 256 256"><path d="M53.92,34.62A8,8,0,1,0,42.08,45.38L44.46,48H40A16,16,0,0,0,24,64V224a15.85,15.85,0,0,0,9.24,14.5A16.13,16.13,0,0,0,40,240a15.94,15.94,0,0,0,10.26-3.78l.08-.07L83,208H189.92l12.16,13.38a8,8,0,1,0,11.84-10.76ZM80,192a8,8,0,0,0-5.23,1.95L40,224V64H59L175.37,192ZM232,64V186a8,8,0,0,1-16,0V64H105.79a8,8,0,0,1,0-16H216A16,16,0,0,1,232,64Z"/></svg>`,
  "chat-text": `<svg viewBox="0 0 256 256"><path d="M216,48H40A16,16,0,0,0,24,64V224a15.85,15.85,0,0,0,9.24,14.5A16.13,16.13,0,0,0,40,240a15.89,15.89,0,0,0,10.25-3.78l.09-.07L83,208H216a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM40,224h0ZM216,192H80a8,8,0,0,0-5.23,1.95L40,224V64H216ZM88,112a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,112Zm0,32a8,8,0,0,1,8-8h64a8,8,0,1,1,0,16H96A8,8,0,0,1,88,144Z"/></svg>`,
  "chat": `<svg viewBox="0 0 256 256"><path d="M216,48H40A16,16,0,0,0,24,64V224a15.84,15.84,0,0,0,9.25,14.5A16.05,16.05,0,0,0,40,240a15.89,15.89,0,0,0,10.25-3.78l.09-.07L83,208H216a16,16,0,0,0,16-16V64A16,16,0,0,0,216,48ZM40,224h0ZM216,192H80a8,8,0,0,0-5.23,1.95L40,224V64H216Z"/></svg>`,
  "chats-circle": `<svg viewBox="0 0 256 256"><path d="M232.07,186.76a80,80,0,0,0-62.5-114.17A80,80,0,1,0,23.93,138.76l-7.27,24.71a16,16,0,0,0,19.87,19.87l24.71-7.27a80.39,80.39,0,0,0,25.18,7.35,80,80,0,0,0,108.34,40.65l24.71,7.27a16,16,0,0,0,19.87-19.86ZM62,159.5a8.28,8.28,0,0,0-2.26.32L32,168l8.17-27.76a8,8,0,0,0-.63-6,64,64,0,1,1,26.26,26.26A8,8,0,0,0,62,159.5Zm153.79,28.73L224,216l-27.76-8.17a8,8,0,0,0-6,.63,64.05,64.05,0,0,1-85.87-24.88A79.93,79.93,0,0,0,174.7,89.71a64,64,0,0,1,41.75,92.48A8,8,0,0,0,215.82,188.23Z"/></svg>`,
  "chats-teardrop": `<svg viewBox="0 0 256 256"><path d="M169.57,72.59A80,80,0,0,0,16,104v64a16,16,0,0,0,16,16H86.67A80.15,80.15,0,0,0,160,232h64a16,16,0,0,0,16-16V152A80,80,0,0,0,169.57,72.59ZM32,104a64,64,0,1,1,64,64H32ZM224,216H160a64.14,64.14,0,0,1-55.68-32.43A79.93,79.93,0,0,0,174.7,89.71,64,64,0,0,1,224,152Z"/></svg>`,
  "chats": `<svg viewBox="0 0 256 256"><path d="M216,80H184V48a16,16,0,0,0-16-16H40A16,16,0,0,0,24,48V176a8,8,0,0,0,13,6.22L72,154V184a16,16,0,0,0,16,16h93.59L219,230.22a8,8,0,0,0,5,1.78,8,8,0,0,0,8-8V96A16,16,0,0,0,216,80ZM66.55,137.78,40,159.25V48H168v88H71.58A8,8,0,0,0,66.55,137.78ZM216,207.25l-26.55-21.47a8,8,0,0,0-5-1.78H88V152h80a16,16,0,0,0,16-16V96h32Z"/></svg>`,
  "check-circle": `<svg viewBox="0 0 256 256"><path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"/></svg>`,
  "check-fat": `<svg viewBox="0 0 256 256"><path d="M243.28,68.24l-24-23.56a16,16,0,0,0-22.59,0L104,136.23l-36.69-35.6a16,16,0,0,0-22.58.05l-24,24a16,16,0,0,0,0,22.61l71.62,72a16,16,0,0,0,22.63,0L243.33,90.91A16,16,0,0,0,243.28,68.24ZM103.62,208,32,136l24-24a.6.6,0,0,1,.08.08l42.35,41.09a8,8,0,0,0,11.19,0L208.06,56,232,79.6Z"/></svg>`,
  "check-square-offset": `<svg viewBox="0 0 256 256"><path d="M224,48V208a16,16,0,0,1-16,16H136a8,8,0,0,1,0-16h72V48H48v96a8,8,0,0,1-16,0V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM125.66,154.34a8,8,0,0,0-11.32,0L64,204.69,45.66,186.34a8,8,0,0,0-11.32,11.32l24,24a8,8,0,0,0,11.32,0l56-56A8,8,0,0,0,125.66,154.34Z"/></svg>`,
  "check-square": `<svg viewBox="0 0 256 256"><path d="M173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34ZM224,48V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM208,208V48H48V208H208Z"/></svg>`,
  "check": `<svg viewBox="0 0 256 256"><path d="M229.66,77.66l-128,128a8,8,0,0,1-11.32,0l-56-56a8,8,0,0,1,11.32-11.32L96,188.69,218.34,66.34a8,8,0,0,1,11.32,11.32Z"/></svg>`,
  "checks": `<svg viewBox="0 0 256 256"><path d="M149.61,85.71l-89.6,88a8,8,0,0,1-11.22,0L10.39,136a8,8,0,1,1,11.22-11.41L54.4,156.79l84-82.5a8,8,0,1,1,11.22,11.42Zm96.1-11.32a8,8,0,0,0-11.32-.1l-84,82.5-18.83-18.5a8,8,0,0,0-11.21,11.42l24.43,24a8,8,0,0,0,11.22,0l89.6-88A8,8,0,0,0,245.71,74.39Z"/></svg>`,
  "clear-formatting": `<svg viewBox="0 0 256 256"><path d="M225,80.4,183.6,39a24,24,0,0,0-33.94,0L31,157.66a24,24,0,0,0,0,33.94l30.06,30.06A8,8,0,0,0,66.74,224H216a8,8,0,0,0,0-16h-84.7L225,114.34A24,24,0,0,0,225,80.4ZM108.68,208H70.06L43.31,181.25a8,8,0,0,1,0-11.31L96,117.25,146.75,168ZM213.66,103,163.31,153.31,112.63,102.63,163,52.28a8,8,0,0,1,11.32,0l41.38,41.38a8,8,0,0,1,0,11.31Z"/></svg>`,
  "clipboard-text": `<svg viewBox="0 0 256 256"><path d="M168,152a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,152Zm-8-40H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm56-64V216a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V48A16,16,0,0,1,56,32H92.26a47.92,47.92,0,0,1,71.48,0H200A16,16,0,0,1,216,48ZM96,64h64a32,32,0,0,0-64,0ZM200,48H173.25A47.93,47.93,0,0,1,176,64v8a8,8,0,0,1-8,8H88a8,8,0,0,1-8-8V64a47.93,47.93,0,0,1,2.75-16H56V216H200Z"/></svg>`,
  "clipboard": `<svg viewBox="0 0 256 256"><path d="M200,32H163.74a47.92,47.92,0,0,0-71.48,0H56A16,16,0,0,0,40,48V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm-72,0a32,32,0,0,1,32,32H96A32,32,0,0,1,128,32Zm72,184H56V48H82.75A47.93,47.93,0,0,0,80,64v8a8,8,0,0,0,8,8h80a8,8,0,0,0,8-8V64a47.93,47.93,0,0,0-2.75-16H200Z"/></svg>`,
  "clock-afternoon": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a8,8,0,0,1-8,8H147.31l26.35,26.34a8,8,0,0,1-11.32,11.32l-40-40A8,8,0,0,1,128,120h56A8,8,0,0,1,192,128Z"/></svg>`,
  "clock-clockwise": `<svg viewBox="0 0 256 256"><path d="M136,80v43.47l36.12,21.67a8,8,0,0,1-8.24,13.72l-40-24A8,8,0,0,1,120,128V80a8,8,0,0,1,16,0Zm88-24a8,8,0,0,0-8,8V82c-6.35-7.36-12.83-14.45-20.12-21.83a96,96,0,1,0-2,137.7,8,8,0,0,0-11-11.64A80,80,0,1,1,184.54,71.4C192.68,79.64,199.81,87.58,207,96H184a8,8,0,0,0,0,16h40a8,8,0,0,0,8-8V64A8,8,0,0,0,224,56Z"/></svg>`,
  "clock-countdown": `<svg viewBox="0 0 256 256"><path d="M232,136.66A104.12,104.12,0,1,1,119.34,24,8,8,0,0,1,120.66,40,88.12,88.12,0,1,0,216,135.34,8,8,0,0,1,232,136.66ZM120,72v56a8,8,0,0,0,8,8h56a8,8,0,0,0,0-16H136V72a8,8,0,0,0-16,0Zm40-24a12,12,0,1,0-12-12A12,12,0,0,0,160,48Zm36,24a12,12,0,1,0-12-12A12,12,0,0,0,196,72Zm24,36a12,12,0,1,0-12-12A12,12,0,0,0,220,108Z"/></svg>`,
  "clock-counter-clockwise": `<svg viewBox="0 0 256 256"><path d="M136,80v43.47l36.12,21.67a8,8,0,0,1-8.24,13.72l-40-24A8,8,0,0,1,120,128V80a8,8,0,0,1,16,0Zm-8-48A95.44,95.44,0,0,0,60.08,60.15C52.81,67.51,46.35,74.59,40,82V64a8,8,0,0,0-16,0v40a8,8,0,0,0,8,8H72a8,8,0,0,0,0-16H49c7.15-8.42,14.27-16.35,22.39-24.57a80,80,0,1,1,1.66,114.75,8,8,0,1,0-11,11.64A96,96,0,1,0,128,32Z"/></svg>`,
  "clock-user": `<svg viewBox="0 0 256 256"><path d="M136,72v43.05l36.42-18.21a8,8,0,0,1,7.16,14.31l-48,24A8,8,0,0,1,120,128V72a8,8,0,0,1,16,0Zm-8,144a88,88,0,1,1,88-88,8,8,0,0,0,16,0A104,104,0,1,0,128,232a8,8,0,0,0,0-16Zm103.73,5.94a8,8,0,1,1-15.46,4.11C213.44,215.42,203.46,208,192,208s-21.44,7.42-24.27,18.05A8,8,0,0,1,160,232a8.15,8.15,0,0,1-2.06-.27,8,8,0,0,1-5.67-9.79,40,40,0,0,1,17.11-23.32,32,32,0,1,1,45.23,0A40,40,0,0,1,231.73,221.94ZM176,176a16,16,0,1,0,16-16A16,16,0,0,0,176,176Z"/></svg>`,
  "clock": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48A8,8,0,0,1,192,128Z"/></svg>`,
  "cloud-arrow-down": `<svg viewBox="0 0 256 256"><path d="M248,128a87.34,87.34,0,0,1-17.6,52.81,8,8,0,1,1-12.8-9.62A71.34,71.34,0,0,0,232,128a72,72,0,0,0-144,0,8,8,0,0,1-16,0,88,88,0,0,1,3.29-23.88C74.2,104,73.1,104,72,104a48,48,0,0,0,0,96H96a8,8,0,0,1,0,16H72A64,64,0,1,1,81.29,88.68,88,88,0,0,1,248,128Zm-69.66,42.34L160,188.69V128a8,8,0,0,0-16,0v60.69l-18.34-18.35a8,8,0,0,0-11.32,11.32l32,32a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z"/></svg>`,
  "cloud-arrow-up": `<svg viewBox="0 0 256 256"><path d="M178.34,165.66,160,147.31V208a8,8,0,0,1-16,0V147.31l-18.34,18.35a8,8,0,0,1-11.32-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32ZM160,40A88.08,88.08,0,0,0,81.29,88.68,64,64,0,1,0,72,216h40a8,8,0,0,0,0-16H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.12A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,100.8,66,8,8,0,0,0,3.2,15.34,7.9,7.9,0,0,0,3.2-.68A88,88,0,0,0,160,40Z"/></svg>`,
  "cloud-check": `<svg viewBox="0 0 256 256"><path d="M160,40A88.09,88.09,0,0,0,81.29,88.67,64,64,0,1,0,72,216h88a88,88,0,0,0,0-176Zm0,160H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.11A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,72,72Zm37.66-93.66a8,8,0,0,1,0,11.32l-48,48a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L144,148.69l42.34-42.35A8,8,0,0,1,197.66,106.34Z"/></svg>`,
  "cloud-slash": `<svg viewBox="0 0 256 256"><path d="M53.92,34.62A8,8,0,1,0,42.08,45.38L81.32,88.55l-.06.12A65,65,0,0,0,72,88a64,64,0,0,0,0,128h88a87.34,87.34,0,0,0,31.8-5.93l10.28,11.31a8,8,0,1,0,11.84-10.76ZM160,200H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.3.12A88.4,88.4,0,0,0,72,128a8,8,0,0,0,16,0,72.25,72.25,0,0,1,5.06-26.54l87,95.7A71.66,71.66,0,0,1,160,200Zm88-72a87.89,87.89,0,0,1-22.35,58.61A8,8,0,0,1,213.71,176,72,72,0,0,0,117.37,70a8,8,0,0,1-9.48-12.89A88,88,0,0,1,248,128Z"/></svg>`,
  "cloud-warning": `<svg viewBox="0 0 256 256"><path d="M160,40A88.09,88.09,0,0,0,81.29,88.67,64,64,0,1,0,72,216h88a88,88,0,0,0,0-176Zm0,160H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.11A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,72,72Zm-8-72V88a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,172,164Z"/></svg>`,
  "cloud-x": `<svg viewBox="0 0 256 256"><path d="M160,40A88.09,88.09,0,0,0,81.29,88.67,64,64,0,1,0,72,216h88a88,88,0,0,0,0-176Zm0,160H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.11A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,72,72Zm29.66-82.34L171.31,136l18.35,18.34a8,8,0,0,1-11.32,11.32L160,147.31l-18.34,18.35a8,8,0,0,1-11.32-11.32L148.69,136l-18.35-18.34a8,8,0,0,1,11.32-11.32L160,124.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z"/></svg>`,
  "cloud": `<svg viewBox="0 0 256 256"><path d="M160,40A88.09,88.09,0,0,0,81.29,88.67,64,64,0,1,0,72,216h88a88,88,0,0,0,0-176Zm0,160H72a48,48,0,0,1,0-96c1.1,0,2.2,0,3.29.11A88,88,0,0,0,72,128a8,8,0,0,0,16,0,72,72,0,1,1,72,72Z"/></svg>`,
  "code-block": `<svg viewBox="0 0 256 256"><path d="M58.34,101.66l-32-32a8,8,0,0,1,0-11.32l32-32A8,8,0,0,1,69.66,37.66L43.31,64,69.66,90.34a8,8,0,0,1-11.32,11.32Zm40,0a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0,0-11.32l-32-32A8,8,0,0,0,98.34,37.66L124.69,64,98.34,90.34A8,8,0,0,0,98.34,101.66ZM200,40H176a8,8,0,0,0,0,16h24V200H56V136a8,8,0,0,0-16,0v64a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V56A16,16,0,0,0,200,40Z"/></svg>`,
  "code-simple": `<svg viewBox="0 0 256 256"><path d="M93.31,70,28,128l65.27,58a8,8,0,1,1-10.62,12l-72-64a8,8,0,0,1,0-12l72-64A8,8,0,1,1,93.31,70Zm152,52-72-64a8,8,0,0,0-10.62,12L228,128l-65.27,58a8,8,0,1,0,10.62,12l72-64a8,8,0,0,0,0-12Z"/></svg>`,
  "code": `<svg viewBox="0 0 256 256"><path d="M69.12,94.15,28.5,128l40.62,33.85a8,8,0,1,1-10.24,12.29l-48-40a8,8,0,0,1,0-12.29l48-40a8,8,0,0,1,10.24,12.3Zm176,27.7-48-40a8,8,0,1,0-10.24,12.3L227.5,128l-40.62,33.85a8,8,0,1,0,10.24,12.29l48-40a8,8,0,0,0,0-12.29ZM162.73,32.48a8,8,0,0,0-10.25,4.79l-64,176a8,8,0,0,0,4.79,10.26A8.14,8.14,0,0,0,96,224a8,8,0,0,0,7.52-5.27l64-176A8,8,0,0,0,162.73,32.48Z"/></svg>`,
  "columns-plus-left": `<svg viewBox="0 0 256 256"><path d="M128,32H104A16,16,0,0,0,88,48V208a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V48A16,16,0,0,0,128,32Zm0,176H104V48h24ZM200,32H176a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V48A16,16,0,0,0,200,32Zm0,176H176V48h24ZM72,128a8,8,0,0,1-8,8H48v16a8,8,0,0,1-16,0V136H16a8,8,0,0,1,0-16H32V104a8,8,0,0,1,16,0v16H64A8,8,0,0,1,72,128Z"/></svg>`,
  "columns-plus-right": `<svg viewBox="0 0 256 256"><path d="M80,32H56A16,16,0,0,0,40,48V208a16,16,0,0,0,16,16H80a16,16,0,0,0,16-16V48A16,16,0,0,0,80,32Zm0,176H56V48H80ZM152,32H128a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h24a16,16,0,0,0,16-16V48A16,16,0,0,0,152,32Zm0,176H128V48h24Zm96-80a8,8,0,0,1-8,8H224v16a8,8,0,0,1-16,0V136H192a8,8,0,0,1,0-16h16V104a8,8,0,0,1,16,0v16h16A8,8,0,0,1,248,128Z"/></svg>`,
  "columns": `<svg viewBox="0 0 256 256"><path d="M104,32H64A16,16,0,0,0,48,48V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,104,32Zm0,176H64V48h40ZM192,32H152a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V48A16,16,0,0,0,192,32Zm0,176H152V48h40Z"/></svg>`,
  "copy-simple": `<svg viewBox="0 0 256 256"><path d="M184,64H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H184a8,8,0,0,0,8-8V72A8,8,0,0,0,184,64Zm-8,144H48V80H176ZM224,40V184a8,8,0,0,1-16,0V48H72a8,8,0,0,1,0-16H216A8,8,0,0,1,224,40Z"/></svg>`,
  "copy": `<svg viewBox="0 0 256 256"><path d="M216,32H88a8,8,0,0,0-8,8V80H40a8,8,0,0,0-8,8V216a8,8,0,0,0,8,8H168a8,8,0,0,0,8-8V176h40a8,8,0,0,0,8-8V40A8,8,0,0,0,216,32ZM160,208H48V96H160Zm48-48H176V88a8,8,0,0,0-8-8H96V48H208Z"/></svg>`,
  "credit-card": `<svg viewBox="0 0 256 256"><path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,16V88H32V64Zm0,128H32V104H224v88Zm-16-24a8,8,0,0,1-8,8H168a8,8,0,0,1,0-16h32A8,8,0,0,1,208,168Zm-64,0a8,8,0,0,1-8,8H120a8,8,0,0,1,0-16h16A8,8,0,0,1,144,168Z"/></svg>`,
  "currency-circle-dollar": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm40-68a28,28,0,0,1-28,28h-4v8a8,8,0,0,1-16,0v-8H104a8,8,0,0,1,0-16h36a12,12,0,0,0,0-24H116a28,28,0,0,1,0-56h4V72a8,8,0,0,1,16,0v8h16a8,8,0,0,1,0,16H116a12,12,0,0,0,0,24h24A28,28,0,0,1,168,148Z"/></svg>`,
  "currency-dollar-simple": `<svg viewBox="0 0 256 256"><path d="M200,168a48.05,48.05,0,0,1-48,48H136v16a8,8,0,0,1-16,0V216H104a48.05,48.05,0,0,1-48-48,8,8,0,0,1,16,0,32,32,0,0,0,32,32h48a32,32,0,0,0,0-64H112a48,48,0,0,1,0-96h8V24a8,8,0,0,1,16,0V40h8a48.05,48.05,0,0,1,48,48,8,8,0,0,1-16,0,32,32,0,0,0-32-32H112a32,32,0,0,0,0,64h40A48.05,48.05,0,0,1,200,168Z"/></svg>`,
  "currency-dollar": `<svg viewBox="0 0 256 256"><path d="M152,120H136V56h8a32,32,0,0,1,32,32,8,8,0,0,0,16,0,48.05,48.05,0,0,0-48-48h-8V24a8,8,0,0,0-16,0V40h-8a48,48,0,0,0,0,96h8v64H104a32,32,0,0,1-32-32,8,8,0,0,0-16,0,48.05,48.05,0,0,0,48,48h16v16a8,8,0,0,0,16,0V216h16a48,48,0,0,0,0-96Zm-40,0a32,32,0,0,1,0-64h8v64Zm40,80H136V136h16a32,32,0,0,1,0,64Z"/></svg>`,
  "currency-eur": `<svg viewBox="0 0 256 256"><path d="M190,192.33a8,8,0,0,1-.63,11.3A80,80,0,0,1,56.4,152H40a8,8,0,0,1,0-16H56V120H40a8,8,0,0,1,0-16H56.4A80,80,0,0,1,189.34,52.37,8,8,0,0,1,178.66,64.3,64,64,0,0,0,72.52,104H136a8,8,0,0,1,0,16H72v16h48a8,8,0,0,1,0,16H72.52a64,64,0,0,0,106.14,39.71A8,8,0,0,1,190,192.33Z"/></svg>`,
  "cursor-click": `<svg viewBox="0 0 256 256"><path d="M88,24V16a8,8,0,0,1,16,0v8a8,8,0,0,1-16,0ZM16,104h8a8,8,0,0,0,0-16H16a8,8,0,0,0,0,16ZM124.42,39.16a8,8,0,0,0,10.74-3.58l8-16a8,8,0,0,0-14.31-7.16l-8,16A8,8,0,0,0,124.42,39.16Zm-96,81.69-16,8a8,8,0,0,0,7.16,14.31l16-8a8,8,0,1,0-7.16-14.31ZM219.31,184a16,16,0,0,1,0,22.63l-12.68,12.68a16,16,0,0,1-22.63,0L132.7,168,115,214.09c0,.1-.08.21-.13.32a15.83,15.83,0,0,1-14.6,9.59l-.79,0a15.83,15.83,0,0,1-14.41-11L32.8,52.92A16,16,0,0,1,52.92,32.8L213,85.07a16,16,0,0,1,1.41,29.8l-.32.13L168,132.69ZM208,195.31,156.69,144h0a16,16,0,0,1,4.93-26l.32-.14,45.95-17.64L48,48l52.2,159.86,17.65-46c0-.11.08-.22.13-.33a16,16,0,0,1,11.69-9.34,16.72,16.72,0,0,1,3-.28,16,16,0,0,1,11.3,4.69L195.31,208Z"/></svg>`,
  "cursor-text": `<svg viewBox="0 0 256 256"><path d="M184,208a8,8,0,0,1-8,8H160a40,40,0,0,1-32-16,40,40,0,0,1-32,16H80a8,8,0,0,1,0-16H96a24,24,0,0,0,24-24V136H104a8,8,0,0,1,0-16h16V80A24,24,0,0,0,96,56H80a8,8,0,0,1,0-16H96a40,40,0,0,1,32,16,40,40,0,0,1,32-16h16a8,8,0,0,1,0,16H160a24,24,0,0,0-24,24v40h16a8,8,0,0,1,0,16H136v40a24,24,0,0,0,24,24h16A8,8,0,0,1,184,208Z"/></svg>`,
  "cursor": `<svg viewBox="0 0 256 256"><path d="M168,132.69,214.08,115l.33-.13A16,16,0,0,0,213,85.07L52.92,32.8A15.95,15.95,0,0,0,32.8,52.92L85.07,213a15.82,15.82,0,0,0,14.41,11l.78,0a15.84,15.84,0,0,0,14.61-9.59l.13-.33L132.69,168,184,219.31a16,16,0,0,0,22.63,0l12.68-12.68a16,16,0,0,0,0-22.63ZM195.31,208,144,156.69a16,16,0,0,0-26,4.93c0,.11-.09.22-.13.32l-17.65,46L48,48l159.85,52.2-45.95,17.64-.32.13a16,16,0,0,0-4.93,26h0L208,195.31Z"/></svg>`,
  "database": `<svg viewBox="0 0 256 256"><path d="M128,24C74.17,24,32,48.6,32,80v96c0,31.4,42.17,56,96,56s96-24.6,96-56V80C224,48.6,181.83,24,128,24Zm80,104c0,9.62-7.88,19.43-21.61,26.92C170.93,163.35,150.19,168,128,168s-42.93-4.65-58.39-13.08C55.88,147.43,48,137.62,48,128V111.36c17.06,15,46.23,24.64,80,24.64s62.94-9.68,80-24.64ZM69.61,53.08C85.07,44.65,105.81,40,128,40s42.93,4.65,58.39,13.08C200.12,60.57,208,70.38,208,80s-7.88,19.43-21.61,26.92C170.93,115.35,150.19,120,128,120s-42.93-4.65-58.39-13.08C55.88,99.43,48,89.62,48,80S55.88,60.57,69.61,53.08ZM186.39,202.92C170.93,211.35,150.19,216,128,216s-42.93-4.65-58.39-13.08C55.88,195.43,48,185.62,48,176V159.36c17.06,15,46.23,24.64,80,24.64s62.94-9.68,80-24.64V176C208,185.62,200.12,195.43,186.39,202.92Z"/></svg>`,
  "door-open": `<svg viewBox="0 0 256 256"><path d="M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-40,0H176V40h16ZM64,40h96V216H64Zm80,92a12,12,0,1,1-12-12A12,12,0,0,1,144,132Z"/></svg>`,
  "door": `<svg viewBox="0 0 256 256"><path d="M232,216H208V40a16,16,0,0,0-16-16H64A16,16,0,0,0,48,40V216H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM64,40H192V216H64Zm104,92a12,12,0,1,1-12-12A12,12,0,0,1,168,132Z"/></svg>`,
  "dots-nine": `<svg viewBox="0 0 256 256"><path d="M72,60A12,12,0,1,1,60,48,12,12,0,0,1,72,60Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,128,48Zm68,24a12,12,0,1,0-12-12A12,12,0,0,0,196,72ZM60,116a12,12,0,1,0,12,12A12,12,0,0,0,60,116Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,116Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,196,116ZM60,184a12,12,0,1,0,12,12A12,12,0,0,0,60,184Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,184Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,196,184Z"/></svg>`,
  "dots-six-vertical": `<svg viewBox="0 0 256 256"><path d="M104,60A12,12,0,1,1,92,48,12,12,0,0,1,104,60Zm60,12a12,12,0,1,0-12-12A12,12,0,0,0,164,72ZM92,116a12,12,0,1,0,12,12A12,12,0,0,0,92,116Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,116ZM92,184a12,12,0,1,0,12,12A12,12,0,0,0,92,184Zm72,0a12,12,0,1,0,12,12A12,12,0,0,0,164,184Z"/></svg>`,
  "dots-six": `<svg viewBox="0 0 256 256"><path d="M72,92A12,12,0,1,1,60,80,12,12,0,0,1,72,92Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,128,80Zm68,24a12,12,0,1,0-12-12A12,12,0,0,0,196,104ZM60,152a12,12,0,1,0,12,12A12,12,0,0,0,60,152Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,128,152Zm68,0a12,12,0,1,0,12,12A12,12,0,0,0,196,152Z"/></svg>`,
  "dots-three-circle-vertical": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm12-88a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm0-44a12,12,0,1,1-12-12A12,12,0,0,1,140,84Zm0,88a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z"/></svg>`,
  "dots-three-circle": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm12-88a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm44,0a12,12,0,1,1-12-12A12,12,0,0,1,184,128Zm-88,0a12,12,0,1,1-12-12A12,12,0,0,1,96,128Z"/></svg>`,
  "dots-three-outline-vertical": `<svg viewBox="0 0 256 256"><path d="M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,144Zm0-64A32,32,0,1,0,96,48,32,32,0,0,0,128,80Zm0-48a16,16,0,1,1-16,16A16,16,0,0,1,128,32Zm0,144a32,32,0,1,0,32,32A32,32,0,0,0,128,176Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,224Z"/></svg>`,
  "dots-three-outline": `<svg viewBox="0 0 256 256"><path d="M128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,144ZM48,96a32,32,0,1,0,32,32A32,32,0,0,0,48,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,48,144ZM208,96a32,32,0,1,0,32,32A32,32,0,0,0,208,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,208,144Z"/></svg>`,
  "dots-three-vertical": `<svg viewBox="0 0 256 256"><path d="M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128ZM128,72a12,12,0,1,0-12-12A12,12,0,0,0,128,72Zm0,112a12,12,0,1,0,12,12A12,12,0,0,0,128,184Z"/></svg>`,
  "dots-three": `<svg viewBox="0 0 256 256"><path d="M140,128a12,12,0,1,1-12-12A12,12,0,0,1,140,128Zm56-12a12,12,0,1,0,12,12A12,12,0,0,0,196,116ZM60,116a12,12,0,1,0,12,12A12,12,0,0,0,60,116Z"/></svg>`,
  "download-simple": `<svg viewBox="0 0 256 256"><path d="M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0Zm-101.66,5.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0-11.32-11.32L136,124.69V32a8,8,0,0,0-16,0v92.69L93.66,98.34a8,8,0,0,0-11.32,11.32Z"/></svg>`,
  "download": `<svg viewBox="0 0 256 256"><path d="M240,136v64a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V136a16,16,0,0,1,16-16H72a8,8,0,0,1,0,16H32v64H224V136H184a8,8,0,0,1,0-16h40A16,16,0,0,1,240,136Zm-117.66-2.34a8,8,0,0,0,11.32,0l48-48a8,8,0,0,0-11.32-11.32L136,108.69V24a8,8,0,0,0-16,0v84.69L85.66,74.34A8,8,0,0,0,74.34,85.66ZM200,168a12,12,0,1,0-12,12A12,12,0,0,0,200,168Z"/></svg>`,
  "dropbox-logo": `<svg viewBox="0 0 256 256"><path d="M236.55,149.42,194.05,120l42.5-29.42a8,8,0,0,0,0-13.16l-52-36a8,8,0,0,0-9.1,0L128,74.27,80.55,41.42a8,8,0,0,0-9.1,0l-52,36a8,8,0,0,0,0,13.16L62,120l-42.5,29.42a8,8,0,0,0,0,13.16l52,36a8,8,0,0,0,9.1,0L128,165.73l47.45,32.85a8,8,0,0,0,9.1,0l52-36a8,8,0,0,0,0-13.16ZM128,146.27,90.05,120l38-26.27L166,120Zm52-88.54L218,84,180,110.27,142.05,84Zm-104,0L114,84,76,110.27,38.05,84Zm0,124.54L38.05,156l38-26.27L114,156Zm104,0L142.05,156,180,129.73,218,156Zm-21.53,24.64a8,8,0,0,1-2,11.13l-23.89,16.54a8,8,0,0,1-9.1,0L99.56,218a8,8,0,0,1,9.1-13.16L128,218.27l19.34-13.39A8,8,0,0,1,158.47,206.91Z"/></svg>`,
  "envelope-open": `<svg viewBox="0 0 256 256"><path d="M228.44,89.34l-96-64a8,8,0,0,0-8.88,0l-96,64A8,8,0,0,0,24,96V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V96A8,8,0,0,0,228.44,89.34ZM96.72,152,40,192V111.53Zm16.37,8h29.82l56.63,40H56.46Zm46.19-8L216,111.53V192ZM128,41.61l81.91,54.61-67,47.78H113.11l-67-47.78Z"/></svg>`,
  "envelope-simple-open": `<svg viewBox="0 0 256 256"><path d="M228.44,89.34l-96-64a8,8,0,0,0-8.88,0l-96,64A8,8,0,0,0,24,96V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V96A8,8,0,0,0,228.44,89.34ZM128,41.61l81.91,54.61-67,47.78H113.11l-67-47.78ZM40,200V111.53l65.9,47a8,8,0,0,0,4.65,1.49h34.9a8,8,0,0,0,4.65-1.49l65.9-47V200Z"/></svg>`,
  "envelope-simple": `<svg viewBox="0 0 256 256"><path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM203.43,64,128,133.15,52.57,64ZM216,192H40V74.19l82.59,75.71a8,8,0,0,0,10.82,0L216,74.19V192Z"/></svg>`,
  "envelope": `<svg viewBox="0 0 256 256"><path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48Zm-96,85.15L52.57,64H203.43ZM98.71,128,40,181.81V74.19Zm11.84,10.85,12,11.05a8,8,0,0,0,10.82,0l12-11.05,58,53.15H52.57ZM157.29,128,216,74.18V181.82Z"/></svg>`,
  "exam": `<svg viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V216a8,8,0,0,0,11.58,7.16L64,208.94l28.42,14.22a8,8,0,0,0,7.16,0L128,208.94l28.42,14.22a8,8,0,0,0,7.16,0L192,208.94l28.42,14.22A8,8,0,0,0,232,216V56A16,16,0,0,0,216,40Zm0,163.06-20.42-10.22a8,8,0,0,0-7.16,0L160,207.06l-28.42-14.22a8,8,0,0,0-7.16,0L96,207.06,67.58,192.84a8,8,0,0,0-7.16,0L40,203.06V56H216ZM60.42,167.16a8,8,0,0,0,10.74-3.58L76.94,152h38.12l5.78,11.58a8,8,0,1,0,14.32-7.16l-32-64a8,8,0,0,0-14.32,0l-32,64A8,8,0,0,0,60.42,167.16ZM96,113.89,107.06,136H84.94ZM136,128a8,8,0,0,1,8-8h16V104a8,8,0,0,1,16,0v16h16a8,8,0,0,1,0,16H176v16a8,8,0,0,1-16,0V136H144A8,8,0,0,1,136,128Z"/></svg>`,
  "exclamation-mark": `<svg viewBox="0 0 256 256"><path d="M144,200a16,16,0,1,1-16-16A16,16,0,0,1,144,200Zm-16-40a8,8,0,0,0,8-8V48a8,8,0,0,0-16,0V152A8,8,0,0,0,128,160Z"/></svg>`,
  "export": `<svg viewBox="0 0 256 256"><path d="M216,112v96a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V112A16,16,0,0,1,56,96H80a8,8,0,0,1,0,16H56v96H200V112H176a8,8,0,0,1,0-16h24A16,16,0,0,1,216,112ZM93.66,69.66,120,43.31V136a8,8,0,0,0,16,0V43.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,69.66Z"/></svg>`,
  "eye-closed": `<svg viewBox="0 0 256 256"><path d="M228,175a8,8,0,0,1-10.92-3l-19-33.2A123.23,123.23,0,0,1,162,155.46l5.87,35.22a8,8,0,0,1-6.58,9.21A8.4,8.4,0,0,1,160,200a8,8,0,0,1-7.88-6.69l-5.77-34.58a133.06,133.06,0,0,1-36.68,0l-5.77,34.58A8,8,0,0,1,96,200a8.4,8.4,0,0,1-1.32-.11,8,8,0,0,1-6.58-9.21L94,155.46a123.23,123.23,0,0,1-36.06-16.69L39,172A8,8,0,1,1,25.06,164l20-35a153.47,153.47,0,0,1-19.3-20A8,8,0,1,1,38.22,99c16.6,20.54,45.64,45,89.78,45s73.18-24.49,89.78-45A8,8,0,1,1,230.22,109a153.47,153.47,0,0,1-19.3,20l20,35A8,8,0,0,1,228,175Z"/></svg>`,
  "eye-slash": `<svg viewBox="0 0 256 256"><path d="M53.92,34.62A8,8,0,1,0,42.08,45.38L61.32,66.55C25,88.84,9.38,123.2,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208a127.11,127.11,0,0,0,52.07-10.83l22,24.21a8,8,0,1,0,11.84-10.76Zm47.33,75.84,41.67,45.85a32,32,0,0,1-41.67-45.85ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.16,133.16,0,0,1,25,128c4.69-8.79,19.66-33.39,47.35-49.38l18,19.75a48,48,0,0,0,63.66,70l14.73,16.2A112,112,0,0,1,128,192Zm6-95.43a8,8,0,0,1,3-15.72,48.16,48.16,0,0,1,38.77,42.64,8,8,0,0,1-7.22,8.71,6.39,6.39,0,0,1-.75,0,8,8,0,0,1-8-7.26A32.09,32.09,0,0,0,134,96.57Zm113.28,34.69c-.42.94-10.55,23.37-33.36,43.8a8,8,0,1,1-10.67-11.92A132.77,132.77,0,0,0,231.05,128a133.15,133.15,0,0,0-23.12-30.77C185.67,75.19,158.78,64,128,64a118.37,118.37,0,0,0-19.36,1.57A8,8,0,1,1,106,49.79,134,134,0,0,1,128,48c34.88,0,66.57,13.26,91.66,38.35,18.83,18.83,27.3,37.62,27.65,38.41A8,8,0,0,1,247.31,131.26Z"/></svg>`,
  "eye": `<svg viewBox="0 0 256 256"><path d="M247.31,124.76c-.35-.79-8.82-19.58-27.65-38.41C194.57,61.26,162.88,48,128,48S61.43,61.26,36.34,86.35C17.51,105.18,9,124,8.69,124.76a8,8,0,0,0,0,6.5c.35.79,8.82,19.57,27.65,38.4C61.43,194.74,93.12,208,128,208s66.57-13.26,91.66-38.34c18.83-18.83,27.3-37.61,27.65-38.4A8,8,0,0,0,247.31,124.76ZM128,192c-30.78,0-57.67-11.19-79.93-33.25A133.47,133.47,0,0,1,25,128,133.33,133.33,0,0,1,48.07,97.25C70.33,75.19,97.22,64,128,64s57.67,11.19,79.93,33.25A133.46,133.46,0,0,1,231.05,128C223.84,141.46,192.43,192,128,192Zm0-112a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Z"/></svg>`,
  "faders-horizontal": `<svg viewBox="0 0 256 256"><path d="M176,80a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H184A8,8,0,0,1,176,80ZM40,88H144v16a8,8,0,0,0,16,0V56a8,8,0,0,0-16,0V72H40a8,8,0,0,0,0,16Zm176,80H120a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16ZM88,144a8,8,0,0,0-8,8v16H40a8,8,0,0,0,0,16H80v16a8,8,0,0,0,16,0V152A8,8,0,0,0,88,144Z"/></svg>`,
  "faders": `<svg viewBox="0 0 256 256"><path d="M136,120v96a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm64,72a8,8,0,0,0-8,8v16a8,8,0,0,0,16,0V200A8,8,0,0,0,200,192Zm24-32H208V40a8,8,0,0,0-16,0V160H176a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16ZM56,160a8,8,0,0,0-8,8v48a8,8,0,0,0,16,0V168A8,8,0,0,0,56,160Zm24-32H64V40a8,8,0,0,0-16,0v88H32a8,8,0,0,0,0,16H80a8,8,0,0,0,0-16Zm72-48H136V40a8,8,0,0,0-16,0V80H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"/></svg>`,
  "file-archive": `<svg viewBox="0 0 256 256"><path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H112V200h8a8,8,0,0,0,0-16h-8V168h8a8,8,0,0,0,0-16h-8V136h8a8,8,0,0,0,0-16h-8v-8a8,8,0,0,0-16,0v8H88a8,8,0,0,0,0,16h8v16H88a8,8,0,0,0,0,16h8v16H88a8,8,0,0,0,0,16h8v16H56V40h88V88a8,8,0,0,0,8,8h48V216Z"/></svg>`,
  "file-arrow-down": `<svg viewBox="0 0 256 256"><path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-42.34-61.66a8,8,0,0,1,0,11.32l-24,24a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L120,164.69V120a8,8,0,0,1,16,0v44.69l10.34-10.35A8,8,0,0,1,157.66,154.34Z"/></svg>`,
  "file-arrow-up": `<svg viewBox="0 0 256 256"><path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-42.34-77.66a8,8,0,0,1-11.32,11.32L136,139.31V184a8,8,0,0,1-16,0V139.31l-10.34,10.35a8,8,0,0,1-11.32-11.32l24-24a8,8,0,0,1,11.32,0Z"/></svg>`,
  "file-cloud": `<svg viewBox="0 0 256 256"><path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216H176a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM108,128a52,52,0,0,0-48,32,36,36,0,0,0,0,72h48a52,52,0,0,0,0-104Zm0,88H60a20,20,0,0,1-3.81-39.64,8,8,0,0,0,16,.36,38,38,0,0,1,1.06-6.09,7.56,7.56,0,0,0,.27-1A36,36,0,1,1,108,216Z"/></svg>`,
  "file-csv": `<svg viewBox="0 0 256 256"><path d="M48,180c0,11,7.18,20,16,20a14.24,14.24,0,0,0,10.22-4.66A8,8,0,0,1,85.78,206.4,30.06,30.06,0,0,1,64,216c-17.65,0-32-16.15-32-36s14.35-36,32-36a30.06,30.06,0,0,1,21.78,9.6,8,8,0,0,1-11.56,11.06A14.24,14.24,0,0,0,64,160C55.18,160,48,169,48,180Zm79.6-8.69c-4-1.16-8.14-2.35-10.45-3.84-1.25-.81-1.23-1-1.12-1.9a4.57,4.57,0,0,1,2-3.67c4.6-3.12,15.34-1.73,19.82-.56A8,8,0,0,0,142,145.86c-2.12-.55-21-5.22-32.84,2.76a20.58,20.58,0,0,0-9,14.95c-2,15.88,13.65,20.41,23,23.11,12.06,3.49,13.12,4.92,12.78,7.59-.31,2.41-1.26,3.34-2.14,3.93-4.6,3.06-15.17,1.56-19.55.36A8,8,0,0,0,109.94,214a61.34,61.34,0,0,0,15.19,2c5.82,0,12.3-1,17.49-4.46a20.82,20.82,0,0,0,9.19-15.23C154,179,137.49,174.17,127.6,171.31Zm83.09-26.84a8,8,0,0,0-10.23,4.84L188,184.21l-12.47-34.9a8,8,0,0,0-15.07,5.38l20,56a8,8,0,0,0,15.07,0l20-56A8,8,0,0,0,210.69,144.47ZM216,88v24a8,8,0,0,1-16,0V96H152a8,8,0,0,1-8-8V40H56v72a8,8,0,0,1-16,0V40A16,16,0,0,1,56,24h96a8,8,0,0,1,5.66,2.34l56,56A8,8,0,0,1,216,88Zm-27.31-8L160,51.31V80Z"/></svg>`,
  "file-dashed": `<svg viewBox="0 0 256 256"><path d="M80,224a8,8,0,0,1-8,8H56a16,16,0,0,1-16-16V184a8,8,0,0,1,16,0v32H72A8,8,0,0,1,80,224ZM216,88v48a8,8,0,0,1-16,0V96H152a8,8,0,0,1-8-8V40H120a8,8,0,0,1,0-16h32a8,8,0,0,1,5.66,2.34l56,56A8,8,0,0,1,216,88Zm-56-8h28.69L160,51.31ZM80,24H56A16,16,0,0,0,40,40V64a8,8,0,0,0,16,0V40H80a8,8,0,0,0,0-16ZM208,168a8,8,0,0,0-8,8v40h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16V176A8,8,0,0,0,208,168ZM48,152a8,8,0,0,0,8-8V104a8,8,0,0,0-16,0v40A8,8,0,0,0,48,152Zm104,64H112a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Z"/></svg>`,
  "file-doc": `<svg viewBox="0 0 256 256"><path d="M52,144H36a8,8,0,0,0-8,8v56a8,8,0,0,0,8,8H52a36,36,0,0,0,0-72Zm0,56H44V160h8a20,20,0,0,1,0,40Zm169.53-4.91a8,8,0,0,1,.25,11.31A30.06,30.06,0,0,1,200,216c-17.65,0-32-16.15-32-36s14.35-36,32-36a30.06,30.06,0,0,1,21.78,9.6,8,8,0,0,1-11.56,11.06A14.24,14.24,0,0,0,200,160c-8.82,0-16,9-16,20s7.18,20,16,20a14.24,14.24,0,0,0,10.22-4.66A8,8,0,0,1,221.53,195.09ZM128,144c-17.65,0-32,16.15-32,36s14.35,36,32,36,32-16.15,32-36S145.65,144,128,144Zm0,56c-8.82,0-16-9-16-20s7.18-20,16-20,16,9,16,20S136.82,200,128,200ZM48,120a8,8,0,0,0,8-8V40h88V88a8,8,0,0,0,8,8h48v16a8,8,0,0,0,16,0V88a8,8,0,0,0-2.34-5.66l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v72A8,8,0,0,0,48,120ZM160,51.31,188.69,80H160Z"/></svg>`,
  "file-image": `<svg viewBox="0 0 256 256"><path d="M110.66,147.56a8,8,0,0,0-13.32,0L76.49,178.85l-9.76-15.18a8,8,0,0,0-13.46,0l-36,56A8,8,0,0,0,24,232H152a8,8,0,0,0,6.66-12.44ZM38.65,216,60,182.79l9.63,15a8,8,0,0,0,13.39.11l21-31.47L137.05,216Zm175-133.66-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216h-8a8,8,0,0,0,0,16h8a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160Z"/></svg>`,
  "file-jpg": `<svg viewBox="0 0 256 256"><path d="M120,144H104a8,8,0,0,0-8,8v56a8,8,0,0,0,16,0v-8h8a28,28,0,0,0,0-56Zm0,40h-8V160h8a12,12,0,0,1,0,24Zm96,0v16.87a8,8,0,0,1-2.22,5.53A30.06,30.06,0,0,1,192,216c-17.65,0-32-16.15-32-36s14.35-36,32-36a29.38,29.38,0,0,1,16.48,5.12,8,8,0,0,1-9,13.26A13.21,13.21,0,0,0,192,160c-8.82,0-16,9-16,20s7.18,20,16,20a13.63,13.63,0,0,0,8-2.71V192a8,8,0,0,1,0-16h8A8,8,0,0,1,216,184ZM80,152v38a26,26,0,0,1-52,0,8,8,0,0,1,16,0,10,10,0,0,0,20,0V152a8,8,0,0,1,16,0ZM213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v72a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48v16a8,8,0,0,0,16,0V88A8,8,0,0,0,213.66,82.34ZM160,80V51.31L188.69,80Z"/></svg>`,
  "file-lock": `<svg viewBox="0 0 256 256"><path d="M120,176h-8v-4a28,28,0,0,0-56,0v4H48a8,8,0,0,0-8,8v40a8,8,0,0,0,8,8h72a8,8,0,0,0,8-8V184A8,8,0,0,0,120,176Zm-48-4a12,12,0,0,1,24,0v4H72Zm40,44H56V192h56ZM213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v88a8,8,0,0,0,16,0V40h88V88a8,8,0,0,0,8,8h48V216H160a8,8,0,0,0,0,16h40a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160Z"/></svg>`,
  "file-magnifying-glass": `<svg viewBox="0 0 256 256"><path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-45.54-48.85a36.05,36.05,0,1,0-11.31,11.31l11.19,11.2a8,8,0,0,0,11.32-11.32ZM104,148a20,20,0,1,1,20,20A20,20,0,0,1,104,148Z"/></svg>`,
  "file-minus": `<svg viewBox="0 0 256 256"><path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-40-64a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16h48A8,8,0,0,1,160,152Z"/></svg>`,
  "file-pdf": `<svg viewBox="0 0 256 256"><path d="M224,152a8,8,0,0,1-8,8H192v16h16a8,8,0,0,1,0,16H192v16a8,8,0,0,1-16,0V152a8,8,0,0,1,8-8h32A8,8,0,0,1,224,152ZM92,172a28,28,0,0,1-28,28H56v8a8,8,0,0,1-16,0V152a8,8,0,0,1,8-8H64A28,28,0,0,1,92,172Zm-16,0a12,12,0,0,0-12-12H56v24h8A12,12,0,0,0,76,172Zm88,8a36,36,0,0,1-36,36H112a8,8,0,0,1-8-8V152a8,8,0,0,1,8-8h16A36,36,0,0,1,164,180Zm-16,0a20,20,0,0,0-20-20h-8v40h8A20,20,0,0,0,148,180ZM40,112V40A16,16,0,0,1,56,24h96a8,8,0,0,1,5.66,2.34l56,56A8,8,0,0,1,216,88v24a8,8,0,0,1-16,0V96H152a8,8,0,0,1-8-8V40H56v72a8,8,0,0,1-16,0ZM160,80h28.69L160,51.31Z"/></svg>`,
  "file-plus": `<svg viewBox="0 0 256 256"><path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-40-64a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V160H104a8,8,0,0,1,0-16h16V128a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,152Z"/></svg>`,
  "file-png": `<svg viewBox="0 0 256 256"><path d="M60,144H44a8,8,0,0,0-8,8v56a8,8,0,0,0,16,0v-8h8a28,28,0,0,0,0-56Zm0,40H52V160h8a12,12,0,0,1,0,24Zm164,16.87a8,8,0,0,1-2.22,5.53A30.06,30.06,0,0,1,200,216c-17.65,0-32-16.15-32-36s14.35-36,32-36a29.45,29.45,0,0,1,16.48,5.11,8,8,0,0,1-9,13.27A13.21,13.21,0,0,0,200,160c-8.82,0-16,9-16,20s7.18,20,16,20a13.57,13.57,0,0,0,8-2.72V192a8,8,0,0,1,0-16h8a8,8,0,0,1,8,8ZM156,152v56a8,8,0,0,1-5.56,7.62A7.91,7.91,0,0,1,148,216a8,8,0,0,1-6.51-3.35L116,177v31a8,8,0,0,1-16,0V152a8,8,0,0,1,14.51-4.65L140,183V152a8,8,0,0,1,16,0ZM48,120a8,8,0,0,0,8-8V40h88V88a8,8,0,0,0,8,8h48v16a8,8,0,0,0,16,0V88a8,8,0,0,0-2.34-5.66l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v72A8,8,0,0,0,48,120ZM160,51.31,188.69,80H160Z"/></svg>`,
  "file-text": `<svg viewBox="0 0 256 256"><path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-32-80a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,136Zm0,32a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,168Z"/></svg>`,
  "file-txt": `<svg viewBox="0 0 256 256"><path d="M48,120a8,8,0,0,0,8-8V40h88V88a8,8,0,0,0,8,8h48v16a8,8,0,0,0,16,0V88a8,8,0,0,0-2.34-5.66l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40v72A8,8,0,0,0,48,120ZM160,51.31,188.69,80H160Zm-5.49,105.34L137.83,180l16.68,23.35a8,8,0,0,1-13,9.3L128,193.76l-13.49,18.89a8,8,0,1,1-13-9.3L118.17,180l-16.68-23.35a8,8,0,1,1,13-9.3L128,166.24l13.49-18.89a8,8,0,0,1,13,9.3ZM92,152a8,8,0,0,1-8,8H72v48a8,8,0,0,1-16,0V160H44a8,8,0,0,1,0-16H84A8,8,0,0,1,92,152Zm128,0a8,8,0,0,1-8,8H200v48a8,8,0,0,1-16,0V160H172a8,8,0,0,1,0-16h40A8,8,0,0,1,220,152Z"/></svg>`,
  "file-x": `<svg viewBox="0 0 256 256"><path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Zm-42.34-82.34L139.31,152l18.35,18.34a8,8,0,0,1-11.32,11.32L128,163.31l-18.34,18.35a8,8,0,0,1-11.32-11.32L116.69,152,98.34,133.66a8,8,0,0,1,11.32-11.32L128,140.69l18.34-18.35a8,8,0,0,1,11.32,11.32Z"/></svg>`,
  "file-xls": `<svg viewBox="0 0 256 256"><path d="M156,208a8,8,0,0,1-8,8H120a8,8,0,0,1-8-8V152a8,8,0,0,1,16,0v48h20A8,8,0,0,1,156,208ZM92.65,145.49a8,8,0,0,0-11.16,1.86L68,166.24,54.51,147.35a8,8,0,1,0-13,9.3L58.17,180,41.49,203.35a8,8,0,0,0,13,9.3L68,193.76l13.49,18.89a8,8,0,0,0,13-9.3L77.83,180l16.68-23.35A8,8,0,0,0,92.65,145.49Zm98.94,25.82c-4-1.16-8.14-2.35-10.45-3.84-1.25-.82-1.23-1-1.12-1.9a4.54,4.54,0,0,1,2-3.67c4.6-3.12,15.34-1.72,19.82-.56a8,8,0,0,0,4.07-15.48c-2.11-.55-21-5.22-32.83,2.76a20.58,20.58,0,0,0-8.95,14.95c-2,15.88,13.65,20.41,23,23.11,12.06,3.49,13.12,4.92,12.78,7.59-.31,2.41-1.26,3.33-2.15,3.93-4.6,3.06-15.16,1.55-19.54.35A8,8,0,0,0,173.93,214a60.63,60.63,0,0,0,15.19,2c5.82,0,12.3-1,17.49-4.46a20.81,20.81,0,0,0,9.18-15.23C218,179,201.48,174.17,191.59,171.31ZM40,112V40A16,16,0,0,1,56,24h96a8,8,0,0,1,5.66,2.34l56,56A8,8,0,0,1,216,88v24a8,8,0,1,1-16,0V96H152a8,8,0,0,1-8-8V40H56v72a8,8,0,0,1-16,0ZM160,80h28.68L160,51.31Z"/></svg>`,
  "file": `<svg viewBox="0 0 256 256"><path d="M213.66,82.34l-56-56A8,8,0,0,0,152,24H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V88A8,8,0,0,0,213.66,82.34ZM160,51.31,188.69,80H160ZM200,216H56V40h88V88a8,8,0,0,0,8,8h48V216Z"/></svg>`,
  "files": `<svg viewBox="0 0 256 256"><path d="M213.66,66.34l-40-40A8,8,0,0,0,168,24H88A16,16,0,0,0,72,40V56H56A16,16,0,0,0,40,72V216a16,16,0,0,0,16,16H168a16,16,0,0,0,16-16V200h16a16,16,0,0,0,16-16V72A8,8,0,0,0,213.66,66.34ZM168,216H56V72h76.69L168,107.31v84.53c0,.06,0,.11,0,.16s0,.1,0,.16V216Zm32-32H184V104a8,8,0,0,0-2.34-5.66l-40-40A8,8,0,0,0,136,56H88V40h76.69L200,75.31Zm-56-32a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,152Zm0,32a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h48A8,8,0,0,1,144,184Z"/></svg>`,
  "fingerprint-simple": `<svg viewBox="0 0 256 256"><path d="M184,128a246.64,246.64,0,0,1-18.54,94.24,8,8,0,0,1-7.4,5,8.19,8.19,0,0,1-3-.6,8,8,0,0,1-4.36-10.45A230.67,230.67,0,0,0,168,128a8,8,0,0,1,16,0ZM128,88a40.06,40.06,0,0,1,29.81,13.33,8,8,0,1,0,11.92-10.67A56,56,0,0,0,72,128a136.06,136.06,0,0,1-17,65.85,8,8,0,1,0,14,7.76A152.14,152.14,0,0,0,88,128,40,40,0,0,1,128,88Zm0-64a103.75,103.75,0,0,0-34.67,5.92A8,8,0,0,0,98.67,45,88.05,88.05,0,0,1,216,128a281.31,281.31,0,0,1-6.94,62.23,8,8,0,0,0,6,9.57,7.77,7.77,0,0,0,1.78.2,8,8,0,0,0,7.8-6.23A298.11,298.11,0,0,0,232,128,104.11,104.11,0,0,0,128,24ZM69.34,62.42A8,8,0,1,0,58.67,50.49,104.16,104.16,0,0,0,24,128a87.29,87.29,0,0,1-8,36.66,8,8,0,0,0,14.54,6.68A103.17,103.17,0,0,0,40,128,88.13,88.13,0,0,1,69.34,62.42Zm44.58,138.32a8,8,0,0,0-10.61,3.93c-1.92,4.2-4,8.39-6.29,12.44A8,8,0,0,0,100.14,228a7.88,7.88,0,0,0,3.87,1,8,8,0,0,0,7-4.12c2.44-4.41,4.74-9,6.84-13.52A8,8,0,0,0,113.92,200.74ZM128,120a8,8,0,0,0-8,8,185.07,185.07,0,0,1-5.79,46,8,8,0,0,0,5.75,9.74,8.12,8.12,0,0,0,2,.25,8,8,0,0,0,7.74-6,200.68,200.68,0,0,0,6.3-50A8,8,0,0,0,128,120Z"/></svg>`,
  "fingerprint": `<svg viewBox="0 0 256 256"><path d="M72,128a134.63,134.63,0,0,1-14.16,60.47,8,8,0,1,1-14.32-7.12A118.8,118.8,0,0,0,56,128,71.73,71.73,0,0,1,83,71.8,8,8,0,1,1,93,84.29,55.76,55.76,0,0,0,72,128Zm56-8a8,8,0,0,0-8,8,184.12,184.12,0,0,1-23,89.1,8,8,0,0,0,14,7.76A200.19,200.19,0,0,0,136,128,8,8,0,0,0,128,120Zm0-32a40,40,0,0,0-40,40,8,8,0,0,0,16,0,24,24,0,0,1,48,0,214.09,214.09,0,0,1-20.51,92A8,8,0,1,0,146,226.83,230,230,0,0,0,168,128,40,40,0,0,0,128,88Zm0-64A104.11,104.11,0,0,0,24,128a87.76,87.76,0,0,1-5,29.33,8,8,0,0,0,15.09,5.33A103.9,103.9,0,0,0,40,128a88,88,0,0,1,176,0,282.24,282.24,0,0,1-5.29,54.45,8,8,0,0,0,6.3,9.4,8.22,8.22,0,0,0,1.55.15,8,8,0,0,0,7.84-6.45A298.37,298.37,0,0,0,232,128,104.12,104.12,0,0,0,128,24ZM94.4,152.17A8,8,0,0,0,85,158.42a151,151,0,0,1-17.21,45.44,8,8,0,0,0,13.86,8,166.67,166.67,0,0,0,19-50.25A8,8,0,0,0,94.4,152.17ZM128,56a72.85,72.85,0,0,0-9,.56,8,8,0,0,0,2,15.87A56.08,56.08,0,0,1,184,128a252.12,252.12,0,0,1-1.92,31A8,8,0,0,0,189,168a8.39,8.39,0,0,0,1,.06,8,8,0,0,0,7.92-7,266.48,266.48,0,0,0,2-33A72.08,72.08,0,0,0,128,56Zm57.93,128.25a8,8,0,0,0-9.75,5.75c-1.46,5.69-3.15,11.4-5,17a8,8,0,0,0,5,10.13,7.88,7.88,0,0,0,2.55.42,8,8,0,0,0,7.58-5.46c2-5.92,3.79-12,5.35-18.05A8,8,0,0,0,185.94,184.26Z"/></svg>`,
  "flag-banner": `<svg viewBox="0 0 256 256"><path d="M238.76,51.73A8,8,0,0,0,232,48H40a8,8,0,0,0-5.66,13.66L76.69,104,34.34,146.34A8,8,0,0,0,40,160H173.62l-28.84,60.56a8,8,0,1,0,14.44,6.88l80-168A8,8,0,0,0,238.76,51.73ZM181.23,144H59.31l34.35-34.34a8,8,0,0,0,0-11.32L59.31,64h160Z"/></svg>`,
  "flag-pennant": `<svg viewBox="0 0 256 256"><path d="M242.63,96.44l-184-64A8,8,0,0,0,48,40V216a8,8,0,0,0,16,0V173.69l178.63-62.13a8,8,0,0,0,0-15.12ZM64,156.75V51.25L215.65,104Z"/></svg>`,
  "flag": `<svg viewBox="0 0 256 256"><path d="M42.76,50A8,8,0,0,0,40,56V224a8,8,0,0,0,16,0V179.77c26.79-21.16,49.87-9.75,76.45,3.41,16.4,8.11,34.06,16.85,53,16.85,13.93,0,28.54-4.75,43.82-18a8,8,0,0,0,2.76-6V56A8,8,0,0,0,218.76,50c-28,24.23-51.72,12.49-79.21-1.12C111.07,34.76,78.78,18.79,42.76,50ZM216,172.25c-26.79,21.16-49.87,9.74-76.45-3.41-25-12.35-52.81-26.13-83.55-8.4V59.79c26.79-21.16,49.87-9.75,76.45,3.4,25,12.35,52.82,26.13,83.55,8.4Z"/></svg>`,
  "floppy-disk-back": `<svg viewBox="0 0 256 256"><path d="M208,32H83.31A15.86,15.86,0,0,0,72,36.69L36.69,72A15.86,15.86,0,0,0,32,83.31V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM88,48h80V80H88ZM208,208H48V83.31l24-24V80A16,16,0,0,0,88,96h80a16,16,0,0,0,16-16V48h24Zm-80-96a40,40,0,1,0,40,40A40,40,0,0,0,128,112Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,176Z"/></svg>`,
  "floppy-disk": `<svg viewBox="0 0 256 256"><path d="M219.31,72,184,36.69A15.86,15.86,0,0,0,172.69,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V83.31A15.86,15.86,0,0,0,219.31,72ZM168,208H88V152h80Zm40,0H184V152a16,16,0,0,0-16-16H88a16,16,0,0,0-16,16v56H48V48H172.69L208,83.31ZM160,72a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h56A8,8,0,0,1,160,72Z"/></svg>`,
  "folder-dashed": `<svg viewBox="0 0 256 256"><path d="M96,208a8,8,0,0,1-8,8H39.38A15.4,15.4,0,0,1,24,200.62V192a8,8,0,0,1,16,0v8H88A8,8,0,0,1,96,208Zm64-8H128a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm64-56a8,8,0,0,0-8,8v48H200a8,8,0,0,0,0,16h16.89A15.13,15.13,0,0,0,232,200.89V152A8,8,0,0,0,224,144Zm-8-72H168a8,8,0,0,0,0,16h48v24a8,8,0,0,0,16,0V88A16,16,0,0,0,216,72ZM24,80V56A16,16,0,0,1,40,40H92.69A15.86,15.86,0,0,1,104,44.69l29.66,29.65A8,8,0,0,1,128,88H32A8,8,0,0,1,24,80Zm16-8h68.69l-16-16H40Zm-8,88a8,8,0,0,0,8-8V120a8,8,0,0,0-16,0v32A8,8,0,0,0,32,160Z"/></svg>`,
  "folder-lock": `<svg viewBox="0 0 256 256"><path d="M224,160h-8v-4a28,28,0,0,0-56,0v4h-8a8,8,0,0,0-8,8v40a8,8,0,0,0,8,8h72a8,8,0,0,0,8-8V168A8,8,0,0,0,224,160Zm-48-4a12,12,0,0,1,24,0v4H176Zm40,44H160V176h56Zm0-128H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216h73.18a8,8,0,0,0,0-16H40V88H216v16a8,8,0,0,0,16,0V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56Z"/></svg>`,
  "folder-minus": `<svg viewBox="0 0 256 256"><path d="M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216ZM104,136h48a8,8,0,0,1,0,16H104a8,8,0,0,1,0-16Z"/></svg>`,
  "folder-open": `<svg viewBox="0 0 256 256"><path d="M245,110.64A16,16,0,0,0,232,104H216V88a16,16,0,0,0-16-16H130.67L102.94,51.2a16.14,16.14,0,0,0-9.6-3.2H40A16,16,0,0,0,24,64V208h0a8,8,0,0,0,8,8H211.1a8,8,0,0,0,7.59-5.47l28.49-85.47A16.05,16.05,0,0,0,245,110.64ZM93.34,64,123.2,86.4A8,8,0,0,0,128,88h72v16H69.77a16,16,0,0,0-15.18,10.94L40,158.7V64Zm112,136H43.1l26.67-80H232Z"/></svg>`,
  "folder-plus": `<svg viewBox="0 0 256 256"><path d="M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56ZM216,200H40V88H216Zm-88-88a8,8,0,0,1,8,8v16h16a8,8,0,0,1,0,16H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120A8,8,0,0,1,128,112Z"/></svg>`,
  "folder-simple-dashed": `<svg viewBox="0 0 256 256"><path d="M24,80V64A16,16,0,0,1,40,48H93.33a16.12,16.12,0,0,1,9.6,3.2L132.8,73.6a8,8,0,1,1-9.6,12.8L93.33,64H40V80a8,8,0,0,1-16,0ZM88,200H40v-8a8,8,0,0,0-16,0v8.62A15.4,15.4,0,0,0,39.38,216H88a8,8,0,0,0,0-16Zm72,0H128a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm64-56a8,8,0,0,0-8,8v48H200a8,8,0,0,0,0,16h16.89A15.13,15.13,0,0,0,232,200.89V152A8,8,0,0,0,224,144Zm-8-72H168a8,8,0,0,0,0,16h48v24a8,8,0,0,0,16,0V88A16,16,0,0,0,216,72ZM32,160a8,8,0,0,0,8-8V120a8,8,0,0,0-16,0v32A8,8,0,0,0,32,160Z"/></svg>`,
  "folder-simple-lock": `<svg viewBox="0 0 256 256"><path d="M232,88v16a8,8,0,0,1-16,0V88H130.67a16.12,16.12,0,0,1-9.6-3.2L93.33,64H40V200h72a8,8,0,0,1,0,16H40a16,16,0,0,1-16-16V64A16,16,0,0,1,40,48H93.33a16.12,16.12,0,0,1,9.6,3.2L130.67,72H216A16,16,0,0,1,232,88Zm0,80v40a8,8,0,0,1-8,8H152a8,8,0,0,1-8-8V168a8,8,0,0,1,8-8h8v-4a28,28,0,0,1,56,0v4h8A8,8,0,0,1,232,168Zm-56-8h24v-4a12,12,0,0,0-24,0Zm40,16H160v24h56Z"/></svg>`,
  "folder-simple-minus": `<svg viewBox="0 0 256 256"><path d="M216,72H130.67L102.93,51.2a16.12,16.12,0,0,0-9.6-3.2H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72Zm0,128H40V64H93.33L123.2,86.4A8,8,0,0,0,128,88h88Zm-56-56a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16h48A8,8,0,0,1,160,144Z"/></svg>`,
  "folder-simple-plus": `<svg viewBox="0 0 256 256"><path d="M216,72H130.67L102.93,51.2a16.12,16.12,0,0,0-9.6-3.2H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72Zm0,128H40V64H93.33L123.2,86.4A8,8,0,0,0,128,88h88Zm-56-56a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V152H104a8,8,0,0,1,0-16h16V120a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,144Z"/></svg>`,
  "folder-simple-user": `<svg viewBox="0 0 256 256"><path d="M214.61,198.62a32,32,0,1,0-45.23,0,40,40,0,0,0-17.11,23.32,8,8,0,0,0,5.67,9.79A8.15,8.15,0,0,0,160,232a8,8,0,0,0,7.73-5.95C170.56,215.42,180.54,208,192,208s21.44,7.42,24.27,18.05a8,8,0,1,0,15.46-4.11A40,40,0,0,0,214.61,198.62ZM192,160a16,16,0,1,1-16,16A16,16,0,0,1,192,160Zm40-72v32a8,8,0,0,1-16,0V88H130.67a16.12,16.12,0,0,1-9.6-3.2L93.33,64H40V200h80a8,8,0,0,1,0,16H40a16,16,0,0,1-16-16V64A16,16,0,0,1,40,48H93.33a16.12,16.12,0,0,1,9.6,3.2L130.67,72H216A16,16,0,0,1,232,88Z"/></svg>`,
  "folder-simple": `<svg viewBox="0 0 256 256"><path d="M216,72H130.67L102.93,51.2a16.12,16.12,0,0,0-9.6-3.2H40A16,16,0,0,0,24,64V200a16,16,0,0,0,16,16H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72Zm0,128H40V64H93.33L123.2,86.4A8,8,0,0,0,128,88h88Z"/></svg>`,
  "folder-star": `<svg viewBox="0 0 256 256"><path d="M120.56,200H40V88H216v32a8,8,0,0,0,16,0V88a16,16,0,0,0-16-16H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216h81.18a8,8,0,0,0,0-16ZM92.69,56l16,16H40V56ZM239.63,159.2a8,8,0,0,0-7-5.56l-29.84-2.31-11.43-26.5a8,8,0,0,0-14.7,0l-11.43,26.5-29.84,2.31a8,8,0,0,0-4.47,14.14l22.51,18.59-6.85,27.71a8,8,0,0,0,11.82,8.81L184,207.82l25.61,15.07a8,8,0,0,0,11.82-8.81l-6.85-27.71,22.51-18.59A8,8,0,0,0,239.63,159.2Zm-39.12,18a8,8,0,0,0-2.68,8.09l3.5,14.12-13.27-7.81a8,8,0,0,0-8.12,0l-13.27,7.81,3.5-14.12a8,8,0,0,0-2.68-8.09l-11.11-9.18,14.89-1.15a8,8,0,0,0,6.73-4.8l6-13.92,6,13.92a8,8,0,0,0,6.73,4.8l14.89,1.15Z"/></svg>`,
  "folder-user": `<svg viewBox="0 0 256 256"><path d="M214.61,198.62a32,32,0,1,0-45.23,0,40,40,0,0,0-17.11,23.32,8,8,0,0,0,5.67,9.79A8.15,8.15,0,0,0,160,232a8,8,0,0,0,7.73-5.95C170.56,215.42,180.54,208,192,208s21.44,7.42,24.27,18.05a8,8,0,1,0,15.46-4.11A40,40,0,0,0,214.61,198.62ZM192,160a16,16,0,1,1-16,16A16,16,0,0,1,192,160Zm24-88H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.61A15.4,15.4,0,0,0,39.38,216h81.18a8,8,0,0,0,0-16H40V88H216v32a8,8,0,0,0,16,0V88A16,16,0,0,0,216,72ZM92.69,56l16,16H40V56Z"/></svg>`,
  "folder": `<svg viewBox="0 0 256 256"><path d="M216,72H131.31L104,44.69A15.86,15.86,0,0,0,92.69,40H40A16,16,0,0,0,24,56V200.62A15.4,15.4,0,0,0,39.38,216H216.89A15.13,15.13,0,0,0,232,200.89V88A16,16,0,0,0,216,72ZM40,56H92.69l16,16H40ZM216,200H40V88H216Z"/></svg>`,
  "folders": `<svg viewBox="0 0 256 256"><path d="M224,64H154.67L126.93,43.2a16.12,16.12,0,0,0-9.6-3.2H72A16,16,0,0,0,56,56V72H40A16,16,0,0,0,24,88V200a16,16,0,0,0,16,16H192.89A15.13,15.13,0,0,0,208,200.89V184h16.89A15.13,15.13,0,0,0,240,168.89V80A16,16,0,0,0,224,64ZM192,200H40V88H85.33l29.87,22.4A8,8,0,0,0,120,112h72Zm32-32H208V112a16,16,0,0,0-16-16H122.67L94.93,75.2a16.12,16.12,0,0,0-9.6-3.2H72V56h45.33L147.2,78.4A8,8,0,0,0,152,80h72Z"/></svg>`,
  "funnel-simple-x": `<svg viewBox="0 0 256 256"><path d="M192,144H64a8,8,0,0,1,0-16H192a8,8,0,0,1,0,16Zm40-64H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16ZM128,176H104a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16Zm93.66-5.66a8,8,0,0,0-11.32,0L192,188.69l-18.34-18.35a8,8,0,0,0-11.32,11.32L180.69,200l-18.35,18.34a8,8,0,0,0,11.32,11.32L192,211.31l18.34,18.35a8,8,0,0,0,11.32-11.32L203.31,200l18.35-18.34A8,8,0,0,0,221.66,170.34Z"/></svg>`,
  "funnel-simple": `<svg viewBox="0 0 256 256"><path d="M200,136a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,136Zm32-56H24a8,8,0,0,0,0,16H232a8,8,0,0,0,0-16Zm-80,96H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Z"/></svg>`,
  "funnel-x": `<svg viewBox="0 0 256 256"><path d="M227.82,66.76A16,16,0,0,0,216,40H40A16,16,0,0,0,28.19,66.76l.08.09L96,139.17V216a16,16,0,0,0,24.87,13.32l32-21.34A16,16,0,0,0,160,194.66V139.17l67.73-72.32ZM40,56h0Zm106.19,74.59A8,8,0,0,0,144,136v58.66L112,216V136a8,8,0,0,0-2.16-5.46L40,56H216Zm99.49,79.81a8,8,0,0,1-11.32,11.32L216,203.32l-18.34,18.35a8,8,0,0,1-11.31-11.32L204.69,192l-18.34-18.35a8,8,0,0,1,11.31-11.31L216,180.69l18.34-18.34a8,8,0,0,1,11.32,11.31L227.31,192Z"/></svg>`,
  "funnel": `<svg viewBox="0 0 256 256"><path d="M230.6,49.53A15.81,15.81,0,0,0,216,40H40A16,16,0,0,0,28.19,66.76l.08.09L96,139.17V216a16,16,0,0,0,24.87,13.32l32-21.34A16,16,0,0,0,160,194.66V139.17l67.74-72.32.08-.09A15.8,15.8,0,0,0,230.6,49.53ZM40,56h0Zm106.18,74.58A8,8,0,0,0,144,136v58.66L112,216V136a8,8,0,0,0-2.16-5.47L40,56H216Z"/></svg>`,
  "gavel": `<svg viewBox="0 0 256 256"><path d="M243.32,116.69l-16-16a16,16,0,0,0-20.84-1.53L156.84,49.52a16,16,0,0,0-1.52-20.84l-16-16a16,16,0,0,0-22.63,0l-64,64a16,16,0,0,0,0,22.63l16,16a16,16,0,0,0,20.83,1.52L96.69,124,31.31,189.38A25,25,0,0,0,66.63,224.7L132,159.32l7.17,7.16a16,16,0,0,0,1.52,20.84l16,16a16,16,0,0,0,22.63,0l64-64A16,16,0,0,0,243.32,116.69ZM80,104,64,88l64-64,16,16ZM55.32,213.38a9,9,0,0,1-12.69,0,9,9,0,0,1,0-12.68L108,135.32,120.69,148ZM101,105.66,145.66,61,195,110.34,150.35,155ZM168,192l-16-16,4-4h0l56-56h0l4-4,16,16Z"/></svg>`,
  "gear-fine": `<svg viewBox="0 0 256 256"><path d="M232,120H215.63a87.27,87.27,0,0,0-7.74-28.88l14.18-8.19a8,8,0,0,0-8-13.86l-14.2,8.2a88.78,88.78,0,0,0-21.14-21.14l8.2-14.2a8,8,0,0,0-13.86-8l-8.19,14.18A87.27,87.27,0,0,0,136,40.37V24a8,8,0,0,0-16,0V40.37a87.27,87.27,0,0,0-28.88,7.74L82.93,33.93a8,8,0,0,0-13.86,8l8.2,14.2A88.78,88.78,0,0,0,56.13,77.27l-14.2-8.2a8,8,0,0,0-8,13.86l14.18,8.19A87.27,87.27,0,0,0,40.37,120H24a8,8,0,0,0,0,16H40.37a87.27,87.27,0,0,0,7.74,28.88l-14.18,8.19a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l14.2-8.2a88.78,88.78,0,0,0,21.14,21.14l-8.2,14.2a8,8,0,0,0,13.86,8l8.19-14.18A87.27,87.27,0,0,0,120,215.63V232a8,8,0,0,0,16,0V215.63a87.27,87.27,0,0,0,28.88-7.74l8.19,14.18a8,8,0,0,0,13.86-8l-8.2-14.2a88.78,88.78,0,0,0,21.14-21.14l14.2,8.2A8,8,0,0,0,225,184a8,8,0,0,0-2.92-10.93l-14.18-8.19A87.27,87.27,0,0,0,215.63,136H232a8,8,0,0,0,0-16ZM128,56a72.08,72.08,0,0,1,71.54,64H132.62L99.16,62.05A71.58,71.58,0,0,1,128,56ZM56,128A72,72,0,0,1,85.31,70.06L118.76,128,85.31,185.94A72,72,0,0,1,56,128Zm72,72A71.58,71.58,0,0,1,99.16,194L132.62,136h66.92A72.08,72.08,0,0,1,128,200Z"/></svg>`,
  "gear-six": `<svg viewBox="0 0 256 256"><path d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm109.94-52.79a8,8,0,0,0-3.89-5.4l-29.83-17-.12-33.62a8,8,0,0,0-2.83-6.08,111.91,111.91,0,0,0-36.72-20.67,8,8,0,0,0-6.46.59L128,41.85,97.88,25a8,8,0,0,0-6.47-.6A112.1,112.1,0,0,0,54.73,45.15a8,8,0,0,0-2.83,6.07l-.15,33.65-29.83,17a8,8,0,0,0-3.89,5.4,106.47,106.47,0,0,0,0,41.56,8,8,0,0,0,3.89,5.4l29.83,17,.12,33.62a8,8,0,0,0,2.83,6.08,111.91,111.91,0,0,0,36.72,20.67,8,8,0,0,0,6.46-.59L128,214.15,158.12,231a7.91,7.91,0,0,0,3.9,1,8.09,8.09,0,0,0,2.57-.42,112.1,112.1,0,0,0,36.68-20.73,8,8,0,0,0,2.83-6.07l.15-33.65,29.83-17a8,8,0,0,0,3.89-5.4A106.47,106.47,0,0,0,237.94,107.21Zm-15,34.91-28.57,16.25a8,8,0,0,0-3,3c-.58,1-1.19,2.06-1.81,3.06a7.94,7.94,0,0,0-1.22,4.21l-.15,32.25a95.89,95.89,0,0,1-25.37,14.3L134,199.13a8,8,0,0,0-3.91-1h-.19c-1.21,0-2.43,0-3.64,0a8.08,8.08,0,0,0-4.1,1l-28.84,16.1A96,96,0,0,1,67.88,201l-.11-32.2a8,8,0,0,0-1.22-4.22c-.62-1-1.23-2-1.8-3.06a8.09,8.09,0,0,0-3-3.06l-28.6-16.29a90.49,90.49,0,0,1,0-28.26L61.67,97.63a8,8,0,0,0,3-3c.58-1,1.19-2.06,1.81-3.06a7.94,7.94,0,0,0,1.22-4.21l.15-32.25a95.89,95.89,0,0,1,25.37-14.3L122,56.87a8,8,0,0,0,4.1,1c1.21,0,2.43,0,3.64,0a8.08,8.08,0,0,0,4.1-1l28.84-16.1A96,96,0,0,1,188.12,55l.11,32.2a8,8,0,0,0,1.22,4.22c.62,1,1.23,2,1.8,3.06a8.09,8.09,0,0,0,3,3.06l28.6,16.29A90.49,90.49,0,0,1,222.9,142.12Z"/></svg>`,
  "gear": `<svg viewBox="0 0 256 256"><path d="M128,80a48,48,0,1,0,48,48A48.05,48.05,0,0,0,128,80Zm0,80a32,32,0,1,1,32-32A32,32,0,0,1,128,160Zm88-29.84q.06-2.16,0-4.32l14.92-18.64a8,8,0,0,0,1.48-7.06,107.21,107.21,0,0,0-10.88-26.25,8,8,0,0,0-6-3.93l-23.72-2.64q-1.48-1.56-3-3L186,40.54a8,8,0,0,0-3.94-6,107.71,107.71,0,0,0-26.25-10.87,8,8,0,0,0-7.06,1.49L130.16,40Q128,40,125.84,40L107.2,25.11a8,8,0,0,0-7.06-1.48A107.6,107.6,0,0,0,73.89,34.51a8,8,0,0,0-3.93,6L67.32,64.27q-1.56,1.49-3,3L40.54,70a8,8,0,0,0-6,3.94,107.71,107.71,0,0,0-10.87,26.25,8,8,0,0,0,1.49,7.06L40,125.84Q40,128,40,130.16L25.11,148.8a8,8,0,0,0-1.48,7.06,107.21,107.21,0,0,0,10.88,26.25,8,8,0,0,0,6,3.93l23.72,2.64q1.49,1.56,3,3L70,215.46a8,8,0,0,0,3.94,6,107.71,107.71,0,0,0,26.25,10.87,8,8,0,0,0,7.06-1.49L125.84,216q2.16.06,4.32,0l18.64,14.92a8,8,0,0,0,7.06,1.48,107.21,107.21,0,0,0,26.25-10.88,8,8,0,0,0,3.93-6l2.64-23.72q1.56-1.48,3-3L215.46,186a8,8,0,0,0,6-3.94,107.71,107.71,0,0,0,10.87-26.25,8,8,0,0,0-1.49-7.06Zm-16.1-6.5a73.93,73.93,0,0,1,0,8.68,8,8,0,0,0,1.74,5.48l14.19,17.73a91.57,91.57,0,0,1-6.23,15L187,173.11a8,8,0,0,0-5.1,2.64,74.11,74.11,0,0,1-6.14,6.14,8,8,0,0,0-2.64,5.1l-2.51,22.58a91.32,91.32,0,0,1-15,6.23l-17.74-14.19a8,8,0,0,0-5-1.75h-.48a73.93,73.93,0,0,1-8.68,0,8,8,0,0,0-5.48,1.74L100.45,215.8a91.57,91.57,0,0,1-15-6.23L82.89,187a8,8,0,0,0-2.64-5.1,74.11,74.11,0,0,1-6.14-6.14,8,8,0,0,0-5.1-2.64L46.43,170.6a91.32,91.32,0,0,1-6.23-15l14.19-17.74a8,8,0,0,0,1.74-5.48,73.93,73.93,0,0,1,0-8.68,8,8,0,0,0-1.74-5.48L40.2,100.45a91.57,91.57,0,0,1,6.23-15L69,82.89a8,8,0,0,0,5.1-2.64,74.11,74.11,0,0,1,6.14-6.14A8,8,0,0,0,82.89,69L85.4,46.43a91.32,91.32,0,0,1,15-6.23l17.74,14.19a8,8,0,0,0,5.48,1.74,73.93,73.93,0,0,1,8.68,0,8,8,0,0,0,5.48-1.74L155.55,40.2a91.57,91.57,0,0,1,15,6.23L173.11,69a8,8,0,0,0,2.64,5.1,74.11,74.11,0,0,1,6.14,6.14,8,8,0,0,0,5.1,2.64l22.58,2.51a91.32,91.32,0,0,1,6.23,15l-14.19,17.74A8,8,0,0,0,199.87,123.66Z"/></svg>`,
  "github-logo": `<svg viewBox="0 0 256 256"><path d="M208.31,75.68A59.78,59.78,0,0,0,202.93,28,8,8,0,0,0,196,24a59.75,59.75,0,0,0-48,24H124A59.75,59.75,0,0,0,76,24a8,8,0,0,0-6.93,4,59.78,59.78,0,0,0-5.38,47.68A58.14,58.14,0,0,0,56,104v8a56.06,56.06,0,0,0,48.44,55.47A39.8,39.8,0,0,0,96,192v8H72a24,24,0,0,1-24-24A40,40,0,0,0,8,136a8,8,0,0,0,0,16,24,24,0,0,1,24,24,40,40,0,0,0,40,40H96v16a8,8,0,0,0,16,0V192a24,24,0,0,1,48,0v40a8,8,0,0,0,16,0V192a39.8,39.8,0,0,0-8.44-24.53A56.06,56.06,0,0,0,216,112v-8A58.14,58.14,0,0,0,208.31,75.68ZM200,112a40,40,0,0,1-40,40H112a40,40,0,0,1-40-40v-8a41.74,41.74,0,0,1,6.9-22.48A8,8,0,0,0,80,73.83a43.81,43.81,0,0,1,.79-33.58,43.88,43.88,0,0,1,32.32,20.06A8,8,0,0,0,119.82,64h32.35a8,8,0,0,0,6.74-3.69,43.87,43.87,0,0,1,32.32-20.06A43.81,43.81,0,0,1,192,73.83a8.09,8.09,0,0,0,1,7.65A41.72,41.72,0,0,1,200,104Z"/></svg>`,
  "globe-hemisphere-east": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,16a87.5,87.5,0,0,1,48,14.28V74L153.83,99.74,122.36,104l-.31-.22L102.38,90.92A16,16,0,0,0,79.87,95.1L58.93,126.4a16,16,0,0,0-2.7,8.81L56,171.44l-3.27,2.15A88,88,0,0,1,128,40ZM62.29,186.47l2.52-1.65A16,16,0,0,0,72,171.53l.21-36.23L93.17,104a3.62,3.62,0,0,0,.32.22l19.67,12.87a15.94,15.94,0,0,0,11.35,2.77L156,115.59a16,16,0,0,0,10-5.41l22.17-25.76A16,16,0,0,0,192,74V67.67A87.87,87.87,0,0,1,211.77,155l-16.14-14.76a16,16,0,0,0-16.93-3l-30.46,12.65a16.08,16.08,0,0,0-9.68,12.45l-2.39,16.19a16,16,0,0,0,11.77,17.81L169.4,202l2.36,2.37A87.88,87.88,0,0,1,62.29,186.47ZM185,195l-4.3-4.31a16,16,0,0,0-7.26-4.18L152,180.85l2.39-16.19L184.84,152,205,170.48A88.43,88.43,0,0,1,185,195Z"/></svg>`,
  "globe-hemisphere-west": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm88,104a87.62,87.62,0,0,1-6.4,32.94l-44.7-27.49a15.92,15.92,0,0,0-6.24-2.23l-22.82-3.08a16.11,16.11,0,0,0-16,7.86h-8.72l-3.8-7.86a15.91,15.91,0,0,0-11-8.67l-8-1.73L96.14,104h16.71a16.06,16.06,0,0,0,7.73-2l12.25-6.76a16.62,16.62,0,0,0,3-2.14l26.91-24.34A15.93,15.93,0,0,0,166,49.1l-.36-.65A88.11,88.11,0,0,1,216,128ZM143.31,41.34,152,56.9,125.09,81.24,112.85,88H96.14a16,16,0,0,0-13.88,8l-8.73,15.23L63.38,84.19,74.32,58.32a87.87,87.87,0,0,1,69-17ZM40,128a87.53,87.53,0,0,1,8.54-37.8l11.34,30.27a16,16,0,0,0,11.62,10l21.43,4.61L96.74,143a16.09,16.09,0,0,0,14.4,9h1.48l-7.23,16.23a16,16,0,0,0,2.86,17.37l.14.14L128,205.94l-1.94,10A88.11,88.11,0,0,1,40,128Zm102.58,86.78,1.13-5.81a16.09,16.09,0,0,0-4-13.9,1.85,1.85,0,0,1-.14-.14L120,174.74,133.7,144l22.82,3.08,45.72,28.12A88.18,88.18,0,0,1,142.58,214.78Z"/></svg>`,
  "globe-simple": `<svg viewBox="0 0 256 256"><path d="M128,24h0A104,104,0,1,0,232,128,104.12,104.12,0,0,0,128,24Zm87.62,96H175.79C174,83.49,159.94,57.67,148.41,42.4A88.19,88.19,0,0,1,215.63,120ZM96.23,136h63.54c-2.31,41.61-22.23,67.11-31.77,77C118.45,203.1,98.54,177.6,96.23,136Zm0-16C98.54,78.39,118.46,52.89,128,43c9.55,9.93,29.46,35.43,31.77,77Zm11.36-77.6C96.06,57.67,82,83.49,80.21,120H40.37A88.19,88.19,0,0,1,107.59,42.4ZM40.37,136H80.21c1.82,36.51,15.85,62.33,27.38,77.6A88.19,88.19,0,0,1,40.37,136Zm108,77.6c11.53-15.27,25.56-41.09,27.38-77.6h39.84A88.19,88.19,0,0,1,148.41,213.6Z"/></svg>`,
  "globe": `<svg viewBox="0 0 256 256"><path d="M128,24h0A104,104,0,1,0,232,128,104.12,104.12,0,0,0,128,24Zm88,104a87.61,87.61,0,0,1-3.33,24H174.16a157.44,157.44,0,0,0,0-48h38.51A87.61,87.61,0,0,1,216,128ZM102,168H154a115.11,115.11,0,0,1-26,45A115.27,115.27,0,0,1,102,168Zm-3.9-16a140.84,140.84,0,0,1,0-48h59.88a140.84,140.84,0,0,1,0,48ZM40,128a87.61,87.61,0,0,1,3.33-24H81.84a157.44,157.44,0,0,0,0,48H43.33A87.61,87.61,0,0,1,40,128ZM154,88H102a115.11,115.11,0,0,1,26-45A115.27,115.27,0,0,1,154,88Zm52.33,0H170.71a135.28,135.28,0,0,0-22.3-45.6A88.29,88.29,0,0,1,206.37,88ZM107.59,42.4A135.28,135.28,0,0,0,85.29,88H49.63A88.29,88.29,0,0,1,107.59,42.4ZM49.63,168H85.29a135.28,135.28,0,0,0,22.3,45.6A88.29,88.29,0,0,1,49.63,168Zm98.78,45.6a135.28,135.28,0,0,0,22.3-45.6h35.66A88.29,88.29,0,0,1,148.41,213.6Z"/></svg>`,
  "google-drive-logo": `<svg viewBox="0 0 256 256"><path d="M237.6,143.78,169.13,31.52A15.91,15.91,0,0,0,155.56,24H100.43a15.89,15.89,0,0,0-13.56,7.52l-.05.07L18.44,143.7a16,16,0,0,0-.33,16.42l27.32,47.82A16,16,0,0,0,59.32,216H196.67a16,16,0,0,0,13.89-8.06l27.32-47.82A15.91,15.91,0,0,0,237.6,143.78ZM219,144H172.52L137.33,85.33l22.75-37.92Zm-116.87,0L128,100.88,153.87,144Zm61.34,16,24,40H68.53l24-40ZM128,69.78,110.12,40l35.78-.05ZM95.91,47.41l22.76,37.92L83.47,144H37ZM36.54,160H73.87L54.72,191.92Zm164.74,31.93L182.12,160h37.41Z"/></svg>`,
  "google-logo": `<svg viewBox="0 0 256 256"><path d="M224,128a96,96,0,1,1-21.95-61.09,8,8,0,1,1-12.33,10.18A80,80,0,1,0,207.6,136H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,128Z"/></svg>`,
  "graduation-cap": `<svg viewBox="0 0 256 256"><path d="M251.76,88.94l-120-64a8,8,0,0,0-7.52,0l-120,64a8,8,0,0,0,0,14.12L32,117.87v48.42a15.91,15.91,0,0,0,4.06,10.65C49.16,191.53,78.51,216,128,216a130,130,0,0,0,48-8.76V240a8,8,0,0,0,16,0V199.51a115.63,115.63,0,0,0,27.94-22.57A15.91,15.91,0,0,0,224,166.29V117.87l27.76-14.81a8,8,0,0,0,0-14.12ZM128,200c-43.27,0-68.72-21.14-80-33.71V126.4l76.24,40.66a8,8,0,0,0,7.52,0L176,143.47v46.34C163.4,195.69,147.52,200,128,200Zm80-33.75a97.83,97.83,0,0,1-16,14.25V134.93l16-8.53ZM188,118.94l-.22-.13-56-29.87a8,8,0,0,0-7.52,14.12L171,128l-43,22.93L25,96,128,41.07,231,96Z"/></svg>`,
  "graph": `<svg viewBox="0 0 256 256"><path d="M200,152a31.84,31.84,0,0,0-19.53,6.68l-23.11-18A31.65,31.65,0,0,0,160,128c0-.74,0-1.48-.08-2.21l13.23-4.41A32,32,0,1,0,168,104c0,.74,0,1.48.08,2.21l-13.23,4.41A32,32,0,0,0,128,96a32.59,32.59,0,0,0-5.27.44L115.89,81A32,32,0,1,0,96,88a32.59,32.59,0,0,0,5.27-.44l6.84,15.4a31.92,31.92,0,0,0-8.57,39.64L73.83,165.44a32.06,32.06,0,1,0,10.63,12l25.71-22.84a31.91,31.91,0,0,0,37.36-1.24l23.11,18A31.65,31.65,0,0,0,168,184a32,32,0,1,0,32-32Zm0-64a16,16,0,1,1-16,16A16,16,0,0,1,200,88ZM80,56A16,16,0,1,1,96,72,16,16,0,0,1,80,56ZM56,208a16,16,0,1,1,16-16A16,16,0,0,1,56,208Zm56-80a16,16,0,1,1,16,16A16,16,0,0,1,112,128Zm88,72a16,16,0,1,1,16-16A16,16,0,0,1,200,200Z"/></svg>`,
  "handshake": `<svg viewBox="0 0 256 256"><path d="M254.3,107.91,228.78,56.85a16,16,0,0,0-21.47-7.15L182.44,62.13,130.05,48.27a8.14,8.14,0,0,0-4.1,0L73.56,62.13,48.69,49.7a16,16,0,0,0-21.47,7.15L1.7,107.9a16,16,0,0,0,7.15,21.47l27,13.51,55.49,39.63a8.06,8.06,0,0,0,2.71,1.25l64,16a8,8,0,0,0,7.6-2.1l55.07-55.08,26.42-13.21a16,16,0,0,0,7.15-21.46Zm-54.89,33.37L165,113.72a8,8,0,0,0-10.68.61C136.51,132.27,116.66,130,104,122L147.24,80h31.81l27.21,54.41ZM41.53,64,62,74.22,36.43,125.27,16,115.06Zm116,119.13L99.42,168.61l-49.2-35.14,28-56L128,64.28l9.8,2.59-45,43.68-.08.09a16,16,0,0,0,2.72,24.81c20.56,13.13,45.37,11,64.91-5L188,152.66Zm62-57.87-25.52-51L214.47,64,240,115.06Zm-87.75,92.67a8,8,0,0,1-7.75,6.06,8.13,8.13,0,0,1-1.95-.24L80.41,213.33a7.89,7.89,0,0,1-2.71-1.25L51.35,193.26a8,8,0,0,1,9.3-13l25.11,17.94L126,208.24A8,8,0,0,1,131.82,217.94Z"/></svg>`,
  "head-circuit": `<svg viewBox="0 0 256 256"><path d="M192.5,171.47A88.34,88.34,0,0,0,224,101.93c-1-45.71-37.61-83.4-83.24-85.8A88,88,0,0,0,48,102L25.55,145.18c-.09.18-.18.36-.26.54a16,16,0,0,0,7.55,20.62l.25.11L56,176.94V208a16,16,0,0,0,16,16h48a8,8,0,0,0,0-16H72V171.81a8,8,0,0,0-4.67-7.28L40,152l23.07-44.34A7.9,7.9,0,0,0,64,104a72,72,0,0,1,56-70.21V49.38a24,24,0,1,0,16,0V32c1.3,0,2.6,0,3.9.1A72.26,72.26,0,0,1,203.84,80H184a8,8,0,0,0-6.15,2.88L152.34,113.5a24.06,24.06,0,1,0,12.28,10.25L187.75,96h19.79q.36,3.12.44,6.3a72.26,72.26,0,0,1-28.78,59.3,8,8,0,0,0-3.14,7.39l8,64a8,8,0,0,0,7.93,7,8.39,8.39,0,0,0,1-.06,8,8,0,0,0,6.95-8.93ZM128,80a8,8,0,1,1,8-8A8,8,0,0,1,128,80Zm16,64a8,8,0,1,1,8-8A8,8,0,0,1,144,144Z"/></svg>`,
  "headset": `<svg viewBox="0 0 256 256"><path d="M201.89,54.66A103.43,103.43,0,0,0,128.79,24H128A104,104,0,0,0,24,128v56a24,24,0,0,0,24,24H64a24,24,0,0,0,24-24V144a24,24,0,0,0-24-24H40.36A88.12,88.12,0,0,1,190.54,65.93,87.39,87.39,0,0,1,215.65,120H192a24,24,0,0,0-24,24v40a24,24,0,0,0,24,24h24a24,24,0,0,1-24,24H136a8,8,0,0,0,0,16h56a40,40,0,0,0,40-40V128A103.41,103.41,0,0,0,201.89,54.66ZM64,136a8,8,0,0,1,8,8v40a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V136Zm128,56a8,8,0,0,1-8-8V144a8,8,0,0,1,8-8h24v56Z"/></svg>`,
  "hourglass-simple": `<svg viewBox="0 0 256 256"><path d="M211.18,196.56,139.57,128l71.61-68.56a1.59,1.59,0,0,1,.13-.13A16,16,0,0,0,200,32H56A16,16,0,0,0,44.7,59.31l.12.13L116.43,128,44.82,196.56l-.12.13A16,16,0,0,0,56,224H200a16,16,0,0,0,11.32-27.31A1.59,1.59,0,0,1,211.18,196.56ZM56,48h0v0Zm144,0-72,68.92L56,48ZM56,208l72-68.92L200,208Z"/></svg>`,
  "hourglass": `<svg viewBox="0 0 256 256"><path d="M200,75.64V40a16,16,0,0,0-16-16H72A16,16,0,0,0,56,40V76a16.07,16.07,0,0,0,6.4,12.8L114.67,128,62.4,167.2A16.07,16.07,0,0,0,56,180v36a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V180.36a16.09,16.09,0,0,0-6.35-12.77L141.27,128l52.38-39.6A16.05,16.05,0,0,0,200,75.64ZM184,216H72V180l56-42,56,42.35Zm0-140.36L128,118,72,76V40H184Z"/></svg>`,
  "house-line": `<svg viewBox="0 0 256 256"><path d="M240,208H224V136l2.34,2.34A8,8,0,0,0,237.66,127L139.31,28.68a16,16,0,0,0-22.62,0L18.34,127a8,8,0,0,0,11.32,11.31L32,136v72H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM48,120l80-80,80,80v88H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48Zm96,88H112V160h32Z"/></svg>`,
  "house-simple": `<svg viewBox="0 0 256 256"><path d="M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8H216a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H48V120l80-80,80,80Z"/></svg>`,
  "house": `<svg viewBox="0 0 256 256"><path d="M219.31,108.68l-80-80a16,16,0,0,0-22.62,0l-80,80A15.87,15.87,0,0,0,32,120v96a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V160h32v56a8,8,0,0,0,8,8h64a8,8,0,0,0,8-8V120A15.87,15.87,0,0,0,219.31,108.68ZM208,208H160V152a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8v56H48V120l80-80,80,80Z"/></svg>`,
  "identification-badge": `<svg viewBox="0 0 256 256"><path d="M75.19,198.4a8,8,0,0,0,11.21-1.6,52,52,0,0,1,83.2,0,8,8,0,1,0,12.8-9.6A67.88,67.88,0,0,0,155,165.51a40,40,0,1,0-53.94,0A67.88,67.88,0,0,0,73.6,187.2,8,8,0,0,0,75.19,198.4ZM128,112a24,24,0,1,1-24,24A24,24,0,0,1,128,112Zm72-88H56A16,16,0,0,0,40,40V216a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24Zm0,192H56V40H200ZM88,64a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,64Z"/></svg>`,
  "identification-card": `<svg viewBox="0 0 256 256"><path d="M200,112a8,8,0,0,1-8,8H152a8,8,0,0,1,0-16h40A8,8,0,0,1,200,112Zm-8,24H152a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm40-80V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM216,200V56H40V200H216Zm-80.26-34a8,8,0,1,1-15.5,4c-2.63-10.26-13.06-18-24.25-18s-21.61,7.74-24.25,18a8,8,0,1,1-15.5-4,39.84,39.84,0,0,1,17.19-23.34,32,32,0,1,1,45.12,0A39.76,39.76,0,0,1,135.75,166ZM96,136a16,16,0,1,0-16-16A16,16,0,0,0,96,136Z"/></svg>`,
  "image-square": `<svg viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM48,48H208v77.38l-24.69-24.7a16,16,0,0,0-22.62,0L53.37,208H48ZM208,208H76l96-96,36,36v60ZM96,120A24,24,0,1,0,72,96,24,24,0,0,0,96,120Zm0-32a8,8,0,1,1-8,8A8,8,0,0,1,96,88Z"/></svg>`,
  "image": `<svg viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V158.75l-26.07-26.06a16,16,0,0,0-22.63,0l-20,20-44-44a16,16,0,0,0-22.62,0L40,149.37V56ZM40,172l52-52,80,80H40Zm176,28H194.63l-36-36,20-20L216,181.38V200ZM144,100a12,12,0,1,1,12,12A12,12,0,0,1,144,100Z"/></svg>`,
  "images-square": `<svg viewBox="0 0 256 256"><path d="M208,32H80A16,16,0,0,0,64,48V64H48A16,16,0,0,0,32,80V208a16,16,0,0,0,16,16H176a16,16,0,0,0,16-16V192h16a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM80,48H208v69.38l-16.7-16.7a16,16,0,0,0-22.62,0L93.37,176H80Zm96,160H48V80H64v96a16,16,0,0,0,16,16h96Zm32-32H116l64-64,28,28v36Zm-88-64A24,24,0,1,0,96,88,24,24,0,0,0,120,112Zm0-32a8,8,0,1,1-8,8A8,8,0,0,1,120,80Z"/></svg>`,
  "images": `<svg viewBox="0 0 256 256"><path d="M216,40H72A16,16,0,0,0,56,56V72H40A16,16,0,0,0,24,88V200a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16V184h16a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM72,56H216v62.75l-10.07-10.06a16,16,0,0,0-22.63,0l-20,20-44-44a16,16,0,0,0-22.62,0L72,109.37ZM184,200H40V88H56v80a16,16,0,0,0,16,16H184Zm32-32H72V132l36-36,49.66,49.66a8,8,0,0,0,11.31,0L194.63,120,216,141.38V168ZM160,84a12,12,0,1,1,12,12A12,12,0,0,1,160,84Z"/></svg>`,
  "info": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm16-40a8,8,0,0,1-8,8,16,16,0,0,1-16-16V128a8,8,0,0,1,0-16,16,16,0,0,1,16,16v40A8,8,0,0,1,144,176ZM112,84a12,12,0,1,1,12,12A12,12,0,0,1,112,84Z"/></svg>`,
  "invoice": `<svg viewBox="0 0 256 256"><path d="M28,128a8,8,0,0,1,0-16H56a8,8,0,0,0,0-16H40a24,24,0,0,1,0-48,8,8,0,0,1,16,0h8a8,8,0,0,1,0,16H40a8,8,0,0,0,0,16H56a24,24,0,0,1,0,48,8,8,0,0,1-16,0ZM232,56V192a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V152a8,8,0,0,1,16,0v40H160V160H80a8,8,0,0,1,0-16h80V112H104a8,8,0,0,1,0-16H216V64H96a8,8,0,0,1,0-16H224A8,8,0,0,1,232,56Zm-56,88h40V112H176Zm40,48V160H176v32Z"/></svg>`,
  "kanban": `<svg viewBox="0 0 256 256"><path d="M216,48H40a8,8,0,0,0-8,8V208a16,16,0,0,0,16,16H88a16,16,0,0,0,16-16V160h48v16a16,16,0,0,0,16,16h40a16,16,0,0,0,16-16V56A8,8,0,0,0,216,48ZM88,208H48V128H88Zm0-96H48V64H88Zm64,32H104V64h48Zm56,32H168V128h40Zm0-64H168V64h40Z"/></svg>`,
  "key": `<svg viewBox="0 0 256 256"><path d="M216.57,39.43A80,80,0,0,0,83.91,120.78L28.69,176A15.86,15.86,0,0,0,24,187.31V216a16,16,0,0,0,16,16H72a8,8,0,0,0,8-8V208H96a8,8,0,0,0,8-8V184h16a8,8,0,0,0,5.66-2.34l9.56-9.57A79.73,79.73,0,0,0,160,176h.1A80,80,0,0,0,216.57,39.43ZM224,98.1c-1.09,34.09-29.75,61.86-63.89,61.9H160a63.7,63.7,0,0,1-23.65-4.51,8,8,0,0,0-8.84,1.68L116.69,168H96a8,8,0,0,0-8,8v16H72a8,8,0,0,0-8,8v16H40V187.31l58.83-58.82a8,8,0,0,0,1.68-8.84A63.72,63.72,0,0,1,96,95.92c0-34.14,27.81-62.8,61.9-63.89A64,64,0,0,1,224,98.1ZM192,76a12,12,0,1,1-12-12A12,12,0,0,1,192,76Z"/></svg>`,
  "keyboard": `<svg viewBox="0 0 256 256"><path d="M224,48H32A16,16,0,0,0,16,64V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V64A16,16,0,0,0,224,48Zm0,144H32V64H224V192Zm-16-64a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,128Zm0-32a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H200A8,8,0,0,1,208,96ZM72,160a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16h8A8,8,0,0,1,72,160Zm96,0a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,160Zm40,0a8,8,0,0,1-8,8h-8a8,8,0,0,1,0-16h8A8,8,0,0,1,208,160Z"/></svg>`,
  "keyhole": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm40-104a40,40,0,1,0-65.94,30.44L88.68,172.77A8,8,0,0,0,96,184h64a8,8,0,0,0,7.32-11.23l-13.38-30.33A40.14,40.14,0,0,0,168,112ZM136.68,143l11,25.05H108.27l11-25.05A8,8,0,0,0,116,132.79a24,24,0,1,1,24,0A8,8,0,0,0,136.68,143Z"/></svg>`,
  "layout": `<svg viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,16V96H40V56ZM40,112H96v88H40Zm176,88H112V112H216v88Z"/></svg>`,
  "lifebuoy": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm39.1,131.79a47.84,47.84,0,0,0,0-55.58l28.5-28.49a87.83,87.83,0,0,1,0,112.56ZM96,128a32,32,0,1,1,32,32A32,32,0,0,1,96,128Zm88.28-67.6L155.79,88.9a47.84,47.84,0,0,0-55.58,0L71.72,60.4a87.83,87.83,0,0,1,112.56,0ZM60.4,71.72l28.5,28.49a47.84,47.84,0,0,0,0,55.58L60.4,184.28a87.83,87.83,0,0,1,0-112.56ZM71.72,195.6l28.49-28.5a47.84,47.84,0,0,0,55.58,0l28.49,28.5a87.83,87.83,0,0,1-112.56,0Z"/></svg>`,
  "lightbulb-filament": `<svg viewBox="0 0 256 256"><path d="M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.5C39.74,56.83,78.26,17.15,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.64,71.64,0,0,0,27.64,56.3h0A32,32,0,0,1,96,186v6h24V147.31L90.34,117.66a8,8,0,0,1,11.32-11.32L128,132.69l26.34-26.35a8,8,0,0,1,11.32,11.32L136,147.31V192h24v-6a32.12,32.12,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Z"/></svg>`,
  "lightbulb": `<svg viewBox="0 0 256 256"><path d="M176,232a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,232Zm40-128a87.55,87.55,0,0,1-33.64,69.21A16.24,16.24,0,0,0,176,186v6a16,16,0,0,1-16,16H96a16,16,0,0,1-16-16v-6a16,16,0,0,0-6.23-12.66A87.59,87.59,0,0,1,40,104.49C39.74,56.83,78.26,17.14,125.88,16A88,88,0,0,1,216,104Zm-16,0a72,72,0,0,0-73.74-72c-39,.92-70.47,33.39-70.26,72.39a71.65,71.65,0,0,0,27.64,56.3A32,32,0,0,1,96,186v6h64v-6a32.15,32.15,0,0,1,12.47-25.35A71.65,71.65,0,0,0,200,104Zm-16.11-9.34a57.6,57.6,0,0,0-46.56-46.55,8,8,0,0,0-2.66,15.78c16.57,2.79,30.63,16.85,33.44,33.45A8,8,0,0,0,176,104a9,9,0,0,0,1.35-.11A8,8,0,0,0,183.89,94.66Z"/></svg>`,
  "link-break": `<svg viewBox="0 0 256 256"><path d="M198.63,57.37a32,32,0,0,0-45.19-.06L141.79,69.52a8,8,0,0,1-11.58-11l11.72-12.29a1.59,1.59,0,0,1,.13-.13,48,48,0,0,1,67.88,67.88,1.59,1.59,0,0,1-.13.13l-12.29,11.72a8,8,0,0,1-11-11.58l12.21-11.65A32,32,0,0,0,198.63,57.37ZM114.21,186.48l-11.65,12.21a32,32,0,0,1-45.25-45.25l12.21-11.65a8,8,0,0,0-11-11.58L46.19,141.93a1.59,1.59,0,0,0-.13.13,48,48,0,0,0,67.88,67.88,1.59,1.59,0,0,0,.13-.13l11.72-12.29a8,8,0,1,0-11.58-11ZM216,152H192a8,8,0,0,0,0,16h24a8,8,0,0,0,0-16ZM40,104H64a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm120,80a8,8,0,0,0-8,8v24a8,8,0,0,0,16,0V192A8,8,0,0,0,160,184ZM96,72a8,8,0,0,0,8-8V40a8,8,0,0,0-16,0V64A8,8,0,0,0,96,72Z"/></svg>`,
  "link-simple-break": `<svg viewBox="0 0 256 256"><path d="M232,80a55.67,55.67,0,0,1-16.4,39.6l-30.07,30.06a8,8,0,0,1-11.31-11.32l30.07-30.06a40,40,0,1,0-56.57-56.56L117.66,81.77a8,8,0,0,1-11.32-11.32L136.4,40.4A56,56,0,0,1,232,80Zm-93.66,94.22-30.06,30.06a40,40,0,1,1-56.56-56.57l30.05-30.05a8,8,0,0,0-11.32-11.32L40.4,136.4a56,56,0,0,0,79.2,79.2l30.06-30.07a8,8,0,0,0-11.32-11.31Z"/></svg>`,
  "link-simple-horizontal-break": `<svg viewBox="0 0 256 256"><path d="M24,128a40,40,0,0,0,40,40h40a8,8,0,0,1,0,16H64A56,56,0,0,1,64,72h40a8,8,0,0,1,0,16H64A40,40,0,0,0,24,128ZM192,72H152a8,8,0,0,0,0,16h40a40,40,0,0,1,0,80H152a8,8,0,0,0,0,16h40a56,56,0,0,0,0-112Z"/></svg>`,
  "link-simple-horizontal": `<svg viewBox="0 0 256 256"><path d="M80,120h96a8,8,0,0,1,0,16H80a8,8,0,0,1,0-16Zm24,48H64a40,40,0,0,1,0-80h40a8,8,0,0,0,0-16H64a56,56,0,0,0,0,112h40a8,8,0,0,0,0-16Zm88-96H152a8,8,0,0,0,0,16h40a40,40,0,0,1,0,80H152a8,8,0,0,0,0,16h40a56,56,0,0,0,0-112Z"/></svg>`,
  "link-simple": `<svg viewBox="0 0 256 256"><path d="M165.66,90.34a8,8,0,0,1,0,11.32l-64,64a8,8,0,0,1-11.32-11.32l64-64A8,8,0,0,1,165.66,90.34ZM215.6,40.4a56,56,0,0,0-79.2,0L106.34,70.45a8,8,0,0,0,11.32,11.32l30.06-30a40,40,0,0,1,56.57,56.56l-30.07,30.06a8,8,0,0,0,11.31,11.32L215.6,119.6a56,56,0,0,0,0-79.2ZM138.34,174.22l-30.06,30.06a40,40,0,1,1-56.56-56.57l30.05-30.05a8,8,0,0,0-11.32-11.32L40.4,136.4a56,56,0,0,0,79.2,79.2l30.06-30.07a8,8,0,0,0-11.32-11.31Z"/></svg>`,
  "link": `<svg viewBox="0 0 256 256"><path d="M240,88.23a54.43,54.43,0,0,1-16,37L189.25,160a54.27,54.27,0,0,1-38.63,16h-.05A54.63,54.63,0,0,1,96,119.84a8,8,0,0,1,16,.45A38.62,38.62,0,0,0,150.58,160h0a38.39,38.39,0,0,0,27.31-11.31l34.75-34.75a38.63,38.63,0,0,0-54.63-54.63l-11,11A8,8,0,0,1,135.7,59l11-11A54.65,54.65,0,0,1,224,48,54.86,54.86,0,0,1,240,88.23ZM109,185.66l-11,11A38.41,38.41,0,0,1,70.6,208h0a38.63,38.63,0,0,1-27.29-65.94L78,107.31A38.63,38.63,0,0,1,144,135.71a8,8,0,0,0,16,.45A54.86,54.86,0,0,0,144,96a54.65,54.65,0,0,0-77.27,0L32,130.75A54.62,54.62,0,0,0,70.56,224h0a54.28,54.28,0,0,0,38.64-16l11-11A8,8,0,0,0,109,185.66Z"/></svg>`,
  "linkedin-logo": `<svg viewBox="0 0 256 256"><path d="M216,24H40A16,16,0,0,0,24,40V216a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V40A16,16,0,0,0,216,24Zm0,192H40V40H216V216ZM96,112v64a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0Zm88,28v36a8,8,0,0,1-16,0V140a20,20,0,0,0-40,0v36a8,8,0,0,1-16,0V112a8,8,0,0,1,15.79-1.78A36,36,0,0,1,184,140ZM100,84A12,12,0,1,1,88,72,12,12,0,0,1,100,84Z"/></svg>`,
  "list-bullets": `<svg viewBox="0 0 256 256"><path d="M80,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H88A8,8,0,0,1,80,64Zm136,56H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM44,52A12,12,0,1,0,56,64,12,12,0,0,0,44,52Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,116Zm0,64a12,12,0,1,0,12,12A12,12,0,0,0,44,180Z"/></svg>`,
  "list-checks": `<svg viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H128a8,8,0,0,1,0-16h88A8,8,0,0,1,224,128ZM128,72h88a8,8,0,0,0,0-16H128a8,8,0,0,0,0,16Zm88,112H128a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16ZM82.34,42.34,56,68.69,45.66,58.34A8,8,0,0,0,34.34,69.66l16,16a8,8,0,0,0,11.32,0l32-32A8,8,0,0,0,82.34,42.34Zm0,64L56,132.69,45.66,122.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Zm0,64L56,196.69,45.66,186.34a8,8,0,0,0-11.32,11.32l16,16a8,8,0,0,0,11.32,0l32-32a8,8,0,0,0-11.32-11.32Z"/></svg>`,
  "list-dashes": `<svg viewBox="0 0 256 256"><path d="M88,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H96A8,8,0,0,1,88,64Zm128,56H96a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,64H96a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM56,56H40a8,8,0,0,0,0,16H56a8,8,0,0,0,0-16Zm0,64H40a8,8,0,0,0,0,16H56a8,8,0,0,0,0-16Zm0,64H40a8,8,0,0,0,0,16H56a8,8,0,0,0,0-16Z"/></svg>`,
  "list-magnifying-glass": `<svg viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72h72a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm88,48H40a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16Zm109.66,13.66a8,8,0,0,1-11.32,0L206,177.36A40,40,0,1,1,217.36,166l20.3,20.3A8,8,0,0,1,237.66,197.66ZM184,168a24,24,0,1,0-24-24A24,24,0,0,0,184,168Z"/></svg>`,
  "list-numbers": `<svg viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H104a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM104,72H216a8,8,0,0,0,0-16H104a8,8,0,0,0,0,16ZM216,184H104a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM43.58,55.16,48,52.94V104a8,8,0,0,0,16,0V40a8,8,0,0,0-11.58-7.16l-16,8a8,8,0,0,0,7.16,14.32ZM79.77,156.72a23.73,23.73,0,0,0-9.6-15.95,24.86,24.86,0,0,0-34.11,4.7,23.63,23.63,0,0,0-3.57,6.46,8,8,0,1,0,15,5.47,7.84,7.84,0,0,1,1.18-2.13,8.76,8.76,0,0,1,12-1.59A7.91,7.91,0,0,1,63.93,159a7.64,7.64,0,0,1-1.57,5.78,1,1,0,0,0-.08.11L33.59,203.21A8,8,0,0,0,40,216H72a8,8,0,0,0,0-16H56l19.08-25.53A23.47,23.47,0,0,0,79.77,156.72Z"/></svg>`,
  "list-plus": `<svg viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm104,48H40a8,8,0,0,0,0,16H144a8,8,0,0,0,0-16Zm88,0H216V168a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V200h16a8,8,0,0,0,0-16Z"/></svg>`,
  "list-star": `<svg viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,72H96a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm72,48H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm125.09-40.22-22.52,18.59,6.86,27.71a8,8,0,0,1-11.82,8.81L184,183.82l-25.61,15.07a8,8,0,0,1-11.82-8.81l6.85-27.71-22.51-18.59a8,8,0,0,1,4.47-14.14l29.84-2.31,11.43-26.5a8,8,0,0,1,14.7,0l11.43,26.5,29.84,2.31a8,8,0,0,1,4.47,14.14Zm-25.47.28-14.89-1.15a8,8,0,0,1-6.73-4.8l-6-13.92-6,13.92a8,8,0,0,1-6.73,4.8l-14.89,1.15,11.11,9.18a8,8,0,0,1,2.68,8.09l-3.5,14.12,13.27-7.81a8,8,0,0,1,8.12,0l13.27,7.81-3.5-14.12a8,8,0,0,1,2.68-8.09Z"/></svg>`,
  "list": `<svg viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM40,72H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"/></svg>`,
  "lock-key-open": `<svg viewBox="0 0 256 256"><path d="M208,80H96V56a32,32,0,0,1,32-32c15.37,0,29.2,11,32.16,25.59a8,8,0,0,0,15.68-3.18C171.32,24.15,151.2,8,128,8A48.05,48.05,0,0,0,80,56V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm0,128H48V96H208V208Zm-80-96a28,28,0,0,0-8,54.83V184a8,8,0,0,0,16,0V166.83A28,28,0,0,0,128,112Zm0,40a12,12,0,1,1,12-12A12,12,0,0,1,128,152Z"/></svg>`,
  "lock-key": `<svg viewBox="0 0 256 256"><path d="M128,112a28,28,0,0,0-8,54.83V184a8,8,0,0,0,16,0V166.83A28,28,0,0,0,128,112Zm0,40a12,12,0,1,1,12-12A12,12,0,0,1,128,152Zm80-72H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Z"/></svg>`,
  "lock-laminated-open": `<svg viewBox="0 0 256 256"><path d="M208,80H96V56a32,32,0,0,1,32-32c15.37,0,29.2,11,32.16,25.59a8,8,0,0,0,15.68-3.18C171.32,24.15,151.2,8,128,8A48.05,48.05,0,0,0,80,56V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM48,128H208v16H48Zm0,32H208v16H48ZM208,96v16H48V96Zm0,112H48V192H208v16Z"/></svg>`,
  "lock-laminated": `<svg viewBox="0 0 256 256"><path d="M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM48,128H208v16H48Zm0,32H208v16H48ZM96,56a32,32,0,0,1,64,0V80H96ZM208,96v16H48V96Zm0,112H48V192H208v16Z"/></svg>`,
  "lock-open": `<svg viewBox="0 0 256 256"><path d="M208,80H96V56a32,32,0,0,1,32-32c15.37,0,29.2,11,32.16,25.59a8,8,0,0,0,15.68-3.18C171.32,24.15,151.2,8,128,8A48.05,48.05,0,0,0,80,56V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm0,128H48V96H208V208Zm-68-56a12,12,0,1,1-12-12A12,12,0,0,1,140,152Z"/></svg>`,
  "lock-simple-open": `<svg viewBox="0 0 256 256"><path d="M208,80H96V56a32,32,0,0,1,32-32c15.37,0,29.2,11,32.16,25.59a8,8,0,0,0,15.68-3.18C171.32,24.15,151.2,8,128,8A48.05,48.05,0,0,0,80,56V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80Zm0,128H48V96H208V208Z"/></svg>`,
  "lock-simple": `<svg viewBox="0 0 256 256"><path d="M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Z"/></svg>`,
  "lock": `<svg viewBox="0 0 256 256"><path d="M208,80H176V56a48,48,0,0,0-96,0V80H48A16,16,0,0,0,32,96V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V96A16,16,0,0,0,208,80ZM96,56a32,32,0,0,1,64,0V80H96ZM208,208H48V96H208V208Zm-68-56a12,12,0,1,1-12-12A12,12,0,0,1,140,152Z"/></svg>`,
  "magic-wand": `<svg viewBox="0 0 256 256"><path d="M48,64a8,8,0,0,1,8-8H72V40a8,8,0,0,1,16,0V56h16a8,8,0,0,1,0,16H88V88a8,8,0,0,1-16,0V72H56A8,8,0,0,1,48,64ZM184,192h-8v-8a8,8,0,0,0-16,0v8h-8a8,8,0,0,0,0,16h8v8a8,8,0,0,0,16,0v-8h8a8,8,0,0,0,0-16Zm56-48H224V128a8,8,0,0,0-16,0v16H192a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V160h16a8,8,0,0,0,0-16ZM219.31,80,80,219.31a16,16,0,0,1-22.62,0L36.68,198.63a16,16,0,0,1,0-22.63L176,36.69a16,16,0,0,1,22.63,0l20.68,20.68A16,16,0,0,1,219.31,80Zm-54.63,32L144,91.31l-96,96L68.68,208ZM208,68.69,187.31,48l-32,32L176,100.69Z"/></svg>`,
  "mailbox": `<svg viewBox="0 0 256 256"><path d="M104,152a8,8,0,0,1-8,8H56a8,8,0,0,1,0-16H96A8,8,0,0,1,104,152Zm136-36v60a16,16,0,0,1-16,16H136v32a8,8,0,0,1-16,0V192H32a16,16,0,0,1-16-16V116A60.07,60.07,0,0,1,76,56h76V24a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H168V56h12A60.07,60.07,0,0,1,240,116ZM120,176V116a44,44,0,0,0-88,0v60Zm104-60a44.05,44.05,0,0,0-44-44H168v72a8,8,0,0,1-16,0V72H116.75A59.86,59.86,0,0,1,136,116v60h88Z"/></svg>`,
  "map-pin-line": `<svg viewBox="0 0 256 256"><path d="M200,224H150.54A266.56,266.56,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25a88,88,0,0,0-176,0c0,31.4,14.51,64.68,42,96.25A266.56,266.56,0,0,0,105.46,224H56a8,8,0,0,0,0,16H200a8,8,0,0,0,0-16ZM56,104a72,72,0,0,1,144,0c0,57.23-55.47,105-72,118C111.47,209,56,161.23,56,104Zm112,0a40,40,0,1,0-40,40A40,40,0,0,0,168,104Zm-64,0a24,24,0,1,1,24,24A24,24,0,0,1,104,104Z"/></svg>`,
  "map-pin-simple-line": `<svg viewBox="0 0 256 256"><path d="M216,208H136V135.42a56,56,0,1,0-16,0V208H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM88,80a40,40,0,1,1,40,40A40,40,0,0,1,88,80Z"/></svg>`,
  "map-pin-simple": `<svg viewBox="0 0 256 256"><path d="M184,72a56,56,0,1,0-64,55.42V232a8,8,0,0,0,16,0V127.42A56.09,56.09,0,0,0,184,72Zm-56,40a40,40,0,1,1,40-40A40,40,0,0,1,128,112Z"/></svg>`,
  "map-pin": `<svg viewBox="0 0 256 256"><path d="M128,64a40,40,0,1,0,40,40A40,40,0,0,0,128,64Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,128Zm0-112a88.1,88.1,0,0,0-88,88c0,31.4,14.51,64.68,42,96.25a254.19,254.19,0,0,0,41.45,38.3,8,8,0,0,0,9.18,0A254.19,254.19,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25A88.1,88.1,0,0,0,128,16Zm0,206c-16.53-13-72-60.75-72-118a72,72,0,0,1,144,0C200,161.23,144.53,209,128,222Z"/></svg>`,
  "map-trifold": `<svg viewBox="0 0 256 256"><path d="M228.92,49.69a8,8,0,0,0-6.86-1.45L160.93,63.52,99.58,32.84a8,8,0,0,0-5.52-.6l-64,16A8,8,0,0,0,24,56V200a8,8,0,0,0,9.94,7.76l61.13-15.28,61.35,30.68A8.15,8.15,0,0,0,160,224a8,8,0,0,0,1.94-.24l64-16A8,8,0,0,0,232,200V56A8,8,0,0,0,228.92,49.69ZM104,52.94l48,24V203.06l-48-24ZM40,62.25l48-12v127.5l-48,12Zm176,131.5-48,12V78.25l48-12Z"/></svg>`,
  "megaphone-simple": `<svg viewBox="0 0 256 256"><path d="M228.54,86.66l-176.06-54A16,16,0,0,0,32,48V192a16,16,0,0,0,16,16,16,16,0,0,0,4.52-.65L136,181.73V192a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16v-29.9l28.54-8.75A16.09,16.09,0,0,0,240,138V102A16.09,16.09,0,0,0,228.54,86.66ZM136,165,48,192V48l88,27Zm48,27H152V176.82L184,167Zm40-54-.11,0L152,160.08V79.92l71.89,22,.11,0v36Z"/></svg>`,
  "megaphone": `<svg viewBox="0 0 256 256"><path d="M248,120a48.05,48.05,0,0,0-48-48H160.2c-2.91-.17-53.62-3.74-101.91-44.24A16,16,0,0,0,32,40V200a16,16,0,0,0,26.29,12.25c37.77-31.68,77-40.76,93.71-43.3v31.72A16,16,0,0,0,159.12,214l11,7.33A16,16,0,0,0,194.5,212l11.77-44.36A48.07,48.07,0,0,0,248,120ZM48,199.93V40h0c42.81,35.91,86.63,45,104,47.24v65.48C134.65,155,90.84,164.07,48,199.93Zm131,8,0,.11-11-7.33V168h21.6ZM200,152H168V88h32a32,32,0,1,1,0,64Z"/></svg>`,
  "microphone-slash": `<svg viewBox="0 0 256 256"><path d="M213.92,218.62l-160-176A8,8,0,0,0,42.08,53.38L80,95.09V128a48,48,0,0,0,69.11,43.12l11.1,12.2A63.41,63.41,0,0,1,128,192a64.07,64.07,0,0,1-64-64,8,8,0,0,0-16,0,80.11,80.11,0,0,0,72,79.6V240a8,8,0,0,0,16,0V207.59a78.83,78.83,0,0,0,35.16-12.22l30.92,34a8,8,0,1,0,11.84-10.76ZM128,160a32,32,0,0,1-32-32V112.69l41.66,45.82A32,32,0,0,1,128,160Zm57.52-3.91A63.32,63.32,0,0,0,192,128a8,8,0,0,1,16,0,79.16,79.16,0,0,1-8.11,35.12,8,8,0,0,1-7.19,4.49,7.88,7.88,0,0,1-3.51-.82A8,8,0,0,1,185.52,156.09ZM84,44.87A48,48,0,0,1,176,64v64a49.19,49.19,0,0,1-.26,5,8,8,0,0,1-8,7.17,8.13,8.13,0,0,1-.84,0,8,8,0,0,1-7.12-8.79c.11-1.1.17-2.24.17-3.36V64A32,32,0,0,0,98.64,51.25,8,8,0,1,1,84,44.87Z"/></svg>`,
  "microphone": `<svg viewBox="0 0 256 256"><path d="M128,176a48.05,48.05,0,0,0,48-48V64a48,48,0,0,0-96,0v64A48.05,48.05,0,0,0,128,176ZM96,64a32,32,0,0,1,64,0v64a32,32,0,0,1-64,0Zm40,143.6V240a8,8,0,0,1-16,0V207.6A80.11,80.11,0,0,1,48,128a8,8,0,0,1,16,0,64,64,0,0,0,128,0,8,8,0,0,1,16,0A80.11,80.11,0,0,1,136,207.6Z"/></svg>`,
  "microsoft-excel-logo": `<svg viewBox="0 0 256 256"><path d="M200,24H72A16,16,0,0,0,56,40V64H40A16,16,0,0,0,24,80v96a16,16,0,0,0,16,16H56v24a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24Zm-40,80h40v48H160Zm40-16H160V80a16,16,0,0,0-16-16V40h56ZM72,40h56V64H72ZM40,80H144v79.83c0,.06,0,.11,0,.17s0,.11,0,.17V176H40ZM72,192h56v24H72Zm72,24V192a16,16,0,0,0,16-16v-8h40v48ZM65.85,146.88,81.59,128,65.85,109.12a8,8,0,0,1,12.3-10.24L92,115.5l13.85-16.62a8,8,0,1,1,12.3,10.24L102.41,128l15.74,18.88a8,8,0,0,1-12.3,10.24L92,140.5,78.15,157.12a8,8,0,0,1-12.3-10.24Z"/></svg>`,
  "microsoft-outlook-logo": `<svg viewBox="0 0 256 256"><path d="M120,128a32,32,0,1,0-32,32A32,32,0,0,0,120,128Zm-48,0a16,16,0,1,1,16,16A16,16,0,0,1,72,128Zm152-24H208V40a8,8,0,0,0-8-8H104a8,8,0,0,0-8,8V64H40A16,16,0,0,0,24,80v96a16,16,0,0,0,16,16H72v16a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V112A8,8,0,0,0,224,104Zm-58.34,60L216,127.65v72.7ZM112,48h80v77.24l-40,28.89V80a16,16,0,0,0-16-16H112ZM40,80h96v77.9c0,.12,0,.24,0,.36V176H40ZM88,192h48a16,16,0,0,0,16-16v-2.13L199.26,208H88Z"/></svg>`,
  "microsoft-teams-logo": `<svg viewBox="0 0 256 256"><path d="M112,104a8,8,0,0,1-8,8H96v40a8,8,0,0,1-16,0V112H72a8,8,0,0,1,0-16h32A8,8,0,0,1,112,104ZM232,92.74V152a40,40,0,0,1-36.63,39.85,64,64,0,0,1-118.7.15H40a16,16,0,0,1-16-16V80A16,16,0,0,1,40,64H96.81a40,40,0,0,1,73.31-28.85A32,32,0,0,1,211.69,80h7.57A12.76,12.76,0,0,1,232,92.74ZM112,56a23.82,23.82,0,0,0,1.38,8H136a16,16,0,0,1,15.07,10.68A24,24,0,1,0,112,56Zm24,120h0V80H40v96h96Zm48-80H152v80a16,16,0,0,1-16,16H94.44A48,48,0,0,0,184,168Zm16-32a16,16,0,0,0-24.4-13.6A39.89,39.89,0,0,1,168,80h16A16,16,0,0,0,200,64Zm16,32H200v72a62.76,62.76,0,0,1-.36,6.75A24,24,0,0,0,216,152Z"/></svg>`,
  "microsoft-word-logo": `<svg viewBox="0 0 256 256"><path d="M200,24H72A16,16,0,0,0,56,40V64H40A16,16,0,0,0,24,80v96a16,16,0,0,0,16,16H56v24a16,16,0,0,0,16,16H200a16,16,0,0,0,16-16V40A16,16,0,0,0,200,24Zm-40,80h40v48H160ZM72,40H200V88H160V80a16,16,0,0,0-16-16H72ZM40,80H144v79.83c0,.06,0,.11,0,.17s0,.11,0,.17V176H40ZM72,216V192h72a16,16,0,0,0,16-16v-8h40v48Zm-3.76-62.06-12-48a8,8,0,1,1,15.52-3.88l6.76,27,6.32-12.66a8,8,0,0,1,14.32,0l6.32,12.66,6.76-27a8,8,0,0,1,15.52,3.88l-12,48a8,8,0,0,1-6.89,6,8.46,8.46,0,0,1-.87.05,8,8,0,0,1-7.16-4.42L92,137.89l-8.84,17.69a8,8,0,0,1-14.92-1.64Z"/></svg>`,
  "minus-circle": `<svg viewBox="0 0 256 256"><path d="M176,128a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,128Zm56,0A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"/></svg>`,
  "minus-square": `<svg viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-32-80a8,8,0,0,1-8,8H88a8,8,0,0,1,0-16h80A8,8,0,0,1,176,128Z"/></svg>`,
  "minus": `<svg viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128Z"/></svg>`,
  "money-wavy": `<svg viewBox="0 0 256 256"><path d="M244.24,60a8,8,0,0,0-7.75-.4c-42.93,21-73.59,11.16-106,.78-34-10.89-69.25-22.14-117.95,1.64A8,8,0,0,0,8,69.24V189.17a8,8,0,0,0,11.51,7.19c42.93-21,73.59-11.16,106.05-.78,19.24,6.15,38.84,12.42,61,12.42,17.09,0,35.73-3.72,56.91-14.06a8,8,0,0,0,4.49-7.18V66.83A8,8,0,0,0,244.24,60ZM232,181.67c-40.6,18.17-70.25,8.69-101.56-1.32-19.24-6.15-38.84-12.42-61-12.42a122,122,0,0,0-45.4,9V74.33c40.6-18.17,70.25-8.69,101.56,1.32S189.14,96,232,79.09ZM128,96a32,32,0,1,0,32,32A32,32,0,0,0,128,96Zm0,48a16,16,0,1,1,16-16A16,16,0,0,1,128,144ZM56,96v48a8,8,0,0,1-16,0V96a8,8,0,1,1,16,0Zm144,64V112a8,8,0,1,1,16,0v48a8,8,0,1,1-16,0Z"/></svg>`,
  "money": `<svg viewBox="0 0 256 256"><path d="M128,88a40,40,0,1,0,40,40A40,40,0,0,0,128,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,128,152ZM240,56H16a8,8,0,0,0-8,8V192a8,8,0,0,0,8,8H240a8,8,0,0,0,8-8V64A8,8,0,0,0,240,56ZM193.65,184H62.35A56.78,56.78,0,0,0,24,145.65v-35.3A56.78,56.78,0,0,0,62.35,72h131.3A56.78,56.78,0,0,0,232,110.35v35.3A56.78,56.78,0,0,0,193.65,184ZM232,93.37A40.81,40.81,0,0,1,210.63,72H232ZM45.37,72A40.81,40.81,0,0,1,24,93.37V72ZM24,162.63A40.81,40.81,0,0,1,45.37,184H24ZM210.63,184A40.81,40.81,0,0,1,232,162.63V184Z"/></svg>`,
  "newspaper-clipping": `<svg viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V216a8,8,0,0,0,11.58,7.15L64,208.94l28.42,14.21a8,8,0,0,0,7.16,0L128,208.94l28.42,14.21a8,8,0,0,0,7.16,0L192,208.94l28.42,14.21A8,8,0,0,0,232,216V56A16,16,0,0,0,216,40Zm0,163.06-20.42-10.22a8,8,0,0,0-7.16,0L160,207.06l-28.42-14.22a8,8,0,0,0-7.16,0L96,207.06,67.58,192.84a8,8,0,0,0-7.16,0L40,203.06V56H216ZM136,112a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H144A8,8,0,0,1,136,112Zm0,32a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H144A8,8,0,0,1,136,144ZM64,168h48a8,8,0,0,0,8-8V96a8,8,0,0,0-8-8H64a8,8,0,0,0-8,8v64A8,8,0,0,0,64,168Zm8-64h32v48H72Z"/></svg>`,
  "note-blank": `<svg viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H156.69A15.86,15.86,0,0,0,168,219.31L219.31,168A15.86,15.86,0,0,0,224,156.69V48A16,16,0,0,0,208,32ZM48,48H208V152H160a8,8,0,0,0-8,8v48H48ZM196.69,168,168,196.69V168Z"/></svg>`,
  "note-pencil": `<svg viewBox="0 0 256 256"><path d="M229.66,58.34l-32-32a8,8,0,0,0-11.32,0l-96,96A8,8,0,0,0,88,128v32a8,8,0,0,0,8,8h32a8,8,0,0,0,5.66-2.34l96-96A8,8,0,0,0,229.66,58.34ZM124.69,152H104V131.31l64-64L188.69,88ZM200,76.69,179.31,56,192,43.31,212.69,64ZM224,128v80a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32h80a8,8,0,0,1,0,16H48V208H208V128a8,8,0,0,1,16,0Z"/></svg>`,
  "note": `<svg viewBox="0 0 256 256"><path d="M88,96a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H96A8,8,0,0,1,88,96Zm8,40h64a8,8,0,0,0,0-16H96a8,8,0,0,0,0,16Zm32,16H96a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM224,48V156.69A15.86,15.86,0,0,1,219.31,168L168,219.31A15.86,15.86,0,0,1,156.69,224H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM48,208H152V160a8,8,0,0,1,8-8h48V48H48Zm120-40v28.7L196.69,168Z"/></svg>`,
  "notebook": `<svg viewBox="0 0 256 256"><path d="M184,112a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h64A8,8,0,0,1,184,112Zm-8,24H112a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm48-88V208a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V48A16,16,0,0,1,48,32H208A16,16,0,0,1,224,48ZM48,208H72V48H48Zm160,0V48H88V208H208Z"/></svg>`,
  "notepad": `<svg viewBox="0 0 256 256"><path d="M168,128a8,8,0,0,1-8,8H96a8,8,0,0,1,0-16h64A8,8,0,0,1,168,128Zm-8,24H96a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16ZM216,40V200a32,32,0,0,1-32,32H72a32,32,0,0,1-32-32V40a8,8,0,0,1,8-8H72V24a8,8,0,0,1,16,0v8h32V24a8,8,0,0,1,16,0v8h32V24a8,8,0,0,1,16,0v8h24A8,8,0,0,1,216,40Zm-16,8H184v8a8,8,0,0,1-16,0V48H136v8a8,8,0,0,1-16,0V48H88v8a8,8,0,0,1-16,0V48H56V200a16,16,0,0,0,16,16H184a16,16,0,0,0,16-16Z"/></svg>`,
  "notification": `<svg viewBox="0 0 256 256"><path d="M216,128v80a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V56A16,16,0,0,1,48,40h80a8,8,0,0,1,0,16H48V208H200V128a8,8,0,0,1,16,0Zm16-68a36,36,0,1,1-36-36A36,36,0,0,1,232,60Zm-16,0a20,20,0,1,0-20,20A20,20,0,0,0,216,60Z"/></svg>`,
  "open-ai-logo": `<svg viewBox="0 0 256 256"><path d="M224.32,114.24a56,56,0,0,0-60.07-76.57A56,56,0,0,0,67.93,51.44a56,56,0,0,0-36.25,90.32A56,56,0,0,0,69,217,56.39,56.39,0,0,0,83.59,219a55.75,55.75,0,0,0,8.17-.61,56,56,0,0,0,96.31-13.78,56,56,0,0,0,36.25-90.32ZM182.85,54.43a40,40,0,0,1,28.56,48c-.95-.63-1.91-1.24-2.91-1.81L164,74.88a8,8,0,0,0-8,0l-44,25.41V81.81l40.5-23.38A39.76,39.76,0,0,1,182.85,54.43ZM144,137.24l-16,9.24-16-9.24V118.76l16-9.24,16,9.24ZM80,72a40,40,0,0,1,67.53-29c-1,.51-2,1-3,1.62L100,70.27a8,8,0,0,0-4,6.92V128l-16-9.24ZM40.86,86.93A39.75,39.75,0,0,1,64.12,68.57C64.05,69.71,64,70.85,64,72v51.38a8,8,0,0,0,4,6.93l44,25.4L96,165,55.5,141.57A40,40,0,0,1,40.86,86.93ZM73.15,201.57a40,40,0,0,1-28.56-48c.95.63,1.91,1.24,2.91,1.81L92,181.12a8,8,0,0,0,8,0l44-25.41v18.48l-40.5,23.38A39.76,39.76,0,0,1,73.15,201.57ZM176,184a40,40,0,0,1-67.52,29.05c1-.51,2-1.05,3-1.63L156,185.73a8,8,0,0,0,4-6.92V128l16,9.24Zm39.14-14.93a39.75,39.75,0,0,1-23.26,18.36c.07-1.14.12-2.28.12-3.43V132.62a8,8,0,0,0-4-6.93l-44-25.4,16-9.24,40.5,23.38A40,40,0,0,1,215.14,169.07Z"/></svg>`,
  "paper-plane-right": `<svg viewBox="0 0 256 256"><path d="M231.87,114l-168-95.89A16,16,0,0,0,40.92,37.34L71.55,128,40.92,218.67A16,16,0,0,0,56,240a16.15,16.15,0,0,0,7.93-2.1l167.92-96.05a16,16,0,0,0,.05-27.89ZM56,224a.56.56,0,0,0,0-.12L85.74,136H144a8,8,0,0,0,0-16H85.74L56.06,32.16A.46.46,0,0,0,56,32l168,95.83Z"/></svg>`,
  "paper-plane-tilt": `<svg viewBox="0 0 256 256"><path d="M227.32,28.68a16,16,0,0,0-15.66-4.08l-.15,0L19.57,82.84a16,16,0,0,0-2.49,29.8L102,154l41.3,84.87A15.86,15.86,0,0,0,157.74,248q.69,0,1.38-.06a15.88,15.88,0,0,0,14-11.51l58.2-191.94c0-.05,0-.1,0-.15A16,16,0,0,0,227.32,28.68ZM157.83,231.85l-.05.14,0-.07-40.06-82.3,48-48a8,8,0,0,0-11.31-11.31l-48,48L24.08,98.25l-.07,0,.14,0L216,40Z"/></svg>`,
  "paper-plane": `<svg viewBox="0 0 256 256"><path d="M237.9,200.1,141.85,32.18a16,16,0,0,0-27.89,0l-95.89,168a16,16,0,0,0,19.26,22.92L128,192.45l90.67,30.63A16.22,16.22,0,0,0,224,224a16,16,0,0,0,13.86-23.9Zm-14.05,7.84L136,178.26V120a8,8,0,0,0-16,0v58.26L32.16,207.94,32,208,127.86,40,224,208Z"/></svg>`,
  "paperclip-horizontal": `<svg viewBox="0 0 256 256"><path d="M248,128a56.06,56.06,0,0,1-56,56H48a40,40,0,0,1,0-80H192a24,24,0,0,1,0,48H80a8,8,0,0,1,0-16H192a8,8,0,0,0,0-16H48a24,24,0,0,0,0,48H192a40,40,0,0,0,0-80H80a8,8,0,0,1,0-16H192A56.06,56.06,0,0,1,248,128Z"/></svg>`,
  "paperclip": `<svg viewBox="0 0 256 256"><path d="M209.66,122.34a8,8,0,0,1,0,11.32l-82.05,82a56,56,0,0,1-79.2-79.21L147.67,35.73a40,40,0,1,1,56.61,56.55L105,193A24,24,0,1,1,71,159L154.3,74.38A8,8,0,1,1,165.7,85.6L82.39,170.31a8,8,0,1,0,11.27,11.36L192.93,81A24,24,0,1,0,159,47L59.76,147.68a40,40,0,1,0,56.53,56.62l82.06-82A8,8,0,0,1,209.66,122.34Z"/></svg>`,
  "paragraph": `<svg viewBox="0 0 256 256"><path d="M208,40H96a64,64,0,0,0,0,128h40v40a8,8,0,0,0,16,0V56h24V208a8,8,0,0,0,16,0V56h16a8,8,0,0,0,0-16ZM136,152H96a48,48,0,0,1,0-96h40Z"/></svg>`,
  "password": `<svg viewBox="0 0 256 256"><path d="M48,56V200a8,8,0,0,1-16,0V56a8,8,0,0,1,16,0Zm92,54.5L120,117V96a8,8,0,0,0-16,0v21L84,110.5a8,8,0,0,0-5,15.22l20,6.49-12.34,17a8,8,0,1,0,12.94,9.4l12.34-17,12.34,17a8,8,0,1,0,12.94-9.4l-12.34-17,20-6.49A8,8,0,0,0,140,110.5ZM246,115.64A8,8,0,0,0,236,110.5L216,117V96a8,8,0,0,0-16,0v21l-20-6.49a8,8,0,0,0-4.95,15.22l20,6.49-12.34,17a8,8,0,1,0,12.94,9.4l12.34-17,12.34,17a8,8,0,1,0,12.94-9.4l-12.34-17,20-6.49A8,8,0,0,0,246,115.64Z"/></svg>`,
  "pen-nib-straight": `<svg viewBox="0 0 256 256"><path d="M222.33,123.89c-.06-.13-.12-.26-.19-.38L192,69.9V32a16,16,0,0,0-16-16H80A16,16,0,0,0,64,32V69.92L33.86,123.51c-.07.12-.13.25-.2.38a15.94,15.94,0,0,0,1.46,16.57l.11.14,86.44,112.28a8,8,0,0,0,12.67,0L220.77,140.6l.11-.14A15.92,15.92,0,0,0,222.33,123.89ZM176,32V64H80V32ZM128,144a12,12,0,1,1,12-12A12,12,0,0,1,128,144Zm8,80.5V158.83a28,28,0,1,0-16,0v65.66L48,131,76.69,80H179.32L208,131Z"/></svg>`,
  "pen-nib": `<svg viewBox="0 0 256 256"><path d="M248,92.68a15.86,15.86,0,0,0-4.69-11.31L174.63,12.68a16,16,0,0,0-22.63,0L123.57,41.11l-58,21.77A16.06,16.06,0,0,0,55.35,75.23L32.11,214.68A8,8,0,0,0,40,224a8.4,8.4,0,0,0,1.32-.11l139.44-23.24a16,16,0,0,0,12.35-10.17l21.77-58L243.31,104A15.87,15.87,0,0,0,248,92.68Zm-69.87,92.19L63.32,204l47.37-47.37a28,28,0,1,0-11.32-11.32L52,192.7,71.13,77.86,126,57.29,198.7,130ZM112,132a12,12,0,1,1,12,12A12,12,0,0,1,112,132Zm96-15.32L139.31,48l24-24L232,92.68Z"/></svg>`,
  "pen": `<svg viewBox="0 0 256 256"><path d="M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31l83.67-83.66,3.48,13.9-36.8,36.79a8,8,0,0,0,11.31,11.32l40-40a8,8,0,0,0,2.11-7.6l-6.9-27.61L227.32,96A16,16,0,0,0,227.32,73.37ZM48,179.31,76.69,208H48Zm48,25.38L51.31,160,136,75.31,180.69,120Zm96-96L147.32,64l24-24L216,84.69Z"/></svg>`,
  "pencil-circle": `<svg viewBox="0 0 256 256"><path d="M201.54,54.46A104,104,0,0,0,54.46,201.54,104,104,0,0,0,201.54,54.46ZM88,192a16,16,0,0,1,32,0v23.59a88,88,0,0,1-32-9.22Zm48,0a16,16,0,0,1,32,0v14.37a88,88,0,0,1-32,9.22Zm-28.73-56h41.46l11.58,25.1A31.93,31.93,0,0,0,128,170.87a31.93,31.93,0,0,0-32.31-9.77Zm7.39-16L128,91.09,141.34,120Zm75.56,70.23c-2,2-4.08,3.87-6.22,5.64V176a7.91,7.91,0,0,0-.74-3.35l-48-104a8,8,0,0,0-14.52,0l-48,104A7.91,7.91,0,0,0,72,176v19.87c-2.14-1.77-4.22-3.64-6.22-5.64a88,88,0,1,1,124.44,0Z"/></svg>`,
  "pencil-line": `<svg viewBox="0 0 256 256"><path d="M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM136,75.31,152.69,92,68,176.69,51.31,160ZM48,208V179.31L76.69,208Zm48-3.31L79.32,188,164,103.31,180.69,120Zm96-96L147.32,64l24-24L216,84.69Z"/></svg>`,
  "pencil-ruler": `<svg viewBox="0 0 256 256"><path d="M208,32H160a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H160V176h24a8,8,0,0,0,0-16H160V136h24a8,8,0,0,0,0-16H160V96h24a8,8,0,0,0,0-16H160V48h48V208ZM77.66,26.34a8,8,0,0,0-11.32,0l-32,32A8,8,0,0,0,32,64V208a16,16,0,0,0,16,16H96a16,16,0,0,0,16-16V64a8,8,0,0,0-2.34-5.66ZM48,176V80H64v96ZM80,80H96v96H80ZM72,43.31,92.69,64H51.31ZM48,208V192H96v16Z"/></svg>`,
  "pencil-simple-line": `<svg viewBox="0 0 256 256"><path d="M227.32,73.37,182.63,28.69a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H216a8,8,0,0,0,0-16H115.32l112-112A16,16,0,0,0,227.32,73.37ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.69,147.32,64l24-24L216,84.69Z"/></svg>`,
  "pencil-simple": `<svg viewBox="0 0 256 256"><path d="M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM92.69,208H48V163.31l88-88L180.69,120ZM192,108.68,147.31,64l24-24L216,84.68Z"/></svg>`,
  "pencil": `<svg viewBox="0 0 256 256"><path d="M227.31,73.37,182.63,28.68a16,16,0,0,0-22.63,0L36.69,152A15.86,15.86,0,0,0,32,163.31V208a16,16,0,0,0,16,16H92.69A15.86,15.86,0,0,0,104,219.31L227.31,96a16,16,0,0,0,0-22.63ZM51.31,160,136,75.31,152.69,92,68,176.68ZM48,179.31,76.69,208H48Zm48,25.38L79.31,188,164,103.31,180.69,120Zm96-96L147.31,64l24-24L216,84.68Z"/></svg>`,
  "percent": `<svg viewBox="0 0 256 256"><path d="M205.66,61.64l-144,144a8,8,0,0,1-11.32-11.32l144-144a8,8,0,0,1,11.32,11.31ZM50.54,101.44a36,36,0,0,1,50.92-50.91h0a36,36,0,0,1-50.92,50.91ZM56,76A20,20,0,1,0,90.14,61.84h0A20,20,0,0,0,56,76ZM216,180a36,36,0,1,1-10.54-25.46h0A35.76,35.76,0,0,1,216,180Zm-16,0a20,20,0,1,0-5.86,14.14A19.87,19.87,0,0,0,200,180Z"/></svg>`,
  "person-simple-circle": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216ZM112,80a16,16,0,1,1,16,16A16,16,0,0,1,112,80Zm72,32a8,8,0,0,1-8,8H136v13.58l30.66,46a8,8,0,0,1-13.32,8.88l-25.34-38-25.34,38a8,8,0,1,1-13.32-8.88l30.66-46V120H80a8,8,0,0,1,0-16h96A8,8,0,0,1,184,112Z"/></svg>`,
  "person-simple": `<svg viewBox="0 0 256 256"><path d="M128,80A32,32,0,1,0,96,48,32,32,0,0,0,128,80Zm0-48a16,16,0,1,1-16,16A16,16,0,0,1,128,32ZM230.86,132.12a8,8,0,0,1-11,2.74c-.35-.21-35.11-20.59-83.88-22.67V149l62,69.73a8,8,0,1,1-12,10.62L128,164,70,229.31a8,8,0,1,1-12-10.62L120,149V112.18c-49,2.08-83.52,22.46-83.88,22.68a8,8,0,1,1-8.23-13.72C29.6,120.11,70.45,96,128,96s98.4,24.11,100.12,25.14A8,8,0,0,1,230.86,132.12Z"/></svg>`,
  "person": `<svg viewBox="0 0 256 256"><path d="M160,40a32,32,0,1,0-32,32A32,32,0,0,0,160,40ZM128,56a16,16,0,1,1,16-16A16,16,0,0,1,128,56Zm90.34,78.05L173.17,82.83a32,32,0,0,0-24-10.83H106.83a32,32,0,0,0-24,10.83L37.66,134.05a20,20,0,0,0,28.13,28.43l16.3-13.08L65.55,212.28A20,20,0,0,0,102,228.8l26-44.87,26,44.87a20,20,0,0,0,36.41-16.52L173.91,149.4l16.3,13.08a20,20,0,0,0,28.13-28.43Zm-11.51,16.77a4,4,0,0,1-5.66,0c-.21-.2-.42-.4-.65-.58L165,121.76A8,8,0,0,0,152.26,130L175.14,217a7.72,7.72,0,0,0,.48,1.35,4,4,0,1,1-7.25,3.38,6.25,6.25,0,0,0-.33-.63L134.92,164a8,8,0,0,0-13.84,0L88,221.05a6.25,6.25,0,0,0-.33.63,4,4,0,0,1-2.26,2.07,4,4,0,0,1-5-5.45,7.72,7.72,0,0,0,.48-1.35L103.74,130A8,8,0,0,0,91,121.76L55.48,150.24c-.23.18-.44.38-.65.58a4,4,0,1,1-5.66-5.65c.12-.12.23-.24.34-.37L94.83,93.41a16,16,0,0,1,12-5.41h42.34a16,16,0,0,1,12,5.41l45.32,51.39c.11.13.22.25.34.37A4,4,0,0,1,206.83,150.82Z"/></svg>`,
  "phone-call": `<svg viewBox="0 0 256 256"><path d="M144.27,45.93a8,8,0,0,1,9.8-5.66,86.22,86.22,0,0,1,61.66,61.66,8,8,0,0,1-5.66,9.8A8.23,8.23,0,0,1,208,112a8,8,0,0,1-7.73-5.94,70.35,70.35,0,0,0-50.33-50.33A8,8,0,0,1,144.27,45.93Zm-2.33,41.8c13.79,3.68,22.65,12.54,26.33,26.33A8,8,0,0,0,176,120a8.23,8.23,0,0,0,2.07-.27,8,8,0,0,0,5.66-9.8c-5.12-19.16-18.5-32.54-37.66-37.66a8,8,0,1,0-4.13,15.46Zm81.94,95.35A56.26,56.26,0,0,1,168,232C88.6,232,24,167.4,24,88A56.26,56.26,0,0,1,72.92,32.12a16,16,0,0,1,16.62,9.52l21.12,47.15,0,.12A16,16,0,0,1,109.39,104c-.18.27-.37.52-.57.77L88,129.45c7.49,15.22,23.41,31,38.83,38.51l24.34-20.71a8.12,8.12,0,0,1,.75-.56,16,16,0,0,1,15.17-1.4l.13.06,47.11,21.11A16,16,0,0,1,223.88,183.08Zm-15.88-2s-.07,0-.11,0h0l-47-21.05-24.35,20.71a8.44,8.44,0,0,1-.74.56,16,16,0,0,1-15.75,1.14c-18.73-9.05-37.4-27.58-46.46-46.11a16,16,0,0,1,1-15.7,6.13,6.13,0,0,1,.57-.77L96,95.15l-21-47a.61.61,0,0,1,0-.12A40.2,40.2,0,0,0,40,88,128.14,128.14,0,0,0,168,216,40.21,40.21,0,0,0,208,181.07Z"/></svg>`,
  "phone-disconnect": `<svg viewBox="0 0 256 256"><path d="M231.59,90.13h0C175.44,34,80.56,34,24.41,90.13c-20,20-21.92,49.49-4.69,71.71A16,16,0,0,0,32.35,168a15.8,15.8,0,0,0,5.75-1.08l49-17.37.29-.11a16,16,0,0,0,9.75-11.73l5.9-29.52a76.52,76.52,0,0,1,49.68-.11h0l6.21,29.75a16,16,0,0,0,9.72,11.59l.29.11,49,17.39a16,16,0,0,0,18.38-5.06C253.51,139.62,251.58,110.13,231.59,90.13ZM223.67,152l-.3-.12-48.82-17.33-6.21-29.74A16,16,0,0,0,158,93a92.56,92.56,0,0,0-60.34.13,16,16,0,0,0-10.32,12l-5.9,29.51L32.63,151.86c-.1,0-.17.13-.27.17-12.33-15.91-11-36.23,3.36-50.58,25-25,58.65-37.53,92.28-37.53s67.27,12.51,92.28,37.53C234.61,115.8,236,136.12,223.67,152Zm.32,48a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,200Z"/></svg>`,
  "phone-incoming": `<svg viewBox="0 0 256 256"><path d="M144,104V64a8,8,0,0,1,16,0V84.69l34.34-34.35a8,8,0,0,1,11.32,11.32L171.32,96H192a8,8,0,0,1,0,16H152A8,8,0,0,1,144,104Zm79.88,79.08A56.26,56.26,0,0,1,168,232C88.6,232,24,167.4,24,88A56.24,56.24,0,0,1,72.92,32.13a16,16,0,0,1,16.62,9.51l21.12,47.15,0,.12A16,16,0,0,1,109.39,104c-.18.27-.37.52-.57.77L88,129.45c7.49,15.22,23.41,31,38.83,38.51l24.34-20.71a8.12,8.12,0,0,1,.75-.56,16,16,0,0,1,15.17-1.4l.13.06,47.11,21.11A16,16,0,0,1,223.88,183.08Zm-15.88-2s-.07,0-.11,0h0l-47-21.05-24.35,20.71a6.84,6.84,0,0,1-.74.56,16,16,0,0,1-15.75,1.14c-18.73-9.05-37.4-27.58-46.46-46.11a16,16,0,0,1,1-15.7,6.13,6.13,0,0,1,.57-.77L96,95.15l-21-47a.61.61,0,0,1,0-.12A40.2,40.2,0,0,0,40,88,128.14,128.14,0,0,0,168,216,40.21,40.21,0,0,0,208,181.07Z"/></svg>`,
  "phone-list": `<svg viewBox="0 0 256 256"><path d="M214.36,166.46l-47.1-21.11-.12-.06a16,16,0,0,0-15.18,1.4,8.12,8.12,0,0,0-.75.56L126.87,168c-15.42-7.49-31.34-23.29-38.83-38.51l20.78-24.71c.2-.25.39-.5.57-.77a16,16,0,0,0,1.32-15.06.61.61,0,0,1,0-.12L89.54,41.64a16,16,0,0,0-16.62-9.52A56.26,56.26,0,0,0,24,88c0,79.4,64.6,144,144,144a56.26,56.26,0,0,0,55.88-48.92A16,16,0,0,0,214.36,166.46ZM168,216A128.14,128.14,0,0,1,40,88,40.2,40.2,0,0,1,74.87,48a.61.61,0,0,0,0,.12l21,47L75.2,119.86a6.13,6.13,0,0,0-.57.77,16,16,0,0,0-1,15.7c9.06,18.53,27.73,37.06,46.46,46.11a16,16,0,0,0,15.75-1.14,6.92,6.92,0,0,0,.74-.57L160.89,160l47,21.06h0s.08,0,.11,0A40.21,40.21,0,0,1,168,216ZM136,64a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H144A8,8,0,0,1,136,64Zm0,40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H144A8,8,0,0,1,136,104Z"/></svg>`,
  "phone-outgoing": `<svg viewBox="0 0 256 256"><path d="M146.34,109.66a8,8,0,0,1,0-11.32L180.69,64H160a8,8,0,0,1,0-16h40a8,8,0,0,1,8,8V96a8,8,0,0,1-16,0V75.31l-34.34,34.35a8,8,0,0,1-11.32,0Zm77.54,73.42A56.26,56.26,0,0,1,168,232C88.6,232,24,167.4,24,88A56.26,56.26,0,0,1,72.92,32.12a16,16,0,0,1,16.62,9.51l21.12,47.16,0,.12A16,16,0,0,1,109.39,104c-.18.27-.37.52-.57.77L88,129.45c7.49,15.22,23.41,31,38.83,38.51l24.34-20.71a8.12,8.12,0,0,1,.75-.56,15.93,15.93,0,0,1,15.17-1.4l.13.06,47.11,21.11A16,16,0,0,1,223.88,183.08Zm-15.88-2s-.07,0-.11,0h0l-47-21.06-24.35,20.72a8.44,8.44,0,0,1-.74.56,16,16,0,0,1-15.75,1.14c-18.73-9.05-37.4-27.58-46.46-46.11a16,16,0,0,1,1-15.7,6.13,6.13,0,0,1,.57-.77L96,95.15l-21-47a.61.61,0,0,1,0-.12A40.2,40.2,0,0,0,40,88,128.14,128.14,0,0,0,168,216,40.21,40.21,0,0,0,208,181.07Z"/></svg>`,
  "phone-plus": `<svg viewBox="0 0 256 256"><path d="M214.36,166.46l-47.1-21.11-.12-.06a16,16,0,0,0-15.18,1.4,8.12,8.12,0,0,0-.75.56L126.87,168c-15.42-7.49-31.34-23.29-38.83-38.51l20.78-24.71c.2-.25.39-.5.57-.77a16,16,0,0,0,1.32-15.06.61.61,0,0,1,0-.12L89.54,41.64a16,16,0,0,0-16.62-9.52A56.26,56.26,0,0,0,24,88c0,79.4,64.6,144,144,144a56.26,56.26,0,0,0,55.88-48.92A16,16,0,0,0,214.36,166.46ZM168,216A128.14,128.14,0,0,1,40,88,40.2,40.2,0,0,1,74.87,48a.61.61,0,0,0,0,.12l21,47L75.2,119.86a6.13,6.13,0,0,0-.57.77,16,16,0,0,0-1,15.7c9.06,18.53,27.73,37.06,46.46,46.11a16,16,0,0,0,15.75-1.14,6.92,6.92,0,0,0,.74-.57L160.89,160l47,21.06h0s.08,0,.11,0A40.21,40.21,0,0,1,168,216ZM136,80a8,8,0,0,1,8-8h24V48a8,8,0,0,1,16,0V72h24a8,8,0,0,1,0,16H184v24a8,8,0,0,1-16,0V88H144A8,8,0,0,1,136,80Z"/></svg>`,
  "phone-slash": `<svg viewBox="0 0 256 256"><path d="M53.93,34.62A8,8,0,1,0,42.09,45.38L69.68,75.74a141.26,141.26,0,0,0-45.27,30.44c-20,20-21.92,49.46-4.69,71.67a16,16,0,0,0,18.38,5.07l49-17.37.29-.11a16,16,0,0,0,9.75-11.72l5.9-29.51a75.89,75.89,0,0,1,8.56-2.4l90.51,99.57a8,8,0,1,0,11.84-10.76Zm43.7,74.52a16,16,0,0,0-10.32,11.94l-5.9,29.5-48.78,17.3c-.1,0-.17.13-.27.17-12.33-15.9-11-36.22,3.36-50.56a125.79,125.79,0,0,1,45.47-29.1l18.3,20.14C98.87,108.73,98.25,108.92,97.63,109.14Zm138.65,68.71a16,16,0,0,1-18.38,5.07l-9.25-3.28A8,8,0,0,1,214,164.56l9.37,3.32.3.12c12.3-15.85,11-36.17-3.39-50.51-25.66-25.66-61.88-39.27-99.35-37.31a8,8,0,1,1-.83-16c42-2.19,82.63,13.1,111.49,42C251.58,126.17,253.51,155.64,236.28,177.85Z"/></svg>`,
  "phone-transfer": `<svg viewBox="0 0 256 256"><path d="M136,72a8,8,0,0,1,8-8h52.69L178.34,45.66a8,8,0,0,1,11.32-11.32l32,32a8,8,0,0,1,0,11.32l-32,32a8,8,0,0,1-11.32-11.32L196.69,80H144A8,8,0,0,1,136,72Zm87.87,111.08A56.24,56.24,0,0,1,168,232C88.6,232,24,167.4,24,88A56.24,56.24,0,0,1,72.92,32.13a16,16,0,0,1,16.62,9.51l21.12,47.15,0,.12A16,16,0,0,1,109.39,104c-.18.27-.37.52-.57.77L88,129.45c7.49,15.22,23.41,31,38.83,38.51l24.34-20.71a8.12,8.12,0,0,1,.75-.56,16,16,0,0,1,15.18-1.4l.11.06,47.11,21.11A16,16,0,0,1,223.87,183.08Zm-15.87-2s-.07,0-.11,0h0l-47-21.05-24.35,20.71a8,8,0,0,1-.74.56,16,16,0,0,1-15.75,1.14c-18.73-9-37.4-27.58-46.46-46.11a16,16,0,0,1,1-15.7,7,7,0,0,1,.57-.77L96,95.15l-21-47a.61.61,0,0,1,0-.12A40.2,40.2,0,0,0,40,88,128.14,128.14,0,0,0,168,216,40.21,40.21,0,0,0,208,181.07Z"/></svg>`,
  "phone-x": `<svg viewBox="0 0 256 256"><path d="M146.34,98.34,164.69,80,146.34,61.66a8,8,0,0,1,11.32-11.32L176,68.69l18.34-18.35a8,8,0,0,1,11.32,11.32L187.32,80l18.34,18.34a8,8,0,0,1-11.32,11.32L176,91.31l-18.34,18.35a8,8,0,0,1-11.32-11.32Zm77.54,84.74A56.26,56.26,0,0,1,168,232C88.6,232,24,167.4,24,88A56.26,56.26,0,0,1,72.92,32.12a16,16,0,0,1,16.62,9.52l21.12,47.15,0,.12A16,16,0,0,1,109.39,104c-.18.27-.37.52-.57.77L88,129.45c7.49,15.22,23.41,31,38.83,38.51l24.34-20.71a8.12,8.12,0,0,1,.75-.56,16,16,0,0,1,15.17-1.4l.13.06,47.11,21.11A16,16,0,0,1,223.88,183.08Zm-15.88-2s-.07,0-.11,0h0l-47-21.05-24.35,20.71a8.44,8.44,0,0,1-.74.56,16,16,0,0,1-15.75,1.14c-18.73-9.05-37.4-27.58-46.46-46.11a16,16,0,0,1,1-15.7,6.13,6.13,0,0,1,.57-.77L96,95.15l-21-47a.61.61,0,0,1,0-.12A40.2,40.2,0,0,0,40,88,128.14,128.14,0,0,0,168,216,40.21,40.21,0,0,0,208,181.07Z"/></svg>`,
  "phone": `<svg viewBox="0 0 256 256"><path d="M222.37,158.46l-47.11-21.11-.13-.06a16,16,0,0,0-15.17,1.4,8.12,8.12,0,0,0-.75.56L134.87,160c-15.42-7.49-31.34-23.29-38.83-38.51l20.78-24.71c.2-.25.39-.5.57-.77a16,16,0,0,0,1.32-15.06l0-.12L97.54,33.64a16,16,0,0,0-16.62-9.52A56.26,56.26,0,0,0,32,80c0,79.4,64.6,144,144,144a56.26,56.26,0,0,0,55.88-48.92A16,16,0,0,0,222.37,158.46ZM176,208A128.14,128.14,0,0,1,48,80,40.2,40.2,0,0,1,82.87,40a.61.61,0,0,0,0,.12l21,47L83.2,111.86a6.13,6.13,0,0,0-.57.77,16,16,0,0,0-1,15.7c9.06,18.53,27.73,37.06,46.46,46.11a16,16,0,0,0,15.75-1.14,8.44,8.44,0,0,0,.74-.56L168.89,152l47,21.05h0s.08,0,.11,0A40.21,40.21,0,0,1,176,208Z"/></svg>`,
  "plug-charging": `<svg viewBox="0 0 256 256"><path d="M224,56H176V16a8,8,0,0,0-16,0V56H96V16a8,8,0,0,0-16,0V56H32.55C26.28,56,24,60.78,24,64a8,8,0,0,0,8,8H48v88a40,40,0,0,0,40,40h32v40a8,8,0,0,0,16,0V200h32a40,40,0,0,0,40-40V72h16a8,8,0,0,0,0-16ZM168,184H88a24,24,0,0,1-24-24V72H192v88A24,24,0,0,1,168,184Zm-17.42-60.56a8,8,0,0,1,.91,7.37l-12,32a8,8,0,0,1-15-5.62l8-21.19H112a8,8,0,0,1-7.49-10.81l12-32a8,8,0,1,1,15,5.62l-8,21.19H144A8,8,0,0,1,150.58,123.44Z"/></svg>`,
  "plug": `<svg viewBox="0 0 256 256"><path d="M237.66,66.34a8,8,0,0,0-11.32,0L192,100.69,155.31,64l34.35-34.34a8,8,0,1,0-11.32-11.32L144,52.69,117.66,26.34a8,8,0,0,0-11.32,11.32L112.69,44l-53,53a40,40,0,0,0,0,56.57l15.71,15.71L26.34,218.34a8,8,0,0,0,11.32,11.32l49.09-49.09,15.71,15.71a40,40,0,0,0,56.57,0l53-53,6.34,6.35a8,8,0,0,0,11.32-11.32L203.31,112l34.35-34.34A8,8,0,0,0,237.66,66.34ZM147.72,185a24,24,0,0,1-33.95,0L71,142.23a24,24,0,0,1,0-33.95l53-53L200.69,132Z"/></svg>`,
  "plugs-connected": `<svg viewBox="0 0 256 256"><path d="M237.66,18.34a8,8,0,0,0-11.32,0l-52.4,52.41-5.37-5.38a32.05,32.05,0,0,0-45.26,0L100,88.69l-6.34-6.35A8,8,0,0,0,82.34,93.66L88.69,100,65.37,123.31a32,32,0,0,0,0,45.26l5.38,5.37-52.41,52.4a8,8,0,0,0,11.32,11.32l52.4-52.41,5.37,5.38a32,32,0,0,0,45.26,0L156,167.31l6.34,6.35a8,8,0,0,0,11.32-11.32L167.31,156l23.32-23.31a32,32,0,0,0,0-45.26l-5.38-5.37,52.41-52.4A8,8,0,0,0,237.66,18.34Zm-116.29,161a16,16,0,0,1-22.62,0L76.69,157.25a16,16,0,0,1,0-22.62L100,111.31,144.69,156Zm57.94-57.94L156,144.69,111.31,100l23.32-23.31a16,16,0,0,1,22.62,0l22.06,22A16,16,0,0,1,179.31,121.37ZM88.57,35A8,8,0,0,1,103.43,29l8,20A8,8,0,0,1,96.57,55ZM24.57,93A8,8,0,0,1,35,88.57l20,8A8,8,0,0,1,49,111.43l-20-8A8,8,0,0,1,24.57,93ZM231.43,163a8,8,0,0,1-10.4,4.46l-20-8A8,8,0,1,1,207,144.57l20,8A8,8,0,0,1,231.43,163Zm-64,58.06A8,8,0,0,1,152.57,227l-8-20A8,8,0,0,1,159.43,201Z"/></svg>`,
  "plugs": `<svg viewBox="0 0 256 256"><path d="M149.66,138.34a8,8,0,0,0-11.32,0L120,156.69,99.31,136l18.35-18.34a8,8,0,0,0-11.32-11.32L88,124.69,69.66,106.34a8,8,0,0,0-11.32,11.32L64.69,124,41.37,147.31a32,32,0,0,0,0,45.26l5.38,5.37-28.41,28.4a8,8,0,0,0,11.32,11.32l28.4-28.41,5.37,5.38a32,32,0,0,0,45.26,0L132,191.31l6.34,6.35a8,8,0,0,0,11.32-11.32L131.31,168l18.35-18.34A8,8,0,0,0,149.66,138.34Zm-52.29,65a16,16,0,0,1-22.62,0L52.69,181.25a16,16,0,0,1,0-22.62L76,135.31,120.69,180Zm140.29-185a8,8,0,0,0-11.32,0l-28.4,28.41-5.37-5.38a32.05,32.05,0,0,0-45.26,0L124,64.69l-6.34-6.35a8,8,0,0,0-11.32,11.32l80,80a8,8,0,0,0,11.32-11.32L191.31,132l23.32-23.31a32,32,0,0,0,0-45.26l-5.38-5.37,28.41-28.4A8,8,0,0,0,237.66,18.34Zm-34.35,79L180,120.69,135.31,76l23.32-23.31a16,16,0,0,1,22.62,0l22.06,22A16,16,0,0,1,203.31,97.37Z"/></svg>`,
  "plus-circle": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm48-88a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z"/></svg>`,
  "plus-minus": `<svg viewBox="0 0 256 256"><path d="M205.66,61.66l-144,144a8,8,0,0,1-11.32-11.32l144-144a8,8,0,0,1,11.32,11.32ZM64,112a8,8,0,0,0,16,0V80h32a8,8,0,0,0,0-16H80V32a8,8,0,0,0-16,0V64H32a8,8,0,0,0,0,16H64Zm160,64H144a8,8,0,0,0,0,16h80a8,8,0,0,0,0-16Z"/></svg>`,
  "plus-square": `<svg viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208Zm-32-80a8,8,0,0,1-8,8H136v32a8,8,0,0,1-16,0V136H88a8,8,0,0,1,0-16h32V88a8,8,0,0,1,16,0v32h32A8,8,0,0,1,176,128Z"/></svg>`,
  "plus": `<svg viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H136v80a8,8,0,0,1-16,0V136H40a8,8,0,0,1,0-16h80V40a8,8,0,0,1,16,0v80h80A8,8,0,0,1,224,128Z"/></svg>`,
  "presentation-chart": `<svg viewBox="0 0 256 256"><path d="M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.36L57.75,219a8,8,0,0,0,12.5,10l29.59-37h56.32l29.59,37a8,8,0,1,0,12.5-10l-21.61-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,136H40V56H216V176ZM104,120v24a8,8,0,0,1-16,0V120a8,8,0,0,1,16,0Zm32-16v40a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm32-16v56a8,8,0,0,1-16,0V88a8,8,0,0,1,16,0Z"/></svg>`,
  "presentation": `<svg viewBox="0 0 256 256"><path d="M216,40H136V24a8,8,0,0,0-16,0V40H40A16,16,0,0,0,24,56V176a16,16,0,0,0,16,16H79.36L57.75,219a8,8,0,0,0,12.5,10l29.59-37h56.32l29.59,37a8,8,0,1,0,12.5-10l-21.61-27H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,136H40V56H216V176Z"/></svg>`,
  "printer": `<svg viewBox="0 0 256 256"><path d="M214.67,72H200V40a8,8,0,0,0-8-8H64a8,8,0,0,0-8,8V72H41.33C27.36,72,16,82.77,16,96v80a8,8,0,0,0,8,8H56v32a8,8,0,0,0,8,8H192a8,8,0,0,0,8-8V184h32a8,8,0,0,0,8-8V96C240,82.77,228.64,72,214.67,72ZM72,48H184V72H72ZM184,208H72V160H184Zm40-40H200V152a8,8,0,0,0-8-8H64a8,8,0,0,0-8,8v16H32V96c0-4.41,4.19-8,9.33-8H214.67c5.14,0,9.33,3.59,9.33,8Zm-24-52a12,12,0,1,1-12-12A12,12,0,0,1,200,116Z"/></svg>`,
  "prohibit-inset": `<svg viewBox="0 0 256 256"><path d="M165.66,154.34a8,8,0,0,1-11.32,11.32l-64-64a8,8,0,0,1,11.32-11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"/></svg>`,
  "prohibit": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm88,104a87.56,87.56,0,0,1-20.41,56.28L71.72,60.4A88,88,0,0,1,216,128ZM40,128A87.56,87.56,0,0,1,60.41,71.72L184.28,195.6A88,88,0,0,1,40,128Z"/></svg>`,
  "projector-screen-chart": `<svg viewBox="0 0 256 256"><path d="M88,144V128a8,8,0,0,1,16,0v16a8,8,0,0,1-16,0Zm40,8a8,8,0,0,0,8-8V120a8,8,0,0,0-16,0v24A8,8,0,0,0,128,152Zm32,0a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,160,152Zm56-72v96h8a8,8,0,0,1,0,16H136v17.38a24,24,0,1,1-16,0V192H32a8,8,0,0,1,0-16h8V80A16,16,0,0,1,24,64V48A16,16,0,0,1,40,32H216a16,16,0,0,1,16,16V64A16,16,0,0,1,216,80ZM136,232a8,8,0,1,0-8,8A8,8,0,0,0,136,232ZM40,64H216V48H40ZM200,80H56v96H200Z"/></svg>`,
  "push-pin-simple-slash": `<svg viewBox="0 0 256 256"><path d="M83.25,40a8,8,0,0,1,8-8H192a8,8,0,0,1,0,16h-6.46l18.75,106.3a8,8,0,0,1-6.48,9.26,7.52,7.52,0,0,1-1.4.13,8,8,0,0,1-7.87-6.61L169.29,48h-78A8,8,0,0,1,83.25,40ZM213.38,221.92a8,8,0,0,1-11.3-.54L168.1,184H136v56a8,8,0,0,1-16,0V184H40a8,8,0,0,1,0-16h9.29L66.24,72,42.08,45.38A8,8,0,1,1,53.92,34.62l160,176A8,8,0,0,1,213.38,221.92ZM153.55,168,79.84,86.92,65.54,168Z"/></svg>`,
  "push-pin-simple": `<svg viewBox="0 0 256 256"><path d="M216,168h-9.29L185.54,48H192a8,8,0,0,0,0-16H64a8,8,0,0,0,0,16h6.46L49.29,168H40a8,8,0,0,0,0,16h80v56a8,8,0,0,0,16,0V184h80a8,8,0,0,0,0-16ZM86.71,48h82.58l21.17,120H65.54Z"/></svg>`,
  "push-pin-slash": `<svg viewBox="0 0 256 256"><path d="M53.92,34.62A8,8,0,1,0,42.08,45.38L67.37,73.2A69.82,69.82,0,0,0,38,87.63a16,16,0,0,0-1.29,23.78L85,159.71,42.34,202.34a8,8,0,0,0,11.32,11.32L96.29,171l48.29,48.29A16,16,0,0,0,155.9,224c.38,0,.75,0,1.13,0a15.93,15.93,0,0,0,11.64-6.33,89.75,89.75,0,0,0,11.58-20.27l21.84,24a8,8,0,1,0,11.84-10.76ZM155.9,208,48,100.08C58.23,91.83,69.2,87.72,80.66,87.81l87.16,95.88C165.59,193.56,160.24,202.23,155.9,208Zm79.42-104-44.64,44.79a8,8,0,1,1-11.33-11.3L224,92.7,163.32,32,122.1,73.35a8,8,0,0,1-11.33-11.29L152,20.7a16,16,0,0,1,22.63,0l60.69,60.68A16,16,0,0,1,235.32,104Z"/></svg>`,
  "push-pin": `<svg viewBox="0 0 256 256"><path d="M235.32,81.37,174.63,20.69a16,16,0,0,0-22.63,0L98.37,74.49c-10.66-3.34-35-7.37-60.4,13.14a16,16,0,0,0-1.29,23.78L85,159.71,42.34,202.34a8,8,0,0,0,11.32,11.32L96.29,171l48.29,48.29A16,16,0,0,0,155.9,224c.38,0,.75,0,1.13,0a15.93,15.93,0,0,0,11.64-6.33c19.64-26.1,17.75-47.32,13.19-60L235.33,104A16,16,0,0,0,235.32,81.37ZM224,92.69h0l-57.27,57.46a8,8,0,0,0-1.49,9.22c9.46,18.93-1.8,38.59-9.34,48.62L48,100.08c12.08-9.74,23.64-12.31,32.48-12.31A40.13,40.13,0,0,1,96.81,91a8,8,0,0,0,9.25-1.51L163.32,32,224,92.68Z"/></svg>`,
  "puzzle-piece": `<svg viewBox="0 0 256 256"><path d="M220.27,158.54a8,8,0,0,0-7.7-.46,20,20,0,1,1,0-36.16A8,8,0,0,0,224,114.69V72a16,16,0,0,0-16-16H171.78a35.36,35.36,0,0,0,.22-4,36.11,36.11,0,0,0-11.36-26.24,36,36,0,0,0-60.55,23.62,36.56,36.56,0,0,0,.14,6.62H64A16,16,0,0,0,48,72v32.22a35.36,35.36,0,0,0-4-.22,36.12,36.12,0,0,0-26.24,11.36,35.7,35.7,0,0,0-9.69,27,36.08,36.08,0,0,0,33.31,33.6,35.68,35.68,0,0,0,6.62-.14V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V165.31A8,8,0,0,0,220.27,158.54ZM208,208H64V165.31a8,8,0,0,0-11.43-7.23,20,20,0,1,1,0-36.16A8,8,0,0,0,64,114.69V72h46.69a8,8,0,0,0,7.23-11.43,20,20,0,1,1,36.16,0A8,8,0,0,0,161.31,72H208v32.23a35.68,35.68,0,0,0-6.62-.14A36,36,0,0,0,204,176a35.36,35.36,0,0,0,4-.22Z"/></svg>`,
  "question-mark": `<svg viewBox="0 0 256 256"><path d="M192,96c0,28.51-24.47,52.11-56,55.56V160a8,8,0,0,1-16,0V144a8,8,0,0,1,8-8c26.47,0,48-17.94,48-40s-21.53-40-48-40S80,73.94,80,96a8,8,0,0,1-16,0c0-30.88,28.71-56,64-56S192,65.12,192,96Zm-64,96a16,16,0,1,0,16,16A16,16,0,0,0,128,192Z"/></svg>`,
  "question": `<svg viewBox="0 0 256 256"><path d="M140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180ZM128,72c-22.06,0-40,16.15-40,36v4a8,8,0,0,0,16,0v-4c0-11,10.77-20,24-20s24,9,24,20-10.77,20-24,20a8,8,0,0,0-8,8v8a8,8,0,0,0,16,0v-.72c18.24-3.35,32-17.9,32-35.28C168,88.15,150.06,72,128,72Zm104,56A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"/></svg>`,
  "queue": `<svg viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm104,56H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm0,64H40a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Zm112-24a8,8,0,0,1-3.76,6.78l-64,40A8,8,0,0,1,168,200V120a8,8,0,0,1,12.24-6.78l64,40A8,8,0,0,1,248,160Zm-23.09,0L184,134.43v51.14Z"/></svg>`,
  "quotes": `<svg viewBox="0 0 256 256"><path d="M100,56H40A16,16,0,0,0,24,72v64a16,16,0,0,0,16,16h60v8a32,32,0,0,1-32,32,8,8,0,0,0,0,16,48.05,48.05,0,0,0,48-48V72A16,16,0,0,0,100,56Zm0,80H40V72h60ZM216,56H156a16,16,0,0,0-16,16v64a16,16,0,0,0,16,16h60v8a32,32,0,0,1-32,32,8,8,0,0,0,0,16,48.05,48.05,0,0,0,48-48V72A16,16,0,0,0,216,56Zm0,80H156V72h60Z"/></svg>`,
  "ranking": `<svg viewBox="0 0 256 256"><path d="M112.41,102.53a8,8,0,0,1,5.06-10.12l12-4A8,8,0,0,1,140,96v40a8,8,0,0,1-16,0V107.1l-1.47.49A8,8,0,0,1,112.41,102.53ZM248,208a8,8,0,0,1-8,8H16a8,8,0,0,1,0-16h8V104A16,16,0,0,1,40,88H80V56A16,16,0,0,1,96,40h64a16,16,0,0,1,16,16v72h40a16,16,0,0,1,16,16v56h8A8,8,0,0,1,248,208Zm-72-64v56h40V144ZM96,200h64V56H96Zm-56,0H80V104H40Z"/></svg>`,
  "read-cv-logo": `<svg viewBox="0 0 256 256"><path d="M210.78,39.25l-130.25-23A16,16,0,0,0,62,29.23l-29.75,169a16,16,0,0,0,13,18.53l130.25,23h0a16,16,0,0,0,18.54-13l29.75-169A16,16,0,0,0,210.78,39.25ZM178.26,224h0L48,201,77.75,32,208,55ZM89.34,58.42a8,8,0,0,1,9.27-6.48l83,14.65a8,8,0,0,1-1.39,15.88,8.36,8.36,0,0,1-1.4-.12l-83-14.66A8,8,0,0,1,89.34,58.42ZM83.8,89.94a8,8,0,0,1,9.27-6.49l83,14.66A8,8,0,0,1,174.67,114a7.55,7.55,0,0,1-1.41-.13l-83-14.65A8,8,0,0,1,83.8,89.94Zm-5.55,31.51A8,8,0,0,1,87.52,115L129,122.29a8,8,0,0,1-1.38,15.88,8.27,8.27,0,0,1-1.4-.12l-41.5-7.33A8,8,0,0,1,78.25,121.45Z"/></svg>`,
  "receipt-x": `<svg viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V208a8,8,0,0,0,11.58,7.15L64,200.94l28.42,14.21a8,8,0,0,0,7.16,0L128,200.94l28.42,14.21a8,8,0,0,0,7.16,0L192,200.94l28.42,14.21A8,8,0,0,0,232,208V56A16,16,0,0,0,216,40Zm0,155.06-20.42-10.22a8,8,0,0,0-7.16,0L160,199.06l-28.42-14.22a8,8,0,0,0-7.16,0L96,199.06,67.58,184.84a8,8,0,0,0-7.16,0L40,195.06V56H216ZM98.34,138.34,116.69,120,98.34,101.66a8,8,0,0,1,11.32-11.32L128,108.69l18.34-18.35a8,8,0,0,1,11.32,11.32L139.31,120l18.35,18.34a8,8,0,0,1-11.32,11.32L128,131.31l-18.34,18.35a8,8,0,0,1-11.32-11.32Z"/></svg>`,
  "receipt": `<svg viewBox="0 0 256 256"><path d="M72,104a8,8,0,0,1,8-8h96a8,8,0,0,1,0,16H80A8,8,0,0,1,72,104Zm8,40h96a8,8,0,0,0,0-16H80a8,8,0,0,0,0,16ZM232,56V208a8,8,0,0,1-11.58,7.15L192,200.94l-28.42,14.21a8,8,0,0,1-7.16,0L128,200.94,99.58,215.15a8,8,0,0,1-7.16,0L64,200.94,35.58,215.15A8,8,0,0,1,24,208V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56Zm-16,0H40V195.06l20.42-10.22a8,8,0,0,1,7.16,0L96,199.06l28.42-14.22a8,8,0,0,1,7.16,0L160,199.06l28.42-14.22a8,8,0,0,1,7.16,0L216,195.06Z"/></svg>`,
  "repeat-once": `<svg viewBox="0 0 256 256"><path d="M24,128A72.08,72.08,0,0,1,96,56H204.69L194.34,45.66a8,8,0,0,1,11.32-11.32l24,24a8,8,0,0,1,0,11.32l-24,24a8,8,0,0,1-11.32-11.32L204.69,72H96a56.06,56.06,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56.06,56.06,0,0,1-56,56H51.31l10.35-10.34a8,8,0,0,0-11.32-11.32l-24,24a8,8,0,0,0,0,11.32l24,24a8,8,0,0,0,11.32-11.32L51.31,200H160a72.08,72.08,0,0,0,72-72A8,8,0,0,0,224,120Zm-88,40a8,8,0,0,0,8-8V104a8,8,0,0,0-11.58-7.16l-16,8a8,8,0,1,0,7.16,14.31l4.42-2.21V152A8,8,0,0,0,136,160Z"/></svg>`,
  "repeat": `<svg viewBox="0 0 256 256"><path d="M24,128A72.08,72.08,0,0,1,96,56H204.69L194.34,45.66a8,8,0,0,1,11.32-11.32l24,24a8,8,0,0,1,0,11.32l-24,24a8,8,0,0,1-11.32-11.32L204.69,72H96a56.06,56.06,0,0,0-56,56,8,8,0,0,1-16,0Zm200-8a8,8,0,0,0-8,8,56.06,56.06,0,0,1-56,56H51.31l10.35-10.34a8,8,0,0,0-11.32-11.32l-24,24a8,8,0,0,0,0,11.32l24,24a8,8,0,0,0,11.32-11.32L51.31,200H160a72.08,72.08,0,0,0,72-72A8,8,0,0,0,224,120Z"/></svg>`,
  "resize": `<svg viewBox="0 0 256 256"><path d="M136,112H48a8,8,0,0,0-8,8v88a8,8,0,0,0,8,8h88a8,8,0,0,0,8-8V120A8,8,0,0,0,136,112Zm-8,88H56V128h72Zm88-16v16a16,16,0,0,1-16,16H176a8,8,0,0,1,0-16h24V184a8,8,0,0,1,16,0Zm0-72v32a8,8,0,0,1-16,0V112a8,8,0,0,1,16,0Zm0-56V72a8,8,0,0,1-16,0V56H184a8,8,0,0,1,0-16h16A16,16,0,0,1,216,56Zm-64-8a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,48ZM40,80V56A16,16,0,0,1,56,40H72a8,8,0,0,1,0,16H56V80a8,8,0,0,1-16,0Z"/></svg>`,
  "robot": `<svg viewBox="0 0 256 256"><path d="M200,48H136V16a8,8,0,0,0-16,0V48H56A32,32,0,0,0,24,80V192a32,32,0,0,0,32,32H200a32,32,0,0,0,32-32V80A32,32,0,0,0,200,48Zm16,144a16,16,0,0,1-16,16H56a16,16,0,0,1-16-16V80A16,16,0,0,1,56,64H200a16,16,0,0,1,16,16Zm-52-56H92a28,28,0,0,0,0,56h72a28,28,0,0,0,0-56Zm-24,16v24H116V152ZM80,164a12,12,0,0,1,12-12h8v24H92A12,12,0,0,1,80,164Zm84,12h-8V152h8a12,12,0,0,1,0,24ZM72,108a12,12,0,1,1,12,12A12,12,0,0,1,72,108Zm88,0a12,12,0,1,1,12,12A12,12,0,0,1,160,108Z"/></svg>`,
  "rows-plus-bottom": `<svg viewBox="0 0 256 256"><path d="M208,112H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V128A16,16,0,0,0,208,112Zm0,40H48V128H208v24Zm0-112H48A16,16,0,0,0,32,56V80A16,16,0,0,0,48,96H208a16,16,0,0,0,16-16V56A16,16,0,0,0,208,40Zm0,40H48V56H208V80ZM160,216a8,8,0,0,1-8,8H136v16a8,8,0,0,1-16,0V224H104a8,8,0,0,1,0-16h16V192a8,8,0,0,1,16,0v16h16A8,8,0,0,1,160,216Z"/></svg>`,
  "rows-plus-top": `<svg viewBox="0 0 256 256"><path d="M208,160H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V176A16,16,0,0,0,208,160Zm0,40H48V176H208v24Zm0-112H48a16,16,0,0,0-16,16v24a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V104A16,16,0,0,0,208,88Zm0,40H48V104H208v24ZM96,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H136V64a8,8,0,0,1-16,0V48H104A8,8,0,0,1,96,40Z"/></svg>`,
  "rows": `<svg viewBox="0 0 256 256"><path d="M208,136H48a16,16,0,0,0-16,16v40a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V152A16,16,0,0,0,208,136Zm0,56H48V152H208v40Zm0-144H48A16,16,0,0,0,32,64v40a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V64A16,16,0,0,0,208,48Zm0,56H48V64H208v40Z"/></svg>`,
  "scales": `<svg viewBox="0 0 256 256"><path d="M239.43,133l-32-80h0a8,8,0,0,0-9.16-4.84L136,62V40a8,8,0,0,0-16,0V65.58L54.26,80.19A8,8,0,0,0,48.57,85h0v.06L16.57,165a7.92,7.92,0,0,0-.57,3c0,23.31,24.54,32,40,32s40-8.69,40-32a7.92,7.92,0,0,0-.57-3L66.92,93.77,120,82V208H104a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16H136V78.42L187,67.1,160.57,133a7.92,7.92,0,0,0-.57,3c0,23.31,24.54,32,40,32s40-8.69,40-32A7.92,7.92,0,0,0,239.43,133ZM56,184c-7.53,0-22.76-3.61-23.93-14.64L56,109.54l23.93,59.82C78.76,180.39,63.53,184,56,184Zm144-32c-7.53,0-22.76-3.61-23.93-14.64L200,77.54l23.93,59.82C222.76,148.39,207.53,152,200,152Z"/></svg>`,
  "seal-check": `<svg viewBox="0 0 256 256"><path d="M225.86,102.82c-3.77-3.94-7.67-8-9.14-11.57-1.36-3.27-1.44-8.69-1.52-13.94-.15-9.76-.31-20.82-8-28.51s-18.75-7.85-28.51-8c-5.25-.08-10.67-.16-13.94-1.52-3.56-1.47-7.63-5.37-11.57-9.14C146.28,23.51,138.44,16,128,16s-18.27,7.51-25.18,14.14c-3.94,3.77-8,7.67-11.57,9.14C88,40.64,82.56,40.72,77.31,40.8c-9.76.15-20.82.31-28.51,8S41,67.55,40.8,77.31c-.08,5.25-.16,10.67-1.52,13.94-1.47,3.56-5.37,7.63-9.14,11.57C23.51,109.72,16,117.56,16,128s7.51,18.27,14.14,25.18c3.77,3.94,7.67,8,9.14,11.57,1.36,3.27,1.44,8.69,1.52,13.94.15,9.76.31,20.82,8,28.51s18.75,7.85,28.51,8c5.25.08,10.67.16,13.94,1.52,3.56,1.47,7.63,5.37,11.57,9.14C109.72,232.49,117.56,240,128,240s18.27-7.51,25.18-14.14c3.94-3.77,8-7.67,11.57-9.14,3.27-1.36,8.69-1.44,13.94-1.52,9.76-.15,20.82-.31,28.51-8s7.85-18.75,8-28.51c.08-5.25.16-10.67,1.52-13.94,1.47-3.56,5.37-7.63,9.14-11.57C232.49,146.28,240,138.44,240,128S232.49,109.73,225.86,102.82Zm-11.55,39.29c-4.79,5-9.75,10.17-12.38,16.52-2.52,6.1-2.63,13.07-2.73,19.82-.1,7-.21,14.33-3.32,17.43s-10.39,3.22-17.43,3.32c-6.75.1-13.72.21-19.82,2.73-6.35,2.63-11.52,7.59-16.52,12.38S132,224,128,224s-9.15-4.92-14.11-9.69-10.17-9.75-16.52-12.38c-6.1-2.52-13.07-2.63-19.82-2.73-7-.1-14.33-.21-17.43-3.32s-3.22-10.39-3.32-17.43c-.1-6.75-.21-13.72-2.73-19.82-2.63-6.35-7.59-11.52-12.38-16.52S32,132,32,128s4.92-9.15,9.69-14.11,9.75-10.17,12.38-16.52c2.52-6.1,2.63-13.07,2.73-19.82.1-7,.21-14.33,3.32-17.43S70.51,56.9,77.55,56.8c6.75-.1,13.72-.21,19.82-2.73,6.35-2.63,11.52-7.59,16.52-12.38S124,32,128,32s9.15,4.92,14.11,9.69,10.17,9.75,16.52,12.38c6.1,2.52,13.07,2.63,19.82,2.73,7,.1,14.33.21,17.43,3.32s3.22,10.39,3.32,17.43c.1,6.75.21,13.72,2.73,19.82,2.63,6.35,7.59,11.52,12.38,16.52S224,124,224,128,219.08,137.15,214.31,142.11ZM173.66,98.34a8,8,0,0,1,0,11.32l-56,56a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35A8,8,0,0,1,173.66,98.34Z"/></svg>`,
  "seal-question": `<svg viewBox="0 0 256 256"><path d="M225.86,102.82c-3.77-3.94-7.67-8-9.14-11.57-1.36-3.27-1.44-8.69-1.52-13.94-.15-9.76-.31-20.82-8-28.51s-18.75-7.85-28.51-8c-5.25-.08-10.67-.16-13.94-1.52-3.56-1.47-7.63-5.37-11.57-9.14C146.28,23.51,138.44,16,128,16s-18.27,7.51-25.18,14.14c-3.94,3.77-8,7.67-11.57,9.14C88,40.64,82.56,40.72,77.31,40.8c-9.76.15-20.82.31-28.51,8S41,67.55,40.8,77.31c-.08,5.25-.16,10.67-1.52,13.94-1.47,3.56-5.37,7.63-9.14,11.57C23.51,109.72,16,117.56,16,128s7.51,18.27,14.14,25.18c3.77,3.94,7.67,8,9.14,11.57,1.36,3.27,1.44,8.69,1.52,13.94.15,9.76.31,20.82,8,28.51s18.75,7.85,28.51,8c5.25.08,10.67.16,13.94,1.52,3.56,1.47,7.63,5.37,11.57,9.14C109.72,232.49,117.56,240,128,240s18.27-7.51,25.18-14.14c3.94-3.77,8-7.67,11.57-9.14,3.27-1.36,8.69-1.44,13.94-1.52,9.76-.15,20.82-.31,28.51-8s7.85-18.75,8-28.51c.08-5.25.16-10.67,1.52-13.94,1.47-3.56,5.37-7.63,9.14-11.57C232.49,146.28,240,138.44,240,128S232.49,109.73,225.86,102.82Zm-11.55,39.29c-4.79,5-9.75,10.17-12.38,16.52-2.52,6.1-2.63,13.07-2.73,19.82-.1,7-.21,14.33-3.32,17.43s-10.39,3.22-17.43,3.32c-6.75.1-13.72.21-19.82,2.73-6.35,2.63-11.52,7.59-16.52,12.38S132,224,128,224s-9.15-4.92-14.11-9.69-10.17-9.75-16.52-12.38c-6.1-2.52-13.07-2.63-19.82-2.73-7-.1-14.33-.21-17.43-3.32s-3.22-10.39-3.32-17.43c-.1-6.75-.21-13.72-2.73-19.82-2.63-6.35-7.59-11.52-12.38-16.52S32,132,32,128s4.92-9.15,9.69-14.11,9.75-10.17,12.38-16.52c2.52-6.1,2.63-13.07,2.73-19.82.1-7,.21-14.33,3.32-17.43S70.51,56.9,77.55,56.8c6.75-.1,13.72-.21,19.82-2.73,6.35-2.63,11.52-7.59,16.52-12.38S124,32,128,32s9.15,4.92,14.11,9.69,10.17,9.75,16.52,12.38c6.1,2.52,13.07,2.63,19.82,2.73,7,.1,14.33.21,17.43,3.32s3.22,10.39,3.32,17.43c.1,6.75.21,13.72,2.73,19.82,2.63,6.35,7.59,11.52,12.38,16.52S224,124,224,128,219.08,137.15,214.31,142.11ZM140,180a12,12,0,1,1-12-12A12,12,0,0,1,140,180Zm28-72c0,17.38-13.76,31.93-32,35.28V144a8,8,0,0,1-16,0v-8a8,8,0,0,1,8-8c13.23,0,24-9,24-20s-10.77-20-24-20-24,9-24,20v4a8,8,0,0,1-16,0v-4c0-19.85,17.94-36,40-36S168,88.15,168,108Z"/></svg>`,
  "seal-warning": `<svg viewBox="0 0 256 256"><path d="M225.86,102.82c-3.77-3.94-7.67-8-9.14-11.57-1.36-3.27-1.44-8.69-1.52-13.94-.15-9.76-.31-20.82-8-28.51s-18.75-7.85-28.51-8c-5.25-.08-10.67-.16-13.94-1.52-3.56-1.47-7.63-5.37-11.57-9.14C146.28,23.51,138.44,16,128,16s-18.27,7.51-25.18,14.14c-3.94,3.77-8,7.67-11.57,9.14C88,40.64,82.56,40.72,77.31,40.8c-9.76.15-20.82.31-28.51,8S41,67.55,40.8,77.31c-.08,5.25-.16,10.67-1.52,13.94-1.47,3.56-5.37,7.63-9.14,11.57C23.51,109.72,16,117.56,16,128s7.51,18.27,14.14,25.18c3.77,3.94,7.67,8,9.14,11.57,1.36,3.27,1.44,8.69,1.52,13.94.15,9.76.31,20.82,8,28.51s18.75,7.85,28.51,8c5.25.08,10.67.16,13.94,1.52,3.56,1.47,7.63,5.37,11.57,9.14C109.72,232.49,117.56,240,128,240s18.27-7.51,25.18-14.14c3.94-3.77,8-7.67,11.57-9.14,3.27-1.36,8.69-1.44,13.94-1.52,9.76-.15,20.82-.31,28.51-8s7.85-18.75,8-28.51c.08-5.25.16-10.67,1.52-13.94,1.47-3.56,5.37-7.63,9.14-11.57C232.49,146.28,240,138.44,240,128S232.49,109.73,225.86,102.82Zm-11.55,39.29c-4.79,5-9.75,10.17-12.38,16.52-2.52,6.1-2.63,13.07-2.73,19.82-.1,7-.21,14.33-3.32,17.43s-10.39,3.22-17.43,3.32c-6.75.1-13.72.21-19.82,2.73-6.35,2.63-11.52,7.59-16.52,12.38S132,224,128,224s-9.15-4.92-14.11-9.69-10.17-9.75-16.52-12.38c-6.1-2.52-13.07-2.63-19.82-2.73-7-.1-14.33-.21-17.43-3.32s-3.22-10.39-3.32-17.43c-.1-6.75-.21-13.72-2.73-19.82-2.63-6.35-7.59-11.52-12.38-16.52S32,132,32,128s4.92-9.15,9.69-14.11,9.75-10.17,12.38-16.52c2.52-6.1,2.63-13.07,2.73-19.82.1-7,.21-14.33,3.32-17.43S70.51,56.9,77.55,56.8c6.75-.1,13.72-.21,19.82-2.73,6.35-2.63,11.52-7.59,16.52-12.38S124,32,128,32s9.15,4.92,14.11,9.69,10.17,9.75,16.52,12.38c6.1,2.52,13.07,2.63,19.82,2.73,7,.1,14.33.21,17.43,3.32s3.22,10.39,3.32,17.43c.1,6.75.21,13.72,2.73,19.82,2.63,6.35,7.59,11.52,12.38,16.52S224,124,224,128,219.08,137.15,214.31,142.11ZM120,136V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z"/></svg>`,
  "seal": `<svg viewBox="0 0 256 256"><path d="M225.86,102.82c-3.77-3.94-7.67-8-9.14-11.57-1.36-3.27-1.44-8.69-1.52-13.94-.15-9.76-.31-20.82-8-28.51s-18.75-7.85-28.51-8c-5.25-.08-10.67-.16-13.94-1.52-3.57-1.47-7.63-5.37-11.57-9.14C146.27,23.51,138.44,16,128,16s-18.27,7.51-25.18,14.14c-3.94,3.77-8,7.67-11.57,9.14C88,40.64,82.56,40.72,77.31,40.8c-9.76.15-20.82.31-28.51,8S41,67.55,40.8,77.31c-.08,5.25-.16,10.67-1.52,13.94-1.47,3.57-5.37,7.63-9.14,11.57C23.51,109.72,16,117.56,16,128s7.51,18.27,14.14,25.18c3.77,3.94,7.67,8,9.14,11.57,1.36,3.27,1.44,8.69,1.52,13.94.15,9.76.31,20.82,8,28.51s18.75,7.85,28.51,8c5.25.08,10.67.16,13.94,1.52,3.56,1.47,7.63,5.37,11.57,9.14C109.73,232.49,117.56,240,128,240s18.27-7.51,25.18-14.14c3.94-3.77,8-7.67,11.57-9.14,3.27-1.36,8.69-1.44,13.94-1.52,9.76-.15,20.82-.31,28.51-8s7.85-18.75,8-28.51c.08-5.25.16-10.67,1.52-13.94,1.47-3.56,5.37-7.63,9.14-11.57C232.49,146.28,240,138.44,240,128S232.49,109.73,225.86,102.82Zm-11.55,39.29c-4.79,5-9.75,10.17-12.38,16.52-2.52,6.1-2.63,13.07-2.73,19.82-.1,7-.21,14.33-3.32,17.43s-10.39,3.22-17.43,3.32c-6.75.1-13.72.21-19.82,2.73-6.35,2.63-11.52,7.59-16.52,12.38S132,224,128,224s-9.14-4.92-14.11-9.69-10.17-9.75-16.52-12.38c-6.1-2.52-13.07-2.63-19.82-2.73-7-.1-14.33-.21-17.43-3.32s-3.22-10.39-3.32-17.43c-.1-6.75-.21-13.72-2.73-19.82-2.63-6.35-7.59-11.52-12.38-16.52S32,132,32,128s4.92-9.14,9.69-14.11,9.75-10.17,12.38-16.52c2.52-6.1,2.63-13.07,2.73-19.82.1-7,.21-14.33,3.32-17.43S70.51,56.9,77.55,56.8c6.75-.1,13.72-.21,19.82-2.73,6.35-2.63,11.52-7.59,16.52-12.38S124,32,128,32s9.14,4.92,14.11,9.69,10.17,9.75,16.52,12.38c6.1,2.52,13.07,2.63,19.82,2.73,7,.1,14.33.21,17.43,3.32s3.22,10.39,3.32,17.43c.1,6.75.21,13.72,2.73,19.82,2.63,6.35,7.59,11.52,12.38,16.52S224,124,224,128,219.08,137.14,214.31,142.11Z"/></svg>`,
  "selection-all": `<svg viewBox="0 0 256 256"><path d="M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM40,80a8,8,0,0,0,8-8V48H72a8,8,0,0,0,0-16H48A16,16,0,0,0,32,48V72A8,8,0,0,0,40,80ZM176,184H80a8,8,0,0,1-8-8V80a8,8,0,0,1,8-8h96a8,8,0,0,1,8,8v96A8,8,0,0,1,176,184Zm-8-96H88v80h80Z"/></svg>`,
  "selection-plus": `<svg viewBox="0 0 256 256"><path d="M152,40a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,40Zm-8,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,48V72a8,8,0,0,0,16,0V48a16,16,0,0,0-16-16H184a8,8,0,0,0,0,16Zm8,56a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM72,32H48A16,16,0,0,0,32,48V72a8,8,0,0,0,16,0V48H72a8,8,0,0,0,0-16ZM240,208H224V192a8,8,0,0,0-16,0v16H192a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V224h16a8,8,0,0,0,0-16Z"/></svg>`,
  "selection-slash": `<svg viewBox="0 0 256 256"><path d="M104,40a8,8,0,0,1,8-8h32a8,8,0,0,1,0,16H112A8,8,0,0,1,104,40Zm40,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM53.92,34.62A8,8,0,1,0,42.08,45.38l160,176a8,8,0,1,0,11.84-10.76Z"/></svg>`,
  "selection": `<svg viewBox="0 0 256 256"><path d="M152,40a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16h32A8,8,0,0,1,152,40Zm-8,168H112a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16ZM208,32H184a8,8,0,0,0,0,16h24V72a8,8,0,0,0,16,0V48A16,16,0,0,0,208,32Zm8,72a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V112A8,8,0,0,0,216,104Zm0,72a8,8,0,0,0-8,8v24H184a8,8,0,0,0,0,16h24a16,16,0,0,0,16-16V184A8,8,0,0,0,216,176ZM40,152a8,8,0,0,0,8-8V112a8,8,0,0,0-16,0v32A8,8,0,0,0,40,152Zm32,56H48V184a8,8,0,0,0-16,0v24a16,16,0,0,0,16,16H72a8,8,0,0,0,0-16ZM72,32H48A16,16,0,0,0,32,48V72a8,8,0,0,0,16,0V48H72a8,8,0,0,0,0-16Z"/></svg>`,
  "share-network": `<svg viewBox="0 0 256 256"><path d="M176,160a39.89,39.89,0,0,0-28.62,12.09l-46.1-29.63a39.8,39.8,0,0,0,0-28.92l46.1-29.63a40,40,0,1,0-8.66-13.45l-46.1,29.63a40,40,0,1,0,0,55.82l46.1,29.63A40,40,0,1,0,176,160Zm0-128a24,24,0,1,1-24,24A24,24,0,0,1,176,32ZM64,152a24,24,0,1,1,24-24A24,24,0,0,1,64,152Zm112,72a24,24,0,1,1,24-24A24,24,0,0,1,176,224Z"/></svg>`,
  "share": `<svg viewBox="0 0 256 256"><path d="M229.66,109.66l-48,48a8,8,0,0,1-11.32-11.32L204.69,112H165a88,88,0,0,0-85.23,66,8,8,0,0,1-15.5-4A103.94,103.94,0,0,1,165,96h39.71L170.34,61.66a8,8,0,0,1,11.32-11.32l48,48A8,8,0,0,1,229.66,109.66ZM192,208H40V88a8,8,0,0,0-16,0V216a8,8,0,0,0,8,8H192a8,8,0,0,0,0-16Z"/></svg>`,
  "shield-check": `<svg viewBox="0 0 256 256"><path d="M208,40H48A16,16,0,0,0,32,56v56c0,52.72,25.52,84.67,46.93,102.19,23.06,18.86,46,25.26,47,25.53a8,8,0,0,0,4.2,0c1-.27,23.91-6.67,47-25.53C198.48,196.67,224,164.72,224,112V56A16,16,0,0,0,208,40Zm0,72c0,37.07-13.66,67.16-40.6,89.42A129.3,129.3,0,0,1,128,223.62a128.25,128.25,0,0,1-38.92-21.81C61.82,179.51,48,149.3,48,112l0-56,160,0ZM82.34,141.66a8,8,0,0,1,11.32-11.32L112,148.69l50.34-50.35a8,8,0,0,1,11.32,11.32l-56,56a8,8,0,0,1-11.32,0Z"/></svg>`,
  "shield-plus": `<svg viewBox="0 0 256 256"><path d="M88,128a8,8,0,0,1,8-8h24V96a8,8,0,0,1,16,0v24h24a8,8,0,0,1,0,16H136v24a8,8,0,0,1-16,0V136H96A8,8,0,0,1,88,128ZM224,56v56c0,52.72-25.52,84.67-46.93,102.19-23.06,18.86-46,25.27-47,25.53a8,8,0,0,1-4.2,0c-1-.26-23.91-6.67-47-25.53C57.52,196.67,32,164.72,32,112V56A16,16,0,0,1,48,40H208A16,16,0,0,1,224,56Zm-16,0L48,56l0,56c0,37.3,13.82,67.51,41.07,89.81A128.25,128.25,0,0,0,128,223.62a129.3,129.3,0,0,0,39.41-22.2C194.34,179.16,208,149.07,208,112Z"/></svg>`,
  "shield-slash": `<svg viewBox="0 0 256 256"><path d="M53.92,34.62A8,8,0,0,0,40.26,42,16,16,0,0,0,32,56v56c0,52.72,25.52,84.67,46.93,102.19,23.06,18.86,46,25.27,47,25.53a8,8,0,0,0,4.2,0c1.36-.37,31.27-8.78,57.09-34.72l14.89,16.38a8,8,0,1,0,11.84-10.76Zm74.07,189a128.48,128.48,0,0,1-38.92-21.81C61.82,179.51,48,149.3,48,112l0-56h3.71L176.41,193.15A129.26,129.26,0,0,1,128,223.62ZM224,56v56c0,20.58-3.89,39.61-11.56,56.59A8,8,0,1,1,197.86,162c6.73-14.89,10.14-31.71,10.14-50V56L98.52,56a8,8,0,1,1,0-16H208A16,16,0,0,1,224,56Z"/></svg>`,
  "shield-warning": `<svg viewBox="0 0 256 256"><path d="M120,136V96a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm8,48a12,12,0,1,0-12-12A12,12,0,0,0,128,184ZM224,56v56c0,52.72-25.52,84.67-46.93,102.19-23.06,18.86-46,25.27-47,25.53a8,8,0,0,1-4.2,0c-1-.26-23.91-6.67-47-25.53C57.52,196.67,32,164.72,32,112V56A16,16,0,0,1,48,40H208A16,16,0,0,1,224,56Zm-16,0L48,56l0,56c0,37.3,13.82,67.51,41.07,89.81A128.25,128.25,0,0,0,128,223.62a129.3,129.3,0,0,0,39.41-22.2C194.34,179.16,208,149.07,208,112Z"/></svg>`,
  "shield": `<svg viewBox="0 0 256 256"><path d="M208,40H48A16,16,0,0,0,32,56v56c0,52.72,25.52,84.67,46.93,102.19,23.06,18.86,46,25.27,47,25.53a8,8,0,0,0,4.2,0c1-.26,23.91-6.67,47-25.53C198.48,196.67,224,164.72,224,112V56A16,16,0,0,0,208,40Zm0,72c0,37.07-13.66,67.16-40.6,89.42A129.3,129.3,0,0,1,128,223.62a128.25,128.25,0,0,1-38.92-21.81C61.82,179.51,48,149.3,48,112l0-56,160,0Z"/></svg>`,
  "sign-in": `<svg viewBox="0 0 256 256"><path d="M141.66,133.66l-40,40a8,8,0,0,1-11.32-11.32L116.69,136H24a8,8,0,0,1,0-16h92.69L90.34,93.66a8,8,0,0,1,11.32-11.32l40,40A8,8,0,0,1,141.66,133.66ZM200,32H136a8,8,0,0,0,0,16h56V208H136a8,8,0,0,0,0,16h64a8,8,0,0,0,8-8V40A8,8,0,0,0,200,32Z"/></svg>`,
  "sign-out": `<svg viewBox="0 0 256 256"><path d="M120,216a8,8,0,0,1-8,8H48a8,8,0,0,1-8-8V40a8,8,0,0,1,8-8h64a8,8,0,0,1,0,16H56V208h56A8,8,0,0,1,120,216Zm109.66-93.66-40-40a8,8,0,0,0-11.32,11.32L204.69,120H112a8,8,0,0,0,0,16h92.69l-26.35,26.34a8,8,0,0,0,11.32,11.32l40-40A8,8,0,0,0,229.66,122.34Z"/></svg>`,
  "signature": `<svg viewBox="0 0 256 256"><path d="M232,168H63.86c2.66-5.24,5.33-10.63,8-16.11,15,1.65,32.58-8.78,52.66-31.14,5,13.46,14.45,30.93,30.58,31.25,9.06.18,18.11-5.2,27.42-16.37C189.31,143.75,203.3,152,232,152a8,8,0,0,0,0-16c-30.43,0-39.43-10.45-40-16.11a7.67,7.67,0,0,0-5.46-7.75,8.14,8.14,0,0,0-9.25,3.49c-12.07,18.54-19.38,20.43-21.92,20.37-8.26-.16-16.66-19.52-19.54-33.42a8,8,0,0,0-14.09-3.37C101.54,124.55,88,133.08,79.57,135.29,88.06,116.42,94.4,99.85,98.46,85.9c6.82-23.44,7.32-39.83,1.51-50.1-3-5.38-9.34-11.8-22.06-11.8C61.85,24,49.18,39.18,43.14,65.65c-3.59,15.71-4.18,33.21-1.62,48s7.87,25.55,15.59,31.94c-3.73,7.72-7.53,15.26-11.23,22.41H24a8,8,0,0,0,0,16H37.41c-11.32,21-20.12,35.64-20.26,35.88a8,8,0,1,0,13.71,8.24c.15-.26,11.27-18.79,24.7-44.12H232a8,8,0,0,0,0-16ZM58.74,69.21C62.72,51.74,70.43,40,77.91,40c5.33,0,7.1,1.86,8.13,3.67,3,5.33,6.52,24.19-21.66,86.39C56.12,118.78,53.31,93,58.74,69.21Z"/></svg>`,
  "slack-logo": `<svg viewBox="0 0 256 256"><path d="M221.13,128A32,32,0,0,0,184,76.31V56a32,32,0,0,0-56-21.13A32,32,0,0,0,76.31,72H56a32,32,0,0,0-21.13,56A32,32,0,0,0,72,179.69V200a32,32,0,0,0,56,21.13A32,32,0,0,0,179.69,184H200a32,32,0,0,0,21.13-56ZM72,152a16,16,0,1,1-16-16H72Zm48,48a16,16,0,0,1-32,0V152a16,16,0,0,1,16-16h16Zm0-80H56a16,16,0,0,1,0-32h48a16,16,0,0,1,16,16Zm0-48H104a16,16,0,1,1,16-16Zm16-16a16,16,0,0,1,32,0v48a16,16,0,0,1-16,16H136Zm16,160a16,16,0,0,1-16-16V184h16a16,16,0,0,1,0,32Zm48-48H152a16,16,0,0,1-16-16V136h64a16,16,0,0,1,0,32Zm0-48H184V104a16,16,0,1,1,16,16Z"/></svg>`,
  "sliders-horizontal": `<svg viewBox="0 0 256 256"><path d="M40,88H73a32,32,0,0,0,62,0h81a8,8,0,0,0,0-16H135a32,32,0,0,0-62,0H40a8,8,0,0,0,0,16Zm64-24A16,16,0,1,1,88,80,16,16,0,0,1,104,64ZM216,168H199a32,32,0,0,0-62,0H40a8,8,0,0,0,0,16h97a32,32,0,0,0,62,0h17a8,8,0,0,0,0-16Zm-48,24a16,16,0,1,1,16-16A16,16,0,0,1,168,192Z"/></svg>`,
  "sliders": `<svg viewBox="0 0 256 256"><path d="M64,105V40a8,8,0,0,0-16,0v65a32,32,0,0,0,0,62v49a8,8,0,0,0,16,0V167a32,32,0,0,0,0-62Zm-8,47a16,16,0,1,1,16-16A16,16,0,0,1,56,152Zm80-95V40a8,8,0,0,0-16,0V57a32,32,0,0,0,0,62v97a8,8,0,0,0,16,0V119a32,32,0,0,0,0-62Zm-8,47a16,16,0,1,1,16-16A16,16,0,0,1,128,104Zm104,64a32.06,32.06,0,0,0-24-31V40a8,8,0,0,0-16,0v97a32,32,0,0,0,0,62v17a8,8,0,0,0,16,0V199A32.06,32.06,0,0,0,232,168Zm-32,16a16,16,0,1,1,16-16A16,16,0,0,1,200,184Z"/></svg>`,
  "sort-ascending": `<svg viewBox="0 0 256 256"><path d="M128,128a8,8,0,0,1-8,8H48a8,8,0,0,1,0-16h72A8,8,0,0,1,128,128ZM48,72H184a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16Zm56,112H48a8,8,0,0,0,0,16h56a8,8,0,0,0,0-16Zm125.66-21.66a8,8,0,0,0-11.32,0L192,188.69V112a8,8,0,0,0-16,0v76.69l-26.34-26.35a8,8,0,0,0-11.32,11.32l40,40a8,8,0,0,0,11.32,0l40-40A8,8,0,0,0,229.66,162.34Z"/></svg>`,
  "sort-descending": `<svg viewBox="0 0 256 256"><path d="M40,128a8,8,0,0,1,8-8h72a8,8,0,0,1,0,16H48A8,8,0,0,1,40,128Zm8-56h56a8,8,0,0,0,0-16H48a8,8,0,0,0,0,16ZM184,184H48a8,8,0,0,0,0,16H184a8,8,0,0,0,0-16ZM229.66,82.34l-40-40a8,8,0,0,0-11.32,0l-40,40a8,8,0,0,0,11.32,11.32L176,67.31V144a8,8,0,0,0,16,0V67.31l26.34,26.35a8,8,0,0,0,11.32-11.32Z"/></svg>`,
  "sparkle": `<svg viewBox="0 0 256 256"><path d="M197.58,129.06,146,110l-19-51.62a15.92,15.92,0,0,0-29.88,0L78,110l-51.62,19a15.92,15.92,0,0,0,0,29.88L78,178l19,51.62a15.92,15.92,0,0,0,29.88,0L146,178l51.62-19a15.92,15.92,0,0,0,0-29.88ZM137,164.22a8,8,0,0,0-4.74,4.74L112,223.85,91.78,169A8,8,0,0,0,87,164.22L32.15,144,87,123.78A8,8,0,0,0,91.78,119L112,64.15,132.22,119a8,8,0,0,0,4.74,4.74L191.85,144ZM144,40a8,8,0,0,1,8-8h16V16a8,8,0,0,1,16,0V32h16a8,8,0,0,1,0,16H184V64a8,8,0,0,1-16,0V48H152A8,8,0,0,1,144,40ZM248,88a8,8,0,0,1-8,8h-8v8a8,8,0,0,1-16,0V96h-8a8,8,0,0,1,0-16h8V72a8,8,0,0,1,16,0v8h8A8,8,0,0,1,248,88Z"/></svg>`,
  "spinner-gap": `<svg viewBox="0 0 256 256"><path d="M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm88,88H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.09,47.6a8,8,0,0,0-11.31,11.31l22.62,22.63a8,8,0,0,0,11.32-11.32ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.09,167.6,54.46,190.22a8,8,0,0,0,11.32,11.32L88.4,178.91A8,8,0,0,0,77.09,167.6ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.78,54.46A8,8,0,0,0,54.46,65.78L77.09,88.4A8,8,0,0,0,88.4,77.09Z"/></svg>`,
  "spinner": `<svg viewBox="0 0 256 256"><path d="M136,32V64a8,8,0,0,1-16,0V32a8,8,0,0,1,16,0Zm37.25,58.75a8,8,0,0,0,5.66-2.35l22.63-22.62a8,8,0,0,0-11.32-11.32L167.6,77.09a8,8,0,0,0,5.65,13.66ZM224,120H192a8,8,0,0,0,0,16h32a8,8,0,0,0,0-16Zm-45.09,47.6a8,8,0,0,0-11.31,11.31l22.62,22.63a8,8,0,0,0,11.32-11.32ZM128,184a8,8,0,0,0-8,8v32a8,8,0,0,0,16,0V192A8,8,0,0,0,128,184ZM77.09,167.6,54.46,190.22a8,8,0,0,0,11.32,11.32L88.4,178.91A8,8,0,0,0,77.09,167.6ZM72,128a8,8,0,0,0-8-8H32a8,8,0,0,0,0,16H64A8,8,0,0,0,72,128ZM65.78,54.46A8,8,0,0,0,54.46,65.78L77.09,88.4A8,8,0,0,0,88.4,77.09Z"/></svg>`,
  "stack-minus": `<svg viewBox="0 0 256 256"><path d="M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM232,192H184a8,8,0,0,0,0,16h48a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"/></svg>`,
  "stack-plus": `<svg viewBox="0 0 256 256"><path d="M230.91,124A8,8,0,0,1,228,134.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,121.09l92,53.65,92-53.65A8,8,0,0,1,230.91,124ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26ZM232,192H216V176a8,8,0,0,0-16,0v16H184a8,8,0,0,0,0,16h16v16a8,8,0,0,0,16,0V208h16a8,8,0,0,0,0-16Zm-92,23.76-12,7L36,169.09A8,8,0,0,0,28,182.91l96,56a8,8,0,0,0,8.06,0l16-9.33A8,8,0,1,0,140,215.76Z"/></svg>`,
  "stack-simple": `<svg viewBox="0 0 256 256"><path d="M12,111l112,64a8,8,0,0,0,7.94,0l112-64a8,8,0,0,0,0-13.9l-112-64a8,8,0,0,0-7.94,0l-112,64A8,8,0,0,0,12,111ZM128,49.21,223.87,104,128,158.79,32.13,104ZM246.94,140A8,8,0,0,1,244,151L132,215a8,8,0,0,1-7.94,0L12,151A8,8,0,0,1,20,137.05l108,61.74,108-61.74A8,8,0,0,1,246.94,140Z"/></svg>`,
  "stack": `<svg viewBox="0 0 256 256"><path d="M230.91,172A8,8,0,0,1,228,182.91l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,36,169.09l92,53.65,92-53.65A8,8,0,0,1,230.91,172ZM220,121.09l-92,53.65L36,121.09A8,8,0,0,0,28,134.91l96,56a8,8,0,0,0,8.06,0l96-56A8,8,0,1,0,220,121.09ZM24,80a8,8,0,0,1,4-6.91l96-56a8,8,0,0,1,8.06,0l96,56a8,8,0,0,1,0,13.82l-96,56a8,8,0,0,1-8.06,0l-96-56A8,8,0,0,1,24,80Zm23.88,0L128,126.74,208.12,80,128,33.26Z"/></svg>`,
  "stamp": `<svg viewBox="0 0 256 256"><path d="M224,224a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,224Zm0-80v40a16,16,0,0,1-16,16H48a16,16,0,0,1-16-16V144a16,16,0,0,1,16-16h56.43L88.72,54.71A32,32,0,0,1,120,16h16a32,32,0,0,1,31.29,38.71L151.57,128H208A16,16,0,0,1,224,144ZM120.79,128h14.42l16.43-76.65A16,16,0,0,0,136,32H120a16,16,0,0,0-15.65,19.35ZM208,184V144H48v40H208Z"/></svg>`,
  "star-four": `<svg viewBox="0 0 256 256"><path d="M229.5,113,166.06,89.94,143,26.5a16,16,0,0,0-30,0L89.94,89.94,26.5,113a16,16,0,0,0,0,30l63.44,23.07L113,229.5a16,16,0,0,0,30,0l23.07-63.44L229.5,143a16,16,0,0,0,0-30ZM157.08,152.3a8,8,0,0,0-4.78,4.78L128,223.9l-24.3-66.82a8,8,0,0,0-4.78-4.78L32.1,128l66.82-24.3a8,8,0,0,0,4.78-4.78L128,32.1l24.3,66.82a8,8,0,0,0,4.78,4.78L223.9,128Z"/></svg>`,
  "star-half": `<svg viewBox="0 0 256 256"><path d="M234.29,114.85l-5.06,4.37a8,8,0,0,1-10.45-12.12l5.06-4.37c.12-.1.23-.19.13-.5s-.18-.27-.34-.29l-8.27-.67a8,8,0,1,1,1.29-15.94l8.27.66a16.46,16.46,0,0,1,9.37,28.86Zm-61.71,37.79,4.08,17.22a8,8,0,0,0,7.78,6.16,7.86,7.86,0,0,0,1.85-.22,8,8,0,0,0,5.94-9.63l-3-12.49,8-6.86a8,8,0,0,0-10.45-12.12l-11.64,10A8,8,0,0,0,172.58,152.64Zm29.13,53.53a8,8,0,0,0-15.57,3.69l1.32,5.58a.37.37,0,0,1-.17.48c-.18.14-.23.11-.38,0l-6.72-4.13a8,8,0,0,0-8.38,13.63l6.72,4.13A16.4,16.4,0,0,0,203,211.75ZM175.36,98.05l-15.64-1.27A8,8,0,0,1,153,91.86L136,50.78V184.63l7.43,4.57a8,8,0,1,1-8.38,13.63L128,198.49,77.47,229.57A16.4,16.4,0,0,1,53,211.75l13.76-58.07-45-38.83A16.46,16.46,0,0,1,31.08,86l59-4.76,22.76-55.08a16.36,16.36,0,0,1,30.27,0l22.75,55.08,10.76.87a8,8,0,1,1-1.29,16ZM120,184.63V50.78L103,91.86a8,8,0,0,1-6.75,4.92l-63.92,5.16c-.15,0-.24,0-.33.29a.39.39,0,0,0,.13.51l48.7,42a8,8,0,0,1,2.56,7.91l-14.88,62.8a.37.37,0,0,0,.17.48c.18.14.23.11.38,0Z"/></svg>`,
  "star": `<svg viewBox="0 0 256 256"><path d="M239.18,97.26A16.38,16.38,0,0,0,224.92,86l-59-4.76L143.14,26.15a16.36,16.36,0,0,0-30.27,0L90.11,81.23,31.08,86a16.46,16.46,0,0,0-9.37,28.86l45,38.83L53,211.75a16.38,16.38,0,0,0,24.5,17.82L128,198.49l50.53,31.08A16.4,16.4,0,0,0,203,211.75l-13.76-58.07,45-38.83A16.43,16.43,0,0,0,239.18,97.26Zm-15.34,5.47-48.7,42a8,8,0,0,0-2.56,7.91l14.88,62.8a.37.37,0,0,1-.17.48c-.18.14-.23.11-.38,0l-54.72-33.65a8,8,0,0,0-8.38,0L69.09,215.94c-.15.09-.19.12-.38,0a.37.37,0,0,1-.17-.48l14.88-62.8a8,8,0,0,0-2.56-7.91l-48.7-42c-.12-.1-.23-.19-.13-.5s.18-.27.33-.29l63.92-5.16A8,8,0,0,0,103,91.86l24.62-59.61c.08-.17.11-.25.35-.25s.27.08.35.25L153,91.86a8,8,0,0,0,6.75,4.92l63.92,5.16c.15,0,.24,0,.33.29S224,102.63,223.84,102.73Z"/></svg>`,
  "strategy": `<svg viewBox="0 0 256 256"><path d="M76,152a36,36,0,1,0,36,36A36,36,0,0,0,76,152Zm0,56a20,20,0,1,1,20-20A20,20,0,0,1,76,208ZM42.34,106.34,56.69,92,42.34,77.66A8,8,0,0,1,53.66,66.34L68,80.69,82.34,66.34A8,8,0,0,1,93.66,77.66L79.31,92l14.35,14.34a8,8,0,0,1-11.32,11.32L68,103.31,53.66,117.66a8,8,0,0,1-11.32-11.32Zm187.32,96a8,8,0,0,1-11.32,11.32L204,199.31l-14.34,14.35a8,8,0,0,1-11.32-11.32L192.69,188l-14.35-14.34a8,8,0,0,1,11.32-11.32L204,176.69l14.34-14.35a8,8,0,0,1,11.32,11.32L215.31,188Zm-45.19-89.51c-6.18,22.33-25.32,41.63-46.53,46.93A8.13,8.13,0,0,1,136,160a8,8,0,0,1-1.93-15.76c15.63-3.91,30.35-18.91,35-35.68,3.19-11.5,3.22-29-14.71-46.9L152,59.31V80a8,8,0,0,1-16,0V40a8,8,0,0,1,8-8h40a8,8,0,0,1,0,16H163.31l2.35,2.34C183.9,68.59,190.58,90.78,184.47,112.83Z"/></svg>`,
  "student": `<svg viewBox="0 0 256 256"><path d="M226.53,56.41l-96-32a8,8,0,0,0-5.06,0l-96,32A8,8,0,0,0,24,64v80a8,8,0,0,0,16,0V75.1L73.59,86.29a64,64,0,0,0,20.65,88.05c-18,7.06-33.56,19.83-44.94,37.29a8,8,0,1,0,13.4,8.74C77.77,197.25,101.57,184,128,184s50.23,13.25,65.3,36.37a8,8,0,0,0,13.4-8.74c-11.38-17.46-27-30.23-44.94-37.29a64,64,0,0,0,20.65-88l44.12-14.7a8,8,0,0,0,0-15.18ZM176,120A48,48,0,1,1,89.35,91.55l36.12,12a8,8,0,0,0,5.06,0l36.12-12A47.89,47.89,0,0,1,176,120ZM128,87.57,57.3,64,128,40.43,198.7,64Z"/></svg>`,
  "swap": `<svg viewBox="0 0 256 256"><path d="M224,48V152a16,16,0,0,1-16,16H99.31l10.35,10.34a8,8,0,0,1-11.32,11.32l-24-24a8,8,0,0,1,0-11.32l24-24a8,8,0,0,1,11.32,11.32L99.31,152H208V48H96v8a8,8,0,0,1-16,0V48A16,16,0,0,1,96,32H208A16,16,0,0,1,224,48ZM168,192a8,8,0,0,0-8,8v8H48V104H156.69l-10.35,10.34a8,8,0,0,0,11.32,11.32l24-24a8,8,0,0,0,0-11.32l-24-24a8,8,0,0,0-11.32,11.32L156.69,88H48a16,16,0,0,0-16,16V208a16,16,0,0,0,16,16H160a16,16,0,0,0,16-16v-8A8,8,0,0,0,168,192Z"/></svg>`,
  "table": `<svg viewBox="0 0 256 256"><path d="M224,48H32a8,8,0,0,0-8,8V192a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A8,8,0,0,0,224,48ZM40,112H80v32H40Zm56,0H216v32H96ZM216,64V96H40V64ZM40,160H80v32H40Zm176,32H96V160H216v32Z"/></svg>`,
  "tabs": `<svg viewBox="0 0 256 256"><path d="M255.66,165.7h0v0a.24.24,0,0,0,0-.08L233.37,91.4A15.89,15.89,0,0,0,218.05,80H208a8,8,0,0,0,0,16h10.05l19.2,64H206L185.37,91.4A15.89,15.89,0,0,0,170.05,80H160a8,8,0,0,0,0,16h10.05l19.2,64H158L137.37,91.4A15.89,15.89,0,0,0,122.05,80H38A15.89,15.89,0,0,0,22.63,91.4L.37,165.6l0,.05v0s0,.05,0,.08A8.1,8.1,0,0,0,0,168a8,8,0,0,0,8,8H248a8,8,0,0,0,7.66-10.3ZM38,96h84.1l19.2,64H18.75Z"/></svg>`,
  "tag-chevron": `<svg viewBox="0 0 256 256"><path d="M246.66,123.56,201,55.12A16,16,0,0,0,187.72,48H32a8,8,0,0,0-6.66,12.44L70.39,128l-45,67.56A8,8,0,0,0,32,208H187.72A16,16,0,0,0,201,200.88l45.63-68.44A8,8,0,0,0,246.66,123.56ZM187.72,192H47l39.71-59.56a8,8,0,0,0,0-8.88L47,64H187.72l42.67,64Z"/></svg>`,
  "tag-simple": `<svg viewBox="0 0 256 256"><path d="M246.66,123.56,201,55.13A15.94,15.94,0,0,0,187.72,48H40A16,16,0,0,0,24,64V192a16,16,0,0,0,16,16H187.72A16,16,0,0,0,201,200.88l45.63-68.44A8,8,0,0,0,246.66,123.56ZM187.72,192H40V64H187.72l42.66,64Z"/></svg>`,
  "tag": `<svg viewBox="0 0 256 256"><path d="M243.31,136,144,36.69A15.86,15.86,0,0,0,132.69,32H40a8,8,0,0,0-8,8v92.69A15.86,15.86,0,0,0,36.69,144L136,243.31a16,16,0,0,0,22.63,0l84.68-84.68a16,16,0,0,0,0-22.63Zm-96,96L48,132.69V48h84.69L232,147.31ZM96,84A12,12,0,1,1,84,72,12,12,0,0,1,96,84Z"/></svg>`,
  "target": `<svg viewBox="0 0 256 256"><path d="M221.87,83.16A104.1,104.1,0,1,1,195.67,49l22.67-22.68a8,8,0,0,1,11.32,11.32l-96,96a8,8,0,0,1-11.32-11.32l27.72-27.72a40,40,0,1,0,17.87,31.09,8,8,0,1,1,16-.9,56,56,0,1,1-22.38-41.65L184.3,60.39a87.88,87.88,0,1,0,23.13,29.67,8,8,0,0,1,14.44-6.9Z"/></svg>`,
  "terminal-window": `<svg viewBox="0 0 256 256"><path d="M128,128a8,8,0,0,1-3,6.25l-40,32a8,8,0,1,1-10-12.5L107.19,128,75,102.25a8,8,0,1,1,10-12.5l40,32A8,8,0,0,1,128,128Zm48,24H136a8,8,0,0,0,0,16h40a8,8,0,0,0,0-16Zm56-96V200a16,16,0,0,1-16,16H40a16,16,0,0,1-16-16V56A16,16,0,0,1,40,40H216A16,16,0,0,1,232,56ZM216,200V56H40V200H216Z"/></svg>`,
  "terminal": `<svg viewBox="0 0 256 256"><path d="M117.31,134l-72,64a8,8,0,1,1-10.63-12L100,128,34.69,70A8,8,0,1,1,45.32,58l72,64a8,8,0,0,1,0,12ZM216,184H120a8,8,0,0,0,0,16h96a8,8,0,0,0,0-16Z"/></svg>`,
  "text-aa": `<svg viewBox="0 0 256 256"><path d="M87.24,52.59a8,8,0,0,0-14.48,0l-64,136a8,8,0,1,0,14.48,6.81L39.9,160h80.2l16.66,35.4a8,8,0,1,0,14.48-6.81ZM47.43,144,80,74.79,112.57,144ZM200,96c-12.76,0-22.73,3.47-29.63,10.32a8,8,0,0,0,11.26,11.36c3.8-3.77,10-5.68,18.37-5.68,13.23,0,24,9,24,20v3.22A42.76,42.76,0,0,0,200,128c-22.06,0-40,16.15-40,36s17.94,36,40,36a42.73,42.73,0,0,0,24-7.25,8,8,0,0,0,16-.75V132C240,112.15,222.06,96,200,96Zm0,88c-13.23,0-24-9-24-20s10.77-20,24-20,24,9,24,20S213.23,184,200,184Z"/></svg>`,
  "text-align-center": `<svg viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM64,96a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Zm152,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-24,40H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z"/></svg>`,
  "text-align-justify": `<svg viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM216,96H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"/></svg>`,
  "text-align-left": `<svg viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64Zm8,48H168a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Zm176,24H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm-48,40H40a8,8,0,0,0,0,16H168a8,8,0,0,0,0-16Z"/></svg>`,
  "text-align-right": `<svg viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM216,96H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"/></svg>`,
  "text-b": `<svg viewBox="0 0 256 256"><path d="M178.48,115.7A44,44,0,0,0,148,40H80a8,8,0,0,0-8,8V200a8,8,0,0,0,8,8h80a48,48,0,0,0,18.48-92.3ZM88,56h60a28,28,0,0,1,0,56H88Zm72,136H88V128h72a32,32,0,0,1,0,64Z"/></svg>`,
  "text-columns": `<svg viewBox="0 0 256 256"><path d="M120,64a8,8,0,0,1-8,8H40a8,8,0,0,1,0-16h72A8,8,0,0,1,120,64Zm-8,32H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16ZM144,72h72a8,8,0,0,0,0-16H144a8,8,0,0,0,0,16Zm72,24H144a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,40H144a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Zm0,40H144a8,8,0,0,0,0,16h72a8,8,0,0,0,0-16Z"/></svg>`,
  "text-indent": `<svg viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM112,72H216a8,8,0,0,0,0-16H112a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM34.34,141.66a8,8,0,0,0,11.32,0l40-40a8,8,0,0,0,0-11.32l-40-40A8,8,0,0,0,34.34,61.66L68.69,96,34.34,130.34A8,8,0,0,0,34.34,141.66Z"/></svg>`,
  "text-italic": `<svg viewBox="0 0 256 256"><path d="M200,56a8,8,0,0,1-8,8H157.77L115.1,192H144a8,8,0,0,1,0,16H64a8,8,0,0,1,0-16H98.23L140.9,64H112a8,8,0,0,1,0-16h80A8,8,0,0,1,200,56Z"/></svg>`,
  "text-outdent": `<svg viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H112a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM112,72H216a8,8,0,0,0,0-16H112a8,8,0,0,0,0,16ZM216,184H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16ZM72,144a8,8,0,0,0,5.66-13.66L43.31,96,77.66,61.66A8,8,0,0,0,66.34,50.34l-40,40a8,8,0,0,0,0,11.32l40,40A8,8,0,0,0,72,144Z"/></svg>`,
  "text-strikethrough": `<svg viewBox="0 0 256 256"><path d="M224,128a8,8,0,0,1-8,8H175.93c9.19,7.11,16.07,17.2,16.07,32,0,13.34-7,25.7-19.75,34.79C160.33,211.31,144.61,216,128,216s-32.33-4.69-44.25-13.21C71,193.7,64,181.34,64,168a8,8,0,0,1,16,0c0,17.35,22,32,48,32s48-14.65,48-32c0-14.85-10.54-23.58-38.77-32H40a8,8,0,0,1,0-16H216A8,8,0,0,1,224,128ZM76.33,104a8,8,0,0,0,7.61-10.49A17.3,17.3,0,0,1,83.11,88c0-18.24,19.3-32,44.89-32,18.84,0,34.16,7.42,41,19.85a8,8,0,0,0,14-7.7C173.33,50.52,152.77,40,128,40,93.29,40,67.11,60.63,67.11,88a33.73,33.73,0,0,0,1.62,10.49A8,8,0,0,0,76.33,104Z"/></svg>`,
  "text-t": `<svg viewBox="0 0 256 256"><path d="M208,56V88a8,8,0,0,1-16,0V64H136V192h24a8,8,0,0,1,0,16H96a8,8,0,0,1,0-16h24V64H64V88a8,8,0,0,1-16,0V56a8,8,0,0,1,8-8H200A8,8,0,0,1,208,56Z"/></svg>`,
  "text-underline": `<svg viewBox="0 0 256 256"><path d="M200,224a8,8,0,0,1-8,8H64a8,8,0,0,1,0-16H192A8,8,0,0,1,200,224Zm-72-24a64.07,64.07,0,0,0,64-64V56a8,8,0,0,0-16,0v80a48,48,0,0,1-96,0V56a8,8,0,0,0-16,0v80A64.07,64.07,0,0,0,128,200Z"/></svg>`,
  "textbox": `<svg viewBox="0 0 256 256"><path d="M112,40a8,8,0,0,0-8,8V64H24A16,16,0,0,0,8,80v96a16,16,0,0,0,16,16h80v16a8,8,0,0,0,16,0V48A8,8,0,0,0,112,40ZM24,176V80h80v96ZM248,80v96a16,16,0,0,1-16,16H144a8,8,0,0,1,0-16h88V80H144a8,8,0,0,1,0-16h88A16,16,0,0,1,248,80ZM88,112a8,8,0,0,1-8,8H72v24a8,8,0,0,1-16,0V120H48a8,8,0,0,1,0-16H80A8,8,0,0,1,88,112Z"/></svg>`,
  "thumbs-down": `<svg viewBox="0 0 256 256"><path d="M239.82,157l-12-96A24,24,0,0,0,204,40H32A16,16,0,0,0,16,56v88a16,16,0,0,0,16,16H75.06l37.78,75.58A8,8,0,0,0,120,240a40,40,0,0,0,40-40V184h56a24,24,0,0,0,23.82-27ZM72,144H32V56H72Zm150,21.29a7.88,7.88,0,0,1-6,2.71H152a8,8,0,0,0-8,8v24a24,24,0,0,1-19.29,23.54L88,150.11V56H204a8,8,0,0,1,7.94,7l12,96A7.87,7.87,0,0,1,222,165.29Z"/></svg>`,
  "thumbs-up": `<svg viewBox="0 0 256 256"><path d="M234,80.12A24,24,0,0,0,216,72H160V56a40,40,0,0,0-40-40,8,8,0,0,0-7.16,4.42L75.06,96H32a16,16,0,0,0-16,16v88a16,16,0,0,0,16,16H204a24,24,0,0,0,23.82-21l12-96A24,24,0,0,0,234,80.12ZM32,112H72v88H32ZM223.94,97l-12,96a8,8,0,0,1-7.94,7H88V105.89l36.71-73.43A24,24,0,0,1,144,56V80a8,8,0,0,0,8,8h64a8,8,0,0,1,7.94,9Z"/></svg>`,
  "timer": `<svg viewBox="0 0 256 256"><path d="M128,40a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,40Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,216ZM173.66,90.34a8,8,0,0,1,0,11.32l-40,40a8,8,0,0,1-11.32-11.32l40-40A8,8,0,0,1,173.66,90.34ZM96,16a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H104A8,8,0,0,1,96,16Z"/></svg>`,
  "toggle-left": `<svg viewBox="0 0 256 256"><path d="M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144Zm0,128H80A56,56,0,0,1,80,72h96a56,56,0,0,1,0,112ZM80,88a40,40,0,1,0,40,40A40,40,0,0,0,80,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,80,152Z"/></svg>`,
  "toggle-right": `<svg viewBox="0 0 256 256"><path d="M176,56H80a72,72,0,0,0,0,144h96a72,72,0,0,0,0-144Zm0,128H80A56,56,0,0,1,80,72h96a56,56,0,0,1,0,112Zm0-96a40,40,0,1,0,40,40A40,40,0,0,0,176,88Zm0,64a24,24,0,1,1,24-24A24,24,0,0,1,176,152Z"/></svg>`,
  "toolbox": `<svg viewBox="0 0 256 256"><path d="M224,64H176V56a24,24,0,0,0-24-24H104A24,24,0,0,0,80,56v8H32A16,16,0,0,0,16,80V192a16,16,0,0,0,16,16H224a16,16,0,0,0,16-16V80A16,16,0,0,0,224,64ZM96,56a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96ZM224,80v32H192v-8a8,8,0,0,0-16,0v8H80v-8a8,8,0,0,0-16,0v8H32V80Zm0,112H32V128H64v8a8,8,0,0,0,16,0v-8h96v8a8,8,0,0,0,16,0v-8h32v64Z"/></svg>`,
  "translate": `<svg viewBox="0 0 256 256"><path d="M247.15,212.42l-56-112a8,8,0,0,0-14.31,0l-21.71,43.43A88,88,0,0,1,108,126.93,103.65,103.65,0,0,0,135.69,64H160a8,8,0,0,0,0-16H104V32a8,8,0,0,0-16,0V48H32a8,8,0,0,0,0,16h87.63A87.76,87.76,0,0,1,96,116.35a87.74,87.74,0,0,1-19-31,8,8,0,1,0-15.08,5.34A103.63,103.63,0,0,0,84,127a87.55,87.55,0,0,1-52,17,8,8,0,0,0,0,16,103.46,103.46,0,0,0,64-22.08,104.18,104.18,0,0,0,51.44,21.31l-26.6,53.19a8,8,0,0,0,14.31,7.16L148.94,192h70.11l13.79,27.58A8,8,0,0,0,240,224a8,8,0,0,0,7.15-11.58ZM156.94,176,184,121.89,211.05,176Z"/></svg>`,
  "trash-simple": `<svg viewBox="0 0 256 256"><path d="M216,48H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM192,208H64V64H192ZM80,24a8,8,0,0,1,8-8h80a8,8,0,0,1,0,16H88A8,8,0,0,1,80,24Z"/></svg>`,
  "trash": `<svg viewBox="0 0 256 256"><path d="M216,48H176V40a24,24,0,0,0-24-24H104A24,24,0,0,0,80,40v8H40a8,8,0,0,0,0,16h8V208a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V64h8a8,8,0,0,0,0-16ZM96,40a8,8,0,0,1,8-8h48a8,8,0,0,1,8,8v8H96Zm96,168H64V64H192ZM112,104v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Zm48,0v64a8,8,0,0,1-16,0V104a8,8,0,0,1,16,0Z"/></svg>`,
  "tray-arrow-down": `<svg viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,16V152h-28.7A15.86,15.86,0,0,0,168,156.69L148.69,176H107.31L88,156.69A15.86,15.86,0,0,0,76.69,152H48V48Zm0,160H48V168H76.69L96,187.31A15.86,15.86,0,0,0,107.31,192h41.38A15.86,15.86,0,0,0,160,187.31L179.31,168H208v40ZM90.34,125.66a8,8,0,0,1,11.32-11.32L120,132.69V72a8,8,0,0,1,16,0v60.69l18.34-18.35a8,8,0,0,1,11.32,11.32l-32,32a8,8,0,0,1-11.32,0Z"/></svg>`,
  "tray-arrow-up": `<svg viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,16V152h-28.7A15.86,15.86,0,0,0,168,156.69L148.69,176H107.31L88,156.69A15.86,15.86,0,0,0,76.69,152H48V48Zm0,160H48V168H76.69L96,187.31A15.86,15.86,0,0,0,107.31,192h41.38A15.86,15.86,0,0,0,160,187.31L179.31,168H208v40ZM90.34,109.66a8,8,0,0,1,0-11.32l32-32a8,8,0,0,1,11.32,0l32,32a8,8,0,0,1-11.32,11.32L136,91.31V152a8,8,0,0,1-16,0V91.31l-18.34,18.35A8,8,0,0,1,90.34,109.66Z"/></svg>`,
  "tray": `<svg viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,16V152h-28.7A15.86,15.86,0,0,0,168,156.69L148.69,176H107.31L88,156.69A15.86,15.86,0,0,0,76.69,152H48V48Zm0,160H48V168H76.69L96,187.31A15.86,15.86,0,0,0,107.31,192h41.38A15.86,15.86,0,0,0,160,187.31L179.31,168H208v40Z"/></svg>`,
  "tree-structure": `<svg viewBox="0 0 256 256"><path d="M160,112h48a16,16,0,0,0,16-16V48a16,16,0,0,0-16-16H160a16,16,0,0,0-16,16V64H128a24,24,0,0,0-24,24v32H72v-8A16,16,0,0,0,56,96H24A16,16,0,0,0,8,112v32a16,16,0,0,0,16,16H56a16,16,0,0,0,16-16v-8h32v32a24,24,0,0,0,24,24h16v16a16,16,0,0,0,16,16h48a16,16,0,0,0,16-16V160a16,16,0,0,0-16-16H160a16,16,0,0,0-16,16v16H128a8,8,0,0,1-8-8V88a8,8,0,0,1,8-8h16V96A16,16,0,0,0,160,112ZM56,144H24V112H56v32Zm104,16h48v48H160Zm0-112h48V96H160Z"/></svg>`,
  "tree-view": `<svg viewBox="0 0 256 256"><path d="M176,152h32a16,16,0,0,0,16-16V104a16,16,0,0,0-16-16H176a16,16,0,0,0-16,16v8H88V80h8a16,16,0,0,0,16-16V32A16,16,0,0,0,96,16H64A16,16,0,0,0,48,32V64A16,16,0,0,0,64,80h8V192a24,24,0,0,0,24,24h64v8a16,16,0,0,0,16,16h32a16,16,0,0,0,16-16V192a16,16,0,0,0-16-16H176a16,16,0,0,0-16,16v8H96a8,8,0,0,1-8-8V128h72v8A16,16,0,0,0,176,152ZM64,32H96V64H64ZM176,192h32v32H176Zm0-88h32v32H176Z"/></svg>`,
  "trend-down": `<svg viewBox="0 0 256 256"><path d="M240,128v64a8,8,0,0,1-8,8H168a8,8,0,0,1,0-16h44.69L136,107.31l-34.34,34.35a8,8,0,0,1-11.32,0l-72-72A8,8,0,0,1,29.66,58.34L96,124.69l34.34-34.35a8,8,0,0,1,11.32,0L224,172.69V128a8,8,0,0,1,16,0Z"/></svg>`,
  "trend-up": `<svg viewBox="0 0 256 256"><path d="M240,56v64a8,8,0,0,1-16,0V75.31l-82.34,82.35a8,8,0,0,1-11.32,0L96,123.31,29.66,189.66a8,8,0,0,1-11.32-11.32l72-72a8,8,0,0,1,11.32,0L136,140.69,212.69,64H168a8,8,0,0,1,0-16h64A8,8,0,0,1,240,56Z"/></svg>`,
  "upload-simple": `<svg viewBox="0 0 256 256"><path d="M224,144v64a8,8,0,0,1-8,8H40a8,8,0,0,1-8-8V144a8,8,0,0,1,16,0v56H208V144a8,8,0,0,1,16,0ZM93.66,77.66,120,51.31V144a8,8,0,0,0,16,0V51.31l26.34,26.35a8,8,0,0,0,11.32-11.32l-40-40a8,8,0,0,0-11.32,0l-40,40A8,8,0,0,0,93.66,77.66Z"/></svg>`,
  "upload": `<svg viewBox="0 0 256 256"><path d="M240,136v64a16,16,0,0,1-16,16H32a16,16,0,0,1-16-16V136a16,16,0,0,1,16-16H80a8,8,0,0,1,0,16H32v64H224V136H176a8,8,0,0,1,0-16h48A16,16,0,0,1,240,136ZM85.66,77.66,120,43.31V128a8,8,0,0,0,16,0V43.31l34.34,34.35a8,8,0,0,0,11.32-11.32l-48-48a8,8,0,0,0-11.32,0l-48,48A8,8,0,0,0,85.66,77.66ZM200,168a12,12,0,1,0-12,12A12,12,0,0,0,200,168Z"/></svg>`,
  "user-check": `<svg viewBox="0 0 256 256"><path d="M144,157.68a68,68,0,1,0-71.9,0c-20.65,6.76-39.23,19.39-54.17,37.17a8,8,0,0,0,12.25,10.3C50.25,181.19,77.91,168,108,168s57.75,13.19,77.87,37.15a8,8,0,0,0,12.25-10.3C183.18,177.07,164.6,164.44,144,157.68ZM56,100a52,52,0,1,1,52,52A52.06,52.06,0,0,1,56,100Zm197.66,33.66-32,32a8,8,0,0,1-11.32,0l-16-16a8,8,0,0,1,11.32-11.32L216,148.69l26.34-26.35a8,8,0,0,1,11.32,11.32Z"/></svg>`,
  "user-circle-check": `<svg viewBox="0 0 256 256"><path d="M221.35,104.11a8,8,0,0,0-6.57,9.21A88.85,88.85,0,0,1,216,128a87.62,87.62,0,0,1-22.24,58.41,79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75A88,88,0,0,1,128,40a88.76,88.76,0,0,1,14.68,1.22,8,8,0,0,0,2.64-15.78,103.92,103.92,0,1,0,85.24,85.24A8,8,0,0,0,221.35,104.11ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0ZM237.66,45.66l-32,32a8,8,0,0,1-11.32,0l-16-16a8,8,0,0,1,11.32-11.32L200,60.69l26.34-26.35a8,8,0,0,1,11.32,11.32Z"/></svg>`,
  "user-circle-dashed": `<svg viewBox="0 0 256 256"><path d="M96.26,37A8,8,0,0,1,102,27.29a104.11,104.11,0,0,1,52,0,8,8,0,0,1-2,15.75,8.15,8.15,0,0,1-2-.26,88,88,0,0,0-44,0A8,8,0,0,1,96.26,37ZM33.35,110a8,8,0,0,0,9.85-5.57,87.88,87.88,0,0,1,22-38.09A8,8,0,0,0,53.8,55.14a103.92,103.92,0,0,0-26,45A8,8,0,0,0,33.35,110ZM150,213.22a88,88,0,0,1-44,0,8,8,0,0,0-4,15.49,104.11,104.11,0,0,0,52,0,8,8,0,0,0-4-15.49Zm62.8-108.77a8,8,0,0,0,15.42-4.28,104,104,0,0,0-26-45,8,8,0,1,0-11.41,11.21A88.14,88.14,0,0,1,212.79,104.45Zm15.44,51.39a103.68,103.68,0,0,1-30.68,49.47A8,8,0,0,1,185.07,203a64,64,0,0,0-114.14,0,8,8,0,0,1-12.48,2.32,103.74,103.74,0,0,1-30.68-49.49,8,8,0,0,1,15.42-4.27,87.58,87.58,0,0,0,19,34.88,79.57,79.57,0,0,1,36.1-28.77,48,48,0,1,1,59.38,0,79.57,79.57,0,0,1,36.1,28.77,87.58,87.58,0,0,0,19-34.88,8,8,0,1,1,15.42,4.28ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Z"/></svg>`,
  "user-circle-gear": `<svg viewBox="0 0 256 256"><path d="M228.25,63.07l-4.66-2.69a23.6,23.6,0,0,0,0-8.76l4.66-2.69a8,8,0,0,0-8-13.86l-4.67,2.7A23.92,23.92,0,0,0,208,33.38V28a8,8,0,0,0-16,0v5.38a23.92,23.92,0,0,0-7.58,4.39l-4.67-2.7a8,8,0,1,0-8,13.86l4.66,2.69a23.6,23.6,0,0,0,0,8.76l-4.66,2.69a8,8,0,0,0,4,14.93,7.92,7.92,0,0,0,4-1.07l4.67-2.7A23.92,23.92,0,0,0,192,78.62V84a8,8,0,0,0,16,0V78.62a23.92,23.92,0,0,0,7.58-4.39l4.67,2.7a7.92,7.92,0,0,0,4,1.07,8,8,0,0,0,4-14.93ZM192,56a8,8,0,1,1,8,8A8,8,0,0,1,192,56Zm29.35,48.11a8,8,0,0,0-6.57,9.21A88.85,88.85,0,0,1,216,128a87.62,87.62,0,0,1-22.24,58.41,79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75A88,88,0,0,1,128,40a88.76,88.76,0,0,1,14.68,1.22,8,8,0,0,0,2.64-15.78,103.92,103.92,0,1,0,85.24,85.24A8,8,0,0,0,221.35,104.11ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0Z"/></svg>`,
  "user-circle-minus": `<svg viewBox="0 0 256 256"><path d="M168,56a8,8,0,0,1,8-8h48a8,8,0,0,1,0,16H176A8,8,0,0,1,168,56Zm58.08,37.33a103.93,103.93,0,1,1-80.76-67.89,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.66,79.66,0,0,1,36.06,28.75A88,88,0,0,0,211,98.67a8,8,0,0,1,15.09-5.34ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a87.57,87.57,0,0,0,53.92-18.5,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"/></svg>`,
  "user-circle-plus": `<svg viewBox="0 0 256 256"><path d="M168,56a8,8,0,0,1,8-8h16V32a8,8,0,0,1,16,0V48h16a8,8,0,0,1,0,16H208V80a8,8,0,0,1-16,0V64H176A8,8,0,0,1,168,56Zm62.56,54.68a103.92,103.92,0,1,1-85.24-85.24,8,8,0,0,1-2.64,15.78A88.07,88.07,0,0,0,40,128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.66,79.66,0,0,1,36.06,28.75A87.62,87.62,0,0,0,216,128a88.85,88.85,0,0,0-1.22-14.68,8,8,0,1,1,15.78-2.64ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a87.57,87.57,0,0,0,53.92-18.5,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"/></svg>`,
  "user-circle": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120Zm97.76,66.41a79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75,88,88,0,1,1,131.52,0Z"/></svg>`,
  "user-focus": `<svg viewBox="0 0 256 256"><path d="M224,40V76a8,8,0,0,1-16,0V48H180a8,8,0,0,1,0-16h36A8,8,0,0,1,224,40Zm-8,132a8,8,0,0,0-8,8v28H180a8,8,0,0,0,0,16h36a8,8,0,0,0,8-8V180A8,8,0,0,0,216,172ZM76,208H48V180a8,8,0,0,0-16,0v36a8,8,0,0,0,8,8H76a8,8,0,0,0,0-16ZM40,84a8,8,0,0,0,8-8V48H76a8,8,0,0,0,0-16H40a8,8,0,0,0-8,8V76A8,8,0,0,0,40,84Zm136,92a8,8,0,0,1-6.41-3.19,52,52,0,0,0-83.2,0,8,8,0,1,1-12.8-9.62A67.94,67.94,0,0,1,101,141.51a40,40,0,1,1,53.94,0,67.94,67.94,0,0,1,27.43,21.68A8,8,0,0,1,176,176Zm-48-40a24,24,0,1,0-24-24A24,24,0,0,0,128,136Z"/></svg>`,
  "user-gear": `<svg viewBox="0 0 256 256"><path d="M144,157.68a68,68,0,1,0-71.9,0c-20.65,6.76-39.23,19.39-54.17,37.17a8,8,0,1,0,12.24,10.3C50.25,181.19,77.91,168,108,168s57.75,13.19,77.87,37.15a8,8,0,0,0,12.26-10.3C183.18,177.07,164.6,164.44,144,157.68ZM56,100a52,52,0,1,1,52,52A52.06,52.06,0,0,1,56,100Zm196.25,43.07-4.66-2.69a23.6,23.6,0,0,0,0-8.76l4.66-2.69a8,8,0,1,0-8-13.86l-4.67,2.7a23.92,23.92,0,0,0-7.58-4.39V108a8,8,0,0,0-16,0v5.38a23.92,23.92,0,0,0-7.58,4.39l-4.67-2.7a8,8,0,1,0-8,13.86l4.66,2.69a23.6,23.6,0,0,0,0,8.76l-4.66,2.69a8,8,0,0,0,8,13.86l4.67-2.7a23.92,23.92,0,0,0,7.58,4.39V164a8,8,0,0,0,16,0v-5.38a23.92,23.92,0,0,0,7.58-4.39l4.67,2.7a7.92,7.92,0,0,0,4,1.07,8,8,0,0,0,4-14.93ZM216,136a8,8,0,1,1,8,8A8,8,0,0,1,216,136Z"/></svg>`,
  "user-list": `<svg viewBox="0 0 256 256"><path d="M152,80a8,8,0,0,1,8-8h88a8,8,0,0,1,0,16H160A8,8,0,0,1,152,80Zm96,40H160a8,8,0,0,0,0,16h88a8,8,0,0,0,0-16Zm0,48H184a8,8,0,0,0,0,16h64a8,8,0,0,0,0-16Zm-96.25,22a8,8,0,0,1-5.76,9.74,7.55,7.55,0,0,1-2,.26,8,8,0,0,1-7.75-6c-6.16-23.94-30.34-42-56.25-42s-50.09,18.05-56.25,42a8,8,0,0,1-15.5-4c5.59-21.71,21.84-39.29,42.46-48a48,48,0,1,1,58.58,0C129.91,150.71,146.16,168.29,151.75,190ZM80,136a32,32,0,1,0-32-32A32,32,0,0,0,80,136Z"/></svg>`,
  "user-minus": `<svg viewBox="0 0 256 256"><path d="M256,136a8,8,0,0,1-8,8H200a8,8,0,0,1,0-16h48A8,8,0,0,1,256,136Zm-57.87,58.85a8,8,0,0,1-12.26,10.3C165.75,181.19,138.09,168,108,168s-57.75,13.19-77.87,37.15a8,8,0,0,1-12.25-10.3c14.94-17.78,33.52-30.41,54.17-37.17a68,68,0,1,1,71.9,0C164.6,164.44,183.18,177.07,198.13,194.85ZM108,152a52,52,0,1,0-52-52A52.06,52.06,0,0,0,108,152Z"/></svg>`,
  "user-plus": `<svg viewBox="0 0 256 256"><path d="M256,136a8,8,0,0,1-8,8H232v16a8,8,0,0,1-16,0V144H200a8,8,0,0,1,0-16h16V112a8,8,0,0,1,16,0v16h16A8,8,0,0,1,256,136Zm-57.87,58.85a8,8,0,0,1-12.26,10.3C165.75,181.19,138.09,168,108,168s-57.75,13.19-77.87,37.15a8,8,0,0,1-12.25-10.3c14.94-17.78,33.52-30.41,54.17-37.17a68,68,0,1,1,71.9,0C164.6,164.44,183.18,177.07,198.13,194.85ZM108,152a52,52,0,1,0-52-52A52.06,52.06,0,0,0,108,152Z"/></svg>`,
  "user-rectangle": `<svg viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120ZM72.57,200a64,64,0,0,1,110.86,0ZM216,200H201.33a80.14,80.14,0,0,0-43.69-42.28,48,48,0,1,0-59.28,0A80.14,80.14,0,0,0,54.67,200H40V56H216V200Z"/></svg>`,
  "user-square": `<svg viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120ZM68.67,208A64.36,64.36,0,0,1,87.8,182.2a64,64,0,0,1,80.4,0A64.36,64.36,0,0,1,187.33,208ZM208,208h-3.67a79.9,79.9,0,0,0-46.68-50.29,48,48,0,1,0-59.3,0A79.9,79.9,0,0,0,51.67,208H48V48H208V208Z"/></svg>`,
  "user-switch": `<svg viewBox="0 0 256 256"><path d="M253.66,133.66l-24,24a8,8,0,0,1-11.32,0l-24-24a8,8,0,0,1,11.32-11.32L216,132.69V128A88,88,0,0,0,56.49,76.67a8,8,0,0,1-13-9.34A104,104,0,0,1,232,128v4.69l10.34-10.35a8,8,0,0,1,11.32,11.32Zm-41.18,55A104,104,0,0,1,24,128v-4.69L13.66,133.66A8,8,0,0,1,2.34,122.34l24-24a8,8,0,0,1,11.32,0l24,24a8,8,0,0,1-11.32,11.32L40,123.31V128a87.62,87.62,0,0,0,22.24,58.41A79.66,79.66,0,0,1,98.3,157.66a48,48,0,1,1,59.4,0,79.59,79.59,0,0,1,36.08,28.78,89.68,89.68,0,0,0,5.71-7.11,8,8,0,0,1,13,9.34ZM128,152a32,32,0,1,0-32-32A32,32,0,0,0,128,152Zm0,64a88.2,88.2,0,0,0,53.92-18.49,64,64,0,0,0-107.84,0A87.57,87.57,0,0,0,128,216Z"/></svg>`,
  "user": `<svg viewBox="0 0 256 256"><path d="M230.92,212c-15.23-26.33-38.7-45.21-66.09-54.16a72,72,0,1,0-73.66,0C63.78,166.78,40.31,185.66,25.08,212a8,8,0,1,0,13.85,8c18.84-32.56,52.14-52,89.07-52s70.23,19.44,89.07,52a8,8,0,1,0,13.85-8ZM72,96a56,56,0,1,1,56,56A56.06,56.06,0,0,1,72,96Z"/></svg>`,
  "users-four": `<svg viewBox="0 0 256 256"><path d="M27.2,126.4a8,8,0,0,0,11.2-1.6,52,52,0,0,1,83.2,0,8,8,0,0,0,11.2,1.59,7.73,7.73,0,0,0,1.59-1.59h0a52,52,0,0,1,83.2,0,8,8,0,0,0,12.8-9.61A67.85,67.85,0,0,0,203,93.51a40,40,0,1,0-53.94,0,67.27,67.27,0,0,0-21,14.31,67.27,67.27,0,0,0-21-14.31,40,40,0,1,0-53.94,0A67.88,67.88,0,0,0,25.6,115.2,8,8,0,0,0,27.2,126.4ZM176,40a24,24,0,1,1-24,24A24,24,0,0,1,176,40ZM80,40A24,24,0,1,1,56,64,24,24,0,0,1,80,40ZM203,197.51a40,40,0,1,0-53.94,0,67.27,67.27,0,0,0-21,14.31,67.27,67.27,0,0,0-21-14.31,40,40,0,1,0-53.94,0A67.88,67.88,0,0,0,25.6,219.2a8,8,0,1,0,12.8,9.6,52,52,0,0,1,83.2,0,8,8,0,0,0,11.2,1.59,7.73,7.73,0,0,0,1.59-1.59h0a52,52,0,0,1,83.2,0,8,8,0,0,0,12.8-9.61A67.85,67.85,0,0,0,203,197.51ZM80,144a24,24,0,1,1-24,24A24,24,0,0,1,80,144Zm96,0a24,24,0,1,1-24,24A24,24,0,0,1,176,144Z"/></svg>`,
  "users-three": `<svg viewBox="0 0 256 256"><path d="M244.8,150.4a8,8,0,0,1-11.2-1.6A51.6,51.6,0,0,0,192,128a8,8,0,0,1-7.37-4.89,8,8,0,0,1,0-6.22A8,8,0,0,1,192,112a24,24,0,1,0-23.24-30,8,8,0,1,1-15.5-4A40,40,0,1,1,219,117.51a67.94,67.94,0,0,1,27.43,21.68A8,8,0,0,1,244.8,150.4ZM190.92,212a8,8,0,1,1-13.84,8,57,57,0,0,0-98.16,0,8,8,0,1,1-13.84-8,72.06,72.06,0,0,1,33.74-29.92,48,48,0,1,1,58.36,0A72.06,72.06,0,0,1,190.92,212ZM128,176a32,32,0,1,0-32-32A32,32,0,0,0,128,176ZM72,120a8,8,0,0,0-8-8A24,24,0,1,1,87.24,82a8,8,0,1,0,15.5-4A40,40,0,1,0,37,117.51,67.94,67.94,0,0,0,9.6,139.19a8,8,0,1,0,12.8,9.61A51.6,51.6,0,0,1,64,128,8,8,0,0,0,72,120Z"/></svg>`,
  "users": `<svg viewBox="0 0 256 256"><path d="M117.25,157.92a60,60,0,1,0-66.5,0A95.83,95.83,0,0,0,3.53,195.63a8,8,0,1,0,13.4,8.74,80,80,0,0,1,134.14,0,8,8,0,0,0,13.4-8.74A95.83,95.83,0,0,0,117.25,157.92ZM40,108a44,44,0,1,1,44,44A44.05,44.05,0,0,1,40,108Zm210.14,98.7a8,8,0,0,1-11.07-2.33A79.83,79.83,0,0,0,172,168a8,8,0,0,1,0-16,44,44,0,1,0-16.34-84.87,8,8,0,1,1-5.94-14.85,60,60,0,0,1,55.53,105.64,95.83,95.83,0,0,1,47.22,37.71A8,8,0,0,1,250.14,206.7Z"/></svg>`,
  "vault": `<svg viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V192a16,16,0,0,0,16,16H56v16a8,8,0,0,0,16,0V208H184v16a8,8,0,0,0,16,0V208h16a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,152H40V56H216v64H199.32a48,48,0,1,0,0,16H216v56Zm-50.16-72a16,16,0,1,0,0,16H183a32,32,0,1,1,0-16Z"/></svg>`,
  "video-camera-slash": `<svg viewBox="0 0 256 256"><path d="M251.77,73a8,8,0,0,0-8.21.39L208,97.05V72a16,16,0,0,0-16-16H113.06a8,8,0,0,0,0,16H192v87.63a8,8,0,0,0,16,0V159l35.56,23.71A8,8,0,0,0,248,184a8,8,0,0,0,8-8V80A8,8,0,0,0,251.77,73ZM240,161.05l-32-21.33V116.28L240,95ZM53.92,34.62A8,8,0,1,0,42.08,45.38L51.73,56H32A16,16,0,0,0,16,72V184a16,16,0,0,0,16,16H182.64l19.44,21.38a8,8,0,1,0,11.84-10.76ZM32,184V72H66.28L168.1,184Z"/></svg>`,
  "video-camera": `<svg viewBox="0 0 256 256"><path d="M251.77,73a8,8,0,0,0-8.21.39L208,97.05V72a16,16,0,0,0-16-16H32A16,16,0,0,0,16,72V184a16,16,0,0,0,16,16H192a16,16,0,0,0,16-16V159l35.56,23.71A8,8,0,0,0,248,184a8,8,0,0,0,8-8V80A8,8,0,0,0,251.77,73ZM192,184H32V72H192V184Zm48-22.95-32-21.33V116.28L240,95Z"/></svg>`,
  "video-conference": `<svg viewBox="0 0 256 256"><path d="M216,40H40A16,16,0,0,0,24,56V200a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,80H168V56h48ZM40,56H152V200H40ZM216,200H168V136h48v64ZM180,88a12,12,0,1,1,12,12A12,12,0,0,1,180,88Zm24,80a12,12,0,1,1-12-12A12,12,0,0,1,204,168Zm-68.25-2a39.76,39.76,0,0,0-17.19-23.34,32,32,0,1,0-45.12,0A39.84,39.84,0,0,0,56.25,166a8,8,0,0,0,15.5,4c2.64-10.25,13.06-18,24.25-18s21.62,7.73,24.25,18a8,8,0,1,0,15.5-4ZM80,120a16,16,0,1,1,16,16A16,16,0,0,1,80,120Z"/></svg>`,
  "video": `<svg viewBox="0 0 256 256"><path d="M164.44,105.34l-48-32A8,8,0,0,0,104,80v64a8,8,0,0,0,12.44,6.66l48-32a8,8,0,0,0,0-13.32ZM120,129.05V95l25.58,17ZM216,40H40A16,16,0,0,0,24,56V168a16,16,0,0,0,16,16H216a16,16,0,0,0,16-16V56A16,16,0,0,0,216,40Zm0,128H40V56H216V168Zm16,40a8,8,0,0,1-8,8H32a8,8,0,0,1,0-16H224A8,8,0,0,1,232,208Z"/></svg>`,
  "voicemail": `<svg viewBox="0 0 256 256"><path d="M200,72a56,56,0,0,0-39.14,96H95.14A56,56,0,1,0,56,184H200a56,56,0,0,0,0-112ZM16,128a40,40,0,1,1,40,40A40,40,0,0,1,16,128Zm184,40a40,40,0,1,1,40-40A40,40,0,0,1,200,168Z"/></svg>`,
  "wallet": `<svg viewBox="0 0 256 256"><path d="M216,64H56a8,8,0,0,1,0-16H192a8,8,0,0,0,0-16H56A24,24,0,0,0,32,56V184a24,24,0,0,0,24,24H216a16,16,0,0,0,16-16V80A16,16,0,0,0,216,64Zm0,128H56a8,8,0,0,1-8-8V78.63A23.84,23.84,0,0,0,56,80H216Zm-48-60a12,12,0,1,1,12,12A12,12,0,0,1,168,132Z"/></svg>`,
  "warning-circle": `<svg viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm-8-80V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,172Z"/></svg>`,
  "warning-diamond": `<svg viewBox="0 0 256 256"><path d="M128,72a8,8,0,0,1,8,8v56a8,8,0,0,1-16,0V80A8,8,0,0,1,128,72ZM116,172a12,12,0,1,0,12-12A12,12,0,0,0,116,172Zm124-44a15.85,15.85,0,0,1-4.67,11.28l-96.05,96.06a16,16,0,0,1-22.56,0h0l-96-96.06a16,16,0,0,1,0-22.56l96.05-96.06a16,16,0,0,1,22.56,0l96.05,96.06A15.85,15.85,0,0,1,240,128Zm-16,0L128,32,32,128,128,224h0Z"/></svg>`,
  "warning-octagon": `<svg viewBox="0 0 256 256"><path d="M120,136V80a8,8,0,0,1,16,0v56a8,8,0,0,1-16,0ZM232,91.55v72.9a15.86,15.86,0,0,1-4.69,11.31l-51.55,51.55A15.86,15.86,0,0,1,164.45,232H91.55a15.86,15.86,0,0,1-11.31-4.69L28.69,175.76A15.86,15.86,0,0,1,24,164.45V91.55a15.86,15.86,0,0,1,4.69-11.31L80.24,28.69A15.86,15.86,0,0,1,91.55,24h72.9a15.86,15.86,0,0,1,11.31,4.69l51.55,51.55A15.86,15.86,0,0,1,232,91.55Zm-16,0L164.45,40H91.55L40,91.55v72.9L91.55,216h72.9L216,164.45ZM128,160a12,12,0,1,0,12,12A12,12,0,0,0,128,160Z"/></svg>`,
  "warning": `<svg viewBox="0 0 256 256"><path d="M236.8,188.09,149.35,36.22h0a24.76,24.76,0,0,0-42.7,0L19.2,188.09a23.51,23.51,0,0,0,0,23.72A24.35,24.35,0,0,0,40.55,224h174.9a24.35,24.35,0,0,0,21.33-12.19A23.51,23.51,0,0,0,236.8,188.09ZM222.93,203.8a8.5,8.5,0,0,1-7.48,4.2H40.55a8.5,8.5,0,0,1-7.48-4.2,7.59,7.59,0,0,1,0-7.72L120.52,44.21a8.75,8.75,0,0,1,15,0l87.45,151.87A7.59,7.59,0,0,1,222.93,203.8ZM120,144V104a8,8,0,0,1,16,0v40a8,8,0,0,1-16,0Zm20,36a12,12,0,1,1-12-12A12,12,0,0,1,140,180Z"/></svg>`,
  "webcam-slash": `<svg viewBox="0 0 256 256"><path d="M213.92,210.62l-160-176A8,8,0,1,0,42.08,45.38L58.82,63.8A80,80,0,0,0,120,183.6V200H32a8,8,0,0,0,0,16H197.19l4.89,5.38a8,8,0,1,0,11.84-10.76ZM64,104a63.65,63.65,0,0,1,6.26-27.62L88.68,96.64A40,40,0,0,0,128,144c1.2,0,2.39-.06,3.58-.17L150,164.11A64,64,0,0,1,64,104Zm72,96V183.59a79.91,79.91,0,0,0,25.44-6.91L182.64,200ZM85.52,45.31a8,8,0,0,1,3-10.91,80,80,0,0,1,105,115.5,8,8,0,1,1-13.1-9.19,64,64,0,0,0-84-92.4A8,8,0,0,1,85.52,45.31Zm65.31,66.12A24,24,0,0,0,128,80a24.17,24.17,0,0,0-5.24.57A8,8,0,1,1,119.3,65,40,40,0,0,1,166,116.38a8,8,0,0,1-15.21-4.95Z"/></svg>`,
  "webcam": `<svg viewBox="0 0 256 256"><path d="M168,104a40,40,0,1,0-40,40A40,40,0,0,0,168,104Zm-64,0a24,24,0,1,1,24,24A24,24,0,0,1,104,104Zm120,96H136V183.6a80,80,0,1,0-16,0V200H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM64,104a64,64,0,1,1,64,64A64.07,64.07,0,0,1,64,104Z"/></svg>`,
  "webhooks-logo": `<svg viewBox="0 0 256 256"><path d="M178.16,176H111.32A48,48,0,1,1,25.6,139.19a8,8,0,0,1,12.8,9.61A31.69,31.69,0,0,0,32,168a32,32,0,0,0,64,0,8,8,0,0,1,8-8h74.16a16,16,0,1,1,0,16ZM64,184a16,16,0,0,0,14.08-23.61l35.77-58.14a8,8,0,0,0-2.62-11,32,32,0,1,1,46.1-40.06A8,8,0,1,0,172,44.79a48,48,0,1,0-75.62,55.33L64.44,152c-.15,0-.29,0-.44,0a16,16,0,0,0,0,32Zm128-64a48.18,48.18,0,0,0-18,3.49L142.08,71.6A16,16,0,1,0,128,80l.44,0,35.78,58.15a8,8,0,0,0,11,2.61A32,32,0,1,1,192,200a8,8,0,0,0,0,16,48,48,0,0,0,0-96Z"/></svg>`,
  "whatsapp-logo": `<svg viewBox="0 0 256 256"><path d="M187.58,144.84l-32-16a8,8,0,0,0-8,.5l-14.69,9.8a40.55,40.55,0,0,1-16-16l9.8-14.69a8,8,0,0,0,.5-8l-16-32A8,8,0,0,0,104,64a40,40,0,0,0-40,40,88.1,88.1,0,0,0,88,88,40,40,0,0,0,40-40A8,8,0,0,0,187.58,144.84ZM152,176a72.08,72.08,0,0,1-72-72A24,24,0,0,1,99.29,80.46l11.48,23L101,118a8,8,0,0,0-.73,7.51,56.47,56.47,0,0,0,30.15,30.15A8,8,0,0,0,138,155l14.61-9.74,23,11.48A24,24,0,0,1,152,176ZM128,24A104,104,0,0,0,36.18,176.88L24.83,210.93a16,16,0,0,0,20.24,20.24l34.05-11.35A104,104,0,1,0,128,24Zm0,192a87.87,87.87,0,0,1-44.06-11.81,8,8,0,0,0-6.54-.67L40,216,52.47,178.6a8,8,0,0,0-.66-6.54A88,88,0,1,1,128,216Z"/></svg>`,
  "wrench": `<svg viewBox="0 0 256 256"><path d="M226.76,69a8,8,0,0,0-12.84-2.88l-40.3,37.19-17.23-3.7-3.7-17.23,37.19-40.3A8,8,0,0,0,187,29.24,72,72,0,0,0,88,96,72.34,72.34,0,0,0,94,124.94L33.79,177c-.15.12-.29.26-.43.39a32,32,0,0,0,45.26,45.26c.13-.13.27-.28.39-.42L131.06,162A72,72,0,0,0,232,96,71.56,71.56,0,0,0,226.76,69ZM160,152a56.14,56.14,0,0,1-27.07-7,8,8,0,0,0-9.92,1.77L67.11,211.51a16,16,0,0,1-22.62-22.62L109.18,133a8,8,0,0,0,1.77-9.93,56,56,0,0,1,58.36-82.31l-31.2,33.81a8,8,0,0,0-1.94,7.1L141.83,108a8,8,0,0,0,6.14,6.14l26.35,5.66a8,8,0,0,0,7.1-1.94l33.81-31.2A56.06,56.06,0,0,1,160,152Z"/></svg>`,
  "x-circle": `<svg viewBox="0 0 256 256"><path d="M165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32ZM232,128A104,104,0,1,1,128,24,104.11,104.11,0,0,1,232,128Zm-16,0a88,88,0,1,0-88,88A88.1,88.1,0,0,0,216,128Z"/></svg>`,
  "x-square": `<svg viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,176H48V48H208V208ZM165.66,101.66,139.31,128l26.35,26.34a8,8,0,0,1-11.32,11.32L128,139.31l-26.34,26.35a8,8,0,0,1-11.32-11.32L116.69,128,90.34,101.66a8,8,0,0,1,11.32-11.32L128,116.69l26.34-26.35a8,8,0,0,1,11.32,11.32Z"/></svg>`,
  "x": `<svg viewBox="0 0 256 256"><path d="M205.66,194.34a8,8,0,0,1-11.32,11.32L128,139.31,61.66,205.66a8,8,0,0,1-11.32-11.32L116.69,128,50.34,61.66A8,8,0,0,1,61.66,50.34L128,116.69l66.34-66.35a8,8,0,0,1,11.32,11.32L139.31,128Z"/></svg>`
};

// src/components/icon/icon.ts
var Icon = class extends i3 {
  constructor() {
    super(...arguments);
    this.size = "m";
  }
  getSvgMarkup() {
    if (this.name === void 0) {
      return void 0;
    }
    if (!(this.name in icons)) {
      return void 0;
    }
    return icons[this.name];
  }
  render() {
    const svgMarkup = this.getSvgMarkup();
    const meaningful = Boolean(svgMarkup && this.label);
    return T`<span
        class="wrap"
        role="${o8(meaningful ? "img" : void 0)}"
        aria-label="${o8(meaningful ? this.label : void 0)}"
      >
        <span class="glyph" aria-hidden="true"
          >${svgMarkup ? o9(svgMarkup) : A}</span
        >
      </span>`;
  }
};
Icon.styles = i`
  /* TODO: Replace with icon size tokens */
    :host {
      display: inline-flex;
      box-sizing: border-box;
      width: var(--duo-space-m);
      height: var(--duo-space-m);
      line-height: 0;
      pointer-events: none;
      vertical-align: middle;
    }

    :host([size="xxs"]) {
      width: var(--duo-space-xs);
      height: var(--duo-space-xs);
    }

    :host([size="xs"]) {
      width: calc((var(--duo-space-xs) + var(--duo-space-s)) / 2);
      height: calc((var(--duo-space-xs) + var(--duo-space-s)) / 2);
    }

    :host([size="s"]) {
      width: calc(var(--duo-space-s) + var(--duo-space-xxs) / 2);
      height: calc(var(--duo-space-s) + var(--duo-space-xxs) / 2);
    }

    :host([size="m"]) {
      width: var(--duo-space-m);
      height: var(--duo-space-m);
    }

    :host([size="l"]) {
      width: calc(var(--duo-space-m) + var(--duo-space-xxs));
      height: calc(var(--duo-space-m) + var(--duo-space-xxs));
    }

    :host([size="xl"]) {
      width: var(--duo-space-l);
      height: var(--duo-space-l);
    }

    :host([size="xxl"]) {
      width: calc(var(--duo-space-xxl) - var(--duo-space-xxs));
      height: calc(var(--duo-space-xxl) - var(--duo-space-xxs));
    }

    .glyph svg {
      display: block;
      width: 100%;
      height: 100%;
      fill: currentColor;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], Icon.prototype, "name", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Icon.prototype, "size", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Icon.prototype, "label", 2);
Icon = __decorateClass([
  t3("duo-icon")
], Icon);

// src/components/banner/banner.ts
var Banner = class extends i3 {
  constructor() {
    super(...arguments);
    this.variant = "danger";
  }
  leadingIconName() {
    if (this.variant === "info") {
      return "info";
    }
    if (this.variant === "danger" || this.variant === "warning") {
      return "warning";
    }
    return null;
  }
  render() {
    const role = this.variant === "danger" || this.variant === "warning" ? "alert" : "status";
    const iconName = this.leadingIconName();
    return T`
      <div class="root" role=${role}>
        ${iconName ? T`<div class="icon" aria-hidden="true">
              <duo-icon name=${iconName} size="l"></duo-icon>
            </div>` : A}
        <div class="body"><slot></slot></div>
      </div>
    `;
  }
};
Banner.styles = i`
    :host {
      display: block;
    }

    :host([hidden]) {
      display: none;
    }

    .root {
      display: flex;
      align-items: flex-start;
      gap: var(--duo-space-m);
      box-sizing: border-box;
      padding: var(--duo-space-s) var(--duo-space-m);
      border-radius: var(--duo-border-radius-s);
      border-width: 1px;
      border-style: solid;
    }

    .icon {
      flex-shrink: 0;
      display: flex;
      color: inherit;
    }

    /* Slotted nodes inherit from the host, not from .root inside the shadow tree. */
    :host([variant="primary"]) {
      color: var(--duo-color-text-feedback-highlight);

    }

    :host([variant="secondary"]) {
      color: var(--duo-color-text-feedback-neutral);
    }

    :host([variant="success"]) {
      color: var(--duo-color-text-feedback-positive);
    }

    :host([variant="danger"]) {
      color: var(--duo-color-text-feedback-negative);
    }

    :host([variant="warning"]) {
      color: var(--duo-color-text-feedback-warning);
    }

    :host([variant="info"]) {
      color: var(--duo-color-text-feedback-informative);
    }

    :host([variant="light"]) {
      color: var(--duo-color-text-feedback-neutral)
    }

    :host([variant="dark"]) {
      color: var(--duo-color-background);
    }

    :host([variant="primary"]) .root {
      background: var(--duo-color-background-feedback-highlight);
      color: inherit;
      border-color: transparent;
    }

    :host([variant="secondary"]) .root {
      background: var(--duo-color-background-feedback-neutral);
      color: inherit;
      border-color: transparent;
    }

    :host([variant="success"]) .root {
      background: var(--duo-color-background-feedback-positive);
      color: inherit;
      border-color: transparent;
    }

    :host([variant="danger"]) .root {
      background: var(--duo-color-background-feedback-negative);
      color: inherit;
      border: none;
    }

    :host([variant="warning"]) .root {
      background: var(--duo-color-background-feedback-warning);
      color: inherit;
      border-color: transparent;
    }

    :host([variant="info"]) .root {
      align-items: center;
      gap: var(--duo-space-s);
      padding: var(--duo-space-s);
      background: var(--duo-color-background-feedback-informative);
      color: inherit;
      border-color: transparent;
    }

    :host([variant="light"]) .root {
      background: var(--duo-color-surface);
      color: inherit;
      border-color: transparent;
    }

    :host([variant="dark"]) .root {
      background: var(--duo-color-accent);
      color: inherit;
      border-color: transparent;
    }

    .body {
      margin: 0;
      flex: 1;
      min-width: 0;
      font: var(--duo-font-body);
    }

    :host([variant="info"]) .body {
      font: var(--duo-font-form);
    }

    ::slotted(p) {
      margin: 0;
    }

    ::slotted(a) {
      font-weight: var(--duo-font-weight-regular);
      color: inherit;
      text-decoration: underline;
      text-underline-offset: 2px;
    }

    ::slotted(a:focus-visible) {
      outline: 2px solid currentColor;
      outline-offset: 2px;
      border-radius: 2px;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], Banner.prototype, "variant", 2);
Banner = __decorateClass([
  t3("duo-banner")
], Banner);

// src/components/empty-state/empty-state.ts
var _EmptyState_instances, useAttributeBody_fn;
var EmptyState = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _EmptyState_instances);
    this.size = "s";
    this.heading = "";
    this.description = "";
    this.headingId = "";
    this.mediaSlot = new SlotController(this, "media");
    this.actionsSlot = new SlotController(this, "actions");
    this.defaultSlot = new SlotController(this);
  }
  connectedCallback() {
    super.connectedCallback();
    if (!this.headingId) {
      this.headingId = `duo-empty-state-heading-${Math.random().toString(36).slice(2, 11)}`;
    }
  }
  render() {
    const useAttrBody = __privateMethod(this, _EmptyState_instances, useAttributeBody_fn).call(this);
    const labelledBy = this.heading && useAttrBody ? this.headingId : void 0;
    return T`
      <section class="root" part="root" aria-labelledby=${o8(labelledBy)}>
        <div
          class=${e6({ media: true, "has-content": this.mediaSlot.hasContent })}
          part="media"
        >
          <slot name="media"></slot>
        </div>
        <div class="message" part="message">
          ${useAttrBody && this.heading ? T`<h2 class="title" id=${this.headingId} part="title">${this.heading}</h2>` : A}
          ${useAttrBody && this.description ? T`<p class="description" part="description">${this.description}</p>` : A}
          <slot class="default-slot"></slot>
        </div>
        <div
          class=${e6({ actions: true, "has-content": this.actionsSlot.hasContent })}
          part="actions"
        >
          <slot name="actions"></slot>
        </div>
      </section>
    `;
  }
};
_EmptyState_instances = new WeakSet();
useAttributeBody_fn = function() {
  return !this.defaultSlot.hasContent;
};
EmptyState.styles = i`
    :host {
      display: block;
      /* Figma defaults (Small); Medium / Large override below */
      --duo-empty-root-gap: calc(var(--duo-space-xl) + var(--duo-space-xs));
      --duo-empty-padding-inline: var(--duo-space-l);
      --duo-empty-padding-block: var(--duo-space-xxl);
      --duo-empty-message-gap: 2px;
      --duo-empty-title-font: var(--duo-font-headline-6);
      --duo-empty-desc-font: var(--duo-font-small);
    }

    :host([size="m"]) {
      --duo-empty-root-gap: calc(var(--duo-space-xl) + var(--duo-space-xs));
      --duo-empty-padding-inline: var(--duo-space-l);
      --duo-empty-padding-block: var(--duo-space-xxl);
      --duo-empty-message-gap: var(--duo-space-xxs);
      --duo-empty-title-font: var(--duo-font-headline-3);
      --duo-empty-desc-font: var(--duo-font-body);
    }

    :host([size="l"]) {
      --duo-empty-root-gap: var(--duo-space-xxl);
      --duo-empty-padding-inline: var(--duo-space-xl);
      --duo-empty-padding-block: calc(var(--duo-space-xxl) + var(--duo-space-xl));
      --duo-empty-message-gap: var(--duo-space-xs);
      --duo-empty-title-font: var(--duo-font-headline-1);
    }

    :host([hidden]) {
      display: none;
    }

    .root {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      box-sizing: border-box;
      width: 100%;
      max-width: 100%;
      gap: var(--duo-empty-root-gap);
      padding-inline: var(--duo-empty-padding-inline);
      padding-block: var(--duo-empty-padding-block);
    }

    .media {
      display: none;
      flex-shrink: 0;
    }

    .media.has-content {
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .media ::slotted(*) {
      max-width: 100%;
    }

    .message {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: var(--duo-empty-message-gap);
      width: 100%;
      min-width: 0;
      font: var(--duo-empty-desc-font);
      color: var(--duo-color-text-weak);
    }

    .message ::slotted(*) {
      margin: 0;
      max-width: 100%;
    }

    .message ::slotted(h1),
    .message ::slotted(h2),
    .message ::slotted(h3),
    .message ::slotted(h4),
    .message ::slotted(h5),
    .message ::slotted(h6) {
      font: var(--duo-empty-title-font);
      color: var(--duo-color-text);
    }

    .message ::slotted(p) {
      font: var(--duo-empty-desc-font);
      color: var(--duo-color-text);
    }

    .title {
      margin: 0;
      max-width: 100%;
      font: var(--duo-empty-title-font);
      color: var(--duo-color-text);
    }

    .description {
      margin: 0;
      max-width: 100%;
      font: var(--duo-empty-desc-font);
      color: var(--duo-color-text-weakest);
    }

    /* Large: Figma description 18 / 28 regular (not token “title”, which is semibold) */
    :host([size="l"]) .description,
    :host([size="l"]) .message ::slotted(p) {
      font-family: var(--duo-font-family-body);
      font-size: 1.125rem;
      line-height: 1.75rem;
      font-weight: 400;
    }

    .actions {
      display: none;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      gap: var(--duo-space-m);
    }

    .actions.has-content {
      display: flex;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], EmptyState.prototype, "size", 2);
__decorateClass([
  n4({ type: String })
], EmptyState.prototype, "heading", 2);
__decorateClass([
  n4({ type: String })
], EmptyState.prototype, "description", 2);
__decorateClass([
  n4({ type: String, attribute: "heading-id" })
], EmptyState.prototype, "headingId", 2);
EmptyState = __decorateClass([
  t3("duo-empty-state")
], EmptyState);

// src/components/avatar/avatar.ts
var _Avatar_instances, imageUrl_fn, imageAlt_fn, iconSize_fn;
var Avatar = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _Avatar_instances);
    this.alt = "";
    this.size = "m";
    this.square = false;
    this.outline = false;
    this.imageFailed = false;
    this.defaultSlot = new SlotController(this);
    this.handleImageError = () => {
      this.imageFailed = true;
    };
  }
  willUpdate(changed) {
    super.willUpdate(changed);
    if (changed.has("avatarUrl") || changed.has("src")) {
      this.imageFailed = false;
    }
  }
  render() {
    if (this.defaultSlot.hasContent) {
      return T`<span class="surface"><slot></slot></span>`;
    }
    const url = __privateMethod(this, _Avatar_instances, imageUrl_fn).call(this);
    const showImage = Boolean(url) && !this.imageFailed;
    if (showImage && url) {
      return T`<span class="surface"
        ><img
          src="${url}"
          alt="${__privateMethod(this, _Avatar_instances, imageAlt_fn).call(this)}"
          decoding="async"
          loading="lazy"
          @error=${this.handleImageError}
      /></span>`;
    }
    if (this.icon) {
      const iconLabel = this.label?.trim() || __privateMethod(this, _Avatar_instances, imageAlt_fn).call(this).trim() || void 0;
      return T`<span class="surface"
        ><span class="glyph"
          ><duo-icon
            name=${this.icon}
            size=${__privateMethod(this, _Avatar_instances, iconSize_fn).call(this)}
            label=${o8(iconLabel || void 0)}
          ></duo-icon></span
      ></span>`;
    }
    if (this.initials?.trim()) {
      const text = this.initials.trim();
      const ariaName = this.label?.trim() || text;
      return T`<span class="surface"
        ><span class="initials" role="img" aria-label="${ariaName}">${text}</span></span
      >`;
    }
    return T`<span class="surface" aria-hidden="true"></span>`;
  }
};
_Avatar_instances = new WeakSet();
imageUrl_fn = function() {
  const fromLegacy = this.avatarUrl?.trim();
  const fromSrc = this.src?.trim();
  return fromLegacy || fromSrc || void 0;
};
imageAlt_fn = function() {
  if (this.altText !== void 0) {
    return this.altText;
  }
  return this.alt ?? "";
};
iconSize_fn = function() {
  return this.size === "xxl" ? "xl" : this.size;
};
Avatar.styles = i`
    :host {
      display: inline-flex;
      vertical-align: middle;
      box-sizing: border-box;
      line-height: 0;
    }

    :host([size="xxs"]) {
      width: var(--duo-space-m);
      height: var(--duo-space-m);
    }

    :host([size="xs"]) {
      width: calc(var(--duo-space-m) + var(--duo-space-xxs));
      height: calc(var(--duo-space-m) + var(--duo-space-xxs));
    }

    :host([size="s"]) {
      width: var(--duo-space-l);
      height: var(--duo-space-l);
    }

    :host([size="m"]) {
      width: var(--duo-space-xl);
      height: var(--duo-space-xl);
    }

    :host([size="l"]) {
      width: calc(var(--duo-space-xl) + var(--duo-space-xs));
      height: calc(var(--duo-space-xl) + var(--duo-space-xs));
    }

    :host([size="xl"]) {
      width: calc(var(--duo-space-xl) + var(--duo-space-m));
      height: calc(var(--duo-space-xl) + var(--duo-space-m));
    }

    :host([size="xxl"]) {
      width: var(--duo-space-xxl);
      height: var(--duo-space-xxl);
    }

    .surface {
      display: flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      overflow: hidden;
      border-radius: var(--duo-border-radius-pill);
      background: var(--duo-color-surface-raised);
      color: var(--duo-color-text);
      border: 1px solid var(--duo-color-border-strong);
    }

    :host([square]) .surface {
      border-radius: var(--duo-border-radius-s);
    }

    :host([outline]) .surface {
      background: transparent;
      border: 1px solid var(--duo-color-border-strong);
    }

    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }

    .initials {
      font-family: var(--duo-font-family-body);
      font-weight: var(--duo-font-weight-bold);
      text-transform: uppercase;
      letter-spacing: 0;
    }

    :host([size="xxs"]) .initials {
      font: normal var(--duo-font-weight-bold) 8px / 1 var(--duo-font-family-body);
    }

    :host([size="xs"]) .initials,
    :host([size="s"]) .initials,
    :host([size="m"]) .initials {
      font: var(--duo-font-tiny);
    }

    :host([size="l"]) .initials,
    :host([size="xl"]) .initials {
      font: var(--duo-font-small);
    }

    :host([size="xxl"]) .initials {
      font: var(--duo-font-body);
    }

    .glyph {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      color: inherit;
    }

    ::slotted(*) {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true, attribute: "avatar-url" })
], Avatar.prototype, "avatarUrl", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Avatar.prototype, "src", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "alt-text" })
], Avatar.prototype, "altText", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Avatar.prototype, "alt", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Avatar.prototype, "initials", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Avatar.prototype, "label", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Avatar.prototype, "icon", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Avatar.prototype, "size", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Avatar.prototype, "square", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Avatar.prototype, "outline", 2);
__decorateClass([
  r5()
], Avatar.prototype, "imageFailed", 2);
Avatar = __decorateClass([
  t3("duo-avatar")
], Avatar);

// src/components/divider/divider.ts
var _Divider_instances, renderLabel_fn;
var Divider = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _Divider_instances);
    this.label = "";
    this.spacing = "none";
    this.dashed = false;
    this.defaultSlot = new SlotController(this);
  }
  render() {
    if (this.defaultSlot.isEmpty && !this.label.trim()) {
      return T`<hr class="line" part="line" />`;
    }
    return T`
      <div class="labeled" part="labeled" role="presentation">
        <span class="line" part="line" aria-hidden="true"></span>
        ${__privateMethod(this, _Divider_instances, renderLabel_fn).call(this)}
        <span class="line" part="line" aria-hidden="true"></span>
      </div>
    `;
  }
};
_Divider_instances = new WeakSet();
renderLabel_fn = function() {
  if (this.defaultSlot.hasContent) {
    return T`<span class="label" part="label"><slot></slot></span>`;
  }
  return T`<span class="label" part="label">${this.label}</span>`;
};
Divider.styles = i`
    :host {
      display: block;
      width: 100%;
      box-sizing: border-box;
      padding-block: var(--duo-space-0);
    }

    :host([hidden]) {
      display: none;
    }

    :host([spacing="none"]) {
      padding-block: var(--duo-space-0);
    }

    :host([spacing="xxs"]) {
      padding-block: var(--duo-space-xxs);
    }

    :host([spacing="xs"]) {
      padding-block: var(--duo-space-xs);
    }

    :host([spacing="s"]) {
      padding-block: var(--duo-space-s);
    }

    :host([spacing="m"]) {
      padding-block: var(--duo-space-m);
    }

    :host([spacing="l"]) {
      padding-block: var(--duo-space-l);
    }

    :host([spacing="xl"]) {
      padding-block: var(--duo-space-xl);
    }

    :host([spacing="xxl"]) {
      padding-block: var(--duo-space-xxl);
    }

    .line {
      flex: 1 1 auto;
      height: 0;
      margin: 0;
      border: 0;
      border-top: 1px solid var(--duo-color-border);
    }

    :host([dashed]) .line {
      border-top-style: dashed;
    }

    hr.line {
      display: block;
      width: 100%;
    }

    .labeled {
      display: flex;
      align-items: center;
      gap: var(--duo-space-s);
      width: 100%;
      margin: 0;
      font: var(--duo-font-body);
      font-weight: var(--duo-font-weight-regular);
      color: var(--duo-color-border);
      text-transform: uppercase;
    }

    .labeled .line {
      flex: 1 1 auto;
    }

    .label {
      flex: 0 0 auto;
      max-width: 100%;
      color: var(--duo-color-text-weakest);
    }
  `;
__decorateClass([
  n4({ type: String })
], Divider.prototype, "label", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Divider.prototype, "spacing", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Divider.prototype, "dashed", 2);
Divider = __decorateClass([
  t3("duo-divider")
], Divider);

// src/components/badge/badge.ts
var Badge = class extends i3 {
  constructor() {
    super(...arguments);
    this.variant = "primary";
    this.size = "m";
    this.pill = false;
    this.defaultSlot = new SlotController(this);
  }
  render() {
    const hasSlot = this.defaultSlot.hasContent;
    return T`<slot></slot>${hasSlot ? A : T`<span class="fallback">${this.label ?? ""}</span>`}`;
  }
};
Badge.styles = i`
    :host {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      min-width: 0;
      vertical-align: baseline;
      max-width: 100%;
      border-radius: var(--duo-border-radius-xs);
      font-family: var(--duo-font-family-body);
      font-size: 10px;
      font-style: normal;
      font-weight: var(--duo-font-weight-regular);
      line-height: 14px;
    }

    :host([pill]) {
      border-radius: var(--duo-border-radius-pill);
    }

    :host([size="s"]) {
      padding: 0 4px;
      font: var(--duo-font-xxs);
    }

    :host([size="m"]) {
      padding: 2px 6px;
      font: var(--duo-font-xs);
    }

    :host([size="l"]) {
      padding: 2px 8px;
      font: var(--duo-font-form);
    }

    ::slotted(*) {
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    :host([variant="primary"]) {
      background: var(--duo-color-accent);
      color: var(--duo-color-on-accent);
    }

    :host([variant="secondary"]) {
      background: var(--duo-color-background-feedback-highlight);
      color: var(--duo-color-accent);
    }

    :host([variant="success"]) {
      background: var(--duo-color-background-feedback-positive);
      color: var(--duo-color-text-feedback-positive);
    }

    :host([variant="danger"]) {
      background: var(--duo-color-background-feedback-negative);
      color: var(--duo-color-text-feedback-negative);
    }

    :host([variant="warning"]) {
      background: var(--duo-color-background-feedback-warning);
      color: var(--duo-color-text-feedback-warning);
    }

    :host([variant="info"]) {
      background: var(--duo-color-background-feedback-informative);
      color: var(--duo-color-text-feedback-informative);
    }

    :host([variant="light"]) {
      background: var(--duo-color-background-0);
      color: var(--duo-color-accent);
    }

    :host([variant="dark"]) {
      background: var(--duo-color-accent);
      color: var(--duo-color-on-accent);
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], Badge.prototype, "variant", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Badge.prototype, "size", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Badge.prototype, "pill", 2);
__decorateClass([
  n4({ type: String })
], Badge.prototype, "label", 2);
Badge = __decorateClass([
  t3("duo-badge")
], Badge);

// src/components/chip/chip.ts
var _Chip_instances, closeLabel_fn, onCloseClick_fn, renderLeadingIcon_fn, renderLabel_fn2, renderDismiss_fn;
var Chip = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _Chip_instances);
    this.variant = "primary";
    this.label = "";
    this.large = false;
    this.outline = false;
    this.dismiss = false;
    this.defaultSlot = new SlotController(this);
    this.iconSlot = new SlotController(this, "icon");
    this.closeButtonSlot = new SlotController(this, "close-button");
  }
  render() {
    return T`
      <span class="root" part="root">
        ${__privateMethod(this, _Chip_instances, renderLeadingIcon_fn).call(this)}
        ${__privateMethod(this, _Chip_instances, renderLabel_fn2).call(this)}
        ${__privateMethod(this, _Chip_instances, renderDismiss_fn).call(this)}
      </span>
    `;
  }
};
_Chip_instances = new WeakSet();
closeLabel_fn = function() {
  const text = this.defaultSlot.hasContent ? this.textContent?.trim() : this.label.trim();
  return text ? `Remove ${text}` : "Remove";
};
onCloseClick_fn = function(event) {
  event.stopPropagation();
  this.dispatchEvent(
    new CustomEvent("close", {
      bubbles: true,
      composed: true
    })
  );
};
renderLeadingIcon_fn = function() {
  if (this.iconSlot.hasContent) {
    return T`<span class="leading-icon" part="icon"><slot name="icon"></slot></span>`;
  }
  if (this.icon) {
    return T`
        <span class="leading-icon" part="icon">
          <duo-icon name=${this.icon} size=${this.large ? "m" : "s"}></duo-icon>
        </span>
      `;
  }
  return A;
};
renderLabel_fn2 = function() {
  if (this.defaultSlot.hasContent) {
    return T`<span class="label" part="label"><slot></slot></span>`;
  }
  return T`<span class="label" part="label">${this.label}</span>`;
};
renderDismiss_fn = function() {
  if (!this.dismiss) {
    return A;
  }
  if (this.closeButtonSlot.hasContent) {
    return T`<slot name="close-button"></slot>`;
  }
  return T`
      <button
        type="button"
        class="close"
        part="close"
        aria-label=${__privateMethod(this, _Chip_instances, closeLabel_fn).call(this)}
        @click=${__privateMethod(this, _Chip_instances, onCloseClick_fn)}
      >
        <duo-icon name="x" size=${this.large ? "m" : "s"}></duo-icon>
      </button>
    `;
};
Chip.styles = i`
    :host {
      display: inline-flex;
      vertical-align: middle;
      max-width: 100%;
    }

    :host([hidden]) {
      display: none;
    }

    .root {
      display: inline-flex;
      align-items: center;
      box-sizing: border-box;
      max-width: 100%;
      gap: var(--duo-space-xxs);
      border: 1px solid transparent;
      border-radius: var(--duo-border-radius-xs);
      font: var(--duo-font-small);
      font-weight: var(--duo-font-weight-medium, 500);
      min-width: 0;
    }

    :host([large]) .root {
      gap: var(--duo-space-xs);
      padding-block: var(--duo-space-xs);
      padding-inline: var(--duo-space-s);
      font: var(--duo-font-body);
      font-weight: var(--duo-font-weight-medium, 500);
    }

    :host(:not([large])) .root {
      padding-block: var(--duo-space-xxs);
      padding-inline: var(--duo-space-xs);
    }

    .label {
      min-width: 0;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    ::slotted(*) {
      min-width: 0;
    }

    .leading-icon {
      display: inline-flex;
      flex-shrink: 0;
      color: inherit;
    }

    .close {
      display: inline-flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: center;
      margin: 0;
      margin-inline-start: var(--duo-space-xxs);
      padding: 0;
      border: none;
      border-radius: var(--duo-border-radius-s);
      background: transparent;
      color: inherit;
      cursor: pointer;
      line-height: 0;
    }

    .close:hover {
      background: color-mix(in srgb, currentColor 12%, transparent);
    }

    .close:focus-visible {
      outline: none;
      box-shadow: var(--duo-box-shadow-button-focus);
    }

    :host([variant="primary"]:not([outline])) .root {
      background: var(--duo-color-accent);
      color: var(--duo-color-on-accent);
    }

    :host([variant="secondary"]:not([outline])) .root {
      background: var(--duo-color-background-feedback-highlight);
      color: var(--duo-color-accent);
    }

    :host([variant="success"]:not([outline])) .root {
      background: var(--duo-color-background-feedback-positive);
      color: var(--duo-color-text-feedback-positive);
    }

    :host([variant="danger"]:not([outline])) .root {
      background: var(--duo-color-background-feedback-negative);
      color: var(--duo-color-text-feedback-negative);
    }

    :host([variant="warning"]:not([outline])) .root {
      background: var(--duo-color-background-feedback-warning);
      color: var(--duo-color-text-feedback-warning);
    }

    :host([variant="info"]:not([outline])) .root {
      background: var(--duo-color-background-feedback-informative);
      color: var(--duo-color-text-feedback-informative);
    }

    :host([variant="light"]:not([outline])) .root {
      background: var(--duo-color-background-0);
      color: var(--duo-color-accent);
    }

    :host([variant="dark"]:not([outline])) .root {
      background: var(--duo-color-accent);
      color: var(--duo-color-on-accent);
    }

    :host([outline][variant="primary"]) .root {
      background: transparent;
      color: var(--duo-color-accent);
      border-color: var(--duo-color-accent);
    }

    :host([outline][variant="secondary"]) .root {
      background: transparent;
      color: var(--duo-color-accent);
      border-color: var(--duo-color-purple-700);
    }

    :host([outline][variant="success"]) .root {
      background: transparent;
      color: var(--duo-color-text-feedback-positive);
      border-color: var(--duo-color-text-feedback-positive);
    }

    :host([outline][variant="danger"]) .root {
      background: transparent;
      color: var(--duo-color-text-feedback-negative);
      border-color: var(--duo-color-text-feedback-negative);
    }

    :host([outline][variant="warning"]) .root {
      background: transparent;
      color: var(--duo-color-text-feedback-warning);
      border-color: var(--duo-color-text-feedback-warning);
    }

    :host([outline][variant="info"]) .root {
      background: transparent;
      color: var(--duo-color-text-feedback-informative);
      border-color: var(--duo-color-text-feedback-informative);
    }

    :host([outline][variant="light"]) .root {
      background: transparent;
      color: var(--duo-color-accent);
      border-color: var(--duo-color-gray-700);
    }

    :host([outline][variant="dark"]) .root {
      background: transparent;
      color: var(--duo-color-gray-1300);
      border-color: var(--duo-color-gray-1300);
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], Chip.prototype, "variant", 2);
__decorateClass([
  n4({ type: String })
], Chip.prototype, "label", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Chip.prototype, "large", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Chip.prototype, "outline", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Chip.prototype, "dismiss", 2);
__decorateClass([
  n4({ type: String })
], Chip.prototype, "icon", 2);
Chip = __decorateClass([
  t3("duo-chip")
], Chip);

// src/components/tag/tag.ts
var Tag = class extends i3 {
  render() {
    return T`<span part="label"><slot></slot></span>`;
  }
};
__decorateClass([
  n4({ type: String, reflect: true })
], Tag.prototype, "variant", 2);
Tag = __decorateClass([
  t3("duo-tag")
], Tag);

// src/components/visually-hidden/visually-hidden.ts
var VisuallyHidden = class extends i3 {
  render() {
    return T`<slot></slot>`;
  }
};
VisuallyHidden.styles = i`
    :host {
      position: absolute;
      width: 1px;
      height: 1px;
      padding: 0;
      margin: -1px;
      overflow: hidden;
      clip: rect(0, 0, 0, 0);
      clip-path: inset(50%);
      white-space: nowrap;
      border: 0;
    }

    :host([hidden]) {
      display: none;
    }
  `;
VisuallyHidden = __decorateClass([
  t3("duo-visually-hidden")
], VisuallyHidden);

// src/components/poster/poster.ts
var POSTER_DETAILS_QUERY = "(max-width: 40rem)";
var posterDetailsIdSeq = 0;
var _copyId, _imageId, _mediaQuery, _onViewportChange, _Poster_instances, isDetailsToggle_fn, isDetailsCollapsed_fn, _toggleDetails, renderTitle_fn, renderContent_fn, renderImage_fn, renderCover_fn, renderInline_fn;
var Poster = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _Poster_instances);
    this.background = "default";
    this.layout = "inline";
    this.imageSide = "left";
    this.imageAlign = "center";
    this.imagePadding = "none";
    this.minHeight = "100vh";
    this.details = false;
    this.open = false;
    this.narrow = false;
    this.titleSlot = new SlotController(this, "title");
    this.descriptionSlot = new SlotController(this, "description");
    this.actionsSlot = new SlotController(this, "actions");
    __privateAdd(this, _copyId, `duo-poster-copy-${posterDetailsIdSeq++}`);
    __privateAdd(this, _imageId, `duo-poster-image-${posterDetailsIdSeq++}`);
    __privateAdd(this, _mediaQuery);
    __privateAdd(this, _onViewportChange, (event) => {
      this.narrow = event.matches;
    });
    __privateAdd(this, _toggleDetails, () => {
      this.open = !this.open;
      this.dispatchEvent(new Event("toggle", { bubbles: true }));
    });
  }
  connectedCallback() {
    super.connectedCallback();
    if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
      return;
    }
    __privateSet(this, _mediaQuery, window.matchMedia(POSTER_DETAILS_QUERY));
    this.narrow = __privateGet(this, _mediaQuery).matches;
    __privateGet(this, _mediaQuery).addEventListener("change", __privateGet(this, _onViewportChange));
  }
  disconnectedCallback() {
    __privateGet(this, _mediaQuery)?.removeEventListener("change", __privateGet(this, _onViewportChange));
    super.disconnectedCallback();
  }
  render() {
    if (this.layout === "inline") {
      return __privateMethod(this, _Poster_instances, renderInline_fn).call(this);
    }
    return __privateMethod(this, _Poster_instances, renderCover_fn).call(this);
  }
};
_copyId = new WeakMap();
_imageId = new WeakMap();
_mediaQuery = new WeakMap();
_onViewportChange = new WeakMap();
_Poster_instances = new WeakSet();
isDetailsToggle_fn = function() {
  return this.details && this.narrow && this.titleSlot.hasContent;
};
isDetailsCollapsed_fn = function() {
  return __privateMethod(this, _Poster_instances, isDetailsToggle_fn).call(this) && !this.open;
};
_toggleDetails = new WeakMap();
renderTitle_fn = function(hasBody) {
  if (!this.titleSlot.hasContent) {
    return A;
  }
  if (!__privateMethod(this, _Poster_instances, isDetailsToggle_fn).call(this)) {
    return T`<slot name="title"></slot>`;
  }
  const controls = [hasBody ? __privateGet(this, _copyId) : "", __privateGet(this, _imageId)].filter(Boolean).join(" ");
  return T`
      <button
        type="button"
        class="summary"
        aria-expanded=${this.open ? "true" : "false"}
        aria-controls=${controls}
        @click=${__privateGet(this, _toggleDetails)}
      >
        <slot name="title"></slot>
        <span class="summary-icon" aria-hidden="true">
          <duo-icon name="info" size="xl"></duo-icon>
        </span>
      </button>
    `;
};
renderContent_fn = function(slotName) {
  const hideBody = __privateMethod(this, _Poster_instances, isDetailsCollapsed_fn).call(this);
  const hasBody = this.descriptionSlot.hasContent || this.actionsSlot.hasContent;
  return T`
      <div class="content" slot=${slotName || A}>
        ${__privateMethod(this, _Poster_instances, renderTitle_fn).call(this, hasBody)}
        ${hasBody ? T`
              <div class="details-panel" id=${__privateGet(this, _copyId)} ?hidden=${hideBody}>
                ${this.descriptionSlot.hasContent ? T`<slot name="description"></slot>` : A}
                ${this.actionsSlot.hasContent ? T`<slot name="actions"></slot>` : A}
              </div>
            ` : A}
      </div>
    `;
};
renderImage_fn = function(slotName) {
  return T`
      <div
        class="image details-panel"
        id=${__privateGet(this, _imageId)}
        slot=${slotName || A}
        ?hidden=${__privateMethod(this, _Poster_instances, isDetailsCollapsed_fn).call(this)}
      >
        <slot name="image"></slot>
      </div>
    `;
};
renderCover_fn = function() {
  return T`
      <duo-cover gap="none" min-height=${__privateMethod(this, _Poster_instances, isDetailsCollapsed_fn).call(this) ? "0" : this.minHeight}>
        ${__privateMethod(this, _Poster_instances, renderContent_fn).call(this, "top")}
        ${__privateMethod(this, _Poster_instances, renderImage_fn).call(this, "bottom")}
      </duo-cover>
    `;
};
renderInline_fn = function() {
  return T`
      <duo-sidebar .side=${this.imageSide} .spacing=${"none"}>
        ${__privateMethod(this, _Poster_instances, renderContent_fn).call(this)}
        ${__privateMethod(this, _Poster_instances, renderImage_fn).call(this, "sidebar")}
      </duo-sidebar>
    `;
};
Poster.styles = i`
    :host {
      display: block;
      background-color: var(--duo-color-surface-raised);
      --duo-poster-image-align: center;
      --duo-poster-image-padding: var(--duo-space-0);
      border-radius: var(--duo-border-radius-s);
    }

    :host([background="highlight"]) {
      background-color: var(--duo-color-background-feedback-highlight);
    }

    :host([image-align="start"]) {
      --duo-poster-image-align: flex-start;
    }

    :host([image-align="center"]) {
      --duo-poster-image-align: center;
    }

    :host([image-align="end"]) {
      --duo-poster-image-align: flex-end;
    }

    :host([image-padding="none"]) {
      --duo-poster-image-padding: var(--duo-space-0);
    }

    :host([image-padding="xxs"]) {
      --duo-poster-image-padding: var(--duo-space-xxs);
    }

    :host([image-padding="xs"]) {
      --duo-poster-image-padding: var(--duo-space-xs);
    }

    :host([image-padding="s"]) {
      --duo-poster-image-padding: var(--duo-space-s);
    }

    :host([image-padding="m"]) {
      --duo-poster-image-padding: var(--duo-space-m);
    }

    :host([image-padding="l"]) {
      --duo-poster-image-padding: var(--duo-space-l);
    }

    :host([image-padding="xl"]) {
      --duo-poster-image-padding: var(--duo-space-xl);
    }

    :host([image-padding="xxl"]) {
      --duo-poster-image-padding: var(--duo-space-xxl);
    }

    .content {
      display: flex;
      flex-direction: column;
      gap: var(--duo-space-s);
      padding: var(--duo-space-l);
    }

    ::slotted([slot="title"]) {
      margin: 0 !important;
      max-width: 100%;
      font: var(--duo-font-headline-3) !important;
      color: var(--duo-color-text) !important;
    }

    @media (max-width: 40rem) {
      ::slotted([slot="title"]) {
        font: var(--duo-font-l) !important;
      }
    }

    ::slotted([slot="description"]) {
      margin: 0;
      max-width: 100%;
      font-family: var(--duo-font-family-body);
      font-size: 1rem;
      font-style: normal;
      font-weight: var(--duo-font-weight-regular);
      line-height: 1.5rem;
      font-feature-settings: "liga" off, "clig" off;
    }

    .image {
      display: flex;
      box-sizing: border-box;
      width: 100%;
      padding: var(--duo-poster-image-padding);
      justify-content: var(--duo-poster-image-align);
      align-items: var(--duo-poster-image-align);
    }

    .content .details-panel {
      display: flex;
      flex-direction: column;
      gap: var(--duo-space-s);
    }

    .image[hidden],
    .details-panel[hidden] {
      display: none !important;
    }

    :host([layout="inline"]) .image {
      height: 100%;
      min-height: 100%;
    }

    :host([layout="cover"]) {
      display: flex;
      flex-direction: column;
      min-height: 0;
    }

    :host([layout="cover"]) duo-cover {
      flex: 1 1 auto;
      min-height: 0;
      width: 100%;
    }

    .image ::slotted(img) {
      max-width: 100%;
      height: auto;
      object-fit: contain;
    }

    :host([layout="inline"]) .image ::slotted(img) {
      max-height: 100%;
    }

    .summary {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: var(--duo-space-s);
      box-sizing: border-box;
      width: 100%;
      margin: 0;
      padding: 0;
      border: 0;
      background: transparent;
      color: inherit;
      font: inherit;
      text-align: start;
      cursor: pointer;
    }

    .summary:focus-visible {
      outline: 2px solid currentColor;
      outline-offset: 2px;
      border-radius: var(--duo-border-radius-s);
    }

    .summary ::slotted([slot="title"]) {
      text-decoration: underline !important;
      text-underline-offset: 0.15em;
    }

    .summary-icon {
      flex-shrink: 0;
      display: flex;
      color: inherit;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], Poster.prototype, "background", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Poster.prototype, "layout", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "image-side" })
], Poster.prototype, "imageSide", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "image-align" })
], Poster.prototype, "imageAlign", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "image-padding" })
], Poster.prototype, "imagePadding", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "min-height" })
], Poster.prototype, "minHeight", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Poster.prototype, "details", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Poster.prototype, "open", 2);
__decorateClass([
  r5()
], Poster.prototype, "narrow", 2);
Poster = __decorateClass([
  t3("duo-poster")
], Poster);

// src/components/price/price.ts
var Price = class extends i3 {
  constructor() {
    super(...arguments);
    this.amount = "";
    this.currency = "";
    this.emphasis = false;
    this.amountSlot = new SlotController(this);
    this.currencySlot = new SlotController(this, "currency");
  }
  render() {
    const showCurrency = this.currencySlot.hasContent || Boolean(this.currency);
    return T`
      <span class="price" part="price">
        <span class="amount" part="amount">
          <slot></slot>${this.amountSlot.hasContent ? A : T`${this.amount}`}
        </span>
        ${showCurrency ? T`<span class="currency" part="currency">
              <slot name="currency"></slot>${this.currencySlot.hasContent ? A : T`${this.currency}`}
            </span>` : A}
      </span>
    `;
  }
};
Price.styles = i`
    :host {
      display: inline-block;
      text-align: right;
    }

    .price {
      display: inline-flex;
      align-items: baseline;
      justify-content: flex-end;
      gap: var(--duo-space-xxs);
      max-width: 100%;
    }

    .currency {
      color: var(--duo-color-text-weakest);
      font: var(--duo-font-body);
    }

    .amount {
      color: var(--duo-color-text);
      font: var(--duo-font-lead);
    }

    :host([emphasis]) .amount {
      color: var(--duo-color-text-strong);
      font: var(--duo-font-headline-4);
      font-family: var(--duo-font-family-body);
      font-weight: 600; /* TODO: Add token */
    }
  `;
__decorateClass([
  n4({ type: String })
], Price.prototype, "amount", 2);
__decorateClass([
  n4({ type: String })
], Price.prototype, "currency", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Price.prototype, "emphasis", 2);
Price = __decorateClass([
  t3("duo-price")
], Price);

// src/components/card/card.ts
var cardTitleIdSeq = 0;
var _titleId2, _Card_instances, useAttributeBody_fn2, hasBody_fn, hasHeader_fn2, labelledBy_fn2, renderTitleElement_fn2, renderSubtitleElement_fn2, renderHeader_fn2, renderMedia_fn, renderBody_fn;
var Card = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _Card_instances);
    this.title = "";
    this.subtitle = "";
    this.text = "";
    this.imageSrc = "";
    this.imageAlt = "card image";
    this.titleTag = "h3";
    this.interactive = false;
    this.mediaSlot = new SlotController(this, "media");
    this.titleSlot = new SlotController(this, "title");
    this.subtitleSlot = new SlotController(this, "subtitle");
    this.headerSlot = new SlotController(this, "header");
    this.headerActionsSlot = new SlotController(this, "header-actions");
    this.defaultSlot = new SlotController(this);
    this.actionsSlot = new SlotController(this, "actions");
    __privateAdd(this, _titleId2, `duo-card-title-${cardTitleIdSeq++}`);
  }
  render() {
    const hasHeader = __privateMethod(this, _Card_instances, hasHeader_fn2).call(this);
    const labelledBy = __privateMethod(this, _Card_instances, labelledBy_fn2).call(this);
    return T`
      <article
        class="root"
        part="root"
        aria-labelledby=${o8(labelledBy)}
        aria-label=${o8(
      !labelledBy && this.accessibleLabel ? this.accessibleLabel : void 0
    )}
      >
        ${__privateMethod(this, _Card_instances, renderMedia_fn).call(this)}
        ${__privateMethod(this, _Card_instances, renderHeader_fn2).call(this)}
        ${__privateMethod(this, _Card_instances, renderBody_fn).call(this, hasHeader)}
      </article>
    `;
  }
};
_titleId2 = new WeakMap();
_Card_instances = new WeakSet();
useAttributeBody_fn2 = function() {
  return !this.defaultSlot.hasContent;
};
hasBody_fn = function() {
  if (this.defaultSlot.hasContent) return true;
  if (__privateMethod(this, _Card_instances, useAttributeBody_fn2).call(this) && this.text.trim()) return true;
  if (this.actionsSlot.hasContent) return true;
  return false;
};
hasHeader_fn2 = function() {
  return this.headerSlot.hasContent || this.titleSlot.hasContent || this.subtitleSlot.hasContent || Boolean(this.title.trim()) || Boolean(this.subtitle.trim()) || this.headerActionsSlot.hasContent;
};
labelledBy_fn2 = function() {
  if (this.headerSlot.hasContent || this.titleSlot.hasContent) return void 0;
  if (this.title.trim()) return __privateGet(this, _titleId2);
  return void 0;
};
renderTitleElement_fn2 = function() {
  if (this.titleSlot.hasContent) {
    return T`<div class="title" part="title">
        <slot name="title"></slot>
      </div>`;
  }
  if (!this.title.trim()) return A;
  const classes = { title: true };
  const id = __privateGet(this, _titleId2);
  const tag = this.titleTag;
  switch (tag) {
    case "h1":
      return T`<h1 id=${id} class=${e6(classes)}>${this.title}</h1>`;
    case "h2":
      return T`<h2 id=${id} class=${e6(classes)}>${this.title}</h2>`;
    case "h3":
      return T`<h3 id=${id} class=${e6(classes)}>${this.title}</h3>`;
    case "h4":
      return T`<h4 id=${id} class=${e6(classes)}>${this.title}</h4>`;
    case "h5":
      return T`<h5 id=${id} class=${e6(classes)}>${this.title}</h5>`;
    case "h6":
      return T`<h6 id=${id} class=${e6(classes)}>${this.title}</h6>`;
    case "p":
      return T`<p id=${id} class=${e6(classes)}>${this.title}</p>`;
    case "div":
    default:
      return T`<div id=${id} class=${e6(classes)} role="heading" aria-level="3">${this.title}</div>`;
  }
};
renderSubtitleElement_fn2 = function() {
  if (this.subtitleSlot.hasContent) {
    return T`<div class="subtitle" part="subtitle">
        <slot name="subtitle"></slot>
      </div>`;
  }
  if (!this.subtitle.trim()) return A;
  return T`<p class="subtitle" part="subtitle">${this.subtitle}</p>`;
};
renderHeader_fn2 = function() {
  if (this.headerSlot.hasContent) {
    return T`<slot name="header"></slot>`;
  }
  const title = __privateMethod(this, _Card_instances, renderTitleElement_fn2).call(this);
  const subtitle = __privateMethod(this, _Card_instances, renderSubtitleElement_fn2).call(this);
  if (!title && !subtitle && !this.headerActionsSlot.hasContent) {
    return A;
  }
  return T`
      <header class="header" part="header">
        <div class="header-text" part="header-text">
          ${title} ${subtitle}
        </div>
        ${this.headerActionsSlot.hasContent ? T`<div class="header-actions" part="header-actions">
              <slot name="header-actions"></slot>
            </div>` : A}
      </header>
    `;
};
renderMedia_fn = function() {
  const hasMedia = this.mediaSlot.hasContent || Boolean(this.imageSrc.trim());
  if (!hasMedia) return A;
  const showImage = !this.mediaSlot.hasContent && Boolean(this.imageSrc.trim());
  return T`
      <div class="media" part="media">
        ${showImage ? T`<img
              class="media-image"
              part="media-image"
              src=${this.imageSrc}
              alt=${this.imageAlt}
              decoding="async"
              loading="lazy"
            />` : A}
        <slot name="media"></slot>
      </div>
    `;
};
renderBody_fn = function(hasHeader) {
  if (!__privateMethod(this, _Card_instances, hasBody_fn).call(this)) return A;
  const useAttrBody = __privateMethod(this, _Card_instances, useAttributeBody_fn2).call(this);
  return T`
      <div class=${e6({ body: true, "has-header": hasHeader })} part="body">
        <slot></slot>
        ${useAttrBody && this.text.trim() ? T`<p class="body-text" part="text">${this.text}</p>` : A}
        ${this.actionsSlot.hasContent ? T`<div class="actions" part="actions">
              <slot name="actions"></slot>
            </div>` : A}
      </div>
    `;
};
Card.styles = i`
    :host {
      display: block;
      box-sizing: border-box;
      --duo-card-media-height: 13.125rem;
      --duo-card-shadow:
        0 0 2px 0 color-mix(in srgb, var(--duo-color-gray-1300) 4%, transparent),
        0 2px 2px 0 color-mix(in srgb, var(--duo-color-gray-1300) 4%, transparent);
      --duo-card-shadow-hover:
        0 1px 2px 0 color-mix(in srgb, var(--duo-color-gray-1300) 30%, transparent),
        0 2px 6px 0 color-mix(in srgb, var(--duo-color-gray-1300) 15%, transparent);
    }

    :host([hidden]) {
      display: none;
    }

    .root {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      overflow: hidden;
      border-radius: var(--duo-border-radius-m);
      background: var(--duo-color-surface-raised);
      color: var(--duo-color-text);
      transition: box-shadow 0.15s ease;
    }

    :host([interactive]) .root:hover,
    :host([interactive]) .root:focus-within {
      box-shadow: var(--duo-card-shadow-hover);
    }

    .media {
      display: block;
      flex-shrink: 0;
      overflow: hidden;
      line-height: 0;
    }

    .media-image {
      display: block;
      width: 100%;
      height: var(--duo-card-media-height);
      object-fit: cover;
    }

    .media ::slotted(*) {
      display: block;
      width: 100%;
      max-height: var(--duo-card-media-height);
      object-fit: cover;
    }

    .header {
      display: flex;
      align-items: flex-start;
      gap: var(--duo-space-m);
      box-sizing: border-box;
      padding: var(--duo-space-l);
    }

    .header-text {
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: 0;
    }

    .title {
      margin: 0;
      font: var(--duo-font-l);
      color: var(--duo-color-text);
    }

    .title ::slotted(*) {
      margin: 0;
      max-width: 100%;
    }

    .title ::slotted(h1),
    .title ::slotted(h2),
    .title ::slotted(h3),
    .title ::slotted(h4),
    .title ::slotted(h5),
    .title ::slotted(h6) {
      font: var(--duo-font-l);
      color: var(--duo-color-text);
    }

    .subtitle {
      margin: 0;
      font: var(--duo-font-body);
      color: var(--duo-color-text-weakest);
    }

    .subtitle ::slotted(*) {
      margin: 0;
      max-width: 100%;
    }

    .subtitle ::slotted(p) {
      font: var(--duo-font-body);
      color: var(--duo-color-text-weakest);
    }

    .header-actions {
      display: flex;
      flex-shrink: 0;
      align-items: flex-start;
    }

    .body {
      display: flex;
      flex-direction: column;
      gap: var(--duo-space-m);
      box-sizing: border-box;
      padding-inline: var(--duo-space-l);
      padding-bottom: var(--duo-space-l);
    }

    .body.has-header {
      padding-top: 0;
    }

    .body:not(.has-header) {
      padding-top: var(--duo-space-l);
    }

    .body-text {
      margin: 0;
      font: var(--duo-font-small);
      color: var(--duo-color-text);
    }

    .body ::slotted(*) {
      margin: 0;
      max-width: 100%;
    }

    .body ::slotted(p) {
      font: var(--duo-font-small);
      color: var(--duo-color-text);
    }

    .actions {
      display: flex;
      align-items: center;
      gap: var(--duo-space-s);
    }

    .actions ::slotted(*) {
      flex: 1 1 0;
      min-width: 0;
    }
  `;
__decorateClass([
  n4({ type: String })
], Card.prototype, "title", 2);
__decorateClass([
  n4({ type: String })
], Card.prototype, "subtitle", 2);
__decorateClass([
  n4({ type: String })
], Card.prototype, "text", 2);
__decorateClass([
  n4({ type: String, attribute: "image-src" })
], Card.prototype, "imageSrc", 2);
__decorateClass([
  n4({ type: String, attribute: "image-alt" })
], Card.prototype, "imageAlt", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "title-tag" })
], Card.prototype, "titleTag", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Card.prototype, "interactive", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-label" })
], Card.prototype, "accessibleLabel", 2);
Card = __decorateClass([
  t3("duo-card")
], Card);

// ../../node_modules/.pnpm/lit-html@3.3.2/node_modules/lit-html/node/directive-helpers.js
var { I: t5 } = Z;
var i6 = (o11) => o11;
var s4 = () => document.createComment("");
var v2 = (o11, n6, e8) => {
  const l3 = o11._$AA.parentNode, d3 = void 0 === n6 ? o11._$AB : n6._$AA;
  if (void 0 === e8) {
    const i7 = l3.insertBefore(s4(), d3), n7 = l3.insertBefore(s4(), d3);
    e8 = new t5(i7, n7, o11, o11.options);
  } else {
    const t7 = e8._$AB.nextSibling, n7 = e8._$AM, c5 = n7 !== o11;
    if (c5) {
      let t8;
      e8._$AQ?.(o11), e8._$AM = o11, void 0 !== e8._$AP && (t8 = o11._$AU) !== n7._$AU && e8._$AP(t8);
    }
    if (t7 !== d3 || c5) {
      let o12 = e8._$AA;
      for (; o12 !== t7; ) {
        const t8 = i6(o12).nextSibling;
        i6(l3).insertBefore(o12, d3), o12 = t8;
      }
    }
  }
  return e8;
};
var u3 = (o11, t7, i7 = o11) => (o11._$AI(t7, i7), o11);
var m3 = {};
var p3 = (o11, t7 = m3) => o11._$AH = t7;
var M2 = (o11) => o11._$AH;
var h3 = (o11) => {
  o11._$AR(), o11._$AA.remove();
};

// ../../node_modules/.pnpm/lit-html@3.3.2/node_modules/lit-html/node/directives/repeat.js
var u4 = (e8, s5, t7) => {
  const r6 = /* @__PURE__ */ new Map();
  for (let l3 = s5; l3 <= t7; l3++) r6.set(e8[l3], l3);
  return r6;
};
var c4 = e5(class extends i4 {
  constructor(e8) {
    if (super(e8), e8.type !== t4.CHILD) throw Error("repeat() can only be used in text expressions");
  }
  dt(e8, s5, t7) {
    let r6;
    void 0 === t7 ? t7 = s5 : void 0 !== s5 && (r6 = s5);
    const l3 = [], o11 = [];
    let i7 = 0;
    for (const s6 of e8) l3[i7] = r6 ? r6(s6, i7) : i7, o11[i7] = t7(s6, i7), i7++;
    return { values: o11, keys: l3 };
  }
  render(e8, s5, t7) {
    return this.dt(e8, s5, t7).values;
  }
  update(s5, [t7, r6, c5]) {
    const d3 = M2(s5), { values: p4, keys: a3 } = this.dt(t7, r6, c5);
    if (!Array.isArray(d3)) return this.ut = a3, p4;
    const h4 = this.ut ??= [], v3 = [];
    let m4, y3, x2 = 0, j2 = d3.length - 1, k2 = 0, w2 = p4.length - 1;
    for (; x2 <= j2 && k2 <= w2; ) if (null === d3[x2]) x2++;
    else if (null === d3[j2]) j2--;
    else if (h4[x2] === a3[k2]) v3[k2] = u3(d3[x2], p4[k2]), x2++, k2++;
    else if (h4[j2] === a3[w2]) v3[w2] = u3(d3[j2], p4[w2]), j2--, w2--;
    else if (h4[x2] === a3[w2]) v3[w2] = u3(d3[x2], p4[w2]), v2(s5, v3[w2 + 1], d3[x2]), x2++, w2--;
    else if (h4[j2] === a3[k2]) v3[k2] = u3(d3[j2], p4[k2]), v2(s5, d3[x2], d3[j2]), j2--, k2++;
    else if (void 0 === m4 && (m4 = u4(a3, k2, w2), y3 = u4(h4, x2, j2)), m4.has(h4[x2])) if (m4.has(h4[j2])) {
      const e8 = y3.get(a3[k2]), t8 = void 0 !== e8 ? d3[e8] : null;
      if (null === t8) {
        const e9 = v2(s5, d3[x2]);
        u3(e9, p4[k2]), v3[k2] = e9;
      } else v3[k2] = u3(t8, p4[k2]), v2(s5, d3[x2], t8), d3[e8] = null;
      k2++;
    } else h3(d3[j2]), j2--;
    else h3(d3[x2]), x2++;
    for (; k2 <= w2; ) {
      const e8 = v2(s5, v3[w2 + 1]);
      u3(e8, p4[k2]), v3[k2++] = e8;
    }
    for (; x2 <= j2; ) {
      const e8 = d3[x2++];
      null !== e8 && h3(e8);
    }
    return this.ut = a3, p3(s5, v3), E;
  }
});

// src/components/databox/databox.ts
var DATABOX_SLOTS = ["value", "label", "trend"];
var EMPTY_VALUE_MARK = "\u2013";
function isDataboxSlot(name) {
  return DATABOX_SLOTS.includes(name);
}
var _Databox_instances, slotName_fn, fallbackValue_fn, hasRegion_fn, orderedNames_fn, renderRegion_fn;
var Databox = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _Databox_instances);
    this.value = "";
    this.label = "";
    this.valueSlot = new SlotController(this, "value");
    this.labelSlot = new SlotController(this, "label");
    this.trendSlot = new SlotController(this, "trend");
  }
  render() {
    return T`
      <div class="root" part="root">
        ${c4(
      __privateMethod(this, _Databox_instances, orderedNames_fn).call(this),
      (name) => name,
      (name) => __privateMethod(this, _Databox_instances, renderRegion_fn).call(this, name)
    )}
      </div>
    `;
  }
};
_Databox_instances = new WeakSet();
slotName_fn = function(element) {
  return (element.slot || element.getAttribute("slot") || "").trim();
};
fallbackValue_fn = function() {
  return this.value.trim() || EMPTY_VALUE_MARK;
};
hasRegion_fn = function(name) {
  switch (name) {
    case "value":
      return true;
    case "label":
      return this.labelSlot.hasContent || Boolean(this.label.trim());
    case "trend":
      return this.trendSlot.hasContent;
  }
};
orderedNames_fn = function() {
  const order = [];
  const seen = /* @__PURE__ */ new Set();
  for (const child of this.children) {
    const name = __privateMethod(this, _Databox_instances, slotName_fn).call(this, child);
    if (!isDataboxSlot(name) || seen.has(name) || !__privateMethod(this, _Databox_instances, hasRegion_fn).call(this, name)) continue;
    seen.add(name);
    order.push(name);
  }
  for (const name of DATABOX_SLOTS) {
    if (seen.has(name) || !__privateMethod(this, _Databox_instances, hasRegion_fn).call(this, name)) continue;
    order.push(name);
  }
  return order;
};
renderRegion_fn = function(name) {
  switch (name) {
    case "value":
      return T`<div class="value" part="value">
          <slot name="value"></slot>${this.valueSlot.hasContent ? A : __privateMethod(this, _Databox_instances, fallbackValue_fn).call(this)}
        </div>`;
    case "label":
      return T`<div class="label" part="label">
          <slot name="label"></slot>${this.labelSlot.hasContent ? A : this.label}
        </div>`;
    case "trend":
      return T`<div class="trend" part="trend">
          <slot name="trend"></slot>
        </div>`;
  }
};
Databox.styles = i`
    :host {
      display: block;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .root {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: center;
      box-sizing: border-box;
      width: 100%;
      min-width: 0;
      overflow: hidden;
      gap: 0;
      padding: var(--duo-space-l);
      border-radius: var(--duo-border-radius-m);
      background: var(--duo-color-surface-raised);
      color: var(--duo-color-text);
    }

    .value,
    .label {
      margin: 0;
      max-width: 100%;
    }

    .value {
      font: var(--duo-font-xl);
      color: var(--duo-color-text);
    }

    .label {
      font: var(--duo-font-m);
      color: var(--duo-color-text-weakest);
    }

    .value ::slotted(*),
    .label ::slotted(*) {
      margin: 0;
      max-width: 100%;
      font: inherit;
      color: inherit;
    }

    .trend {
      display: flex;
      flex-shrink: 0;
      align-items: center;
      max-width: 100%;
    }

    .trend:not(:first-child) {
      margin-block-start: var(--duo-space-xxs);
    }

    .trend ::slotted(*) {
      max-width: 100%;
    }
  `;
__decorateClass([
  n4({ type: String })
], Databox.prototype, "value", 2);
__decorateClass([
  n4({ type: String })
], Databox.prototype, "label", 2);
Databox = __decorateClass([
  t3("duo-databox")
], Databox);

// src/components/list/list-item.ts
var _ListItem_instances, hasTitle_fn, hasSubtitle_fn, hasDescription_fn, hasPrefix_fn, hasTrailing_fn, _onSlotChange;
var ListItem = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ListItem_instances);
    this.itemsAlign = "center";
    this.size = "default";
    this.divided = false;
    this.selected = false;
    this.prefixSlot = new SlotController(this, "prefix");
    this.titleSlot = new SlotController(this, "title");
    this.subtitleSlot = new SlotController(this, "subtitle");
    this.descriptionSlot = new SlotController(this, "description");
    this.trailingSlot = new SlotController(this, "trailing");
    __privateAdd(this, _onSlotChange, () => {
      this.requestUpdate();
    });
  }
  connectedCallback() {
    super.connectedCallback();
    if (!this.hasAttribute("role")) {
      this.setAttribute("role", "listitem");
    }
  }
  render() {
    const hasTitle = __privateMethod(this, _ListItem_instances, hasTitle_fn).call(this);
    const hasSubtitle = __privateMethod(this, _ListItem_instances, hasSubtitle_fn).call(this);
    const hasDescription = __privateMethod(this, _ListItem_instances, hasDescription_fn).call(this);
    const hasPrefix = __privateMethod(this, _ListItem_instances, hasPrefix_fn).call(this);
    const hasTrailing = __privateMethod(this, _ListItem_instances, hasTrailing_fn).call(this);
    const hasCopy = hasTitle || hasSubtitle || hasDescription;
    const hasLead = hasPrefix || hasCopy;
    if (!hasLead && !hasTrailing) {
      return A;
    }
    return T`
      <div class=${e6({ row: true, "has-description": hasDescription })} part="row">
        <div
          class=${e6({ lead: true, "has-description": hasDescription })}
          part="lead"
          ?hidden=${!hasLead}
        >
          <span class="prefix" part="prefix" ?hidden=${!hasPrefix}>
            <slot name="prefix" @slotchange=${__privateGet(this, _onSlotChange)}></slot>
          </span>
          <div class="copy" part="copy" ?hidden=${!hasCopy}>
            <div class="title" part="title" ?hidden=${!hasTitle}>
              <slot name="title" @slotchange=${__privateGet(this, _onSlotChange)}></slot>
            </div>
            <div class="subtitle" part="subtitle" ?hidden=${!hasSubtitle}>
              <slot name="subtitle" @slotchange=${__privateGet(this, _onSlotChange)}></slot>
            </div>
            <div class="description" part="description" ?hidden=${!hasDescription}>
              <slot name="description" @slotchange=${__privateGet(this, _onSlotChange)}></slot>
            </div>
          </div>
        </div>
        <span class="trailing" part="trailing" ?hidden=${!hasTrailing}>
          <slot name="trailing" @slotchange=${__privateGet(this, _onSlotChange)}></slot>
        </span>
      </div>
    `;
  }
};
_ListItem_instances = new WeakSet();
hasTitle_fn = function() {
  return this.titleSlot.hasContent;
};
hasSubtitle_fn = function() {
  return this.subtitleSlot.hasContent;
};
hasDescription_fn = function() {
  return this.descriptionSlot.hasContent;
};
hasPrefix_fn = function() {
  return this.prefixSlot.hasContent;
};
hasTrailing_fn = function() {
  return this.trailingSlot.hasContent;
};
_onSlotChange = new WeakMap();
ListItem.styles = i`
    :host {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: var(--duo-space-xs);
      box-sizing: border-box;
      width: 100%;
      margin: 0;
      padding: var(--duo-space-s) 0;
      text-align: start;
    }

    .row.has-description {
      align-items: flex-start;
    }

    :host([items-align="start"]) .row {
      align-items: flex-start;
    }

    :host([items-align="end"]) .row {
      align-items: flex-end;
    }

    :host([size="compact"]) .row {
      gap: var(--duo-space-s);
      padding: var(--duo-space-xs) 0;
    }

    :host([divided]) .row {
      border-block-start: 1px solid var(--duo-color-border);
    }

    :host([selected]) .row {
      background: color-mix(
        in srgb,
        var(--duo-color-background-feedback-highlight) 20%,
        transparent
      );
    }

    .lead {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      gap: var(--duo-space-s);
      min-width: 0;
    }

    .lead.has-description {
      align-items: flex-start;
    }

    :host([items-align="start"]) .lead {
      align-items: flex-start;
    }

    :host([items-align="end"]) .lead {
      align-items: flex-end;
    }

    :host([size="compact"]) .lead {
      gap: var(--duo-space-s);
    }

    .prefix {
      flex: 0 0 calc(var(--duo-space-m) + var(--duo-space-xxs));
      display: flex;
      align-items: center;
      justify-content: center;
      color: var(--duo-color-text);
    }

    .lead.has-description .prefix {
      align-items: flex-start;
    }

    :host([size="compact"]) .prefix {
      flex-basis: auto;
      min-inline-size: calc(var(--duo-space-m) + var(--duo-space-xxs));
      justify-content: flex-start;
    }

    .prefix[hidden],
    .title[hidden],
    .subtitle[hidden],
    .description[hidden],
    .trailing[hidden],
    .copy[hidden],
    .lead[hidden] {
      display: none;
    }

    .prefix ::slotted(*) {
      margin: 0;
    }

    .prefix ::slotted(duo-field) {
      display: flex;
      align-items: center;
    }

    .copy {
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: var(--duo-space-xxs);
      text-align: start;
      overflow-wrap: break-word;
    }

    .title ::slotted(*) {
      margin: 0 !important;
      padding: 0 !important;
      font: var(--duo-font-body) !important;
      color: var(--duo-color-text) !important;
      text-align: start !important;
    }

    :host([size="compact"]) .title ::slotted(*) {
      font: var(--duo-font-small) !important;
    }

    .title ::slotted(strong) {
      font-weight: var(--duo-font-weight-bold) !important;
    }

    .subtitle ::slotted(*) {
      margin: 0 !important;
      padding: 0 !important;
      font: var(--duo-font-body) !important;
      color: var(--duo-color-text-weakest) !important;
      text-align: start !important;
    }

    :host([size="compact"]) .subtitle ::slotted(*) {
      font: var(--duo-font-tiny) !important;
      color: var(--duo-color-text-weak) !important;
    }

    .description ::slotted(*) {
      margin: 0 !important;
      padding: 0 !important;
      font: var(--duo-font-small) !important;
      color: var(--duo-color-text-weak) !important;
      text-align: start !important;
    }

    .trailing {
      flex: 0 0 auto;
      align-self: center;
    }

    :host([items-align="start"]) .trailing {
      align-self: center;
    }

    .trailing ::slotted(*) {
      margin: 0;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true, attribute: "items-align" })
], ListItem.prototype, "itemsAlign", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], ListItem.prototype, "size", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], ListItem.prototype, "divided", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], ListItem.prototype, "selected", 2);
ListItem = __decorateClass([
  t3("duo-list-item")
], ListItem);

// src/components/list/list-section.ts
var listSectionHeaderIdSeq = 0;
var _headerId, _ListSection_instances, hasHeader_fn3, renderHeader_fn3, labelledBy_fn3;
var ListSection = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _ListSection_instances);
    this.header = "";
    this.headerSlot = new SlotController(this, "header");
    __privateAdd(this, _headerId, `duo-list-section-header-${listSectionHeaderIdSeq++}`);
  }
  render() {
    return T`
      <div class="section" part="section">
        ${__privateMethod(this, _ListSection_instances, renderHeader_fn3).call(this)}
        <div
          class="items"
          part="items"
          role="list"
          aria-labelledby=${o8(__privateMethod(this, _ListSection_instances, labelledBy_fn3).call(this))}
        >
          <slot></slot>
        </div>
      </div>
    `;
  }
};
_headerId = new WeakMap();
_ListSection_instances = new WeakSet();
hasHeader_fn3 = function() {
  return this.headerSlot.hasContent || Boolean(this.header.trim());
};
renderHeader_fn3 = function() {
  if (!__privateMethod(this, _ListSection_instances, hasHeader_fn3).call(this)) return A;
  const label = this.headerSlot.hasContent ? T`<div id=${__privateGet(this, _headerId)} class="label" part="header-label">
          <slot name="header"></slot>
        </div>` : T`<p id=${__privateGet(this, _headerId)} class="label" part="header-label">${this.header}</p>`;
  return T`
      <div class="split-header" part="header" role="presentation">
        <span class="line" part="line" aria-hidden="true"></span>
        ${label}
        <span class="line" part="line" aria-hidden="true"></span>
      </div>
    `;
};
labelledBy_fn3 = function() {
  if (__privateMethod(this, _ListSection_instances, hasHeader_fn3).call(this) && !this.headerSlot.hasContent) {
    return __privateGet(this, _headerId);
  }
  return void 0;
};
ListSection.styles = i`
    :host {
      display: block;
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .section {
      display: flex;
      flex-direction: column;
      gap: var(--duo-space-m);
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }

    .split-header {
      display: flex;
      align-items: center;
      gap: var(--duo-space-m);
      width: 100%;
      min-width: 0;
      margin: 0;
    }

    .line {
      flex: 1 1 auto;
      min-width: 0;
      height: 0;
      margin: 0;
      border: 0;
      border-top: 1px solid var(--duo-color-border);
    }

    .label {
      flex: 0 1 auto;
      max-width: 100%;
      margin: 0;
      overflow-wrap: break-word;
      text-align: center;
      font: var(--duo-font-form);
      font-weight: var(--duo-font-weight-regular);
      color: var(--duo-color-text-weakest);
    }

    .label ::slotted(*) {
      margin: 0;
      overflow-wrap: break-word;
    }

    .items {
      display: flex;
      flex-direction: column;
      width: 100%;
      min-width: 0;
      margin: 0;
      padding: 0;
    }
  `;
__decorateClass([
  n4({ type: String })
], ListSection.prototype, "header", 2);
ListSection = __decorateClass([
  t3("duo-list-section")
], ListSection);

// src/components/list/list.ts
var listTitleIdSeq = 0;
var _titleId3, _List_instances, hasTitle_fn2, hasSections_fn, titleInside_fn, label_fn, labelledBy_fn4, renderTitle_fn2;
var List = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _List_instances);
    this.title = "";
    this.titleSize = "large";
    this.titlePlacement = "outside";
    this.wrapper = "default";
    this.ariaLabel = "";
    this.ariaLabelledby = "";
    this.titleSlot = new SlotController(this, "title");
    __privateAdd(this, _titleId3, `duo-list-title-${listTitleIdSeq++}`);
  }
  render() {
    const hasTitle = __privateMethod(this, _List_instances, hasTitle_fn2).call(this);
    const titleInside = __privateMethod(this, _List_instances, titleInside_fn).call(this);
    const hasSections = __privateMethod(this, _List_instances, hasSections_fn).call(this);
    const title = hasTitle ? __privateMethod(this, _List_instances, renderTitle_fn2).call(this) : A;
    return T`
      <div
        class=${e6({
      root: true,
      "has-outside-title": hasTitle && !titleInside
    })}
        part="root"
      >
        ${hasTitle && !titleInside ? title : A}
        <div
          class=${e6({
      wrapper: true,
      "has-inside-title": hasTitle && titleInside,
      "has-sections": hasSections
    })}
          part="wrapper"
        >
          ${hasTitle && titleInside ? title : A}
          <div
            part="list"
            class=${e6({ list: true, "has-sections": hasSections })}
            role=${o8(hasSections ? void 0 : "list")}
            aria-label=${o8(hasSections ? void 0 : __privateMethod(this, _List_instances, label_fn).call(this))}
            aria-labelledby=${o8(hasSections ? void 0 : __privateMethod(this, _List_instances, labelledBy_fn4).call(this))}
          >
            <slot @slotchange=${() => this.requestUpdate()}></slot>
          </div>
        </div>
      </div>
    `;
  }
};
_titleId3 = new WeakMap();
_List_instances = new WeakSet();
hasTitle_fn2 = function() {
  return this.titleSlot.hasContent || Boolean(this.title.trim());
};
hasSections_fn = function() {
  for (const child of this.children) {
    if (child.tagName.toLowerCase() === "duo-list-section") {
      return true;
    }
  }
  return false;
};
titleInside_fn = function() {
  return this.titlePlacement === "inside";
};
label_fn = function() {
  return this.ariaLabel.trim() || void 0;
};
labelledBy_fn4 = function() {
  if (this.ariaLabelledby.trim()) {
    return this.ariaLabelledby.trim();
  }
  if (__privateMethod(this, _List_instances, hasTitle_fn2).call(this) && !this.titleSlot.hasContent) {
    return __privateGet(this, _titleId3);
  }
  return void 0;
};
renderTitle_fn2 = function() {
  if (this.titleSlot.hasContent) {
    return T`<div class="title" part="title">
        <slot name="title"></slot>
      </div>`;
  }
  if (!this.title.trim()) return A;
  return T`<h3 id=${__privateGet(this, _titleId3)} class="title" part="title">${this.title}</h3>`;
};
List.styles = i`
    :host {
      display: block;
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .root {
      display: flex;
      flex-direction: column;
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }

    .root.has-outside-title {
      gap: var(--duo-space-m);
    }

    .title {
      margin: 0;
      max-width: 100%;
      min-width: 0;
      overflow-wrap: break-word;
      font: var(--duo-font-xl);
      color: var(--duo-color-text);
    }

    :host([title-size="small"]) .title {
      font: var(--duo-font-l);
    }

    .title ::slotted(*) {
      margin: 0;
      max-width: 100%;
      overflow-wrap: break-word;
    }

    .wrapper {
      display: flex;
      flex-direction: column;
      width: 100%;
      min-width: 0;
      box-sizing: border-box;
    }

    .wrapper.has-inside-title {
      gap: var(--duo-space-m);
    }

    .wrapper.has-inside-title.has-sections {
      gap: var(--duo-space-m);
    }

    :host([wrapper="raised"]) .wrapper,
    :host([wrapper="card"]) .wrapper {
      padding: var(--duo-space-l);
      border-radius: var(--duo-border-radius-m);
      overflow: hidden;
    }

    :host([wrapper="raised"]) .wrapper {
      background: var(--duo-color-surface-raised);
    }

    :host([wrapper="card"]) .wrapper {
      border: 1px solid var(--duo-color-border);
      background: var(--duo-color-background);
    }

    .list {
      display: flex;
      flex-direction: column;
      width: 100%;
      min-width: 0;
      margin: 0;
      padding: 0;
    }
  `;
__decorateClass([
  n4({ type: String })
], List.prototype, "title", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "title-size" })
], List.prototype, "titleSize", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "title-placement" })
], List.prototype, "titlePlacement", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], List.prototype, "wrapper", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-label", reflect: true })
], List.prototype, "ariaLabel", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-labelledby", reflect: true })
], List.prototype, "ariaLabelledby", 2);
List = __decorateClass([
  t3("duo-list")
], List);

// src/components/list-group/list-group-item.ts
var ListGroupItem = class extends i3 {
  constructor() {
    super(...arguments);
    this.role = "listitem";
    this.href = "";
    this.target = "";
    this.rel = "";
    this.disabled = false;
    this._onSlotChange = () => {
      this.requestUpdate();
    };
    this._onLinkClick = (e8) => {
      if (this.disabled) {
        e8.preventDefault();
      }
    };
  }
  _hasSlot(name) {
    for (const node of this.children) {
      if (!(node instanceof Element)) continue;
      if (node.getAttribute("slot") === name) return true;
    }
    return false;
  }
  get _structured() {
    return this._hasSlot("prefix") || this._hasSlot("title") || this._hasSlot("subtitle") || this._hasSlot("description");
  }
  get _isLink() {
    return Boolean(this.href?.trim());
  }
  _linkRel() {
    const user = this.rel?.trim();
    if (this.target === "_blank") {
      const parts = /* @__PURE__ */ new Set();
      if (user) {
        for (const p4 of user.split(/\s+/)) {
          if (p4) parts.add(p4);
        }
      }
      parts.add("noopener");
      parts.add("noreferrer");
      return Array.from(parts).join(" ");
    }
    return user || A;
  }
  _renderTrail() {
    return T`
      <span class="trail" part="trail">
        <slot name="icon" @slotchange=${this._onSlotChange}>
          ${this.icon ? T`<duo-icon name=${this.icon} size="m"></duo-icon>` : A}
        </slot>
      </span>
    `;
  }
  _renderMain() {
    if (this._structured) {
      const hasPrefix = this._hasSlot("prefix");
      const hasTitle = this._hasSlot("title");
      const hasSubtitle = this._hasSlot("subtitle");
      const hasDescription = this._hasSlot("description");
      return T`
        <div class="main structured" part="main">
          <div class="block-top" part="block-top">
            ${hasPrefix ? T`<span class="prefix" part="prefix"
                  ><slot name="prefix" @slotchange=${this._onSlotChange}></slot
                ></span>` : A}
            <div class="copy">
              ${hasTitle ? T`<div class="title" part="title">
                    <slot name="title" @slotchange=${this._onSlotChange}></slot>
                  </div>` : A}
              ${hasSubtitle ? T`<div class="subtitle" part="subtitle">
                    <slot name="subtitle" @slotchange=${this._onSlotChange}></slot>
                  </div>` : A}
            </div>
          </div>
          ${hasDescription ? T`<div class="description" part="description">
                <slot name="description" @slotchange=${this._onSlotChange}></slot>
              </div>` : A}
        </div>
      `;
    }
    return T`
      <div class="main simple" part="main">
        <slot @slotchange=${this._onSlotChange}></slot>
      </div>
    `;
  }
  render() {
    const trail = this._renderTrail();
    const main = this._renderMain();
    if (this._isLink) {
      return T`
        <a
          class="panel"
          part="panel"
          href=${this.disabled ? A : this.href}
          target=${this.target?.trim() ? this.target : A}
          rel=${this._linkRel()}
          aria-disabled=${this.disabled ? "true" : A}
          tabindex=${this.disabled ? -1 : A}
          @click=${this._onLinkClick}
        >
          ${main} ${trail}
        </a>
      `;
    }
    return T`<div class="panel" part="panel">${main} ${trail}</div>`;
  }
};
ListGroupItem.styles = i`
    :host {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .panel {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 8px;
      box-sizing: border-box;
      width: 100%;
      margin: 0;
      padding: var(--duo-space-s) var(--duo-space-m);
      font: var(--duo-font-body);
      color: var(--duo-color-text);
      text-decoration: none;
      background-color: var(--duo-color-background);
      border: none;
      cursor: default;
      text-align: start;
      transition:
        background-color 0.15s ease
    }
    
    .main {
      flex: 1 1 auto;
      min-width: 0;
    }

    .main.simple {
      min-width: 0;
    }

    .structured {
      display: flex;
      flex-direction: column;
      gap: var(--duo-space-s);
    }

    .block-top {
      display: flex;
      align-items: flex-start;
      gap: var(--duo-space-s);
    }

    .prefix {
      flex-shrink: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .prefix ::slotted(*) {
      margin: 0;
    }

    .copy {
      flex: 1 1 auto;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: var(--duo-space-xxs);
    }

    .title ::slotted(*) {
      margin: 0 !important;
      padding: 0 !important;
      font: var(--duo-font-body) !important;
      color: var(--duo-color-text) !important;
      line-height: 1.25rem !important;
    }

    .subtitle ::slotted(*) {
      margin: 0 !important;
      padding: 0 !important;
      font: var(--duo-font-small) !important;
      color: var(--duo-color-text-weakest) !important;
      line-height: 1rem !important;
    }

    .description ::slotted(*) {
      margin: 0 !important;
      padding: 0 !important;
      font: var(--duo-font-tiny) !important;
      font-weight: var(--duo-font-weight-regular) !important;
      color: var(--duo-color-text-weak) !important;
      line-height: 1rem !important;
    }

    .description ::slotted(p) {
      margin: 0 !important;
    }

    ::slotted(*) {
      margin: 0;
    }

    .trail {
      display: inline-flex;
      flex-shrink: 0;
      align-items: center;
      align-self: center;
      color: var(--duo-color-text-weakest);
    }

    a.panel:hover:not([aria-disabled="true"]) {
      filter: brightness(97%);
      cursor: pointer;
    }

    a.panel:hover:not([aria-disabled="true"]) .trail {
      color: var(--duo-color-text);
    }

    a.panel:focus-visible {
      outline: 2px solid var(--duo-color-accent);
      outline-offset: -2px;
      position: relative;
      z-index: 1;
    }

    a.panel:focus-visible .trail {
      color: var(--duo-color-text);
    }

    a.panel[aria-disabled="true"] {
      opacity: 0.55;
      cursor: not-allowed;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], ListGroupItem.prototype, "role", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], ListGroupItem.prototype, "href", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], ListGroupItem.prototype, "target", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], ListGroupItem.prototype, "rel", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], ListGroupItem.prototype, "icon", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], ListGroupItem.prototype, "disabled", 2);
ListGroupItem = __decorateClass([
  t3("duo-list-group-item")
], ListGroupItem);

// src/components/list-group/list-group.ts
var ListGroup = class extends i3 {
  constructor() {
    super(...arguments);
    this.horizontal = false;
    this.flush = false;
    this.ariaLabel = "";
  }
  render() {
    return T`
      <div
        class="root"
        part="root"
        role="list"
        aria-label=${this.ariaLabel?.trim() ? this.ariaLabel : A}
      >
        <slot></slot>
      </div>
    `;
  }
};
ListGroup.styles = i`
    :host {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .root {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      border: 1px solid var(--duo-color-border);
      background-color: var(--duo-color-surface);
      overflow: hidden;
    }

    :host(:not([flush])) .root {
      border-radius: var(--duo-border-radius-s);
    }

    :host([horizontal]) .root {
      flex-direction: row;
      align-items: stretch;
    }

    :host([horizontal]) ::slotted(duo-list-group-item) {
      flex: 1 1 0;
      min-inline-size: 0;
    }

    ::slotted(duo-list-group-item:not(:last-of-type)) {
      border-bottom: 1px solid var(--duo-color-border);
    }

    :host([horizontal]) ::slotted(duo-list-group-item:not(:last-of-type)) {
      border-bottom: none;
      border-right: 1px solid var(--duo-color-border);
    }
  `;
__decorateClass([
  n4({ type: Boolean, reflect: true })
], ListGroup.prototype, "horizontal", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], ListGroup.prototype, "flush", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "aria-label" })
], ListGroup.prototype, "ariaLabel", 2);
ListGroup = __decorateClass([
  t3("duo-list-group")
], ListGroup);

// src/components/description-list/description-list-item.ts
var _DescriptionListItem_instances, hasTerm_fn, hasValue_fn, renderTerm_fn, renderValue_fn;
var DescriptionListItem = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _DescriptionListItem_instances);
    this.term = "";
    this.value = "";
    this.termSlot = new SlotController(this, "term");
    this.valueSlot = new SlotController(this, "value");
  }
  connectedCallback() {
    super.connectedCallback();
    if (!this.hasAttribute("role")) {
      this.setAttribute("role", "listitem");
    }
  }
  render() {
    const hasTerm = __privateMethod(this, _DescriptionListItem_instances, hasTerm_fn).call(this);
    const hasValue = __privateMethod(this, _DescriptionListItem_instances, hasValue_fn).call(this);
    if (!hasTerm && !hasValue) {
      return A;
    }
    return T`
      <div class="row" part="row">
        ${__privateMethod(this, _DescriptionListItem_instances, renderTerm_fn).call(this)} ${__privateMethod(this, _DescriptionListItem_instances, renderValue_fn).call(this)}
      </div>
    `;
  }
};
_DescriptionListItem_instances = new WeakSet();
hasTerm_fn = function() {
  return this.termSlot.hasContent || Boolean(this.term.trim());
};
hasValue_fn = function() {
  return this.valueSlot.hasContent || Boolean(this.value.trim());
};
renderTerm_fn = function() {
  if (this.termSlot.hasContent) {
    return T`<div class="term" part="term" role="term">
        <slot name="term"></slot>
      </div>`;
  }
  if (!this.term.trim()) return A;
  return T`<div class="term" part="term" role="term">${this.term}</div>`;
};
renderValue_fn = function() {
  if (this.valueSlot.hasContent) {
    return T`<div class="value" part="value" role="definition">
        <slot name="value"></slot>
      </div>`;
  }
  if (!this.value.trim()) return A;
  return T`<div class="value" part="value" role="definition">${this.value}</div>`;
};
DescriptionListItem.styles = i`
    :host {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .row {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      gap: var(--duo-space-m);
      box-sizing: border-box;
      font: var(--duo-font-body);
      color: var(--duo-color-text);
    }

    .term,
    .value {
      margin: 0;
    }

    .term {
      flex: 1 1 auto;
      min-width: 0;
      color: var(--duo-color-text-weaker);
    }

    .value {
      flex: 0 0 auto;
      text-align: end;
    }

    .value ::slotted(*) {
      margin: 0;
    }
  `;
__decorateClass([
  n4({ type: String })
], DescriptionListItem.prototype, "term", 2);
__decorateClass([
  n4({ type: String })
], DescriptionListItem.prototype, "value", 2);
DescriptionListItem = __decorateClass([
  t3("duo-description-list-item")
], DescriptionListItem);

// src/components/description-list/description-list.ts
var _DescriptionList_instances, label_fn2;
var DescriptionList = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _DescriptionList_instances);
    this.ariaLabel = "";
  }
  render() {
    return T`
      <div part="list" class="list" role="list" aria-label=${o8(__privateMethod(this, _DescriptionList_instances, label_fn2).call(this))}>
        <slot></slot>
      </div>
    `;
  }
};
_DescriptionList_instances = new WeakSet();
label_fn2 = function() {
  return this.ariaLabel.trim() || void 0;
};
DescriptionList.styles = i`
    :host {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .list {
      display: flex;
      flex-direction: column;
      gap: var(--duo-space-m);
      margin: 0;
      padding: 0;
    }
  `;
__decorateClass([
  n4({ type: String, attribute: "aria-label", reflect: true })
], DescriptionList.prototype, "ariaLabel", 2);
DescriptionList = __decorateClass([
  t3("duo-description-list")
], DescriptionList);

// src/components/table/table.ts
function isDocument(node) {
  return node.nodeType === Node.DOCUMENT_NODE;
}
var _Table_instances, renderStyles_fn;
var Table = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _Table_instances);
  }
  connectedCallback() {
    super.connectedCallback();
    __privateMethod(this, _Table_instances, renderStyles_fn).call(this);
  }
  createRenderRoot() {
    return this;
  }
  render() {
    return T`<slot></slot>`;
  }
};
_Table_instances = new WeakSet();
renderStyles_fn = function() {
  const rootNode = this.getRootNode();
  const renderTarget = isDocument(rootNode) ? rootNode.head : rootNode;
  const tagName = this.localName;
  if (rootNode.querySelector(`style[data-component=${tagName}]`)) {
    return;
  }
  const fragment = document.createDocumentFragment();
  B(
    T`
        <style data-component=${tagName}>
          ${Table.styles}
        </style>
      `,
    fragment
  );
  renderTarget.appendChild(fragment);
};
Table.styles = i`
    duo-table {
      display: block;
      width: 100%;
      overflow: auto;
    }

    duo-table table {
      width: 100%;
      border-collapse: separate;
      border: 1px solid var(--duo-color-border);
      font: inherit;
      color: var(--duo-color-text);
      background: var(--duo-color-background);
      border-radius: var(--duo-border-radius-s);
      border-spacing: 0;
    }

    duo-table th,
    duo-table td {
      padding: var(--duo-space-xs) var(--duo-space-s);
      color: var(--duo-color-text);
      font: var(--duo-font-small);
      text-align: left;
      line-height: inherit;
      border-bottom: 1px solid var(--duo-color-border);
    }

    duo-table th[align="center"],
    duo-table td[align="center"] {
      text-align: center;
    }

    duo-table th[align="right"],
    duo-table td[align="right"] {
      text-align: right;
    }

    duo-table th[align="left"],
    duo-table td[align="left"] {
      text-align: left;
    }

    duo-table thead th {
      color: var(--duo-color-text-weakest);
      font-weight: 500;
      background: var(--duo-color-surface-raised);
    }

    duo-table thead tr:first-child th:first-child,
    duo-table tbody tr:first-child td:first-child {
      border-top-left-radius: var(--duo-border-radius-s);
    }

    duo-table thead tr:first-child th:last-child,
    duo-table tbody tr:first-child td:last-child {
      border-top-right-radius: var(--duo-border-radius-s);
    }

    duo-table:has(table caption) table {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }

    duo-table:has(table caption) thead tr:first-child th:first-child,
    duo-table:has(table caption) tbody tr:first-child td:first-child {
      border-top-left-radius: 0;
    }

    duo-table:has(table caption) thead tr:first-child th:last-child,
    duo-table:has(table caption) tbody tr:first-child td:last-child {
      border-top-right-radius: 0;
    }

    duo-table tbody:last-child tr:last-child td {
      border-bottom: none;
    }

    duo-table tfoot tr:last-child td {
      border-bottom: none;
    }

    duo-table tbody tr:focus-within {
      background: var(--duo-color-surface);
      outline: 2px solid var(--duo-color-border);
      outline-offset: -2px;
    }

    duo-table td:has(duo-button) {
      padding: var(--duo-space-xxs) var(--duo-space-m);
    }

    duo-table table caption {
      color: var(--duo-color-text);
      font: var(--duo-font-m);
      font-weight: 600;
      text-align: left;
      padding: var(--duo-space-xs) var(--duo-space-s);
      
      border-radius: var(--duo-border-radius-s);
      border-top: 1px solid var(--duo-color-border);
      border-left: 1px solid var(--duo-color-border);
      border-right: 1px solid var(--duo-color-border);
      border-bottom-right-radius: 0;
      border-bottom-left-radius: 0;
    }

    duo-table table caption + thead tr:first-child th,
    duo-table table caption + thead tr:first-child td,
    duo-table table colgroup + thead tr:first-child th,
    duo-table table colgroup + thead tr:first-child td,
    duo-table table thead:first-child tr:first-child th,
    duo-table table thead:first-child tr:first-child td {
      border-top: 0;
    }
  `;
Table = __decorateClass([
  t3("duo-table")
], Table);

// src/common/FocusTrapController.ts
var FOCUSABLE_SELECTOR = [
  "a[href]",
  'button:not([disabled]):not([tabindex="-1"])',
  'input:not([disabled]):not([type="hidden"])',
  "select:not([disabled])",
  "textarea:not([disabled])",
  '[tabindex]:not([tabindex="-1"])',
  "[contenteditable]:not([contenteditable='false'])",
  "details > summary"
].join(",");
function isElementVisible(el) {
  return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
}
function isFocusable(el) {
  if (!el.matches(FOCUSABLE_SELECTOR) || !isElementVisible(el)) return false;
  if (el.getAttribute("aria-hidden") === "true") return false;
  if (el.hasAttribute("disabled")) return false;
  return true;
}
function getDeepActiveElement() {
  let active = document.activeElement;
  while (active?.shadowRoot?.activeElement) {
    active = active.shadowRoot.activeElement;
  }
  return active;
}
function getFocusableElements(root) {
  const result = [];
  const visit = (node) => {
    if (node instanceof HTMLElement && isFocusable(node)) {
      result.push(node);
    }
    if (node instanceof HTMLSlotElement) {
      const assigned = node.assignedElements({ flatten: true });
      if (assigned.length > 0) {
        for (const el of assigned) visit(el);
      } else {
        for (const child of node.children) visit(child);
      }
      return;
    }
    if (node instanceof Element && node.shadowRoot) {
      if (node.getAttribute("tabindex") === "-1") return;
      visit(node.shadowRoot);
      return;
    }
    for (const child of node.children) {
      visit(child);
    }
  };
  visit(root);
  return result;
}
var FocusTrapController = class {
  #container = null;
  #previousFocus = null;
  #initialFocus = null;
  #restoreFocus = true;
  #active = false;
  constructor(host) {
    host.addController(this);
  }
  get active() {
    return this.#active;
  }
  get container() {
    return this.#container;
  }
  hostDisconnected() {
    this.deactivate({ restoreFocus: false });
  }
  /** Prefer this over {@link FocusTrapActivateOptions.initialFocus} when the target is set ahead of open. */
  setInitialFocus(element) {
    this.#initialFocus = element;
  }
  /**
   * Start trapping focus inside `container`. Remembers the currently focused
   * element and moves focus into the container (after a frame so open DOM settles).
   */
  activate(container, options = {}) {
    if (this.#active && this.#container === container) {
      return;
    }
    if (this.#active) {
      this.deactivate({ restoreFocus: false });
    }
    this.#container = container;
    this.#restoreFocus = options.restoreFocus !== false;
    if (options.initialFocus !== void 0) {
      this.#initialFocus = options.initialFocus;
    }
    this.#rememberFocus();
    document.addEventListener("keydown", this.#onKeyDown);
    this.#active = true;
    this.#focusInitial();
  }
  /**
   * Stop trapping and optionally restore focus to the element that was focused
   * before {@link activate}.
   */
  deactivate(options = {}) {
    if (!this.#active) {
      this.#container = null;
      return;
    }
    const shouldRestore = options.restoreFocus ?? this.#restoreFocus;
    document.removeEventListener("keydown", this.#onKeyDown);
    this.#container = null;
    this.#active = false;
    this.#initialFocus = null;
    if (shouldRestore) {
      this.#restorePreviousFocus();
    } else {
      this.#previousFocus = null;
    }
  }
  /** Cycle Tab / Shift+Tab within the active container. Safe to call when inactive. */
  handleKeyDown(event) {
    this.#onKeyDown(event);
  }
  #rememberFocus() {
    const active = getDeepActiveElement();
    this.#previousFocus = active instanceof HTMLElement && active !== document.body ? active : null;
  }
  #restorePreviousFocus() {
    const target = this.#previousFocus;
    this.#previousFocus = null;
    if (!target) return;
    try {
      target.focus({ preventScroll: true });
    } catch {
    }
  }
  #focusInitial() {
    const container = this.#container;
    if (!container) return;
    const initial = this.#initialFocus;
    requestAnimationFrame(() => {
      if (!this.#active || this.#container !== container) return;
      const target = initial ?? getFocusableElements(container)[0] ?? container;
      try {
        target.focus({ preventScroll: true });
      } catch {
      }
    });
  }
  #onKeyDown = (event) => {
    if (event.key !== "Tab" || !this.#active) return;
    const container = this.#container;
    if (!container) return;
    const focusables = getFocusableElements(container);
    if (focusables.length === 0) {
      event.preventDefault();
      container.focus({ preventScroll: true });
      return;
    }
    const active = getDeepActiveElement();
    let currentIndex = focusables.indexOf(active);
    if (currentIndex === -1 && active instanceof HTMLElement) {
      currentIndex = focusables.findIndex((el) => {
        if (active.contains(el)) return true;
        if (active.shadowRoot?.contains(el)) return true;
        return false;
      });
    }
    event.preventDefault();
    let nextIndex;
    if (event.shiftKey) {
      nextIndex = currentIndex <= 0 ? focusables.length - 1 : currentIndex - 1;
    } else if (currentIndex === -1 || currentIndex >= focusables.length - 1) {
      nextIndex = 0;
    } else {
      nextIndex = currentIndex + 1;
    }
    focusables[nextIndex]?.focus({ preventScroll: true });
  };
};

// src/components/modal/modal.ts
var modalTitleIdSeq = 0;
var booleanAttribute2 = {
  fromAttribute(value, defaultValue = false) {
    if (value === null) return defaultValue;
    if (value === "false" || value === "0") return false;
    return true;
  },
  toAttribute(value) {
    return value ? "" : "false";
  }
};
var _titleId4, _subtitleId, _focusTrap, _Modal_instances, isOpen_fn, shouldShowClose_fn, syncDialogOpen_fn, syncDialogA11y_fn, labelledByIds_fn, emitClose_fn, renderTitleElement_fn3, renderHeader_fn4, _onNativeClose;
var Modal = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _Modal_instances);
    this.open = false;
    this.showModal = false;
    this.title = "";
    this.subtitle = "";
    this.titleTag = "h5";
    this.size = "m";
    this.showClose = true;
    this.isMobile = false;
    this.mobile = false;
    this.mobileFooter = false;
    this.titleSlot = new SlotController(this, "title");
    this.headerSlot = new SlotController(this, "header");
    this.footerSlot = new SlotController(this, "footer");
    __privateAdd(this, _titleId4, `duo-modal-title-${modalTitleIdSeq++}`);
    __privateAdd(this, _subtitleId, `duo-modal-subtitle-${modalTitleIdSeq++}`);
    __privateAdd(this, _focusTrap, new FocusTrapController(this));
    this.onDialogCancel = (event) => {
      event.preventDefault();
      __privateMethod(this, _Modal_instances, emitClose_fn).call(this, "escape");
    };
    this.onDialogClick = (event) => {
      const dialog = this.dialogEl;
      if (!dialog || event.target !== dialog) return;
      __privateMethod(this, _Modal_instances, emitClose_fn).call(this, "backdrop");
    };
    this.onCloseClick = () => {
      __privateMethod(this, _Modal_instances, emitClose_fn).call(this, "close-button");
    };
    __privateAdd(this, _onNativeClose, () => {
      if (__privateMethod(this, _Modal_instances, isOpen_fn).call(this)) {
        this.open = false;
        this.showModal = false;
      }
      __privateGet(this, _focusTrap).deactivate();
    });
  }
  firstUpdated() {
    __privateMethod(this, _Modal_instances, syncDialogOpen_fn).call(this);
    __privateMethod(this, _Modal_instances, syncDialogA11y_fn).call(this);
  }
  updated(changed) {
    super.updated(changed);
    if (changed.has("open") || changed.has("showModal") || changed.has("accessibleLabel") || changed.has("title") || changed.has("subtitle")) {
      __privateMethod(this, _Modal_instances, syncDialogA11y_fn).call(this);
    }
    if (changed.has("open") || changed.has("showModal")) {
      __privateMethod(this, _Modal_instances, syncDialogOpen_fn).call(this);
    }
  }
  render() {
    return T`
      <dialog
        part="dialog"
        aria-modal="true"
        tabindex="-1"
        @cancel=${this.onDialogCancel}
        @click=${this.onDialogClick}
        @close=${__privateGet(this, _onNativeClose)}
      >
        <div class="panel" part="panel" @click=${(event) => event.stopPropagation()}>
          ${__privateMethod(this, _Modal_instances, renderHeader_fn4).call(this)}
          <div class="body" part="body">
            <slot></slot>
          </div>
          <footer
            class=${e6({ footer: true, "has-content": this.footerSlot.hasContent })}
            part="footer"
          >
            <slot name="footer"></slot>
          </footer>
        </div>
      </dialog>
    `;
  }
  /** Programmatically open (sets `open` and `show-modal`). */
  show() {
    this.open = true;
    this.showModal = true;
  }
  /** Programmatically close without emitting `close` (use click handlers that call `#emitClose` instead). */
  hide() {
    this.open = false;
    this.showModal = false;
    this.dialogEl?.close();
  }
};
_titleId4 = new WeakMap();
_subtitleId = new WeakMap();
_focusTrap = new WeakMap();
_Modal_instances = new WeakSet();
isOpen_fn = function() {
  return this.open || this.showModal;
};
shouldShowClose_fn = function() {
  return this.showClose || this.isMobile || this.mobile;
};
syncDialogOpen_fn = function() {
  const dialog = this.dialogEl;
  if (!dialog) return;
  const shouldOpen = __privateMethod(this, _Modal_instances, isOpen_fn).call(this);
  if (shouldOpen && !dialog.open) {
    try {
      if (typeof dialog.showModal === "function") {
        dialog.showModal();
      } else {
        dialog.setAttribute("open", "");
      }
    } catch {
    }
    __privateGet(this, _focusTrap).activate(dialog);
  } else if (!shouldOpen && dialog.open) {
    dialog.close();
    __privateGet(this, _focusTrap).deactivate();
  } else if (!shouldOpen && __privateGet(this, _focusTrap).active) {
    __privateGet(this, _focusTrap).deactivate();
  }
};
syncDialogA11y_fn = function() {
  const dialog = this.dialogEl;
  if (!dialog) return;
  const labelledBy = __privateMethod(this, _Modal_instances, labelledByIds_fn).call(this);
  if (labelledBy) {
    dialog.setAttribute("aria-labelledby", labelledBy);
    dialog.removeAttribute("aria-label");
  } else if (this.accessibleLabel) {
    dialog.setAttribute("aria-label", this.accessibleLabel);
    dialog.removeAttribute("aria-labelledby");
  } else {
    dialog.removeAttribute("aria-labelledby");
    dialog.removeAttribute("aria-label");
  }
  const describedBy = this.subtitle.trim() ? __privateGet(this, _subtitleId) : void 0;
  if (describedBy) {
    dialog.setAttribute("aria-describedby", describedBy);
  } else {
    dialog.removeAttribute("aria-describedby");
  }
};
labelledByIds_fn = function() {
  if (this.headerSlot.hasContent || this.titleSlot.hasContent) return void 0;
  if (this.title.trim()) return __privateGet(this, _titleId4);
  return void 0;
};
emitClose_fn = function(reason) {
  this.open = false;
  this.showModal = false;
  this.dialogEl?.close();
  this.dispatchEvent(
    new CustomEvent("close", {
      bubbles: true,
      composed: true,
      detail: { reason }
    })
  );
};
renderTitleElement_fn3 = function() {
  const content = this.titleSlot.hasContent ? T`<slot name="title"></slot>` : this.title;
  if (!this.titleSlot.hasContent && !String(this.title).trim()) return A;
  const tag = this.titleTag;
  const classes = { title: true };
  switch (tag) {
    case "h1":
      return T`<h1 id=${__privateGet(this, _titleId4)} class=${e6(classes)}>${content}</h1>`;
    case "h2":
      return T`<h2 id=${__privateGet(this, _titleId4)} class=${e6(classes)}>${content}</h2>`;
    case "h3":
      return T`<h3 id=${__privateGet(this, _titleId4)} class=${e6(classes)}>${content}</h3>`;
    case "h4":
      return T`<h4 id=${__privateGet(this, _titleId4)} class=${e6(classes)}>${content}</h4>`;
    case "h5":
      return T`<h5 id=${__privateGet(this, _titleId4)} class=${e6(classes)}>${content}</h5>`;
    case "h6":
      return T`<h6 id=${__privateGet(this, _titleId4)} class=${e6(classes)}>${content}</h6>`;
    case "p":
      return T`<p id=${__privateGet(this, _titleId4)} class=${e6(classes)}>${content}</p>`;
    case "div":
    default:
      return T`<div id=${__privateGet(this, _titleId4)} class=${e6(classes)} role="heading" aria-level="2">${content}</div>`;
  }
};
renderHeader_fn4 = function() {
  if (this.headerSlot.hasContent) {
    return T`<slot name="header"></slot>`;
  }
  const title = __privateMethod(this, _Modal_instances, renderTitleElement_fn3).call(this);
  const subtitle = this.subtitle.trim() ? T`<p id=${__privateGet(this, _subtitleId)} class="subtitle">${this.subtitle}</p>` : A;
  const hasTitle = this.titleSlot.hasContent || Boolean(this.title.trim());
  const hasSubtitle = Boolean(this.subtitle.trim());
  if (!hasTitle && !hasSubtitle && !__privateMethod(this, _Modal_instances, shouldShowClose_fn).call(this)) {
    return A;
  }
  return T`
      <header class="header" part="header">
        <div class="header-text">
          ${title} ${subtitle}
        </div>
        ${__privateMethod(this, _Modal_instances, shouldShowClose_fn).call(this) ? T`
              <button
                type="button"
                class="close"
                part="close"
                aria-label="Close"
                @click=${this.onCloseClick}
              >
                <duo-icon name="x" size="m" label=""></duo-icon>
              </button>
            ` : A}
      </header>
    `;
};
_onNativeClose = new WeakMap();
Modal.styles = i`
    :host {
      display: none;
      --duo-modal-max-width: 30.125rem;
      --duo-modal-panel-shadow:
      0 24px 38px 3px rgba(12, 12, 12, .16), 0 9px 86px 8px rgba(12, 12, 12, .1), 0 11px 15px -7px rgba(12, 12, 12, .1), 0 0 0 1px rgba(0, 0, 0, .05);
    }

    /* Avoid display:contents — it breaks native dialog focus containment with Shadow DOM. */
    :host([open]),
    :host([show-modal]) {
      display: block;
    }

    :host([size="s"]) {
      --duo-modal-max-width: 18.75rem;
    }

    :host([size="m"]) {
      --duo-modal-max-width: 30.125rem;
    }

    :host([size="l"]) {
      --duo-modal-max-width: 50rem;
    }

    :host([size="xl"]) {
      --duo-modal-max-width: 71.25rem;
    }

    :host([size="fullscreen"]) {
     
    }

    :host([size="fullscreen"]) dialog {
      width: 100%;
      max-width: none;
      height: 100%;
      min-height: 100vh;
      margin: 0;
    }

    :host([size="fullscreen"]) .panel {
      width: 100%;
      min-height: 100vh;
      height: 100vh;
      border: 0;
      border-radius: 0;
      background: var(--duo-color-surface);
      box-shadow: none;
      position: fixed;
    }

    dialog {
      box-sizing: border-box;
      margin: auto;
      padding: 0;
      border: none;
      max-width: min(var(--duo-modal-max-width), calc(100vw - 2 * var(--duo-space-m)));
      width: 100%;
      background: transparent;
      color: inherit;
      border-radius: var(--duo-border-radius-m);
      box-shadow: var(--duo-modal-panel-shadow);
    }

    dialog::backdrop {
      background: color-mix(in srgb, var(--duo-color-gray-1300) 35%, transparent);
    }

    dialog:not([open]) {
      display: none;
    }

    .panel {
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      max-height: min(90vh, 100%);
      overflow: hidden;
      border-radius: var(--duo-space-xs);
      background: var(--duo-color-surface);
      box-shadow: var(--duo-modal-panel-shadow);
    }

    .header {
      display: flex;
      align-items: flex-start;
      gap: var(--duo-space-m);
      box-sizing: border-box;
      padding: var(--duo-space-l);
      box-shadow: 0 -1px 0 0 #D6D6DC inset;
    }

    .header-text {
      flex: 1 1 auto;
      min-width: 0;
    }

    .title {
      margin: 0;
      font: var(--duo-font-headline-3);
      color: var(--duo-color-text);
    }

    .subtitle {
      margin: var(--duo-space-xs) 0 0;
      font: var(--duo-font-body);
      color: var(--duo-color-text-weakest);
    }

    .close {
      flex-shrink: 0;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      margin: 0;
      margin-inline-start: auto;
      padding: var(--duo-space-xxs);
      border: none;
      border-radius: var(--duo-border-radius-s);
      background: transparent;
      color: var(--duo-color-text-weak);
      cursor: pointer;
    }

    .close:hover {
      color: var(--duo-color-text);
      background: color-mix(in srgb, var(--duo-color-gray-1300) 6%, transparent);
    }

    .close:focus-visible {
      outline: none;
      box-shadow: var(--duo-box-shadow-button-focus);
    }

    .body {
      flex: 1 1 auto;
      overflow: auto;
      box-sizing: border-box;
      padding: var(--duo-space-l);
      font: var(--duo-font-body);
      color: var(--duo-color-text-weak);
    }

    .body ::slotted(*) {
      margin: 0;
    }

    .footer {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      justify-content: flex-end;
      gap: var(--duo-space-m);
      box-sizing: border-box;
      padding: var(--duo-space-s) var(--duo-space-l);
      background: color-mix(in srgb, var(--duo-color-surface) 25%, transparent);
      box-shadow: 0 1px 0 0 #D6D6DC inset;
    }

    .footer.has-content {
      display: flex;
    }

    .footer:not(.has-content) {
      display: none;
    }

    :host([size="s"]),
    :host([mobile-footer]),
    :host([is-mobile]),
    :host([mobile]) {
      --duo-modal-footer-direction: column-reverse;
    }

    .footer {
      flex-direction: var(--duo-modal-footer-direction, row);
    }

    :host([size="s"]) .footer ::slotted(duo-button),
    :host([mobile-footer]) .footer ::slotted(duo-button),
    :host([is-mobile]) .footer ::slotted(duo-button),
    :host([mobile]) .footer ::slotted(duo-button) {
      width: 100%;
    }
  `;
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Modal.prototype, "open", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true, attribute: "show-modal" })
], Modal.prototype, "showModal", 2);
__decorateClass([
  n4({ type: String })
], Modal.prototype, "title", 2);
__decorateClass([
  n4({ type: String })
], Modal.prototype, "subtitle", 2);
__decorateClass([
  n4({ type: String, reflect: true, attribute: "title-tag" })
], Modal.prototype, "titleTag", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Modal.prototype, "size", 2);
__decorateClass([
  n4({
    type: Boolean,
    reflect: true,
    attribute: "show-close",
    converter: {
      fromAttribute: (value) => booleanAttribute2.fromAttribute(value, true),
      toAttribute: booleanAttribute2.toAttribute
    }
  })
], Modal.prototype, "showClose", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true, attribute: "is-mobile" })
], Modal.prototype, "isMobile", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], Modal.prototype, "mobile", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true, attribute: "mobile-footer" })
], Modal.prototype, "mobileFooter", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-label" })
], Modal.prototype, "accessibleLabel", 2);
__decorateClass([
  e4("dialog")
], Modal.prototype, "dialogEl", 2);
Modal = __decorateClass([
  t3("duo-modal")
], Modal);

// src/components/radio-card/radio-card.ts
var _RadioCard_instances, hasTitle_fn3, hasSubtitle_fn2, hasDescription_fn2, hasBadges_fn, hasTrailing_fn2, radioLabel_fn, requestSelect_fn, _onCardClick, _onCardKeyDown, renderTitle_fn3, renderSubtitle_fn, renderDescription_fn, renderTrailing_fn;
var RadioCard = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _RadioCard_instances);
    this.name = "";
    this.value = "";
    this.checked = false;
    this.disabled = false;
    this.title = "";
    this.subtitle = "";
    this.description = "";
    this.selectedLabel = "Selected";
    this.ariaLabel = "";
    this.optionTabIndex = -1;
    this.titleSlot = new SlotController(this, "title");
    this.subtitleSlot = new SlotController(this, "subtitle");
    this.descriptionSlot = new SlotController(this, "description");
    this.badgesSlot = new SlotController(this, "badges");
    this.trailingSlot = new SlotController(this, "trailing");
    __privateAdd(this, _onCardClick, () => {
      __privateMethod(this, _RadioCard_instances, requestSelect_fn).call(this);
    });
    __privateAdd(this, _onCardKeyDown, (event) => {
      if (this.disabled) {
        return;
      }
      if (event.key === " " || event.key === "Enter") {
        event.preventDefault();
        __privateMethod(this, _RadioCard_instances, requestSelect_fn).call(this);
      }
    });
  }
  focusOption() {
    this.shadowRoot?.querySelector('[part="card"]')?.focus();
  }
  render() {
    const hasTitle = __privateMethod(this, _RadioCard_instances, hasTitle_fn3).call(this);
    const hasSubtitle = __privateMethod(this, _RadioCard_instances, hasSubtitle_fn2).call(this);
    const hasTrailing = __privateMethod(this, _RadioCard_instances, hasTrailing_fn2).call(this);
    return T`
      <div
        class=${e6({
      card: true,
      "has-trailing": hasTrailing
    })}
        part="card"
        role="radio"
        aria-checked=${this.checked ? "true" : "false"}
        aria-disabled=${this.disabled ? "true" : "false"}
        aria-label=${o8(__privateMethod(this, _RadioCard_instances, radioLabel_fn).call(this))}
        tabindex=${this.optionTabIndex}
        @click=${__privateGet(this, _onCardClick)}
        @keydown=${__privateGet(this, _onCardKeyDown)}
      >
        <div class="copy" part="copy">
          ${hasTitle || hasSubtitle ? T`<div class="header" part="header">
                ${__privateMethod(this, _RadioCard_instances, renderTitle_fn3).call(this)} ${__privateMethod(this, _RadioCard_instances, renderSubtitle_fn).call(this)}
              </div>` : A}
          ${__privateMethod(this, _RadioCard_instances, hasDescription_fn2).call(this) ? __privateMethod(this, _RadioCard_instances, renderDescription_fn).call(this) : A}
          ${__privateMethod(this, _RadioCard_instances, hasBadges_fn).call(this) ? T`<div class="badges" part="badges">
                <slot name="badges"></slot>
              </div>` : A}
        </div>
        <div class="status" part="status"></div>
        ${__privateMethod(this, _RadioCard_instances, renderTrailing_fn).call(this)}
      </div>
    `;
  }
};
_RadioCard_instances = new WeakSet();
hasTitle_fn3 = function() {
  return this.titleSlot.hasContent || Boolean(this.title.trim());
};
hasSubtitle_fn2 = function() {
  return this.subtitleSlot.hasContent || Boolean(this.subtitle.trim());
};
hasDescription_fn2 = function() {
  return this.descriptionSlot.hasContent || Boolean(this.description.trim());
};
hasBadges_fn = function() {
  return this.badgesSlot.hasContent;
};
hasTrailing_fn2 = function() {
  return this.trailingSlot.hasContent;
};
radioLabel_fn = function() {
  const explicit = this.ariaLabel.trim();
  if (explicit) return explicit;
  const title = this.title.trim();
  if (!title) return void 0;
  return title;
};
requestSelect_fn = function() {
  if (this.disabled || this.checked) {
    return;
  }
  this.dispatchEvent(
    new CustomEvent("radio-card-select", {
      bubbles: true,
      composed: true,
      detail: { value: this.value }
    })
  );
};
_onCardClick = new WeakMap();
_onCardKeyDown = new WeakMap();
renderTitle_fn3 = function() {
  if (this.titleSlot.hasContent) {
    return T`<div class="title" part="title">
        <slot name="title"></slot>
      </div>`;
  }
  if (!this.title.trim()) return A;
  return T`<p class="title" part="title">${this.title}</p>`;
};
renderSubtitle_fn = function() {
  if (this.subtitleSlot.hasContent) {
    return T`<div class="subtitle" part="subtitle">
        <slot name="subtitle"></slot>
      </div>`;
  }
  if (!this.subtitle.trim()) return A;
  return T`<p class="subtitle" part="subtitle">${this.subtitle}</p>`;
};
renderDescription_fn = function() {
  if (this.descriptionSlot.hasContent) {
    return T`<div class="description" part="description">
        <slot name="description"></slot>
      </div>`;
  }
  if (!this.description.trim()) return A;
  return T`<p class="description" part="description">${this.description}</p>`;
};
renderTrailing_fn = function() {
  if (!__privateMethod(this, _RadioCard_instances, hasTrailing_fn2).call(this)) return A;
  return T`<div class="trailing" part="trailing">
      <slot name="trailing"></slot>
    </div>`;
};
RadioCard.styles = i`
    :host {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .card {
      display: grid;
      grid-template-columns: minmax(0, 1fr) auto;
      align-items: start;
      gap: var(--duo-space-s);
      box-sizing: border-box;
      margin: 0;
      padding: var(--duo-space-s) var(--duo-space-m);
      border: 1px solid var(--duo-color-border);
      border-radius: var(--duo-border-radius-s);
      background: var(--duo-color-surface);
      cursor: pointer;
      transition:
        border-color 0.15s ease,
        background 0.15s ease,
        box-shadow 0.15s ease;
    }

    .card.has-trailing {
      grid-template-columns: minmax(0, 1fr) auto auto;
    }

    :host([checked]) .card {
      border-color: var(--duo-color-accent);
      box-shadow: 0 0 0 2px var(--duo-color-accent);
    }

    .card:hover:not([aria-disabled="true"]) {
      border-color: var(--duo-color-border-strong);
    }

    :host([checked]) .card:hover:not([aria-disabled="true"]) {
      border-color: var(--duo-color-accent);
    }

    .card:focus-visible {
      outline: 2px solid var(--duo-color-accent);
      outline-offset: 2px;
    }

    :host([disabled]) .card {
      opacity: 0.55;
      cursor: not-allowed;
    }

    .copy {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: var(--duo-space-xs);
      min-width: 0;
    }

    .header {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: var(--duo-space-xxs);
    }

    .title {
      margin: 0;
      font: var(--duo-font-m);
      font-weight: 600;
      color: var(--duo-color-text);
    }

    .title ::slotted(*) {
      margin: 0;
      font: inherit;
      color: inherit;
    }

    .subtitle {
      margin: 0;
      font: var(--duo-font-form);
      color: var(--duo-color-text-weak);
    }

    .subtitle ::slotted(*) {
      margin: 0;
      font: inherit;
      color: inherit;
    }

    .description {
      width: 100%;
      margin: 0;
      font: var(--duo-font-small);
      color: var(--duo-color-text-weakest);
    }

    :host([checked]) .description {
      color: var(--duo-color-text-weakest);
    }

    .description ::slotted(*) {
      margin: 0;
      font: inherit;
      color: inherit;
    }

    .badges {
      display: flex;
      flex-wrap: wrap;
      gap: var(--duo-space-xxs);
    }

    .badges ::slotted(*) {
      margin: 0;
    }

    .status {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      align-self: start;
    }

    :host(:not([checked])) .status {
      visibility: hidden;
    }

    .trailing {
      flex-shrink: 0;
      align-self: start;
      text-align: end;
      font: var(--duo-font-s);
      color: var(--duo-color-text);
    }

    .trailing ::slotted(*) {
      margin: 0;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], RadioCard.prototype, "name", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], RadioCard.prototype, "value", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], RadioCard.prototype, "checked", 2);
__decorateClass([
  n4({ type: Boolean, reflect: true })
], RadioCard.prototype, "disabled", 2);
__decorateClass([
  n4({ type: String })
], RadioCard.prototype, "title", 2);
__decorateClass([
  n4({ type: String })
], RadioCard.prototype, "subtitle", 2);
__decorateClass([
  n4({ type: String })
], RadioCard.prototype, "description", 2);
__decorateClass([
  n4({ type: String, attribute: "selected-label" })
], RadioCard.prototype, "selectedLabel", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-label" })
], RadioCard.prototype, "ariaLabel", 2);
__decorateClass([
  n4({ type: Number, attribute: "option-tab-index" })
], RadioCard.prototype, "optionTabIndex", 2);
RadioCard = __decorateClass([
  t3("duo-radio-card")
], RadioCard);

// src/components/radio-card/radio-card-group.ts
var _RadioCardGroup_instances, label_fn3, labelledBy_fn5, cards_fn, selectedCard_fn, syncCardsToValue_fn, updateTabIndices_fn, selectCard_fn, _onSlotChange2, _onCardSelect, activeCard_fn, _onKeyDown;
var RadioCardGroup = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _RadioCardGroup_instances);
    this.name = "";
    this.value = "";
    this.ariaLabel = "";
    this.ariaLabelledBy = "";
    __privateAdd(this, _onSlotChange2, () => {
      if (this.name.trim()) {
        __privateMethod(this, _RadioCardGroup_instances, cards_fn).call(this).forEach((card) => {
          card.name = this.name;
        });
      }
      const cards = __privateMethod(this, _RadioCardGroup_instances, cards_fn).call(this);
      const checkedCards = cards.filter((card) => card.checked);
      if (checkedCards.length === 1) {
        this.value = checkedCards[0].value;
      } else if (checkedCards.length > 1) {
        __privateMethod(this, _RadioCardGroup_instances, selectCard_fn).call(this, checkedCards[0]);
      } else if (this.value.trim()) {
        __privateMethod(this, _RadioCardGroup_instances, syncCardsToValue_fn).call(this);
      }
      __privateMethod(this, _RadioCardGroup_instances, updateTabIndices_fn).call(this);
    });
    __privateAdd(this, _onCardSelect, (event) => {
      const card = event.target;
      if (!(card instanceof RadioCard) || card.disabled) {
        return;
      }
      __privateMethod(this, _RadioCardGroup_instances, selectCard_fn).call(this, card, true);
    });
    __privateAdd(this, _onKeyDown, (event) => {
      const cards = __privateMethod(this, _RadioCardGroup_instances, cards_fn).call(this);
      if (cards.length === 0) {
        return;
      }
      const activeCard = __privateMethod(this, _RadioCardGroup_instances, activeCard_fn).call(this, event);
      if (!activeCard) {
        return;
      }
      const currentIndex = cards.indexOf(activeCard);
      if (currentIndex === -1) {
        return;
      }
      let nextIndex = currentIndex;
      switch (event.key) {
        case "ArrowDown":
        case "ArrowRight":
          nextIndex = (currentIndex + 1) % cards.length;
          break;
        case "ArrowUp":
        case "ArrowLeft":
          nextIndex = (currentIndex - 1 + cards.length) % cards.length;
          break;
        case "Home":
          nextIndex = 0;
          break;
        case "End":
          nextIndex = cards.length - 1;
          break;
        default:
          return;
      }
      event.preventDefault();
      __privateMethod(this, _RadioCardGroup_instances, selectCard_fn).call(this, cards[nextIndex], true);
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this.addEventListener("radio-card-select", __privateGet(this, _onCardSelect));
    this.addEventListener("keydown", __privateGet(this, _onKeyDown));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    this.removeEventListener("radio-card-select", __privateGet(this, _onCardSelect));
    this.removeEventListener("keydown", __privateGet(this, _onKeyDown));
  }
  updated(changed) {
    if (changed.has("value")) {
      __privateMethod(this, _RadioCardGroup_instances, syncCardsToValue_fn).call(this);
    }
  }
  render() {
    const formName = this.name.trim() || A;
    const formValue = this.value.trim() || A;
    return T`
      <div
        class="list"
        part="list"
        role="radiogroup"
        aria-label=${o8(__privateMethod(this, _RadioCardGroup_instances, label_fn3).call(this))}
        aria-labelledby=${o8(__privateMethod(this, _RadioCardGroup_instances, labelledBy_fn5).call(this))}
      >
        ${formName ? T`<input
              part="input"
              type="hidden"
              name=${formName}
              .value=${formValue}
              tabindex="-1"
              aria-hidden="true"
            />` : A}
        <slot @slotchange=${__privateGet(this, _onSlotChange2)}></slot>
      </div>
    `;
  }
};
_RadioCardGroup_instances = new WeakSet();
label_fn3 = function() {
  return this.ariaLabel.trim() || void 0;
};
labelledBy_fn5 = function() {
  return this.ariaLabelledBy.trim() || void 0;
};
cards_fn = function() {
  return this.assignedCards.filter((card) => !card.disabled && !card.hidden);
};
selectedCard_fn = function() {
  return __privateMethod(this, _RadioCardGroup_instances, cards_fn).call(this).find((card) => card.checked);
};
syncCardsToValue_fn = function() {
  const cards = __privateMethod(this, _RadioCardGroup_instances, cards_fn).call(this);
  if (cards.length === 0) {
    return;
  }
  const nextValue = this.value.trim();
  let matched = false;
  cards.forEach((card) => {
    const isSelected = Boolean(nextValue) && card.value === nextValue;
    card.checked = isSelected;
    matched ||= isSelected;
  });
  if (nextValue && !matched) {
    return;
  }
  __privateMethod(this, _RadioCardGroup_instances, updateTabIndices_fn).call(this);
};
updateTabIndices_fn = function() {
  const cards = __privateMethod(this, _RadioCardGroup_instances, cards_fn).call(this);
  const selected = __privateMethod(this, _RadioCardGroup_instances, selectedCard_fn).call(this) ?? cards.find((card) => !card.disabled);
  cards.forEach((card) => {
    card.optionTabIndex = card === selected ? 0 : -1;
  });
};
selectCard_fn = function(card, focus = false) {
  if (card.disabled || card.hidden) {
    return;
  }
  const previousValue = this.value;
  const cards = __privateMethod(this, _RadioCardGroup_instances, cards_fn).call(this);
  cards.forEach((item) => {
    item.checked = item === card;
  });
  this.value = card.value;
  __privateMethod(this, _RadioCardGroup_instances, updateTabIndices_fn).call(this);
  if (focus) {
    card.focusOption();
  }
  if (previousValue !== card.value) {
    this.dispatchEvent(
      new CustomEvent("change", {
        bubbles: true,
        composed: true,
        detail: { value: card.value }
      })
    );
  }
};
_onSlotChange2 = new WeakMap();
_onCardSelect = new WeakMap();
activeCard_fn = function(event) {
  const cards = __privateMethod(this, _RadioCardGroup_instances, cards_fn).call(this);
  const path = event.composedPath();
  return cards.find((card) => path.includes(card));
};
_onKeyDown = new WeakMap();
RadioCardGroup.styles = i`
    :host {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .list {
      display: flex;
      flex-direction: column;
      gap: var(--duo-space-s);
      margin: 0;
      padding: 0;
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], RadioCardGroup.prototype, "name", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], RadioCardGroup.prototype, "value", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-label", reflect: true })
], RadioCardGroup.prototype, "ariaLabel", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-labelledby", reflect: true })
], RadioCardGroup.prototype, "ariaLabelledBy", 2);
__decorateClass([
  o6({ selector: "duo-radio-card" })
], RadioCardGroup.prototype, "assignedCards", 2);
RadioCardGroup = __decorateClass([
  t3("duo-radio-card-group")
], RadioCardGroup);

// src/components/stepper/stepper.ts
var _Stepper_instances, syncItems_fn, label_fn4;
var Stepper = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _Stepper_instances);
    this.current = 1;
    this.orientation = "horizontal";
    this.completeLabel = "Complete";
    this.ariaLabel = "";
  }
  firstUpdated() {
    __privateMethod(this, _Stepper_instances, syncItems_fn).call(this);
  }
  updated(changed) {
    if (changed.has("current") || changed.has("completeLabel")) {
      __privateMethod(this, _Stepper_instances, syncItems_fn).call(this);
    }
  }
  render() {
    return T`
      <div
        part="list"
        class="list"
        role="list"
        aria-label=${o8(__privateMethod(this, _Stepper_instances, label_fn4).call(this))}
      >
        <slot @slotchange=${__privateMethod(this, _Stepper_instances, syncItems_fn)}></slot>
      </div>
    `;
  }
};
_Stepper_instances = new WeakSet();
syncItems_fn = function() {
  const items = this.assignedItems ?? [];
  const current = Number.isFinite(this.current) ? this.current : 1;
  items.forEach((item, i7) => {
    const position = i7 + 1;
    item.displayIndex = position;
    item.completeLabel = this.completeLabel.trim() || "Complete";
    if (position < current) {
      item.status = "complete";
    } else if (position === current) {
      item.status = "current";
    } else {
      item.status = "upcoming";
    }
  });
};
label_fn4 = function() {
  return this.ariaLabel.trim() || void 0;
};
Stepper.styles = i`
    :host {
      display: block;
      width: 100%;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .list {
      display: flex;
      flex-direction: row;
      align-items: stretch;
      gap: var(--duo-space-xs);
      margin: 0;
      padding: 0;
      box-sizing: border-box;
      width: 100%;
    }
  `;
__decorateClass([
  n4({ type: Number, reflect: true })
], Stepper.prototype, "current", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], Stepper.prototype, "orientation", 2);
__decorateClass([
  n4({ type: String, attribute: "complete-label" })
], Stepper.prototype, "completeLabel", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-label", reflect: true })
], Stepper.prototype, "ariaLabel", 2);
__decorateClass([
  o6({ selector: "duo-stepper-item" })
], Stepper.prototype, "assignedItems", 2);
Stepper = __decorateClass([
  t3("duo-stepper")
], Stepper);

// src/components/stepper/stepper-item.ts
var _StepperItem_instances, shownIndex_fn, labelContent_fn2;
var StepperItem = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _StepperItem_instances);
    this.label = "";
    this.index = 0;
    this.displayIndex = 0;
    this.status = "upcoming";
    this.completeLabel = "Complete";
  }
  connectedCallback() {
    super.connectedCallback();
    if (!this.hasAttribute("role")) {
      this.setAttribute("role", "listitem");
    }
  }
  updated() {
    if (this.status === "current") {
      this.setAttribute("aria-current", "step");
    } else {
      this.removeAttribute("aria-current");
    }
  }
  render() {
    const complete = this.status === "complete";
    return T`
      <span class="bar" part="bar" aria-hidden="true"></span>
      <span class="meta" part="meta">
        <span class="index" part="index" ?aria-hidden=${complete}>
          ${complete ? T`<duo-icon name="check" size="xs"></duo-icon>` : __privateMethod(this, _StepperItem_instances, shownIndex_fn).call(this)}
        </span>
        <span class="label" part="label">
          ${__privateMethod(this, _StepperItem_instances, labelContent_fn2).call(this)}
          ${complete ? T`<duo-visually-hidden>, ${this.completeLabel}</duo-visually-hidden>` : A}
        </span>
      </span>
    `;
  }
};
_StepperItem_instances = new WeakSet();
shownIndex_fn = function() {
  return this.index > 0 ? this.index : this.displayIndex;
};
labelContent_fn2 = function() {
  return T`<slot>${this.label}</slot>`;
};
StepperItem.styles = i`
    :host {
      flex: 1 1 0;
      min-width: 0;
      display: flex;
      flex-direction: column;
      gap: var(--duo-space-xs);
      box-sizing: border-box;
      color: var(--duo-color-text-weakest);
    }

    :host([hidden]) {
      display: none;
    }

    :host([status="current"]),
    :host([status="complete"]) {
      color: var(--duo-color-text);
    }

    .bar {
      display: block;
      height: var(--duo-space-xxs);
      border-radius: var(--duo-border-radius-xs);
      background: var(--duo-color-border);
    }

    :host([status="current"]) .bar,
    :host([status="complete"]) .bar {
      background: var(--duo-color-text);
    }

    .meta {
      display: flex;
      align-items: center;
      gap: var(--duo-space-xs);
      min-width: 0;
    }

    .index {
      display: inline-flex;
      flex: 0 0 auto;
      align-items: center;
      justify-content: center;
      width: var(--duo-space-l);
      height: var(--duo-space-l);
      border-radius: 50%;
      background: var(--duo-color-border);
      color: var(--duo-color-surface);
      font: var(--duo-font-small);
      font-weight: var(--duo-font-weight-bold);
    }

    :host([status="current"]) .index,
    :host([status="complete"]) .index {
      background: var(--duo-color-text);
    }

    .index duo-icon {
      color: currentColor;
    }

    .label {
      min-width: 0;
      font: var(--duo-font-body);
      font-weight: var(--duo-font-weight-medium);
    }
  `;
__decorateClass([
  n4({ type: String })
], StepperItem.prototype, "label", 2);
__decorateClass([
  n4({ type: Number })
], StepperItem.prototype, "index", 2);
__decorateClass([
  n4({ type: Number, attribute: false })
], StepperItem.prototype, "displayIndex", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], StepperItem.prototype, "status", 2);
__decorateClass([
  n4({ type: String, attribute: false })
], StepperItem.prototype, "completeLabel", 2);
StepperItem = __decorateClass([
  t3("duo-stepper-item")
], StepperItem);

// ../../node_modules/.pnpm/lit-html@3.3.2/node_modules/lit-html/node/directives/unsafe-svg.js
var t6 = class extends e7 {
};
t6.directiveName = "unsafeSVG", t6.resultType = 2;
var o10 = e5(t6);

// src/components/brand-attribution/talentech-wordmark.svg.ts
var TALENTECH_WORDMARK_SVG = `<svg viewBox="0 0 255 56" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
<mask id="duo-brand-attribution-wordmark-mask" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="2" y="4" width="251" height="48">
<path d="M252.185 4.60486H2.13252V51.3642H252.185V4.60486Z" fill="white"/>
</mask>
<g mask="url(#duo-brand-attribution-wordmark-mask)">
<path d="M223.725 50.733V4.60474H229.783V22.7784C231.865 19.8126 235.462 17.3516 239.943 17.3516C247.074 17.3516 252.185 21.7688 252.185 28.8994V50.733H246.064V30.2877C246.064 25.5549 243.288 22.7153 238.681 22.7153C234.39 22.7153 230.856 26.3753 229.783 30.9189V50.733H223.725Z" fill="currentColor"/>
<path d="M206.05 51.3642C196.521 51.3642 189.957 44.423 189.957 34.3263C189.957 24.2299 196.521 17.3516 206.05 17.3516C213.559 17.3516 219.113 21.5795 220.248 28.2054L214.443 29.2781H214.19C213.433 25.4288 210.278 22.7154 206.113 22.7154C200.181 22.7154 196.268 27.385 196.268 34.3263C196.268 41.2676 200.181 46.0004 206.113 46.0004C210.467 46.0004 213.622 43.4133 214.443 38.8699L220.501 40.0057C219.113 47.1364 213.559 51.3642 206.05 51.3642Z" fill="currentColor"/>
<path d="M163.152 35.2729C163.53 42.025 167.443 46.0634 173.249 46.0634C177.793 46.0634 180.569 44.1705 181.768 39.9427L187.826 41.7095C186.059 47.5781 180.948 51.3642 173.123 51.3642C163.72 51.3642 157.031 44.2966 157.031 34.3263C157.031 24.3561 163.594 17.3516 172.87 17.3516C185.87 17.3516 188.647 28.2685 187.826 35.2729H163.152ZM172.87 22.2106C167.696 22.2106 164.414 25.4288 163.467 30.6664H181.453C181.137 25.6181 177.919 22.2106 172.87 22.2106Z" fill="currentColor"/>
<path d="M152.105 51.3643C146.552 51.3643 142.513 48.0831 142.513 41.2679V23.1573H136.644V17.9828C142.387 17.9828 142.765 17.4149 142.765 10.3474H148.571V17.9828H157.153V23.1573H148.571V40.8893C148.571 44.5491 150.717 46.0007 153.115 46.0007C154.314 46.0007 155.45 45.8743 156.712 45.0541V50.2916C155.891 50.9227 153.872 51.3643 152.105 51.3643Z" fill="currentColor"/>
<path d="M106.811 50.7331V17.9827H112.869V22.7785C114.951 19.8127 118.548 17.3516 123.029 17.3516C130.16 17.3516 135.272 21.7689 135.272 28.8995V50.7331H129.15V30.2877C129.15 25.555 126.374 22.7154 121.767 22.7154C117.413 22.7154 113.942 26.3754 112.869 30.9187V50.7331H106.811Z" fill="currentColor"/>
<path d="M78.3015 35.2729C78.6801 42.025 82.5927 46.0634 88.3985 46.0634C92.9418 46.0634 95.7187 44.1705 96.9178 39.9427L102.976 41.7095C101.209 47.5781 96.0972 51.3642 88.2721 51.3642C78.8692 51.3642 72.1801 44.2966 72.1801 34.3263C72.1801 24.3561 78.7431 17.3516 88.0196 17.3516C101.019 17.3516 103.796 28.2685 102.976 35.2729H78.3015ZM88.0196 22.2106C82.8451 22.2106 79.5633 25.4288 78.617 30.6664H96.6022C96.2867 25.6181 93.0682 22.2106 88.0196 22.2106Z" fill="currentColor"/>
<path d="M68.5252 46.6944V50.733H62.4672V4.60474H68.5252V46.6944Z" fill="currentColor"/>
<path d="M41.0401 51.3642C34.4768 51.3642 29.744 47.515 29.744 41.8986C29.744 36.2826 33.9721 32.8119 40.9768 31.8023L51.3263 30.2878V29.0888C51.3263 24.5454 48.2342 22.2737 44.1952 22.2737C39.4624 22.2737 36.875 24.7978 35.9915 28.4578L30.2488 26.8171C31.7633 21.832 36.244 17.3516 44.1952 17.3516C52.1465 17.3516 57.3843 21.7057 57.3843 29.2781V50.7332H51.2632V45.8112C48.9283 49.6604 44.9524 51.3642 41.0401 51.3642ZM51.2632 39.3116V34.8313L41.9234 36.3456C38.2003 36.9767 36.0545 38.6174 36.0545 41.7095C36.0545 44.5491 38.4527 46.5684 41.9234 46.5684C46.972 46.5684 50.1271 43.0347 51.2632 39.3116Z" fill="currentColor"/>
<path d="M16.4575 50.7331V10.9782H2.13248V5.23578H37.2824V10.9782H23.0206V50.7331H16.4575Z" fill="currentColor"/>
</g>
</svg>`;

// src/components/brand-attribution/brand-attribution.ts
var wordmarkMaskSeq = 0;
var _i18n2, _maskId, _BrandAttribution_instances, visibleLabel_fn, accessibleName_fn2;
var BrandAttribution = class extends i3 {
  constructor() {
    super(...arguments);
    __privateAdd(this, _BrandAttribution_instances);
    this.href = "";
    this.target = "";
    this.rel = "";
    this.label = "";
    this.accessibleLabel = "";
    __privateAdd(this, _i18n2, new LocaleController(this));
    __privateAdd(this, _maskId, `duo-brand-attribution-wordmark-mask-${wordmarkMaskSeq++}`);
  }
  get _isLink() {
    return Boolean(this.href?.trim());
  }
  _linkRel() {
    const user = this.rel?.trim();
    if (this.target === "_blank") {
      const parts = /* @__PURE__ */ new Set();
      if (user) {
        for (const p4 of user.split(/\s+/)) {
          if (p4) parts.add(p4);
        }
      }
      parts.add("noopener");
      parts.add("noreferrer");
      return Array.from(parts).join(" ");
    }
    return user || A;
  }
  _renderContent() {
    return T`
      <span class="wordmark" part="wordmark"
        >${o10(
      TALENTECH_WORDMARK_SVG.replaceAll(
        "duo-brand-attribution-wordmark-mask",
        __privateGet(this, _maskId)
      )
    )}</span
      >
      <p class="label" part="label" aria-hidden="true">${__privateMethod(this, _BrandAttribution_instances, visibleLabel_fn).call(this)}</p>
    `;
  }
  render() {
    const content = this._renderContent();
    const accessibleName = __privateMethod(this, _BrandAttribution_instances, accessibleName_fn2).call(this);
    if (this._isLink) {
      return T`
        <a
          class="root"
          part="root"
          href=${this.href}
          target=${this.target?.trim() ? this.target : A}
          rel=${this._linkRel()}
          aria-label=${accessibleName}
        >
          ${content}
        </a>
      `;
    }
    return T`
      <div class="root" part="root" role="img" aria-label=${accessibleName}>
        ${content}
      </div>
    `;
  }
};
_i18n2 = new WeakMap();
_maskId = new WeakMap();
_BrandAttribution_instances = new WeakSet();
visibleLabel_fn = function() {
  return this.label?.trim() || __privateGet(this, _i18n2).t("brandAttribution.label");
};
accessibleName_fn2 = function() {
  const override = this.accessibleLabel?.trim();
  if (override) return override;
  return __privateGet(this, _i18n2).t(
    this._isLink ? "brandAttribution.linkAccessibleLabel" : "brandAttribution.accessibleLabel"
  );
};
BrandAttribution.styles = i`
    :host {
      display: inline-block;
      box-sizing: border-box;
    }

    :host([hidden]) {
      display: none;
    }

    .root {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      box-sizing: border-box;
      width: 100%;
      max-inline-size: 100%;
      padding: var(--duo-space-xs);
      gap: var(--duo-space-s);
      text-align: center;
    }

    a.root {
      margin: 0;
      font: inherit;
      text-decoration: none;
      color: inherit;
      cursor: pointer;
      border-radius: var(--duo-border-radius-s);
    }

    a.root:focus-visible {
      outline: none;
      box-shadow: var(--duo-box-shadow-button-focus);
    }

    .wordmark {
      display: block;
      flex-shrink: 0;
      block-size: calc(var(--duo-space-m) + var(--duo-space-s));
      width: auto;
      color: var(--duo-color-text);
    }

    .wordmark svg {
      display: block;
      height: 100%;
      width: auto;
    }

    .label {
      margin: 0;
      width: 100%;
      font: var(--duo-font-body);
      color: var(--duo-color-text-weakest);
    }
  `;
__decorateClass([
  n4({ type: String, reflect: true })
], BrandAttribution.prototype, "href", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], BrandAttribution.prototype, "target", 2);
__decorateClass([
  n4({ type: String, reflect: true })
], BrandAttribution.prototype, "rel", 2);
__decorateClass([
  n4({ type: String })
], BrandAttribution.prototype, "label", 2);
__decorateClass([
  n4({ type: String, attribute: "aria-label" })
], BrandAttribution.prototype, "accessibleLabel", 2);
BrandAttribution = __decorateClass([
  t3("duo-brand-attribution")
], BrandAttribution);
/*!
 * Duo Icons
 * Includes icons derived from Phosphor Icons.
 * Phosphor Icons are licensed under the MIT License.
 * See LICENSE in this package/CDN version folder.
 */
/*! Bundled license information:

@lit-labs/ssr-dom-shim/lib/element-internals.js:
@lit-labs/ssr-dom-shim/lib/events.js:
  (**
   * @license
   * Copyright 2023 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit-labs/ssr-dom-shim/lib/css.js:
  (**
   * @license
   * Copyright 2024 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit-labs/ssr-dom-shim/index.js:
@lit/reactive-element/node/css-tag.js:
  (**
   * @license
   * Copyright 2019 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/node/lit-html.js:
lit-element/lit-element.js:
@lit/reactive-element/node/decorators/custom-element.js:
@lit/reactive-element/node/decorators/property.js:
@lit/reactive-element/node/decorators/state.js:
@lit/reactive-element/node/decorators/event-options.js:
@lit/reactive-element/node/decorators/base.js:
@lit/reactive-element/node/decorators/query.js:
@lit/reactive-element/node/decorators/query-all.js:
@lit/reactive-element/node/decorators/query-async.js:
@lit/reactive-element/node/decorators/query-assigned-nodes.js:
lit-html/node/directive.js:
lit-html/node/directives/unsafe-html.js:
lit-html/node/directives/repeat.js:
lit-html/node/directives/unsafe-svg.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/node/is-server.js:
  (**
   * @license
   * Copyright 2022 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

@lit/reactive-element/node/decorators/query-assigned-elements.js:
  (**
   * @license
   * Copyright 2021 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/node/directives/style-map.js:
lit-html/node/directives/class-map.js:
lit-html/node/directives/if-defined.js:
  (**
   * @license
   * Copyright 2018 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)

lit-html/node/directive-helpers.js:
  (**
   * @license
   * Copyright 2020 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/

export { Avatar, Badge, Banner, Box, BrandAttribution, Button, Card, Center, Chip, ConfirmButton, Cover, Databox, DescriptionList, DescriptionListItem, Divider, EmptyState, Field, FileInput, Icon, List, ListGroup, ListGroupItem, ListItem, ListSection, Modal, OtpInput, Poster, Price, RadioCard, RadioCardGroup, Section, Sidebar, Stack, Stepper, StepperItem, Table, Tag, VisuallyHidden, duoSpacingValues };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map